import {
  warmUpRapier
} from "./chunk-FZTH6MUO.mjs";
import {
  resolveMirrorTheme
} from "./chunk-ZUBYS2Q3.mjs";
import {
  resolveHideDistanceM,
  resolveOpenRadiusM
} from "./chunk-WPDYYNOF.mjs";
import {
  CreaturePhoto
} from "./chunk-VALZG35Q.mjs";
import {
  FeedingGame,
  RewardRevealPanel_default
} from "./chunk-WIVZKXML.mjs";
import {
  ARPageShell,
  BackgroundWrapper,
  GameCanvasGuard,
  HTMLBlock_default,
  PageModal,
  PageModalContainerProvider,
  PermissionsDialog,
  QuestionCard,
  SkipDialog,
  getPermissionStatus,
  isIOS,
  sanitizeHtml,
  usePermissionStatuses
} from "./chunk-FXF7X2MJ.mjs";
import {
  WRONG_STATUS_MS
} from "./chunk-4CND2RGS.mjs";
import {
  ArcadeAssetError
} from "./chunk-NYFW62XT.mjs";
import {
  useCameraVideo
} from "./chunk-QEROQ2RW.mjs";
import {
  ScannerFrame,
  classes
} from "./chunk-HXABEUTY.mjs";
import {
  OBJECT_DETECTOR_ASSETS_BASE_URL,
  OBJECT_DETECTOR_DEFAULT_MAX_RESULTS,
  OBJECT_DETECTOR_DEFAULT_SCORE_THRESHOLD,
  OBJECT_DETECTOR_MODEL_FILE,
  OBJECT_DETECTOR_MODEL_PATH,
  OBJECT_DETECTOR_WASM_PATH,
  bestDetectionFor,
  boxToView,
  coverTransform,
  labelsSeen,
  loadObjectDetector,
  toDetections
} from "./chunk-U3YN5RIT.mjs";
import {
  SVGIcon_default
} from "./chunk-VDCOTHYR.mjs";
import {
  CHARACTERS,
  CHARACTER_IDS,
  FEEDABLE_CHARACTERS,
  FOODS,
  PHOTO_CHARACTERS,
  characterCollection,
  characterModelUrl,
  characterMotion,
  characterSpec,
  isCharacterId,
  prefetchCharacter
} from "./chunk-C7FE5SD3.mjs";
import {
  clampCount,
  clampOptionalCount,
  clampOptionalDuration
} from "./chunk-FSHWH3TV.mjs";
import "./chunk-IHWFYIIF.mjs";
import {
  DEFAULT_GADGET_THEME,
  DEFAULT_SCANNER_THEME,
  GADGET_THEMES,
  SCANNER_THEMES,
  gadgetThemeClass,
  resolveGadgetTheme,
  resolveScannerTheme,
  scannerThemeClass
} from "./chunk-XXDZHRIA.mjs";
import {
  warmUpImmersiveARSupport
} from "./chunk-PM3UV6CK.mjs";
import {
  usePrefersReducedMotion
} from "./chunk-XK4WW6FW.mjs";
import {
  CAUGHT_ERROR_EVENT,
  reportCaughtError
} from "./chunk-ETY2OVGU.mjs";

// src/components/ErrorBoundary.tsx
import React from "react";
var ErrorBoundary = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    reportCaughtError({
      source: "ErrorBoundary",
      kind: "react-render-error",
      error,
      message: info.componentStack ?? void 0
    });
    console.error(
      "ErrorBoundary caught an error:",
      error,
      info?.componentStack
    );
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
};
var ErrorBoundary_default = ErrorBoundary;

// src/components/OutsideClickHandler.tsx
import React2, { useEffect, useRef } from "react";
var OutsideClickHandler = ({
  onOutsideClick,
  className,
  children
}) => {
  const wrapperRef = useRef(null);
  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target) && onOutsideClick) {
      onOutsideClick();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);
  return /* @__PURE__ */ React2.createElement("div", { className, ref: wrapperRef }, children);
};
var OutsideClickHandler_default = OutsideClickHandler;

// src/components/HeroIcon.tsx
import React3 from "react";
function HeroIcon({ className, icon }) {
  return /* @__PURE__ */ React3.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      className
    },
    icon === "bold" && /* @__PURE__ */ React3.createElement(
      "path",
      {
        strokeLinejoin: "round",
        d: "M6.75 3.744h-.753v8.25h7.125a4.125 4.125 0 0 0 0-8.25H6.75Zm0 0v.38m0 16.122h6.747a4.5 4.5 0 0 0 0-9.001h-7.5v9h.753Zm0 0v-.37m0-15.751h6a3.75 3.75 0 1 1 0 7.5h-6m0-7.5v7.5m0 0v8.25m0-8.25h6.375a4.125 4.125 0 0 1 0 8.25H6.75m.747-15.38h4.875a3.375 3.375 0 0 1 0 6.75H7.497v-6.75Zm0 7.5h5.25a3.75 3.75 0 0 1 0 7.5h-5.25v-7.5Z"
      }
    ),
    icon === "italic" && /* @__PURE__ */ React3.createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5.248 20.246H9.05m0 0h3.696m-3.696 0 5.893-16.502m0 0h-3.697m3.697 0h3.803"
      }
    ),
    icon === "underline" && /* @__PURE__ */ React3.createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17.995 3.744v7.5a6 6 0 1 1-12 0v-7.5m-2.25 16.502h16.5"
      }
    ),
    icon == "numbered-list" && /* @__PURE__ */ React3.createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.242 5.992h12m-12 6.003H20.24m-12 5.999h12M4.117 7.495v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.577a1.125 1.125 0 1 1 1.591 1.59l-1.83 1.83h2.16M2.99 15.745h1.125a1.125 1.125 0 0 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 0 1 0 2.25H2.99"
      }
    )
  );
}

// src/components/Pages/PageRenderer.tsx
import React70, { useCallback as useCallback24, useState as useState31 } from "react";

// src/components/Pages/Layout01.tsx
import React5 from "react";

// src/components/Pages/SnowCanvas.tsx
import React4, { useEffect as useEffect2, useRef as useRef2 } from "react";
function frand(min, max) {
  return Math.random() * (max - min) + min;
}
var Particle = class {
  origin;
  position;
  velocity;
  size;
  amplitude;
  dx;
  constructor(origin, velocity, size, amplitude) {
    this.origin = { ...origin };
    this.position = { ...origin };
    this.velocity = { ...velocity };
    this.size = size;
    this.amplitude = amplitude;
    this.dx = Math.random() * 100;
  }
  update(deltaTime, canvasWidth, canvasHeight) {
    this.position.y += this.velocity.y * deltaTime;
    this.dx += this.velocity.x * deltaTime;
    this.position.x = this.origin.x + this.amplitude * Math.sin(this.dx);
    if (this.position.y - this.size > canvasHeight) {
      this.position.y = -this.size;
      this.position.x = this.origin.x = Math.random() * canvasWidth;
      this.dx = Math.random() * 100;
    }
  }
};
var SnowCanvas = ({ width, height, style }) => {
  const canvasRef = useRef2(null);
  const particlesRef = useRef2([]);
  const runningRef = useRef2(false);
  const lastFrameTimeRef = useRef2(0);
  const frameIdRef = useRef2(null);
  const sizeRef = useRef2({ width: 0, height: 0 });
  const pAmount = 1e3;
  const pSize = [0.5, 2.5];
  const pSwing = [0.1, 1];
  const pSpeed = [20, 80];
  const pAmplitude = [25, 50];
  const initParticles = (canvasWidth, canvasHeight) => {
    particlesRef.current = [];
    for (let i = 0; i < pAmount; i++) {
      const origin = {
        x: frand(0, canvasWidth),
        // Distribute particles initially anywhere in the visible range
        y: frand(0, canvasHeight)
      };
      const velocity = {
        x: frand(pSwing[0], pSwing[1]),
        y: frand(pSpeed[0], pSpeed[1])
      };
      const size = frand(pSize[0], pSize[1]);
      const amp = frand(pAmplitude[0], pAmplitude[1]);
      particlesRef.current.push(new Particle(origin, velocity, size, amp));
    }
  };
  const draw = (ctx, canvasWidth, canvasHeight, deltaTime) => {
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    ctx.fillStyle = "rgb(255,255,255)";
    const particles = particlesRef.current;
    for (let i = 0; i < particles.length; i++) {
      const p = particles[i];
      p.update(deltaTime, canvasWidth, canvasHeight);
      ctx.fillRect(p.position.x, p.position.y, p.size, p.size);
    }
  };
  const onResize = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const parent = canvas.parentElement;
    const rect = parent && parent.clientWidth > 0 && parent.clientHeight > 0 ? { width: parent.clientWidth, height: parent.clientHeight } : parent?.getBoundingClientRect();
    const w = Math.max(
      1,
      Math.floor(width || rect?.width || window.innerWidth)
    );
    const h = Math.max(
      1,
      Math.floor(height || rect?.height || window.innerHeight)
    );
    const dpr = window.devicePixelRatio || 1;
    canvas.style.width = `${w}px`;
    canvas.style.height = `${h}px`;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const sizeChanged = w !== sizeRef.current.width || h !== sizeRef.current.height;
    sizeRef.current = { width: w, height: h };
    if (sizeChanged) {
      initParticles(w, h);
    }
  };
  useEffect2(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    onResize();
    runningRef.current = true;
    lastFrameTimeRef.current = performance.now();
    const animate = () => {
      if (!runningRef.current) return;
      const now = performance.now();
      const deltaTime = (now - lastFrameTimeRef.current) / 1e3;
      lastFrameTimeRef.current = now;
      const { width: logicalWidth, height: logicalHeight } = sizeRef.current;
      draw(ctx, logicalWidth, logicalHeight, deltaTime);
      frameIdRef.current = requestAnimationFrame(animate);
    };
    animate();
    const observer = new ResizeObserver(onResize);
    if (canvas.parentElement) observer.observe(canvas.parentElement);
    return () => {
      runningRef.current = false;
      if (frameIdRef.current !== null) {
        cancelAnimationFrame(frameIdRef.current);
        frameIdRef.current = null;
      }
      observer.disconnect();
    };
  }, []);
  return /* @__PURE__ */ React4.createElement("canvas", { ref: canvasRef, style });
};
var SnowCanvas_default = SnowCanvas;

// src/components/Pages/Layout01.tsx
import { ChevronRightIcon } from "@heroicons/react/20/solid";
var Layout01 = ({ page, nextPage, closeModal }) => /* @__PURE__ */ React5.createElement("div", { className: "h-full w-full overflow-y-auto" }, /* @__PURE__ */ React5.createElement(
  "img",
  {
    src: page?.image,
    alt: page?.altText ?? "",
    className: "pointer-events-none absolute top-0 right-0 bottom-0 left-0 z-0 block h-full w-full object-cover"
  }
), page.particles === "snow" && /* @__PURE__ */ React5.createElement(
  SnowCanvas_default,
  {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      pointerEvents: "none"
    }
  }
), (page?.title || page?.content) && /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement("span", { className: "block h-[90%]" }), /* @__PURE__ */ React5.createElement("div", { className: "Layout01_content relative z-10 mx-4 mb-8 rounded-md bg-white/95 p-4 shadow-lg @3xl:mx-auto @3xl:max-w-2xl" }, page.title && /* @__PURE__ */ React5.createElement("h1", { className: "mb-2 text-lg font-bold" }, page.title), /* @__PURE__ */ React5.createElement(HTMLBlock_default, { html: page.content }), nextPage && /* @__PURE__ */ React5.createElement(
  "button",
  {
    type: "button",
    className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mx-auto mt-6 flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
    onClick: () => nextPage()
  },
  "Continue",
  /* @__PURE__ */ React5.createElement(
    ChevronRightIcon,
    {
      className: "-mr-0.5 h-5 w-5",
      "aria-hidden": "true"
    }
  )
), page.showCloseButton && closeModal && /* @__PURE__ */ React5.createElement(
  "button",
  {
    type: "button",
    className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mx-auto mt-6 flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
    onClick: () => closeModal()
  },
  page.closeButtonText || "Close"
))));
var Layout01_default = Layout01;

// src/components/Pages/Layout02.tsx
import React6 from "react";
var Layout02 = ({ page, nextPage, closeModal }) => /* @__PURE__ */ React6.createElement("div", { className: "bg-mt-surface text-mt-ink h-full w-full overflow-y-auto" }, page.image && /* @__PURE__ */ React6.createElement(
  "img",
  {
    src: page.image,
    alt: page.altText || page.title || "Article header image",
    className: "block h-auto max-h-[50vh] w-full object-cover"
  }
), /* @__PURE__ */ React6.createElement("div", { className: "mx-auto flex w-full max-w-[65ch] flex-col gap-6 px-5 pt-8 pb-12 sm:px-6" }, page.title && /* @__PURE__ */ React6.createElement("h1", { className: "text-mt-ink text-2xl leading-tight font-semibold tracking-tight sm:text-3xl" }, page.title), /* @__PURE__ */ React6.createElement("div", { className: "prose prose-neutral max-w-none" }, /* @__PURE__ */ React6.createElement(HTMLBlock_default, { html: page.content })), (nextPage || page.showCloseButton && closeModal) && /* @__PURE__ */ React6.createElement("div", { className: "flex flex-wrap items-center gap-3 pt-2" }, nextPage && /* @__PURE__ */ React6.createElement(
  "button",
  {
    type: "button",
    className: "border-mt-border bg-mt-surface text-mt-ink-soft hover:border-mt-border hover:bg-mt-surface-2 rounded-md border px-4 py-2 text-sm font-medium transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-700",
    onClick: () => nextPage()
  },
  "Continue"
), page.showCloseButton && closeModal && /* @__PURE__ */ React6.createElement(
  "button",
  {
    type: "button",
    className: "border-mt-border bg-mt-surface text-mt-ink-soft hover:border-mt-border hover:bg-mt-surface-2 rounded-md border px-4 py-2 text-sm font-medium transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-700",
    onClick: () => closeModal()
  },
  page.closeButtonText || "Close"
))));

// src/components/Pages/Question.tsx
import React7 from "react";
import { CheckIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

// src/utils/question-utils.ts
function levenshtein(a, b) {
  const an = a.length;
  const bn = b.length;
  if (an === 0) return bn;
  if (bn === 0) return an;
  const matrix = new Array(bn + 1);
  for (let i = 0; i <= bn; ++i) {
    let row = matrix[i] = new Array(an + 1);
    row[0] = i;
  }
  const firstRow = matrix[0];
  for (let j = 1; j <= an; ++j) {
    firstRow[j] = j;
  }
  for (let i = 1; i <= bn; ++i) {
    for (let j = 1; j <= an; ++j) {
      const cost = a[j - 1] === b[i - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        // deletion
        matrix[i][j - 1] + 1,
        // insertion
        matrix[i - 1][j - 1] + cost
        // substitution
      );
    }
  }
  return matrix[bn][an];
}
function isCloseEnough(userInput, correctAnswer, tolerance = 0.8) {
  if (!userInput || !correctAnswer) {
    return userInput === correctAnswer;
  }
  if (tolerance < 0 || tolerance > 1) {
    throw new Error("Tolerance must be between 0 and 1");
  }
  const distance = levenshtein(userInput, correctAnswer);
  const length2 = Math.max(userInput.length, correctAnswer.length);
  const similarity = (length2 - distance) / length2;
  return similarity >= tolerance;
}
function gradeAnswer(page, usersAnswer) {
  const given = usersAnswer.trim();
  if (page.answerType === "multipleChoice") {
    return given.toLowerCase() === page.answer.trim().toLowerCase();
  }
  if (given === "") return false;
  if (page.answerType === "number") {
    const givenNum = Number(given);
    const expectedNum = Number(page.answer.trim());
    if (Number.isNaN(givenNum) || Number.isNaN(expectedNum)) return false;
    const rawTolerance = page.answerTolerance ?? 0;
    const tolerance = Number.isFinite(rawTolerance) && rawTolerance >= 0 ? rawTolerance : 0;
    return Math.abs(givenNum - expectedNum) <= tolerance;
  }
  const answer = page.answer.trim().toLowerCase();
  const givenLower = given.toLowerCase();
  if (answer === givenLower) return true;
  const clampedTolerance = page.answerTolerance === void 0 ? void 0 : Math.min(1, Math.max(0, page.answerTolerance));
  return clampedTolerance !== 0 && isCloseEnough(answer, givenLower, clampedTolerance);
}

// src/components/Pages/Question.tsx
var Question = ({
  page,
  trailEvent,
  nextPage,
  prevPage,
  answerQuestion
}) => {
  const [currentSection, setCurrentSection] = useState("question");
  const initialAnswer = page.userAnswer || "";
  const [usersAnswer, setUsersAnswer] = useState(initialAnswer);
  const [selectedChoiceIndex, setSelectedChoiceIndex] = useState(
    () => {
      if (!page.choices || initialAnswer === "") return null;
      const i = page.choices.indexOf(initialAnswer);
      return i >= 0 ? i : null;
    }
  );
  const handleSubmit = () => {
    const hasAnswer = page.answerType === "multipleChoice" ? selectedChoiceIndex !== null : usersAnswer !== "";
    hasAnswer && answerQuestion(usersAnswer);
    const correct = hasAnswer && gradeAnswer(page, usersAnswer);
    if (hasAnswer) {
      trailEvent?.(correct ? "question_correct" : "question_wrong");
    }
    setCurrentSection(correct ? "correctAnswer" : "wrongAnswer");
  };
  const misconfiguredMultipleChoice = page.answerType === "multipleChoice" && (page.choices?.length ?? 0) < 2;
  if (misconfiguredMultipleChoice) {
    return /* @__PURE__ */ React7.createElement(
      "div",
      {
        className: "flex h-full min-h-full items-center justify-center overflow-y-auto overscroll-none bg-cover bg-center bg-no-repeat p-4 text-center",
        style: {
          backgroundImage: page.backgroundImage ? `url(${page.backgroundImage})` : void 0
        }
      },
      /* @__PURE__ */ React7.createElement(QuestionCard, { image: page.questionImage }, /* @__PURE__ */ React7.createElement("div", { className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100" }, /* @__PURE__ */ React7.createElement(XMarkIcon, { className: "h-6 w-6 text-yellow-600", "aria-hidden": "true" })), /* @__PURE__ */ React7.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React7.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, "This question is misconfigured"), /* @__PURE__ */ React7.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React7.createElement("p", { className: "text-mt-ink-muted text-sm" }, "A multiple-choice question needs at least two answer options. Please contact the trail creator."))), nextPage && /* @__PURE__ */ React7.createElement("div", { className: "mt-5 sm:mt-6" }, /* @__PURE__ */ React7.createElement(
        "button",
        {
          type: "button",
          className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
          onClick: () => nextPage?.()
        },
        "Skip"
      )))
    );
  }
  return /* @__PURE__ */ React7.createElement(
    "div",
    {
      className: "flex h-full min-h-full items-center justify-center overflow-y-auto overscroll-none bg-cover bg-center bg-no-repeat p-4 text-center",
      style: {
        backgroundImage: page.backgroundImage ? `url(${page.backgroundImage})` : void 0
      }
    },
    currentSection === "question" && /* @__PURE__ */ React7.createElement(QuestionCard, { image: page.questionImage }, /* @__PURE__ */ React7.createElement("div", { className: "space-y-2" }, page.title && /* @__PURE__ */ React7.createElement("h2", { className: "text-mt-ink text-2xl leading-7 font-bold sm:truncate sm:text-3xl sm:tracking-tight" }, page.title), page.question && /* @__PURE__ */ React7.createElement(HTMLBlock_default, { html: page.question }), (page.answerType === "text" || page.answerType === "number") && /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(
      "label",
      {
        htmlFor: "usersAnswer",
        className: "text-mt-ink block text-sm leading-6 font-medium"
      },
      "Answer"
    ), /* @__PURE__ */ React7.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React7.createElement(
      "input",
      {
        id: "usersAnswer",
        name: "usersAnswer",
        type: page.answerType === "number" ? "number" : "text",
        autoComplete: "off",
        required: true,
        className: "text-mt-ink ring-mt-border placeholder:text-mt-ink-faint focus:ring-mt-primary block w-full rounded-md border-0 py-1.5 shadow-xs ring-1 ring-inset focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6",
        onChange: (e) => setUsersAnswer(e.target.value),
        value: usersAnswer,
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            handleSubmit();
          }
        }
      }
    ))), page.answerType === "multipleChoice" && /* @__PURE__ */ React7.createElement("div", { className: "py-2" }, /* @__PURE__ */ React7.createElement("ul", { className: "flex flex-col gap-2" }, page.choices?.map((choice, index) => /* @__PURE__ */ React7.createElement("li", { key: `choice-${index}`, className: "flex items-center" }, /* @__PURE__ */ React7.createElement(
      "input",
      {
        id: `mc-answer-${index}`,
        name: "multiple-choice-answers",
        type: "radio",
        className: "border-mt-border text-mt-primary focus:ring-mt-primary h-4 w-4",
        onChange: () => {
          setSelectedChoiceIndex(index);
          setUsersAnswer(choice);
        },
        checked: selectedChoiceIndex === index,
        value: index
      }
    ), /* @__PURE__ */ React7.createElement(
      "label",
      {
        htmlFor: `mc-answer-${index}`,
        className: "text-mt-ink ml-3 block text-sm leading-6 font-medium"
      },
      choice
    )))))), /* @__PURE__ */ React7.createElement("div", { className: "mt-4" }, /* @__PURE__ */ React7.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary flex w-full justify-center rounded-md px-3 py-1.5 text-sm leading-6 font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        onClick: () => handleSubmit()
      },
      "Submit"
    ))),
    currentSection === "wrongAnswer" && /* @__PURE__ */ React7.createElement(QuestionCard, { image: page.wrongAnswerImage }, /* @__PURE__ */ React7.createElement("div", { className: "bg-mt-danger-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React7.createElement(XMarkIcon, { className: "text-mt-danger h-6 w-6", "aria-hidden": "true" })), /* @__PURE__ */ React7.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React7.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, "Wrong Answer!"), /* @__PURE__ */ React7.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React7.createElement("p", { className: "text-mt-ink-muted text-sm" }, "Sorry that is not the correct answer."))), /* @__PURE__ */ React7.createElement("div", { className: "mt-5 sm:mt-6" }, /* @__PURE__ */ React7.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        onClick: () => setCurrentSection("question")
      },
      "Try again"
    ))),
    currentSection === "correctAnswer" && /* @__PURE__ */ React7.createElement(QuestionCard, { image: page.correctAnswerImage }, /* @__PURE__ */ React7.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React7.createElement(CheckIcon, { className: "text-mt-success h-6 w-6", "aria-hidden": "true" })), /* @__PURE__ */ React7.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React7.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, "Correct Answer!"), /* @__PURE__ */ React7.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React7.createElement("p", { className: "text-mt-ink-muted text-sm" }, "The correct answer was ", page.answer, "."))), nextPage && /* @__PURE__ */ React7.createElement("div", { className: "mt-5 sm:mt-6" }, /* @__PURE__ */ React7.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        onClick: () => nextPage?.()
      },
      "Continue"
    )))
  );
};
var Question_default = Question;

// src/components/Pages/Reveal01.tsx
import React8, { useState as useState2 } from "react";
var Reveal01 = ({ page, nextPage, prevPage }) => {
  const [active, setActive] = useState2(false);
  return /* @__PURE__ */ React8.createElement(
    "div",
    {
      className: [
        "Reveal01 relative h-full bg-cover bg-center",
        active ? "Reveal01_active" : "Reveal01_notactive"
      ].join(" "),
      role: "button",
      tabIndex: 0,
      "aria-label": "Reveal hidden content",
      onClick: () => {
        setActive(true);
      },
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          setActive(true);
        }
      },
      style: {
        backgroundImage: `url(${page.backgroundImage})`
      }
    },
    /* @__PURE__ */ React8.createElement(
      "div",
      {
        className: "Reveal01_revealedImage absolute -top-0 right-0 h-full w-full bg-cover bg-center",
        style: {
          backgroundImage: `url(${page.revealedImage})`
        },
        onAnimationEnd: () => {
          nextPage?.();
        }
      }
    ),
    /* @__PURE__ */ React8.createElement("div", { className: "Reveal01_objectWrapper" }, /* @__PURE__ */ React8.createElement(
      "div",
      {
        className: "Reveal01_object",
        style: {
          backgroundImage: `url(${page.objectImage})`
        }
      }
    ), /* @__PURE__ */ React8.createElement(
      "div",
      {
        className: "Reveal01_objectSplitTop",
        style: {
          backgroundImage: `url(${page.objectSplitTopImage})`
        }
      }
    ), /* @__PURE__ */ React8.createElement(
      "div",
      {
        className: "Reveal01_objectSplitBottom",
        style: {
          backgroundImage: `url(${page.objectSplitBottomImage})`
        }
      }
    )),
    page.title && /* @__PURE__ */ React8.createElement("div", { className: "Reveal01_title" }, /* @__PURE__ */ React8.createElement("h3", { className: "text-mt-ink text-lg leading-6 font-semibold" }, page.title))
  );
};
var Reveal01_default = Reveal01;

// src/components/Pages/Starburst.tsx
import React9 from "react";
import {
  ArrowRightIcon,
  ChevronLeftIcon,
  XMarkIcon as XMarkIcon2
} from "@heroicons/react/20/solid";
function Starburst({
  page,
  nextPage,
  prevPage,
  closeModal
}) {
  return /* @__PURE__ */ React9.createElement(
    "div",
    {
      className: "relative flex h-full w-full shrink grow flex-col items-center justify-center overflow-y-auto bg-cover bg-no-repeat",
      style: {
        backgroundImage: page.backgroundImage ? `url(${page.backgroundImage})` : void 0
      }
    },
    /* @__PURE__ */ React9.createElement("div", { className: "fixed flex h-full w-full flex-col items-center justify-center" }, page.starburstImage && /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(
      "div",
      {
        className: "Starburst_starburst1 absolute top-1/2 left-1/2 aspect-square w-full max-w-2xl bg-cover bg-no-repeat",
        style: {
          backgroundImage: `url(${page.starburstImage})`
        }
      }
    ), /* @__PURE__ */ React9.createElement(
      "div",
      {
        className: "Starburst_starburst2 absolute top-1/2 left-1/2 aspect-square w-full max-w-2xl bg-cover bg-no-repeat",
        style: {
          backgroundImage: `url(${page.starburstImage})`
        }
      }
    )), /* @__PURE__ */ React9.createElement(
      "img",
      {
        src: page?.image,
        alt: page?.altText ?? "",
        className: "Starburst_image relative"
      }
    )),
    (page?.title || page?.content) && /* @__PURE__ */ React9.createElement("div", { className: "Layout01_content relative z-10" }, page.title && /* @__PURE__ */ React9.createElement("h1", { className: "mb-2 text-lg font-bold" }, page.title), page.content && /* @__PURE__ */ React9.createElement(HTMLBlock_default, { html: page.content }), nextPage && /* @__PURE__ */ React9.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary text-mt-on-primary mx-auto mt-6 flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        onClick: () => nextPage()
      },
      "Continue",
      /* @__PURE__ */ React9.createElement(ArrowRightIcon, { className: "-mr-0.5 h-5 w-5", "aria-hidden": "true" })
    ), (prevPage || closeModal) && /* @__PURE__ */ React9.createElement("div", { className: "flex w-full gap-4" }, prevPage && /* @__PURE__ */ React9.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary text-mt-on-primary mx-auto flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        onClick: () => prevPage()
      },
      /* @__PURE__ */ React9.createElement(
        ChevronLeftIcon,
        {
          className: "-mr-0.5 h-5 w-5",
          "aria-hidden": "true"
        }
      ),
      "Previous"
    ), closeModal && /* @__PURE__ */ React9.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary text-mt-on-primary mx-auto flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        onClick: () => closeModal()
      },
      "Close",
      /* @__PURE__ */ React9.createElement(XMarkIcon2, { className: "-mr-0.5 h-5 w-5", "aria-hidden": "true" })
    )))
  );
}

// src/components/Pages/SlidingTilePuzzle.tsx
import React11, {
  useState as useState3,
  useEffect as useEffect3,
  useRef as useRef3,
  useCallback,
  useLayoutEffect
} from "react";
import { CheckIcon as CheckIcon2 } from "@heroicons/react/20/solid";

// src/components/Pages/GameCompleteModal.tsx
import React10 from "react";
function GameCompleteModal({ open, image, children }) {
  return /* @__PURE__ */ React10.createElement(PageModal, { open, ariaLabel: "Game complete" }, /* @__PURE__ */ React10.createElement(QuestionCard, { image }, children));
}

// src/components/Pages/SlidingTilePuzzle.tsx
function normalizeGridSize(raw) {
  return Number.isFinite(raw) ? Math.min(6, Math.max(2, Math.round(raw))) : 3;
}
var Tile = React11.memo(
  ({
    tile,
    index,
    tileSize,
    gridSize,
    emptyTile,
    image,
    onClick,
    disabled
  }) => {
    if (tile === emptyTile) return null;
    const row = Math.floor(index / gridSize);
    const col = index % gridSize;
    const originalRow = Math.floor(tile / gridSize);
    const originalCol = tile % gridSize;
    return /* @__PURE__ */ React11.createElement(
      "button",
      {
        type: "button",
        onClick: () => !disabled && onClick(index),
        disabled,
        "aria-label": disabled ? `Tile ${tile + 1}` : `Move tile ${tile + 1}`,
        className: "border-mt-border focus-visible:outline-mt-primary absolute cursor-pointer border bg-cover bg-no-repeat p-0 transition-all duration-150 focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-default",
        style: {
          top: `${row * tileSize}px`,
          left: `${col * tileSize}px`,
          width: `${tileSize}px`,
          height: `${tileSize}px`,
          backgroundImage: `url(${image})`,
          backgroundSize: `${tileSize * gridSize}px ${tileSize * gridSize}px`,
          backgroundPosition: `-${originalCol * tileSize}px -${originalRow * tileSize}px`
        }
      }
    );
  }
);
var SlidingTilePuzzle = ({
  page,
  trailEvent,
  nextPage,
  prevPage
}) => {
  const {
    image,
    gridSize: gridSizeRaw = 3,
    difficulty = "medium",
    backgroundImage,
    instructions,
    completeImage,
    completeTitle,
    completeText
  } = page;
  const gridSize = normalizeGridSize(gridSizeRaw);
  const tileCount = gridSize * gridSize;
  const emptyTile = tileCount - 1;
  const [tiles, setTiles] = useState3([]);
  const [currentDifficulty, setCurrentDifficulty] = useState3(difficulty);
  const [tileSize, setTileSize] = useState3(0);
  const [gameCompleted, setGameCompleted] = useState3(false);
  const [showEndScreen, setShowEndScreen] = useState3(false);
  const containerRef = useRef3(null);
  useEffect3(() => {
    initializeTiles(currentDifficulty);
  }, [image, gridSize, currentDifficulty]);
  useLayoutEffect(() => {
    if (!containerRef.current) return;
    const container = containerRef.current;
    const resizeObserver = new ResizeObserver(() => {
      const containerRect = container.getBoundingClientRect();
      const size = Math.min(containerRect.width, containerRect.height);
      setTileSize(size / gridSize);
    });
    resizeObserver.observe(container);
    return () => {
      resizeObserver.disconnect();
    };
  }, [gridSize]);
  const initializeTiles = (difficultyLevel) => {
    const initialTiles = Array.from({ length: tileCount }, (_, index) => index);
    const shuffledTiles = shuffleTiles(initialTiles, difficultyLevel);
    setTiles(shuffledTiles);
  };
  const shuffleTiles = useCallback(
    (tilesArray, difficultyLevel) => {
      const shuffleIterations = difficultyLevel === "easy" ? 5 : difficultyLevel === "medium" ? 15 : 30;
      let shuffled = [...tilesArray];
      let attempts = 0;
      do {
        shuffled = [...tilesArray];
        for (let i = 0; i < shuffleIterations; i++) {
          const emptyIndex2 = shuffled.indexOf(emptyTile);
          const neighbors = getNeighbors(emptyIndex2);
          const swapWith = neighbors[Math.floor(Math.random() * neighbors.length)];
          [shuffled[emptyIndex2], shuffled[swapWith]] = [
            shuffled[swapWith],
            shuffled[emptyIndex2]
          ];
        }
        attempts++;
      } while (isSolved(shuffled) && attempts < 50);
      return shuffled;
    },
    [gridSize, emptyTile]
  );
  const getNeighbors = (index) => {
    const neighbors = [];
    const x = index % gridSize;
    const y = Math.floor(index / gridSize);
    if (x > 0) neighbors.push(index - 1);
    if (x < gridSize - 1) neighbors.push(index + 1);
    if (y > 0) neighbors.push(index - gridSize);
    if (y < gridSize - 1) neighbors.push(index + gridSize);
    return neighbors;
  };
  const isSolved = (tilesArray) => {
    for (let i = 0; i < tilesArray.length; i++) {
      if (tilesArray[i] !== i) return false;
    }
    return true;
  };
  const onComplete = () => {
    trailEvent?.("Sliding Tile Puzzle: Completed");
    setGameCompleted(true);
    setTimeout(() => {
      setShowEndScreen(true);
    }, 1500);
  };
  const isAdjacent = (index1, index2) => {
    const x1 = index1 % gridSize;
    const y1 = Math.floor(index1 / gridSize);
    const x2 = index2 % gridSize;
    const y2 = Math.floor(index2 / gridSize);
    return Math.abs(x1 - x2) + Math.abs(y1 - y2) === 1;
  };
  const handleTileClick = useCallback(
    (index) => {
      const emptyIndex2 = tiles.indexOf(emptyTile);
      if (isAdjacent(index, emptyIndex2)) {
        const newTiles = [...tiles];
        [newTiles[index], newTiles[emptyIndex2]] = [
          newTiles[emptyIndex2],
          newTiles[index]
        ];
        setTiles(newTiles);
        if (isSolved(newTiles)) {
          onComplete();
        }
      }
    },
    [tiles, emptyTile, onComplete, gridSize]
  );
  const handleReset = useCallback(() => {
    const newDifficulty = currentDifficulty === "hard" ? "medium" : currentDifficulty === "medium" ? "easy" : "easy";
    if (newDifficulty === currentDifficulty) {
      initializeTiles(newDifficulty);
    } else {
      setCurrentDifficulty(newDifficulty);
    }
  }, [currentDifficulty]);
  const emptyIndex = tiles.indexOf(emptyTile);
  return /* @__PURE__ */ React11.createElement(
    "div",
    {
      className: "flex h-full w-full flex-col items-center justify-center gap-4",
      style: {
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : void 0
      }
    },
    instructions && /* @__PURE__ */ React11.createElement("div", { className: "bg-mt-surface relative mb-8 w-full max-w-lg transform overflow-hidden rounded-lg p-4 text-left shadow-xl" }, /* @__PURE__ */ React11.createElement("p", null, instructions)),
    /* @__PURE__ */ React11.createElement(
      "div",
      {
        ref: containerRef,
        className: "relative aspect-square w-full max-w-xs flex-none @2xl:max-w-sm @3xl:max-w-md @5xl:max-w-lg"
      },
      /* @__PURE__ */ React11.createElement(
        "div",
        {
          className: `absolute -inset-8 rounded-lg ${gameCompleted ? "bg-green-500" : "bg-red-500"} shadow-2xl`
        }
      ),
      /* @__PURE__ */ React11.createElement(
        "div",
        {
          className: `absolute inset-0 rounded-lg ${gameCompleted ? "bg-green-900" : "bg-red-900"} shadow-inner`
        }
      ),
      tiles.map((tile, index) => /* @__PURE__ */ React11.createElement(
        Tile,
        {
          key: tile,
          tile,
          index,
          tileSize,
          gridSize,
          emptyTile,
          image,
          onClick: handleTileClick,
          disabled: gameCompleted || !isAdjacent(index, emptyIndex)
        }
      ))
    ),
    /* @__PURE__ */ React11.createElement(
      "button",
      {
        onClick: handleReset,
        className: "mt-8 rounded-sm bg-blue-600 px-6 py-2 font-semibold text-white transition-colors duration-150 hover:bg-blue-700",
        disabled: gameCompleted
      },
      "Reset Puzzle"
    ),
    /* @__PURE__ */ React11.createElement(GameCompleteModal, { open: showEndScreen, image: completeImage }, /* @__PURE__ */ React11.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React11.createElement(CheckIcon2, { className: "text-mt-success h-6 w-6", "aria-hidden": "true" })), /* @__PURE__ */ React11.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React11.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle), /* @__PURE__ */ React11.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React11.createElement("p", { className: "text-mt-ink-muted text-sm" }, completeText))), nextPage && /* @__PURE__ */ React11.createElement("div", { className: "mt-5 sm:mt-6" }, /* @__PURE__ */ React11.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        onClick: () => nextPage?.()
      },
      "Continue"
    )))
  );
};
var SlidingTilePuzzle_default = SlidingTilePuzzle;

// src/components/Pages/TapTheThing.tsx
import React13, { useEffect as useEffect4, useRef as useRef4, useState as useState4 } from "react";

// src/components/Instructions.tsx
import React12 from "react";
import { Transition } from "@headlessui/react";
import { InformationCircleIcon, XMarkIcon as XMarkIcon3 } from "@heroicons/react/20/solid";
import { Fragment } from "react";
function Instructions({
  show,
  title,
  text,
  close,
  continueButtonText
}) {
  return (
    // absolute (not fixed): anchors to the page container, so the toast stays
    // inside the editor's phone-frame preview; in the player the page root
    // fills the viewport, where it reads identically.
    /* @__PURE__ */ React12.createElement(
      "div",
      {
        "aria-live": "assertive",
        className: "pointer-events-none absolute inset-0 z-40 flex items-end px-4 py-6"
      },
      /* @__PURE__ */ React12.createElement("div", { className: "flex w-full flex-col items-end space-y-4" }, /* @__PURE__ */ React12.createElement(Transition, { show, as: Fragment }, /* @__PURE__ */ React12.createElement("div", { className: "bg-mt-surface pointer-events-auto w-full max-w-xs overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5 transition data-closed:opacity-0 data-enter:transform data-enter:duration-300 data-enter:ease-out data-closed:data-enter:translate-y-2 data-leave:duration-100 data-leave:ease-in sm:data-closed:data-enter:translate-x-2 sm:data-closed:data-enter:translate-y-0" }, /* @__PURE__ */ React12.createElement("div", { className: "p-4" }, /* @__PURE__ */ React12.createElement("div", { className: "flex items-start" }, /* @__PURE__ */ React12.createElement("div", { className: "shrink-0" }, /* @__PURE__ */ React12.createElement(
        InformationCircleIcon,
        {
          "aria-hidden": "true",
          className: "h-6 w-6 text-blue-400"
        }
      )), /* @__PURE__ */ React12.createElement("div", { className: "ml-3 w-0 flex-1 pt-0.5" }, title && /* @__PURE__ */ React12.createElement("p", { className: "text-mt-ink text-sm font-medium" }, title), text && /* @__PURE__ */ React12.createElement(
        HTMLBlock_default,
        {
          className: "text-mt-ink-muted mt-1 text-sm",
          html: text
        }
      ), close && continueButtonText && /* @__PURE__ */ React12.createElement("div", { className: "mt-6 flex justify-end" }, /* @__PURE__ */ React12.createElement(
        "button",
        {
          type: "button",
          onClick: close,
          className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary rounded px-2 py-1 text-xs font-semibold shadow-sm focus-visible:outline-2 focus-visible:outline-offset-2"
        },
        continueButtonText
      ))), close && /* @__PURE__ */ React12.createElement("div", { className: "ml-4 flex shrink-0" }, /* @__PURE__ */ React12.createElement(
        "button",
        {
          type: "button",
          onClick: close,
          className: "bg-mt-surface text-mt-ink-faint hover:text-mt-ink-muted focus:ring-mt-primary inline-flex rounded-md focus:ring-2 focus:ring-offset-2 focus:outline-hidden"
        },
        /* @__PURE__ */ React12.createElement("span", { className: "sr-only" }, "Close"),
        /* @__PURE__ */ React12.createElement(XMarkIcon3, { "aria-hidden": "true", className: "size-5" })
      )))))))
    )
  );
}

// src/components/Pages/TapTheThing.tsx
import { CheckIcon as CheckIcon3 } from "@heroicons/react/20/solid";
var TapTheThing = ({
  page,
  trailEvent,
  nextPage,
  prevPage
}) => {
  const {
    images,
    targetScore: targetScoreRaw,
    movementStyle,
    speed = 0.5,
    size = 50,
    particleCount = 10,
    thingCount: thingCountRaw = 8,
    particleColor = "confetti",
    customParticleColors = [],
    rotationSpeed = 0,
    backgroundImage,
    instructions,
    completeImage,
    completeText,
    completeTitle
  } = page;
  const targetScore = clampCount(targetScoreRaw, 1);
  const thingCount = clampCount(thingCountRaw, 1);
  const canvasRef = useRef4(null);
  const [score, setScore] = useState4(0);
  const [showInstructions, setShowInstructions] = useState4(true);
  const [showEndScreen, setShowEndScreen] = useState4(false);
  const [loadedImages, setLoadedImages] = useState4([]);
  const [assetsFailed, setAssetsFailed] = useState4(false);
  const spritesRef = useRef4([]);
  const particlesRef = useRef4([]);
  const gameCompleteRef = useRef4(false);
  const adjustedTargetScore = Math.min(targetScore, thingCount);
  const onComplete = () => {
    trailEvent?.("Tap The Thing: Completed");
    setShowEndScreen(true);
  };
  useEffect4(() => {
    const loadImages = async () => {
      const loadedImagesArray = await Promise.all(
        images.map((src) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = () => resolve(img);
            img.onerror = () => {
              console.error(`Failed to load image: ${src}`);
              resolve(img);
            };
          });
        })
      );
      const validImages = loadedImagesArray.filter(
        (img) => img.width > 0 && img.height > 0
      );
      if (validImages.length === 0) {
        console.error("No images loaded successfully");
      }
      setAssetsFailed(images.length > 0 && validImages.length === 0);
      setLoadedImages(validImages);
    };
    loadImages();
  }, [images]);
  const createSprite = (index) => {
    const canvasWidth = canvasRef.current?.width || 0;
    const canvasHeight = canvasRef.current?.height || 0;
    const x = Math.random() * (canvasWidth - size);
    let y;
    if (movementStyle === "falling") {
      const totalDistance = canvasHeight + size;
      const spacing = totalDistance / thingCount;
      y = -size - spacing * index;
    } else if (movementStyle === "rising") {
      const totalDistance = canvasHeight + size;
      const spacing = totalDistance / thingCount;
      y = canvasHeight + spacing * index;
    } else {
      y = Math.random() * (canvasHeight - size);
    }
    const velocityX = movementStyle === "floating" ? (Math.random() - 0.5) * speed : 0;
    const velocityY = movementStyle === "falling" ? (Math.random() * 0.5 + 0.5) * speed : movementStyle === "rising" ? -((Math.random() * 0.5 + 0.5) * speed) : (Math.random() - 0.5) * speed;
    const image = loadedImages[Math.floor(Math.random() * loadedImages.length)];
    const spriteRotationSpeed = rotationSpeed !== 0 ? (Math.random() - 0.5) * rotationSpeed : 0;
    return {
      id: `sprite-${Date.now()}-${Math.random()}`,
      x,
      y,
      velocityX,
      velocityY,
      rotation: Math.random() * 360,
      // Random initial rotation angle
      rotationSpeed: spriteRotationSpeed,
      image
    };
  };
  const drawSprite = (ctx, sprite) => {
    if (sprite.rotationSpeed !== 0) {
      ctx.save();
      ctx.translate(sprite.x + size / 2, sprite.y + size / 2);
      ctx.rotate(sprite.rotation * Math.PI / 180);
      ctx.drawImage(sprite.image, -size / 2, -size / 2, size, size);
      ctx.restore();
    } else {
      ctx.drawImage(sprite.image, sprite.x, sprite.y, size, size);
    }
  };
  const createParticles = (x, y, count) => {
    const newParticles = [];
    for (let i = 0; i < count; i++) {
      const angle = Math.random() * 2 * Math.PI;
      const speed2 = Math.random() * 2 + 1;
      const velocityX = Math.cos(angle) * speed2;
      const velocityY = Math.sin(angle) * speed2;
      const lifetime = Math.random() * 30 + 30;
      let color = "";
      switch (particleColor) {
        case "confetti":
          color = `hsl(${Math.random() * 360}, 100%, 50%)`;
          break;
        case "fire":
          color = `hsl(${Math.random() * 40}, 100%, ${Math.random() * 20 + 40}%)`;
          break;
        case "magic":
          color = `hsl(${Math.random() * 60 + 220}, 100%, ${Math.random() * 20 + 40}%)`;
          break;
        case "custom":
          if (customParticleColors.length > 0) {
            color = customParticleColors[Math.floor(Math.random() * customParticleColors.length)];
          } else {
            color = "white";
          }
          break;
        default:
          color = "white";
      }
      newParticles.push({
        x,
        y,
        velocityX,
        velocityY,
        lifetime,
        color
      });
    }
    particlesRef.current.push(...newParticles);
  };
  const drawParticles = (ctx) => {
    particlesRef.current = particlesRef.current.filter((particle) => {
      particle.x += particle.velocityX;
      particle.y += particle.velocityY;
      particle.lifetime--;
      ctx.fillStyle = particle.color;
      ctx.beginPath();
      ctx.arc(particle.x, particle.y, 3, 0, Math.PI * 2);
      ctx.fill();
      return particle.lifetime > 0;
    });
  };
  const handleTap = (tapX, tapY) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    if (showInstructions) setShowInstructions(false);
    if (gameCompleteRef.current) return;
    const newSprites = spritesRef.current.filter((sprite) => {
      const isTapped = tapX >= sprite.x && tapX <= sprite.x + size && tapY >= sprite.y && tapY <= sprite.y + size;
      if (isTapped) {
        createParticles(
          sprite.x + size / 2,
          sprite.y + size / 2,
          particleCount
        );
      }
      return !isTapped;
    });
    const increment = spritesRef.current.length - newSprites.length;
    const newScore = score + increment;
    if (newScore >= adjustedTargetScore && !gameCompleteRef.current) {
      gameCompleteRef.current = true;
      spritesRef.current.forEach((sprite) => {
        createParticles(
          sprite.x + size / 2,
          sprite.y + size / 2,
          particleCount
        );
      });
      spritesRef.current = [];
      onComplete();
    }
    setScore(newScore);
    spritesRef.current = newSprites;
  };
  useEffect4(() => {
    if (loadedImages.length === 0) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    spritesRef.current = Array.from(
      { length: thingCount },
      (_, index) => createSprite(index)
    );
    let animationFrameId;
    const update = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (!gameCompleteRef.current) {
        spritesRef.current.forEach((sprite) => {
          let { x, y, velocityX, velocityY, rotation, rotationSpeed: rotationSpeed2 } = sprite;
          x += velocityX;
          y += velocityY;
          if (rotationSpeed2 !== 0) {
            rotation += rotationSpeed2;
            rotation %= 360;
          }
          if (movementStyle === "falling" && y > canvas.height) {
            y = -size;
            x = Math.random() * (canvas.width - size);
          } else if (movementStyle === "rising" && y < -size) {
            y = canvas.height + size;
            x = Math.random() * (canvas.width - size);
          } else if (movementStyle === "floating") {
            if (x < 0 || x > canvas.width - size) velocityX = -velocityX;
            if (y < 0 || y > canvas.height - size) velocityY = -velocityY;
          }
          sprite.x = x;
          sprite.y = y;
          sprite.velocityX = velocityX;
          sprite.velocityY = velocityY;
          sprite.rotation = rotation;
          drawSprite(ctx, sprite);
        });
      }
      drawParticles(ctx);
      if (gameCompleteRef.current && particlesRef.current.length === 0) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        cancelAnimationFrame(animationFrameId);
        return;
      }
      animationFrameId = requestAnimationFrame(update);
    };
    update();
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [loadedImages, movementStyle, speed, size, thingCount, rotationSpeed]);
  useEffect4(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const resizeCanvas = () => {
      const width = canvas.clientWidth || window.innerWidth;
      const height = canvas.clientHeight || window.innerHeight;
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
      }
    };
    resizeCanvas();
    const observer = new ResizeObserver(resizeCanvas);
    observer.observe(canvas);
    return () => observer.disconnect();
  }, []);
  const handleCanvasTap = (e) => {
    if (!canvasRef.current) return;
    const rect = canvasRef.current.getBoundingClientRect();
    let clientX, clientY;
    if ("touches" in e && e.touches.length > 0) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else if ("clientX" in e) {
      clientX = e.clientX;
      clientY = e.clientY;
    } else {
      return;
    }
    const tapX = clientX - rect.left;
    const tapY = clientY - rect.top;
    handleTap(tapX, tapY);
  };
  if (assetsFailed) {
    return /* @__PURE__ */ React13.createElement(ArcadeAssetError, null);
  }
  return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(
    "div",
    {
      className: "h-full w-full bg-cover bg-center bg-no-repeat",
      style: backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}
    },
    /* @__PURE__ */ React13.createElement(
      "canvas",
      {
        ref: canvasRef,
        onMouseDown: handleCanvasTap,
        onTouchStart: handleCanvasTap,
        style: { touchAction: "none" },
        className: "h-full w-full"
      }
    )
  ), /* @__PURE__ */ React13.createElement(
    Instructions,
    {
      show: showInstructions && !!instructions,
      title: "Instructions",
      text: instructions
    }
  ), /* @__PURE__ */ React13.createElement(GameCompleteModal, { open: showEndScreen, image: completeImage }, /* @__PURE__ */ React13.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React13.createElement(CheckIcon3, { className: "text-mt-success h-6 w-6", "aria-hidden": "true" })), /* @__PURE__ */ React13.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React13.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle), /* @__PURE__ */ React13.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React13.createElement("p", { className: "text-mt-ink-muted text-sm" }, completeText))), nextPage && /* @__PURE__ */ React13.createElement("div", { className: "mt-5 sm:mt-6" }, /* @__PURE__ */ React13.createElement(
    "button",
    {
      type: "button",
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
      onClick: () => nextPage?.()
    },
    "Continue"
  ))));
};
var TapTheThing_default = TapTheThing;

// src/components/Pages/ImageSliceMatcher.tsx
import React14, { useState as useState5, useEffect as useEffect5, useCallback as useCallback2, useRef as useRef5 } from "react";
import { CheckIcon as CheckIcon4, XMarkIcon as XMarkIcon4 } from "@heroicons/react/20/solid";
var MAX_SECTION_WEIGHT = 1e6;
var MAX_SHUFFLE_ATTEMPTS = 1e3;
var generateShuffledIndexes = (sectionCount, imageCount, correctIndex) => {
  if (imageCount < 2) {
    return Array.from({ length: sectionCount }, () => correctIndex);
  }
  const indexes = [];
  const availableIndexes = Array.from(
    { length: imageCount },
    (_, i) => i
  ).filter((index) => index !== correctIndex);
  for (let i = availableIndexes.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [availableIndexes[i], availableIndexes[j]] = [
      availableIndexes[j],
      availableIndexes[i]
    ];
  }
  for (let i = 0; i < sectionCount; i++) {
    if (availableIndexes.length > 0) {
      indexes.push(availableIndexes.shift());
    } else {
      let randomIndex = correctIndex;
      let attempts = 0;
      while (randomIndex === correctIndex && attempts < MAX_SHUFFLE_ATTEMPTS) {
        randomIndex = Math.floor(Math.random() * imageCount);
        attempts += 1;
      }
      indexes.push(randomIndex);
    }
  }
  return indexes;
};
var Section = ({ images, currentIndex, onCycle, objectPositionY, disabled }) => {
  const [touchStartX, setTouchStartX] = useState5(null);
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };
  const handleTouchEnd = (e) => {
    if (touchStartX === null || disabled === true) return;
    const diff = e.changedTouches[0].clientX - touchStartX;
    if (diff > 50) {
      onCycle("left");
    } else if (diff < -50) {
      onCycle("right");
    }
    setTouchStartX(null);
  };
  return /* @__PURE__ */ React14.createElement(
    "div",
    {
      className: "relative h-full w-full overflow-hidden",
      onTouchStart: handleTouchStart,
      onTouchEnd: handleTouchEnd
    },
    /* @__PURE__ */ React14.createElement(
      "img",
      {
        src: images[currentIndex],
        alt: "Section image",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: `50% ${objectPositionY}%`
        }
      }
    )
  );
};
var ImageSliceMatcher = ({
  page,
  trailEvent,
  nextPage,
  prevPage
}) => {
  const {
    images,
    correctIndex,
    sections: sectionsRaw,
    aspectRatio = "2/3",
    backgroundImage,
    instructions,
    completeImage,
    completeTitle,
    completeText
  } = page;
  const sections = (() => {
    const positive = sectionsRaw.filter((value) => Number.isFinite(value) && value > 0).map((value) => Math.min(value, MAX_SECTION_WEIGHT));
    return positive.length > 0 ? positive : [1];
  })();
  const imageCount = images.length;
  const isMisconfigured = imageCount < 2;
  const clampedCorrectIndex = imageCount > 0 ? Math.min(Math.max(correctIndex, 0), imageCount - 1) : 0;
  const [sectionIndexes, setSectionIndexes] = useState5(
    () => generateShuffledIndexes(sections.length, imageCount, clampedCorrectIndex)
  );
  const [gameCompleted, setGameCompleted] = useState5(false);
  const [showEndScreen, setShowEndScreen] = useState5(false);
  const completedRef = useRef5(false);
  const total = sections.reduce((acc, val) => acc + val, 0);
  const sectionPercents = sections.map((val) => val / total * 100);
  const cumulativePercents = sectionPercents.reduce((acc, val, i) => {
    const prev = i === 0 ? 0 : acc[i - 1];
    acc.push(prev + val);
    return acc;
  }, []);
  const onComplete = useCallback2(() => {
    if (completedRef.current) return;
    completedRef.current = true;
    trailEvent?.("Image Slice Matcher: Completed");
    setGameCompleted(true);
    setTimeout(() => {
      setShowEndScreen(true);
    }, 1500);
  }, [trailEvent]);
  const objectPositionsY = sectionPercents.map((percent, i) => {
    const topOffsetPercent = i === 0 ? 0 : cumulativePercents[i - 1];
    const overflowPercent = 100 - percent;
    return overflowPercent > 0 ? topOffsetPercent * 100 / overflowPercent : 0;
  });
  const cycleIndex = (index, direction) => {
    if (direction === "left") return (index - 1 + imageCount) % imageCount;
    if (direction === "right") return (index + 1) % imageCount;
    return index;
  };
  const checkCorrectMatch = useCallback2(() => {
    if (isMisconfigured) return;
    if (sectionIndexes.every((idx) => idx === clampedCorrectIndex)) {
      onComplete();
    }
  }, [sectionIndexes, clampedCorrectIndex, onComplete, isMisconfigured]);
  useEffect5(() => {
    checkCorrectMatch();
  }, [sectionIndexes, checkCorrectMatch]);
  const handleCycle = (sectionIndex, direction) => {
    setSectionIndexes((prev) => {
      const newArr = [...prev];
      newArr[sectionIndex] = cycleIndex(newArr[sectionIndex], direction);
      return newArr;
    });
  };
  if (isMisconfigured) {
    return /* @__PURE__ */ React14.createElement(
      "div",
      {
        className: "flex h-full w-full flex-col items-center justify-center bg-cover bg-center bg-repeat p-4",
        style: {
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : void 0
        }
      },
      /* @__PURE__ */ React14.createElement("div", { className: "bg-mt-surface relative flex w-full max-w-lg flex-col items-center justify-center rounded-lg p-4 text-center shadow-xl" }, /* @__PURE__ */ React14.createElement("div", { className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100" }, /* @__PURE__ */ React14.createElement(XMarkIcon4, { className: "h-6 w-6 text-yellow-600", "aria-hidden": "true" })), /* @__PURE__ */ React14.createElement("div", { className: "mt-3 sm:mt-5" }, /* @__PURE__ */ React14.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, "This puzzle is misconfigured"), /* @__PURE__ */ React14.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React14.createElement("p", { className: "text-mt-ink-muted text-sm" }, "Image Slice Matcher needs at least two images to play. Please contact the trail creator."))), nextPage && /* @__PURE__ */ React14.createElement("div", { className: "mt-5 sm:mt-6" }, /* @__PURE__ */ React14.createElement(
        "button",
        {
          type: "button",
          className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
          onClick: () => nextPage?.()
        },
        "Skip"
      )))
    );
  }
  return /* @__PURE__ */ React14.createElement(
    "div",
    {
      className: "flex h-full w-full flex-col items-center justify-center bg-cover bg-center bg-repeat p-4",
      style: {
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : void 0
      }
    },
    /* @__PURE__ */ React14.createElement("div", { className: "bg-mt-surface relative flex w-full max-w-lg transform flex-col items-center justify-center overflow-hidden rounded-lg p-4 text-left shadow-xl sm:my-8" }, /* @__PURE__ */ React14.createElement("h2", { className: "mb-4 text-center text-lg font-bold" }, instructions), /* @__PURE__ */ React14.createElement(
      "div",
      {
        className: "relative mx-auto",
        style: {
          maxWidth: "300px",
          width: "100%",
          aspectRatio,
          position: "relative"
        }
      },
      /* @__PURE__ */ React14.createElement("div", { className: "absolute inset-0 flex flex-col" }, sections.map((_, i) => /* @__PURE__ */ React14.createElement(
        "div",
        {
          key: i,
          className: "relative flex items-center justify-center",
          style: { height: `${sectionPercents[i]}%`, width: "100%" }
        },
        !gameCompleted && /* @__PURE__ */ React14.createElement(
          "button",
          {
            onClick: () => handleCycle(i, "left"),
            className: "z-10 mx-1 rounded-sm bg-blue-500 px-2 py-1 text-white shadow-md",
            style: { position: "absolute", left: "-1rem" }
          },
          "\u25C0"
        ),
        /* @__PURE__ */ React14.createElement("div", { className: "h-full w-full overflow-hidden" }, /* @__PURE__ */ React14.createElement(
          Section,
          {
            images,
            currentIndex: sectionIndexes[i],
            onCycle: (dir) => handleCycle(i, dir),
            objectPositionY: objectPositionsY[i],
            disabled: gameCompleted
          }
        )),
        !gameCompleted && /* @__PURE__ */ React14.createElement(
          "button",
          {
            onClick: () => handleCycle(i, "right"),
            className: "z-10 mx-1 rounded-sm bg-blue-500 px-2 py-1 text-white shadow-md",
            style: { position: "absolute", right: "-1rem" }
          },
          "\u25B6"
        )
      )))
    )),
    /* @__PURE__ */ React14.createElement(GameCompleteModal, { open: showEndScreen, image: completeImage }, /* @__PURE__ */ React14.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React14.createElement(CheckIcon4, { className: "text-mt-success h-6 w-6", "aria-hidden": "true" })), /* @__PURE__ */ React14.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React14.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle), /* @__PURE__ */ React14.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React14.createElement("p", { className: "text-mt-ink-muted text-sm" }, completeText))), nextPage && /* @__PURE__ */ React14.createElement("div", { className: "mt-5 sm:mt-6" }, /* @__PURE__ */ React14.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        onClick: () => nextPage?.()
      },
      "Continue"
    )))
  );
};
var ImageSliceMatcher_default = ImageSliceMatcher;

// src/components/Pages/IFrame.tsx
import React15 from "react";
function safeIframeSrc(url) {
  if (!url) return "about:blank";
  try {
    if (new URL(url).protocol === "https:") return url;
  } catch {
  }
  return "about:blank";
}
function IFrame({ page }) {
  return /* @__PURE__ */ React15.createElement("div", { className: "bg-mt-surface" }, /* @__PURE__ */ React15.createElement(
    "iframe",
    {
      className: "h-[calc(100dvh-65px)] w-full",
      src: safeIframeSrc(page.iframeUrl),
      title: page.title ?? "embedded-content",
      sandbox: "allow-scripts allow-forms allow-popups allow-top-navigation-by-user-activation",
      referrerPolicy: "no-referrer",
      loading: "lazy"
    }
  ));
}
var IFrame_default = IFrame;

// src/utils/getPaginationData.ts
function getPaginationData(allowNavigation, currentIndex) {
  const navigableIndexes = allowNavigation.map((allow, index) => allow ? index : -1).filter((index) => index !== -1);
  const totalPages = navigableIndexes.length;
  const currentPagePosition = navigableIndexes.indexOf(currentIndex);
  const currentPage = currentPagePosition === -1 ? 1 : currentPagePosition + 1;
  const paginationRequired = totalPages > 1 && allowNavigation[currentIndex] === true;
  return {
    paginationRequired,
    totalPages,
    currentPage,
    navigableIndexes
  };
}

// src/components/Pages/Pagination.tsx
import React16 from "react";
import { ChevronLeftIcon as ChevronLeftIcon2, ChevronRightIcon as ChevronRightIcon2 } from "@heroicons/react/20/solid";
function Pagination({
  totalPages,
  currentPage,
  setPage
}) {
  return /* @__PURE__ */ React16.createElement("div", { className: "border-mt-border-soft bg-mt-surface relative flex shrink-0 grow-0 items-center justify-between border-t px-4 py-3 sm:px-6" }, /* @__PURE__ */ React16.createElement(
    "div",
    {
      "aria-label": "Pagination",
      className: "isolate mx-auto inline-flex -space-x-px rounded-md shadow-xs"
    },
    /* @__PURE__ */ React16.createElement(
      "button",
      {
        onClick: () => {
          if (currentPage > 1) {
            setPage(currentPage - 1);
          }
        },
        className: "text-mt-ink-faint ring-mt-border hover:bg-mt-surface-2 relative inline-flex items-center rounded-l-md px-2 py-2 ring-1 ring-inset focus:z-20 focus:outline-offset-0"
      },
      /* @__PURE__ */ React16.createElement("span", { className: "sr-only" }, "Previous"),
      /* @__PURE__ */ React16.createElement(ChevronLeftIcon2, { "aria-hidden": "true", className: "h-5 w-5" })
    ),
    Array.from(new Array(totalPages)).map((_, index) => /* @__PURE__ */ React16.createElement(
      "button",
      {
        "aria-current": currentPage === index + 1 ? "page" : void 0,
        onClick: () => setPage(index + 1),
        key: index,
        className: currentPage === index + 1 ? "mt-btn bg-mt-primary text-mt-on-primary focus-visible:outline-mt-primary relative z-10 inline-flex items-center px-4 py-2 text-sm font-semibold focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2" : "text-mt-ink ring-mt-border hover:bg-mt-surface-2 relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset focus:z-20 focus:outline-offset-0"
      },
      index + 1
    )),
    /* @__PURE__ */ React16.createElement(
      "button",
      {
        onClick: () => {
          if (currentPage < totalPages) {
            setPage(currentPage + 1);
          }
        },
        className: "text-mt-ink-faint ring-mt-border hover:bg-mt-surface-2 relative inline-flex items-center rounded-r-md px-2 py-2 ring-1 ring-inset focus:z-20 focus:outline-offset-0"
      },
      /* @__PURE__ */ React16.createElement("span", { className: "sr-only" }, "Next"),
      /* @__PURE__ */ React16.createElement(ChevronRightIcon2, { "aria-hidden": "true", className: "h-5 w-5" })
    )
  ));
}

// src/components/Pages/VisionMatch/VisionMatch.tsx
import React19, { useCallback as useCallback4, useMemo as useMemo2, useState as useState7 } from "react";

// src/components/Pages/VisionMatch/LiveVisionScanner.tsx
import React17, {
  useCallback as useCallback3,
  useEffect as useEffect6,
  useId,
  useMemo,
  useRef as useRef6,
  useState as useState6
} from "react";
import {
  ForwardIcon,
  InformationCircleIcon as InformationCircleIcon2,
  XMarkIcon as XMarkIcon5
} from "@heroicons/react/20/solid";

// src/components/Pages/VisionMatch/hiddenMessage.ts
var MIN_HOMOGRAPHY_INLIERS = 12;
var RANSAC_THRESHOLD_PX = 6;
var RANSAC_ITERATIONS = 200;
var solveLinear = (a, b) => {
  const n = b.length;
  const m = a.map((row, i) => [...row, b[i]]);
  for (let col = 0; col < n; col++) {
    let pivot = col;
    for (let r = col + 1; r < n; r++) {
      if (Math.abs(m[r][col]) > Math.abs(m[pivot][col])) pivot = r;
    }
    if (Math.abs(m[pivot][col]) < 1e-12) return null;
    if (pivot !== col) [m[pivot], m[col]] = [m[col], m[pivot]];
    for (let r = 0; r < n; r++) {
      if (r === col) continue;
      const f = m[r][col] / m[col][col];
      if (f === 0) continue;
      for (let c = col; c <= n; c++) m[r][c] -= f * m[col][c];
    }
  }
  return m.map((row, i) => row[n] / row[i]);
};
var normalise = (points) => {
  const n = points.length;
  let cx = 0;
  let cy = 0;
  for (const [x, y] of points) {
    cx += x;
    cy += y;
  }
  cx /= n;
  cy /= n;
  let mean = 0;
  for (const [x, y] of points) mean += Math.hypot(x - cx, y - cy);
  mean /= n;
  const s = mean > 1e-9 ? Math.SQRT2 / mean : 1;
  const t = [s, 0, -s * cx, 0, s, -s * cy, 0, 0, 1];
  const tInv = [1 / s, 0, cx, 0, 1 / s, cy, 0, 0, 1];
  return {
    t,
    tInv,
    normalised: points.map(([x, y]) => [(x - cx) * s, (y - cy) * s])
  };
};
var fitHomography = (from, to) => {
  const n = Math.min(from.length, to.length);
  if (n < 4) return null;
  const nf = normalise(from.slice(0, n));
  const nt = normalise(to.slice(0, n));
  const ata = Array.from({ length: 8 }, () => new Array(8).fill(0));
  const atb = new Array(8).fill(0);
  const rows = [];
  const rhs = [];
  for (let i = 0; i < n; i++) {
    const [x, y] = nf.normalised[i];
    const [u, v] = nt.normalised[i];
    rows.push([x, y, 1, 0, 0, 0, -u * x, -u * y]);
    rhs.push(u);
    rows.push([0, 0, 0, x, y, 1, -v * x, -v * y]);
    rhs.push(v);
  }
  for (let r = 0; r < rows.length; r++) {
    const row = rows[r];
    for (let i = 0; i < 8; i++) {
      atb[i] += row[i] * rhs[r];
      for (let j = 0; j < 8; j++) ata[i][j] += row[i] * row[j];
    }
  }
  const h = solveLinear(ata, atb);
  if (!h || h.some((v) => !Number.isFinite(v))) return null;
  const hn = [h[0], h[1], h[2], h[3], h[4], h[5], h[6], h[7], 1];
  const result = multiply3(nt.tInv, multiply3(hn, nf.t));
  const k = Math.abs(result[8]) < 1e-12 ? 1 : 1 / result[8];
  return result.map((v) => v * k);
};
var mulberry = (seed) => {
  let a = seed >>> 0;
  return () => {
    a = a + 1831565813 >>> 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
};
var ransacHomography = (from, to, options = {}) => {
  const n = Math.min(from.length, to.length);
  if (n < 4) return null;
  const threshold = options.threshold ?? RANSAC_THRESHOLD_PX;
  const iterations = options.iterations ?? RANSAC_ITERATIONS;
  const rand = mulberry(options.seed ?? 1);
  const thresholdSq = threshold * threshold;
  let bestMask = null;
  let bestCount = 0;
  const pick = () => {
    const idx = /* @__PURE__ */ new Set();
    while (idx.size < 4) idx.add(Math.floor(rand() * n));
    return [...idx];
  };
  for (let it = 0; it < iterations; it++) {
    const idx = pick();
    const h = fitHomography(
      idx.map((i) => from[i]),
      idx.map((i) => to[i])
    );
    if (!h) continue;
    const mask = new Array(n);
    let count = 0;
    for (let i = 0; i < n; i++) {
      const p = applyHomography(h, from[i][0], from[i][1]);
      const dx = p.x - to[i][0];
      const dy = p.y - to[i][1];
      const ok = dx * dx + dy * dy <= thresholdSq;
      mask[i] = ok;
      if (ok) count++;
    }
    if (count > bestCount) {
      bestCount = count;
      bestMask = mask;
      if (count >= n * 0.9) break;
    }
  }
  if (!bestMask || bestCount < 4) return null;
  const inFrom = [];
  const inTo = [];
  for (let i = 0; i < n; i++) {
    if (bestMask[i]) {
      inFrom.push(from[i]);
      inTo.push(to[i]);
    }
  }
  const refined = fitHomography(inFrom, inTo);
  return refined ? { homography: refined, inliers: bestCount } : null;
};
var matchFromCorrespondences = (c) => {
  const fit = ransacHomography(c.reference, c.frame);
  if (!fit) return null;
  const match = {
    homography: fit.homography,
    inliers: fit.inliers,
    referenceWidth: c.referenceWidth,
    referenceHeight: c.referenceHeight,
    frameWidth: c.frameWidth,
    frameHeight: c.frameHeight
  };
  return isUsableHomography(match) ? match : null;
};
var coverTransform2 = (frameWidth, frameHeight, viewWidth, viewHeight) => {
  if (frameWidth <= 0 || frameHeight <= 0 || viewWidth <= 0 || viewHeight <= 0) {
    return { scale: 1, offsetX: 0, offsetY: 0 };
  }
  const scale = Math.max(viewWidth / frameWidth, viewHeight / frameHeight);
  return {
    scale,
    offsetX: (viewWidth - frameWidth * scale) / 2,
    offsetY: (viewHeight - frameHeight * scale) / 2
  };
};
var multiply3 = (a, b) => {
  const out = new Array(9).fill(0);
  for (let r = 0; r < 3; r++) {
    for (let c = 0; c < 3; c++) {
      out[r * 3 + c] = a[r * 3] * b[c] + a[r * 3 + 1] * b[3 + c] + a[r * 3 + 2] * b[6 + c];
    }
  }
  return out;
};
var applyHomography = (h, x, y) => {
  const w = h[6] * x + h[7] * y + h[8];
  const d = Math.abs(w) < 1e-9 ? 1e-9 : w;
  return {
    x: (h[0] * x + h[1] * y + h[2]) / d,
    y: (h[3] * x + h[4] * y + h[5]) / d
  };
};
var homographyToMatrix3d = (match, elementWidth, elementHeight, viewWidth, viewHeight) => {
  const cover = coverTransform2(
    match.frameWidth,
    match.frameHeight,
    viewWidth,
    viewHeight
  );
  const sx = match.referenceWidth / Math.max(elementWidth, 1e-6);
  const sy = match.referenceHeight / Math.max(elementHeight, 1e-6);
  const elementToReference = [sx, 0, 0, 0, sy, 0, 0, 0, 1];
  const frameToView = [
    cover.scale,
    0,
    cover.offsetX,
    0,
    cover.scale,
    cover.offsetY,
    0,
    0,
    1
  ];
  const h = multiply3(frameToView, multiply3(match.homography, elementToReference));
  const k = Math.abs(h[8]) < 1e-9 ? 1 : 1 / h[8];
  const m = h.map((v) => v * k);
  const values = [
    m[0],
    m[3],
    0,
    m[6],
    m[1],
    m[4],
    0,
    m[7],
    0,
    0,
    1,
    0,
    m[2],
    m[5],
    0,
    m[8]
  ];
  return `matrix3d(${values.map((v) => formatNumber(v)).join(",")})`;
};
var formatNumber = (v) => {
  if (!Number.isFinite(v)) return "0";
  const text = v.toFixed(6).replace(/\.?0+$/, "");
  return text === "" || text === "-0" || text === "-" ? "0" : text;
};
var isUsableHomography = (match) => {
  if (match.inliers < MIN_HOMOGRAPHY_INLIERS) return false;
  if (!match.homography.every((v) => Number.isFinite(v))) return false;
  const w = match.referenceWidth;
  const h = match.referenceHeight;
  const corners = [
    applyHomography(match.homography, 0, 0),
    applyHomography(match.homography, w, 0),
    applyHomography(match.homography, w, h),
    applyHomography(match.homography, 0, h)
  ];
  let area = 0;
  for (let i = 0; i < 4; i++) {
    const a = corners[i];
    const b = corners[(i + 1) % 4];
    area += a.x * b.y - b.x * a.y;
  }
  area /= 2;
  const frameArea = match.frameWidth * match.frameHeight;
  if (!(area > frameArea * 5e-3) || area > frameArea * 4) return false;
  for (let i = 0; i < 4; i++) {
    const a = corners[i];
    const b = corners[(i + 1) % 4];
    const c = corners[(i + 2) % 4];
    const cross2 = (b.x - a.x) * (c.y - b.y) - (b.y - a.y) * (c.x - b.x);
    if (cross2 <= 0) return false;
  }
  return true;
};
var blendHomography = (from, to, k) => from.map((v, i) => v + (to[i] - v) * k);
var resolveRevealStyle = (style, theme) => {
  if (style && style !== "auto") return style;
  switch (theme) {
    case "scifi":
      return "hologram";
    case "spy":
      return "spy";
    case "steampunk":
      return "forensic";
    case "enchanted":
    case "pumpkin":
    case "classic":
    default:
      return "magical";
  }
};
var REVEAL_COPY = {
  magical: {
    resolving: "The magic is stirring\u2026",
    revealed: "A hidden message appears!",
    continueLabel: "I have read the message"
  },
  hologram: {
    resolving: "DECRYPTING HOLOGRAM\u2026",
    revealed: "HOLOGRAM STABLE",
    continueLabel: "Close hologram"
  },
  forensic: {
    resolving: "UV LAMP\u2026 ENHANCING\u2026",
    revealed: "LATENT MESSAGE RECOVERED",
    continueLabel: "Log evidence"
  },
  spy: {
    resolving: "DEVELOPING INVISIBLE INK\u2026",
    revealed: "MESSAGE DECODED. BURN AFTER READING.",
    continueLabel: "Message received"
  }
};
var REVEAL_SETTLE_MS = {
  magical: 1800,
  hologram: 1600,
  forensic: 2200,
  spy: 2400
};

// src/components/Pages/VisionMatch/LiveVisionScanner.tsx
var SCAN_INTERVAL_MS = 700;
var TRACK_INTERVAL_MS = 320;
var FRAME_MAX_WIDTH = 640;
var CAMERA_CONSTRAINTS = {
  facingMode: { ideal: "environment" },
  width: { ideal: 1280 },
  height: { ideal: 720 }
};
var STATUS_INTERVAL_MS = 1400;
var MATCH_HOLD_MS = 900;
var TRACK_BLEND = 0.55;
function LiveVisionScanner({
  referenceImages,
  matchThreshold,
  compareImages,
  theme,
  hint,
  showTargetPreview = true,
  reveal,
  onMatch,
  onUnavailable,
  onHelp,
  onSkip
}) {
  const { videoRef, videoReady, cameraError } = useCameraVideo(
    true,
    CAMERA_CONSTRAINTS
  );
  const canvasRef = useRef6(null);
  const overlayHostRef = useRef6(null);
  const [bestScore, setBestScore] = useState6(0);
  const [lockedScore, setLockedScore] = useState6(null);
  const [statusIndex, setStatusIndex] = useState6(0);
  const [targetExpanded, setTargetExpanded] = useState6(false);
  const matchedRef = useRef6(false);
  const matchedReferenceRef = useRef6(null);
  const instanceId = useId();
  const tickRef = useRef6(0);
  const homographyRef = useRef6(null);
  const [overlay, setOverlay] = useState6(null);
  const [revealSettled, setRevealSettled] = useState6(false);
  const spec = useMemo(() => resolveScannerTheme(theme), [theme]);
  const locked = lockedScore !== null;
  const revealing = locked && !!reveal;
  useEffect6(() => {
    if (cameraError) onUnavailable();
  }, [cameraError, onUnavailable]);
  const captureFrame = useCallback3(() => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas || video.videoWidth === 0) return null;
    const scale = Math.min(1, FRAME_MAX_WIDTH / video.videoWidth);
    const w = Math.round(video.videoWidth * scale);
    const h = Math.round(video.videoHeight * scale);
    if (canvas.width !== w) canvas.width = w;
    if (canvas.height !== h) canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    ctx.drawImage(video, 0, 0, w, h);
    return canvas;
  }, [videoRef]);
  const placeOverlay = useCallback3((next) => {
    const previous = homographyRef.current;
    let current = next;
    if (next && previous) {
      current = {
        ...next,
        homography: blendHomography(
          previous.homography,
          next.homography,
          TRACK_BLEND
        )
      };
    } else if (!next) {
      current = previous;
    }
    if (!current) return;
    homographyRef.current = current;
    const host = overlayHostRef.current;
    const viewWidth = host?.clientWidth ?? 0;
    const viewHeight = host?.clientHeight ?? 0;
    if (viewWidth <= 0 || viewHeight <= 0) return;
    const width = current.referenceWidth;
    const height = current.referenceHeight;
    setOverlay({
      width,
      height,
      transform: homographyToMatrix3d(
        current,
        width,
        height,
        viewWidth,
        viewHeight
      )
    });
  }, []);
  useEffect6(() => {
    if (!videoReady) return;
    let cancelled = false;
    let timer;
    const nextFrameKey = () => `vm${instanceId}-${tickRef.current += 1}`;
    const track = async () => {
      if (cancelled) return;
      const frame = captureFrame();
      const reference = matchedReferenceRef.current;
      if (frame && reference) {
        try {
          const result = await compareImages(frame, reference, {
            ...matchThreshold ? { matchThreshold } : {},
            wantCorrespondences: true,
            frameKey: nextFrameKey()
          });
          if (!cancelled) placeOverlay(homographyFromResult(result));
        } catch (error) {
          console.error("[VisionMatch] live track error", error);
        }
      }
      if (!cancelled) timer = setTimeout(track, TRACK_INTERVAL_MS);
    };
    const scan = async () => {
      if (cancelled) return;
      if (matchedRef.current) {
        if (reveal) void track();
        return;
      }
      const frame = captureFrame();
      if (frame) {
        try {
          let best = 0;
          const frameKey = nextFrameKey();
          for (const candidate of referenceImages) {
            const result = await compareImages(frame, candidate, {
              ...matchThreshold ? { matchThreshold } : {},
              ...reveal ? { wantCorrespondences: true } : {},
              frameKey
            });
            if (result.score > best) best = result.score;
            if (result.match) {
              matchedRef.current = true;
              matchedReferenceRef.current = candidate;
              if (!cancelled) {
                setBestScore(result.score);
                setLockedScore(result.score);
                if (reveal) {
                  placeOverlay(homographyFromResult(result));
                  timer = setTimeout(track, TRACK_INTERVAL_MS);
                }
              }
              return;
            }
          }
          if (!cancelled) setBestScore((prev) => Math.max(prev, best));
        } catch (error) {
          console.error("[VisionMatch] live compare error", error);
        }
      }
      if (!cancelled && !matchedRef.current) {
        timer = setTimeout(scan, SCAN_INTERVAL_MS);
      }
    };
    timer = setTimeout(scan, SCAN_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [
    videoReady,
    referenceImages,
    matchThreshold,
    compareImages,
    captureFrame,
    placeOverlay,
    reveal,
    instanceId
  ]);
  useEffect6(() => {
    if (lockedScore === null || reveal) return;
    const t = setTimeout(() => onMatch(lockedScore), MATCH_HOLD_MS);
    return () => clearTimeout(t);
  }, [lockedScore, onMatch, reveal]);
  useEffect6(() => {
    if (!revealing || !reveal) return;
    const t = setTimeout(
      () => setRevealSettled(true),
      REVEAL_SETTLE_MS[reveal.style]
    );
    return () => clearTimeout(t);
  }, [revealing, reveal]);
  useEffect6(() => {
    if (!videoReady || locked) return;
    const t = setInterval(
      () => setStatusIndex((i) => (i + 1) % spec.scanning.length),
      STATUS_INTERVAL_MS
    );
    return () => clearInterval(t);
  }, [videoReady, locked, spec]);
  const progress = locked ? 100 : matchThreshold ? Math.min(100, Math.round(bestScore / matchThreshold * 100)) : 0;
  const revealCopy = reveal ? REVEAL_COPY[reveal.style] : null;
  const status = revealing && revealCopy ? revealSettled ? revealCopy.revealed : revealCopy.resolving : locked ? spec.locked : spec.scanning[statusIndex] ?? spec.scanning[0];
  const showTargetCard = showTargetPreview && !revealing && referenceImages.length > 0;
  const targetImages = referenceImages.slice(0, 3);
  return /* @__PURE__ */ React17.createElement(
    ScannerFrame,
    {
      spec,
      className: "vm-scanner--fill",
      locked: locked && !revealing,
      status,
      showStatus: videoReady,
      hint: revealing && revealCopy ? revealCopy.revealed : hint?.trim() || spec.hint,
      progress,
      readout: [
        `SIG ${String(progress).padStart(3, "0")}%`,
        `REF ${String(referenceImages.length).padStart(2, "0")}`,
        revealing ? "PROJ" : locked ? "LOCK" : "LIVE"
      ],
      before: /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(
        "video",
        {
          ref: videoRef,
          playsInline: true,
          muted: true,
          autoPlay: true,
          className: "vm-video"
        }
      ), /* @__PURE__ */ React17.createElement("canvas", { ref: canvasRef, className: "hidden" })),
      after: /* @__PURE__ */ React17.createElement(React17.Fragment, null, showTargetCard && /* @__PURE__ */ React17.createElement(
        "div",
        {
          className: classes(
            "vm-target",
            scannerThemeClass(spec),
            targetExpanded ? "vm-target--expanded" : "vm-target--mini"
          )
        },
        /* @__PURE__ */ React17.createElement(
          "button",
          {
            type: "button",
            className: "vm-target-toggle",
            onClick: () => setTargetExpanded((open) => !open),
            "aria-expanded": targetExpanded,
            "aria-label": targetExpanded ? "Hide the reference image" : `${spec.targetLabel}: show the reference image`
          },
          /* @__PURE__ */ React17.createElement("span", { className: "vm-target-label" }, spec.targetLabel),
          targetExpanded && /* @__PURE__ */ React17.createElement(XMarkIcon5, { className: "vm-target-close", "aria-hidden": "true" })
        ),
        /* @__PURE__ */ React17.createElement("div", { className: "vm-target-images" }, (targetExpanded ? targetImages : targetImages.slice(0, 1)).map(
          (src, i) => /* @__PURE__ */ React17.createElement(
            "img",
            {
              key: `${src}-${i}`,
              src,
              alt: targetImages.length > 1 ? `Target ${i + 1} of ${targetImages.length}` : "The object to find"
            }
          )
        ))
      ), (onHelp || onSkip || revealing && revealSettled && revealCopy) && /* @__PURE__ */ React17.createElement("div", { className: "vm-controls" }, onHelp && /* @__PURE__ */ React17.createElement("button", { type: "button", className: "vm-control", onClick: onHelp }, /* @__PURE__ */ React17.createElement(InformationCircleIcon2, { "aria-hidden": "true" }), /* @__PURE__ */ React17.createElement("span", null, "How to scan")), revealing && revealSettled && revealCopy && /* @__PURE__ */ React17.createElement(
        "button",
        {
          type: "button",
          className: "vm-control vm-control--primary",
          onClick: () => onMatch(lockedScore ?? 0)
        },
        /* @__PURE__ */ React17.createElement("span", null, revealCopy.continueLabel)
      ), onSkip && /* @__PURE__ */ React17.createElement("button", { type: "button", className: "vm-control", onClick: onSkip }, /* @__PURE__ */ React17.createElement(ForwardIcon, { "aria-hidden": "true" }), /* @__PURE__ */ React17.createElement("span", null, "Skip"))))
    },
    !videoReady && !cameraError && /* @__PURE__ */ React17.createElement("div", { className: "vm-layer vm-starting" }, /* @__PURE__ */ React17.createElement("div", { className: "flex flex-col items-center gap-3" }, /* @__PURE__ */ React17.createElement("div", { className: "h-8 w-8 animate-spin rounded-full border-2 border-white/30 border-t-white" }), /* @__PURE__ */ React17.createElement("span", { className: "text-sm font-medium" }, "Starting camera\u2026"))),
    /* @__PURE__ */ React17.createElement("div", { ref: overlayHostRef, className: "vm-layer", "aria-hidden": !revealing }, revealing && reveal && /* @__PURE__ */ React17.createElement(
      "div",
      {
        className: classes(
          "vm-reveal",
          `vm-reveal--${reveal.style}`,
          overlay ? "vm-reveal--tracked" : "vm-reveal--centred",
          revealSettled && "vm-reveal--settled"
        ),
        style: overlay ? {
          width: overlay.width,
          height: overlay.height,
          transform: overlay.transform
        } : void 0
      },
      /* @__PURE__ */ React17.createElement("div", { className: "vm-reveal-plate" }, /* @__PURE__ */ React17.createElement("div", { className: "vm-reveal-effect", "aria-hidden": "true" }), reveal.image && /* @__PURE__ */ React17.createElement("img", { className: "vm-reveal-image", src: reveal.image, alt: "" }), reveal.text && /* @__PURE__ */ React17.createElement("div", { className: "vm-reveal-text" }, reveal.text), reveal.style === "spy" && /* @__PURE__ */ React17.createElement("div", { className: "vm-reveal-stamp", "aria-hidden": "true" }, "CLASSIFIED"))
    )),
    reveal && /* @__PURE__ */ React17.createElement("p", { className: "sr-only", role: "status", "aria-live": "polite" }, revealing ? reveal.text ? `Hidden message: ${reveal.text}` : "A hidden image appears on the sign." : "")
  );
}
function homographyFromResult(result) {
  const c = result.correspondences;
  if (!c) return null;
  if (result.homography && result.homography.length === 9) {
    const match = {
      homography: result.homography,
      inliers: c.reference.length,
      referenceWidth: c.referenceWidth,
      referenceHeight: c.referenceHeight,
      frameWidth: c.frameWidth,
      frameHeight: c.frameHeight
    };
    if (isUsableHomography(match)) return match;
  }
  return matchFromCorrespondences(c);
}

// src/components/Pages/VisionMatch/VisionMatch.tsx
import {
  CameraIcon,
  CheckIcon as CheckIcon6,
  InformationCircleIcon as InformationCircleIcon3,
  XMarkIcon as XMarkIcon7
} from "@heroicons/react/20/solid";

// src/components/Pages/VisionMatch/VisionMatchInstructions.tsx
import React18 from "react";
import { CheckIcon as CheckIcon5, XMarkIcon as XMarkIcon6 } from "@heroicons/react/20/solid";
var Signpost = ({ className, style }) => /* @__PURE__ */ React18.createElement(
  "svg",
  {
    id: `signpost-${Math.random().toString(36).substr(2, 9)}`,
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 1024 1024",
    className,
    style
  },
  /* @__PURE__ */ React18.createElement("rect", { fill: "#bbfcff", x: "0", y: "0", width: "1024", height: "1024" }),
  /* @__PURE__ */ React18.createElement("rect", { fill: "#90ff80", x: "0", y: "531", width: "1024", height: "493" }),
  /* @__PURE__ */ React18.createElement("rect", { fill: "#4c4c4c;", x: "433.8", y: "416", width: "12", height: "158" }),
  /* @__PURE__ */ React18.createElement("rect", { fill: "#4c4c4c;", x: "578.2", y: "416", width: "12", height: "158" }),
  /* @__PURE__ */ React18.createElement(
    "rect",
    {
      fill: "#1e1e1e",
      x: "402",
      y: "419.9",
      width: "220",
      height: "92",
      rx: "18",
      ry: "18"
    }
  ),
  /* @__PURE__ */ React18.createElement(
    "rect",
    {
      fill: "#fff",
      x: "407",
      y: "424.9",
      width: "210",
      height: "82",
      rx: "12",
      ry: "12"
    }
  )
);
var Phone = ({ children, style }) => /* @__PURE__ */ React18.createElement(
  "div",
  {
    className: "flex h-32 w-16 flex-col justify-between overflow-hidden rounded-2xl border-4 border-black",
    style
  },
  /* @__PURE__ */ React18.createElement("div", { className: "h-5/6 overflow-hidden perspective-dramatic" }, children),
  /* @__PURE__ */ React18.createElement("div", { className: "bg-mt-surface flex grow items-center justify-center border-t border-black" }, /* @__PURE__ */ React18.createElement("div", { className: "size-3 rounded-full border border-black" }))
);
function VisionMatchInstructions() {
  return /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement("div", { className: "border-mt-border-soft bg-mt-surface border-b px-4 pb-5 sm:px-6" }, /* @__PURE__ */ React18.createElement("h3", { className: "text-mt-ink text-base font-semibold" }, "For best results:")), /* @__PURE__ */ React18.createElement("div", { className: "flex flex-col gap-4 px-8 pt-8" }, /* @__PURE__ */ React18.createElement("div", { className: "mx-auto flex max-w-42 items-center justify-between" }, /* @__PURE__ */ React18.createElement(Phone, null, /* @__PURE__ */ React18.createElement(
    Signpost,
    {
      className: "aspect-square h-full",
      style: { transform: "translateX(-21%)" }
    }
  )), /* @__PURE__ */ React18.createElement(XMarkIcon6, { className: "text-mt-danger size-16" })), /* @__PURE__ */ React18.createElement("div", { className: "mx-auto flex max-w-42 items-center justify-between" }, /* @__PURE__ */ React18.createElement(Phone, null, /* @__PURE__ */ React18.createElement(
    Signpost,
    {
      className: "aspect-square h-full",
      style: {
        transform: "translateX(-11%) rotateY(59deg) scale(4) rotateZ(341deg)"
      }
    }
  )), /* @__PURE__ */ React18.createElement(XMarkIcon6, { className: "text-mt-danger size-16" })), /* @__PURE__ */ React18.createElement("div", { className: "mx-auto flex max-w-42 items-center justify-between" }, /* @__PURE__ */ React18.createElement(Phone, null, /* @__PURE__ */ React18.createElement(
    Signpost,
    {
      className: "aspect-square h-full",
      style: { transform: "translateX(-10%) scale(3) translateY(2%)" }
    }
  )), /* @__PURE__ */ React18.createElement(XMarkIcon6, { className: "text-mt-danger size-16" })), /* @__PURE__ */ React18.createElement("div", { className: "mx-auto flex max-w-42 items-center justify-between" }, /* @__PURE__ */ React18.createElement(Phone, null, /* @__PURE__ */ React18.createElement(
    Signpost,
    {
      className: "aspect-square h-full",
      style: {
        transform: "translateX(-22%) scale(2.5) translateY(2%)"
      }
    }
  )), /* @__PURE__ */ React18.createElement(CheckIcon5, { className: "text-mt-success size-16" })), /* @__PURE__ */ React18.createElement(
    "div",
    {
      className: "mx-auto flex items-center justify-between",
      style: { transform: "translateY(-1rem)" }
    },
    /* @__PURE__ */ React18.createElement(Phone, { style: { transform: "rotate(-90deg) scale(0.8)" } }, /* @__PURE__ */ React18.createElement(
      Signpost,
      {
        className: "aspect-square h-full",
        style: {
          transform: "translateX(-40%) translateY(-7%) scale(4.2) translateY(2%) rotate(90deg)"
        }
      }
    )),
    /* @__PURE__ */ React18.createElement("span", { className: "block w-5 grow" }),
    /* @__PURE__ */ React18.createElement(CheckIcon5, { className: "text-mt-success -mr-6 size-16" }),
    /* @__PURE__ */ React18.createElement(CheckIcon5, { className: "text-mt-success size-16" })
  )));
}

// src/components/Pages/VisionMatch/VisionMatch.tsx
function clampScorePercent(score, matchThreshold) {
  if (!Number.isFinite(matchThreshold) || matchThreshold <= 0) {
    return score > 0 ? 100 : 0;
  }
  return Math.min(100, Math.round(score / matchThreshold * 100));
}
function formatComparisonScore(comparisonScore, matchThreshold) {
  return comparisonScore.map((score) => `${clampScorePercent(score, matchThreshold)}%`).join(" - ");
}
function VisionMatch({
  page,
  trailEvent,
  compareImages,
  nextPage
}) {
  const {
    backgroundImage,
    visionMatchImages,
    matchThreshold = 15,
    scannerTheme,
    scannerHint,
    showTargetPreview,
    hiddenText,
    hiddenImage,
    revealStyle,
    instructions,
    completeImage,
    completeTitle,
    completeText,
    instructionsImage,
    wrongAnswerImage,
    wrongAnswerText
  } = page;
  const [step, setStep] = useState7("INSTRUCTIONS");
  const [comparisonScore, setComparisonScore] = useState7([]);
  const [skipDialogOpen, setSkipDialogOpen] = useState7(false);
  const [instructionsOpen, setInstructionsOpen] = useState7(false);
  const reveal = useMemo2(() => {
    const text = hiddenText?.trim();
    const image = hiddenImage?.trim();
    if (!text && !image) return void 0;
    return {
      text: text || void 0,
      image: image || void 0,
      style: resolveRevealStyle(revealStyle, scannerTheme)
    };
  }, [hiddenText, hiddenImage, revealStyle, scannerTheme]);
  const handleMatch = useCallback4(
    (score) => {
      setComparisonScore([score]);
      trailEvent("visionMatchSuccess");
      setStep("COMPLETE");
    },
    [trailEvent]
  );
  const handleUnavailable = useCallback4(() => {
    trailEvent("visionMatchError");
    setStep("UNAVAILABLE");
  }, [trailEvent]);
  return /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement(
    "div",
    {
      className: step === "SCANNING" ? "relative h-full w-full overflow-hidden bg-black" : "flex h-full w-full flex-col items-center justify-center overflow-auto bg-cover bg-center bg-no-repeat p-4",
      style: backgroundImage && step !== "SCANNING" ? { backgroundImage: `url(${backgroundImage})` } : {}
    },
    step === "INSTRUCTIONS" && /* @__PURE__ */ React19.createElement(
      QuestionCard,
      {
        image: instructionsImage,
        insetImage: visionMatchImages[0]
      },
      instructions && /* @__PURE__ */ React19.createElement(HTMLBlock_default, { html: instructions }),
      /* @__PURE__ */ React19.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React19.createElement(
        "button",
        {
          type: "button",
          onClick: () => setStep("SCANNING"),
          className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2.5 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2"
        },
        /* @__PURE__ */ React19.createElement(CameraIcon, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
        "Start Scanning"
      ), /* @__PURE__ */ React19.createElement(
        "button",
        {
          className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2",
          onClick: () => setInstructionsOpen(true)
        },
        /* @__PURE__ */ React19.createElement(
          InformationCircleIcon3,
          {
            "aria-hidden": "true",
            className: "mr-2 h-6 w-6"
          }
        ),
        "Instructions"
      ), /* @__PURE__ */ React19.createElement(
        "button",
        {
          type: "button",
          onClick: () => {
            setSkipDialogOpen(true);
          },
          className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
        },
        "Skip Scanning"
      ))
    ),
    step === "SCANNING" && /* @__PURE__ */ React19.createElement(
      LiveVisionScanner,
      {
        referenceImages: visionMatchImages,
        matchThreshold,
        compareImages,
        theme: scannerTheme,
        hint: scannerHint,
        showTargetPreview: showTargetPreview ?? true,
        reveal,
        onMatch: handleMatch,
        onUnavailable: handleUnavailable,
        onHelp: () => setInstructionsOpen(true),
        onSkip: () => setSkipDialogOpen(true)
      }
    ),
    step === "UNAVAILABLE" && /* @__PURE__ */ React19.createElement(QuestionCard, { image: wrongAnswerImage }, /* @__PURE__ */ React19.createElement("div", { className: "bg-mt-danger-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React19.createElement(
      XMarkIcon7,
      {
        className: "text-mt-danger h-6 w-6",
        "aria-hidden": "true"
      }
    )), /* @__PURE__ */ React19.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React19.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, "Camera unavailable"), /* @__PURE__ */ React19.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React19.createElement("p", { className: "text-mt-ink-muted text-sm" }, "We couldn't access your camera. Check your browser's camera permission and try again, or skip this step."), wrongAnswerText && /* @__PURE__ */ React19.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React19.createElement(HTMLBlock_default, { html: wrongAnswerText })))), /* @__PURE__ */ React19.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React19.createElement(
      "button",
      {
        onClick: () => {
          setStep("INSTRUCTIONS");
          setComparisonScore([]);
        },
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
      },
      "Try Again"
    ), /* @__PURE__ */ React19.createElement(
      "button",
      {
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2",
        onClick: () => setInstructionsOpen(true)
      },
      /* @__PURE__ */ React19.createElement(
        InformationCircleIcon3,
        {
          "aria-hidden": "true",
          className: "mr-2 h-6 w-6"
        }
      ),
      "Instructions"
    ), /* @__PURE__ */ React19.createElement(
      "button",
      {
        type: "button",
        onClick: () => {
          setSkipDialogOpen(true);
        },
        className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
      },
      "Skip Scanning"
    ))),
    step === "COMPLETE" && /* @__PURE__ */ React19.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React19.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React19.createElement(
      CheckIcon6,
      {
        className: "text-mt-success h-6 w-6",
        "aria-hidden": "true"
      }
    )), /* @__PURE__ */ React19.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React19.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle), completeText && /* @__PURE__ */ React19.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React19.createElement(
      HTMLBlock_default,
      {
        className: "text-mt-ink-muted text-sm",
        html: completeText
      }
    ), /* @__PURE__ */ React19.createElement("p", { className: "text-mt-ink-faint mt-2 text-xs" }, "Match score:", " ", formatComparisonScore(comparisonScore, matchThreshold))), /* @__PURE__ */ React19.createElement(
      "button",
      {
        onClick: () => {
          nextPage && nextPage();
        },
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
      },
      "Continue"
    )))
  ), /* @__PURE__ */ React19.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip Scanning",
      text: "Are you sure you want to skip this scan?",
      onSkip: () => {
        setSkipDialogOpen(false);
        trailEvent("visionMatchSkipped");
        nextPage && nextPage();
      }
    }
  ), /* @__PURE__ */ React19.createElement(
    PageModal,
    {
      open: instructionsOpen,
      onBackdropClick: () => setInstructionsOpen(false),
      ariaLabel: "How to scan",
      align: "end"
    },
    /* @__PURE__ */ React19.createElement("div", { className: "bg-mt-surface relative transform overflow-hidden rounded-lg px-4 pt-5 pb-4 text-left shadow-xl sm:my-8 sm:w-full sm:max-w-lg sm:p-6" }, /* @__PURE__ */ React19.createElement("div", { className: "absolute top-0 right-0 pt-5 pr-5" }, /* @__PURE__ */ React19.createElement(
      "button",
      {
        type: "button",
        onClick: () => setInstructionsOpen(false),
        className: "bg-mt-surface text-mt-ink-faint hover:text-mt-ink-muted focus:ring-mt-primary rounded-md focus:ring-2 focus:ring-offset-2 focus:outline-none"
      },
      /* @__PURE__ */ React19.createElement("span", { className: "sr-only" }, "Close"),
      /* @__PURE__ */ React19.createElement(XMarkIcon7, { "aria-hidden": "true", className: "size-6" })
    )), /* @__PURE__ */ React19.createElement(VisionMatchInstructions, null), /* @__PURE__ */ React19.createElement("div", { className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" }, /* @__PURE__ */ React19.createElement(
      "button",
      {
        type: "button",
        onClick: () => {
          setInstructionsOpen(false);
        },
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs sm:ml-3 sm:w-auto"
      },
      "Continue"
    )))
  ));
}

// src/components/Pages/ObjectScan/ObjectScan.tsx
import React21, { Suspense, useCallback as useCallback5, useEffect as useEffect7, useState as useState8 } from "react";
import {
  objectScanTargetInfo,
  OBJECT_SCAN_DEFAULT_CONFIDENCE,
  OBJECT_SCAN_DEFAULT_HOLD_SECONDS
} from "magical-trails";
import {
  CameraIcon as CameraIcon2,
  CheckIcon as CheckIcon7,
  InformationCircleIcon as InformationCircleIcon4,
  XMarkIcon as XMarkIcon8
} from "@heroicons/react/20/solid";

// src/components/Pages/ObjectScan/ObjectScanInstructions.tsx
import React20 from "react";
function ObjectScanInstructions({
  target
}) {
  const thing = target.label.toLowerCase();
  return /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement("div", { className: "border-mt-border-soft bg-mt-surface border-b px-4 pb-5 sm:px-6" }, /* @__PURE__ */ React20.createElement("h3", { className: "text-mt-ink text-base font-semibold" }, /* @__PURE__ */ React20.createElement("span", { "aria-hidden": "true" }, target.emoji, " "), "Find ", target.article, " ", thing)), /* @__PURE__ */ React20.createElement("ul", { className: "text-mt-ink-muted flex flex-col gap-3 px-4 pt-5 text-sm sm:px-6" }, /* @__PURE__ */ React20.createElement("li", { className: "flex gap-3" }, /* @__PURE__ */ React20.createElement("span", { className: "text-xl", "aria-hidden": "true" }, "\u{1F5BC}\uFE0F"), /* @__PURE__ */ React20.createElement("span", null, "Get the whole ", thing, " in the picture, not just a corner of it.")), /* @__PURE__ */ React20.createElement("li", { className: "flex gap-3" }, /* @__PURE__ */ React20.createElement("span", { className: "text-xl", "aria-hidden": "true" }, "\u{1F4CF}"), /* @__PURE__ */ React20.createElement("span", null, "Stand a few steps back so it fills a good part of the screen.")), /* @__PURE__ */ React20.createElement("li", { className: "flex gap-3" }, /* @__PURE__ */ React20.createElement("span", { className: "text-xl", "aria-hidden": "true" }, "\u270B"), /* @__PURE__ */ React20.createElement("span", null, "Hold still once the box appears. The bar fills while the scanner keeps it in view.")), /* @__PURE__ */ React20.createElement("li", { className: "flex gap-3" }, /* @__PURE__ */ React20.createElement("span", { className: "text-xl", "aria-hidden": "true" }, "\u2600\uFE0F"), /* @__PURE__ */ React20.createElement("span", null, "Good light helps. Try another angle if nothing happens."))));
}

// src/components/Pages/ObjectScan/ObjectScan.tsx
var viewChunk = null;
var loadObjectScanView = () => {
  if (!viewChunk) {
    viewChunk = import("./ObjectScanView-PBIB4HNM.mjs").catch((error) => {
      viewChunk = null;
      throw error;
    });
  }
  return viewChunk;
};
var ObjectScanView = React21.lazy(loadObjectScanView);
var warmUpObjectScanView = () => {
  void loadObjectScanView().catch(() => void 0);
};
var resolveObjectScanTarget = (id) => objectScanTargetInfo(id) ?? {
  id: id ?? "",
  label: id?.trim() || "the thing",
  emoji: "\u{1F50E}",
  article: "a",
  where: ""
};
function ObjectScan({ page, trailEvent, nextPage }) {
  const {
    backgroundImage,
    targetObject,
    confidence = OBJECT_SCAN_DEFAULT_CONFIDENCE,
    holdSeconds = OBJECT_SCAN_DEFAULT_HOLD_SECONDS,
    scannerTheme,
    scannerHint,
    showTargetPreview,
    instructions,
    completeImage,
    completeTitle,
    completeText,
    instructionsImage,
    wrongAnswerImage,
    wrongAnswerText
  } = page;
  const target = resolveObjectScanTarget(targetObject);
  const [step, setStep] = useState8("INSTRUCTIONS");
  const [score, setScore] = useState8(null);
  const [skipDialogOpen, setSkipDialogOpen] = useState8(false);
  const [instructionsOpen, setInstructionsOpen] = useState8(false);
  useEffect7(() => {
    if (step === "INSTRUCTIONS") warmUpObjectScanView();
  }, [step]);
  const handleFound = useCallback5(() => {
    trailEvent("Object Scan: Found");
  }, [trailEvent]);
  const handleMatch = useCallback5(
    (matched) => {
      setScore(matched);
      trailEvent("Object Scan: Completed");
      setStep("COMPLETE");
    },
    [trailEvent]
  );
  const handleUnavailable = useCallback5(() => {
    trailEvent("Object Scan: Unavailable (camera)");
    setStep("UNAVAILABLE");
  }, [trailEvent]);
  const handleDetectorFailed = useCallback5(() => {
    trailEvent("Object Scan: Unavailable (detector)");
  }, [trailEvent]);
  const startScanning = () => {
    trailEvent("Object Scan: Started");
    setStep("SCANNING");
  };
  const findLine = `Find ${target.article} ${target.label.toLowerCase()}`;
  return /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement(
    "div",
    {
      className: step === "SCANNING" ? "relative h-full w-full overflow-hidden bg-black" : "flex h-full w-full flex-col items-center justify-center overflow-auto bg-cover bg-center bg-no-repeat p-4",
      style: backgroundImage && step !== "SCANNING" ? { backgroundImage: `url(${backgroundImage})` } : {}
    },
    step === "INSTRUCTIONS" && /* @__PURE__ */ React21.createElement(QuestionCard, { image: instructionsImage }, /* @__PURE__ */ React21.createElement("div", { className: "border-mt-border bg-mt-surface-2 mb-4 flex items-center justify-center gap-3 rounded-lg border px-4 py-3" }, /* @__PURE__ */ React21.createElement("span", { className: "text-3xl", "aria-hidden": "true" }, target.emoji), /* @__PURE__ */ React21.createElement("span", { className: "text-mt-ink text-lg font-semibold" }, findLine)), instructions && /* @__PURE__ */ React21.createElement(HTMLBlock_default, { html: instructions }), /* @__PURE__ */ React21.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React21.createElement(
      "button",
      {
        type: "button",
        onClick: startScanning,
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2.5 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2"
      },
      /* @__PURE__ */ React21.createElement(CameraIcon2, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
      "Start Scanning"
    ), /* @__PURE__ */ React21.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2",
        onClick: () => setInstructionsOpen(true)
      },
      /* @__PURE__ */ React21.createElement(
        InformationCircleIcon4,
        {
          "aria-hidden": "true",
          className: "mr-2 h-6 w-6"
        }
      ),
      "Instructions"
    ), /* @__PURE__ */ React21.createElement(
      "button",
      {
        type: "button",
        onClick: () => setSkipDialogOpen(true),
        className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
      },
      "Skip Scanning"
    ))),
    step === "SCANNING" && /* @__PURE__ */ React21.createElement(
      Suspense,
      {
        fallback: /* @__PURE__ */ React21.createElement("div", { className: "flex h-full w-full items-center justify-center bg-black text-white" }, /* @__PURE__ */ React21.createElement("div", { className: "flex flex-col items-center gap-3" }, /* @__PURE__ */ React21.createElement("div", { className: "h-8 w-8 animate-spin rounded-full border-2 border-white/30 border-t-white" }), /* @__PURE__ */ React21.createElement("span", { className: "text-sm font-medium" }, "Starting the scanner\u2026")))
      },
      /* @__PURE__ */ React21.createElement(
        ObjectScanView,
        {
          target,
          confidence,
          holdSeconds,
          theme: scannerTheme,
          hint: scannerHint,
          showTargetPreview: showTargetPreview ?? true,
          onFound: handleFound,
          onMatch: handleMatch,
          onUnavailable: handleUnavailable,
          onDetectorFailed: handleDetectorFailed,
          onHelp: () => setInstructionsOpen(true),
          onSkip: () => setSkipDialogOpen(true)
        }
      )
    ),
    step === "UNAVAILABLE" && /* @__PURE__ */ React21.createElement(QuestionCard, { image: wrongAnswerImage }, /* @__PURE__ */ React21.createElement("div", { className: "bg-mt-danger-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React21.createElement(
      XMarkIcon8,
      {
        className: "text-mt-danger h-6 w-6",
        "aria-hidden": "true"
      }
    )), /* @__PURE__ */ React21.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React21.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, "Camera unavailable"), /* @__PURE__ */ React21.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React21.createElement("p", { className: "text-mt-ink-muted text-sm" }, "We couldn't access your camera. Check your browser's camera permission and try again, or skip this step."), wrongAnswerText && /* @__PURE__ */ React21.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React21.createElement(HTMLBlock_default, { html: wrongAnswerText })))), /* @__PURE__ */ React21.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React21.createElement(
      "button",
      {
        type: "button",
        onClick: () => setStep("INSTRUCTIONS"),
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
      },
      "Try Again"
    ), /* @__PURE__ */ React21.createElement(
      "button",
      {
        type: "button",
        onClick: () => setSkipDialogOpen(true),
        className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
      },
      "Skip Scanning"
    ))),
    step === "COMPLETE" && /* @__PURE__ */ React21.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React21.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React21.createElement(
      CheckIcon7,
      {
        className: "text-mt-success h-6 w-6",
        "aria-hidden": "true"
      }
    )), /* @__PURE__ */ React21.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React21.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle || "Found it!"), /* @__PURE__ */ React21.createElement("div", { className: "mt-2" }, completeText && /* @__PURE__ */ React21.createElement(
      HTMLBlock_default,
      {
        className: "text-mt-ink-muted text-sm",
        html: completeText
      }
    ), score !== null && /* @__PURE__ */ React21.createElement("p", { className: "text-mt-ink-faint mt-2 text-xs" }, "Seen: ", target.emoji, " ", target.label, " ", Math.round(score * 100), "%")), /* @__PURE__ */ React21.createElement(
      "button",
      {
        type: "button",
        onClick: () => nextPage?.(),
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
      },
      "Continue"
    )))
  ), /* @__PURE__ */ React21.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip Scanning",
      text: "Are you sure you want to skip this scan?",
      onSkip: () => {
        setSkipDialogOpen(false);
        trailEvent("Object Scan: Skipped");
        nextPage?.();
      }
    }
  ), /* @__PURE__ */ React21.createElement(
    PageModal,
    {
      open: instructionsOpen,
      onBackdropClick: () => setInstructionsOpen(false),
      ariaLabel: "How to scan",
      align: "end"
    },
    /* @__PURE__ */ React21.createElement("div", { className: "bg-mt-surface relative transform overflow-hidden rounded-lg px-4 pt-5 pb-4 text-left shadow-xl sm:my-8 sm:w-full sm:max-w-lg sm:p-6" }, /* @__PURE__ */ React21.createElement("div", { className: "absolute top-0 right-0 pt-5 pr-5" }, /* @__PURE__ */ React21.createElement(
      "button",
      {
        type: "button",
        onClick: () => setInstructionsOpen(false),
        className: "bg-mt-surface text-mt-ink-faint hover:text-mt-ink-muted focus:ring-mt-primary rounded-md focus:ring-2 focus:ring-offset-2 focus:outline-none"
      },
      /* @__PURE__ */ React21.createElement("span", { className: "sr-only" }, "Close"),
      /* @__PURE__ */ React21.createElement(XMarkIcon8, { "aria-hidden": "true", className: "size-6" })
    )), /* @__PURE__ */ React21.createElement(ObjectScanInstructions, { target }), /* @__PURE__ */ React21.createElement("div", { className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" }, /* @__PURE__ */ React21.createElement(
      "button",
      {
        type: "button",
        onClick: () => setInstructionsOpen(false),
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs sm:ml-3 sm:w-auto"
      },
      "Continue"
    )))
  ));
}

// src/components/Pages/SnapChase/SnapChase.tsx
import React22, {
  useCallback as useCallback6,
  useEffect as useEffect8,
  useMemo as useMemo3,
  useRef as useRef7,
  useState as useState9
} from "react";
import { CameraIcon as CameraIcon3, CheckIcon as CheckIcon8, XMarkIcon as XMarkIcon9 } from "@heroicons/react/20/solid";
var SnapChaseAR = React22.lazy(() => import("./SnapChaseAR-W3BU4MJ5.mjs"));
var SnapChaseWorldAR = React22.lazy(() => import("./SnapChaseWorldAR-HIAE3Q37.mjs"));
function SnapChase({
  page,
  trailEvent,
  nextPage,
  editorMode
}) {
  const {
    backgroundImage,
    instructionsImage,
    instructions,
    character,
    panoImageUrl,
    characterSpeed,
    characterMovementY,
    characterMovementX,
    size,
    distance,
    spawnInFront,
    characterRotation,
    fallbackMode,
    locomotion,
    completeImage,
    completeTitle,
    completeText,
    wrongAnswerImage,
    wrongAnswerTitle,
    wrongAnswerText
  } = page;
  const [step, setStep] = useState9("INSTRUCTIONS");
  const [forceFallback, setForceFallback] = useState9(false);
  const [worldFailed, setWorldFailed] = useState9(false);
  const [gameKey, setGameKey] = useState9(0);
  const [skipDialogOpen, setSkipDialogOpen] = useState9(false);
  const [permissionsDialogOpen, setPermissionsDialogOpen] = useState9(false);
  const [requiredPermissions, setRequiredPermissions] = useState9(["camera"]);
  const wasHidden = useRef7(false);
  useEffect8(() => {
    let cancelled = false;
    (async () => {
      if (!isIOS) {
        if (!cancelled) {
          setRequiredPermissions(["camera"]);
        }
        return;
      }
      const motionStatus = await getPermissionStatus("motion");
      if (cancelled) return;
      if (motionStatus !== "unavailable") {
        setRequiredPermissions(["camera", "motion"]);
        return;
      }
      setRequiredPermissions(["camera"]);
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  const perms = usePermissionStatuses(requiredPermissions);
  const {
    statuses,
    loading: permissionsLoading,
    hasLoaded,
    refresh,
    refreshAndGet,
    allGranted,
    anyDenied,
    anyUnavailable,
    anyPrompt,
    anyUserDenied
  } = perms;
  useEffect8(() => {
    if (step === "INSTRUCTIONS") {
      refresh();
    }
  }, [refresh, step, requiredPermissions]);
  const overallState = useMemo3(() => {
    if (anyUnavailable) return "unavailable";
    if (anyDenied) return "denied";
    if (anyUserDenied) return "user_denied";
    if (anyPrompt) return "prompt";
    return allGranted ? "granted" : "prompt";
  }, [allGranted, anyDenied, anyPrompt, anyUnavailable, anyUserDenied]);
  const motionBlocked = requiredPermissions.includes("motion") && statuses.motion === "blocked_by_system";
  const resolvedFallback = fallbackMode || editorMode || requiredPermissions.some((id) => {
    const status = statuses[id];
    return status === "denied" || status === "blocked_by_system" || status === "unavailable" || status === "user_denied";
  });
  const effectiveFallback = resolvedFallback || forceFallback;
  const handleSetStep = useCallback6(
    (step2) => {
      setStep(step2);
      if (step2 === "INSTRUCTIONS") {
        setForceFallback(false);
        setWorldFailed(false);
      }
      if (step2 === "COMPLETE") {
        trailEvent("Snap Chase: Completed");
      }
      if (step2 === "WRONG") {
        trailEvent("Snap Chase: Failed");
      }
    },
    [trailEvent]
  );
  useEffect8(() => {
    if (step !== "GAME" || editorMode === true) return;
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        wasHidden.current = true;
        return;
      }
      if (wasHidden.current && document.visibilityState === "visible") {
        wasHidden.current = false;
        handleSetStep("INSTRUCTIONS");
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [editorMode, handleSetStep, step]);
  return /* @__PURE__ */ React22.createElement(React22.Fragment, null, step === "INSTRUCTIONS" && /* @__PURE__ */ React22.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React22.createElement(QuestionCard, { image: instructionsImage }, instructions && /* @__PURE__ */ React22.createElement(HTMLBlock_default, { html: instructions }), (permissionsLoading || !hasLoaded) && /* @__PURE__ */ React22.createElement("p", { className: "text-mt-ink-muted text-sm" }, "Checking permissions\u2026"), !permissionsLoading && hasLoaded && /* @__PURE__ */ React22.createElement("div", { className: "text-mt-ink-soft space-y-2 text-sm" }, overallState === "prompt" && /* @__PURE__ */ React22.createElement("p", null, "We need access to your camera", requiredPermissions.includes("motion") ? " and motion" : "", " ", "to play this game."), overallState === "user_denied" && /* @__PURE__ */ React22.createElement("p", null, "You chose not to enable the camera", requiredPermissions.includes("motion") ? " and motion" : "", " ", "yet. You can continue in fallback mode, or enable them to play the full AR version."), overallState === "denied" && /* @__PURE__ */ React22.createElement("p", null, motionBlocked ? "Motion access is blocked by your device settings. Enable Motion & Orientation Access to play, or continue in fallback mode." : "Camera access is blocked. Enable it to play, or continue in fallback mode."), overallState === "unavailable" && /* @__PURE__ */ React22.createElement("p", null, "Camera or motion is not available on this device. We will switch to fallback mode.")), /* @__PURE__ */ React22.createElement("div", { className: "mt-5 flex flex-col gap-3" }, overallState === "granted" && /* @__PURE__ */ React22.createElement(
    "button",
    {
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2.5 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2",
      onClick: () => setStep("GAME")
    },
    /* @__PURE__ */ React22.createElement(CameraIcon3, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
    "Take Photo"
  ), overallState !== "granted" && hasLoaded && /* @__PURE__ */ React22.createElement(
    "button",
    {
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2.5 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:bg-indigo-300",
      onClick: () => setPermissionsDialogOpen(true)
    },
    /* @__PURE__ */ React22.createElement(CameraIcon3, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
    "Enable camera",
    requiredPermissions.includes("motion") ? " & motion" : ""
  ), (fallbackMode || editorMode || overallState !== "granted" && hasLoaded) && /* @__PURE__ */ React22.createElement(
    "button",
    {
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2.5 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2",
      onClick: () => {
        setForceFallback(true);
        setStep("GAME");
      }
    },
    "Continue in fallback mode"
  ), /* @__PURE__ */ React22.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setSkipDialogOpen(true);
      },
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
    },
    "Skip Game"
  )))), step === "GAME" && /* @__PURE__ */ React22.createElement("div", { className: "relative h-full w-full" }, /* @__PURE__ */ React22.createElement(
    GameCanvasGuard,
    {
      key: gameKey,
      logTag: "SnapChase",
      emoji: "\u{1F4F8}",
      loadingLabel: "Loading AR...",
      onRetry: () => setGameKey((k) => k + 1)
    },
    !effectiveFallback && !worldFailed ? (
      // The world-anchored experience: the character holds a real
      // ground anchor (flying above it or running around it) and the
      // shutter captures an actual photo. Runtime failure drops to the
      // legacy component below for this run.
      /* @__PURE__ */ React22.createElement(
        SnapChaseWorldAR,
        {
          setStep: handleSetStep,
          character,
          size,
          distance,
          locomotion,
          onFallback: () => setWorldFailed(true)
        }
      )
    ) : (
      // The panorama version: the editor preview, the no-camera
      // path, and where a runtime camera failure above lands.
      /* @__PURE__ */ React22.createElement(
        SnapChaseAR,
        {
          setStep: handleSetStep,
          character,
          panoImageUrl,
          characterSpeed,
          characterMovementY,
          characterMovementX,
          size,
          distance,
          spawnInFront: editorMode || spawnInFront,
          characterRotation
        }
      )
    )
  ), /* @__PURE__ */ React22.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "absolute top-3 right-3 z-40 rounded-full bg-black/55 px-3.5 py-1.5 text-sm font-semibold text-white shadow-lg hover:bg-black/70 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-white"
    },
    "Skip"
  )), step === "WRONG" && /* @__PURE__ */ React22.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React22.createElement(QuestionCard, { image: wrongAnswerImage }, /* @__PURE__ */ React22.createElement("div", { className: "bg-mt-danger-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React22.createElement(
    XMarkIcon9,
    {
      className: "text-mt-danger h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React22.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React22.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, wrongAnswerTitle), wrongAnswerText && /* @__PURE__ */ React22.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React22.createElement(HTMLBlock_default, { html: wrongAnswerText }))), /* @__PURE__ */ React22.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React22.createElement(
    "button",
    {
      onClick: () => {
        handleSetStep("INSTRUCTIONS");
        trailEvent("Snap Chase: Retry");
      },
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    "Try Again"
  ), /* @__PURE__ */ React22.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setSkipDialogOpen(true);
      },
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
    },
    "Skip Game"
  )))), step === "COMPLETE" && /* @__PURE__ */ React22.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React22.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React22.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React22.createElement(
    CheckIcon8,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React22.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React22.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle), completeText && /* @__PURE__ */ React22.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React22.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), /* @__PURE__ */ React22.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React22.createElement(
    "button",
    {
      onClick: () => {
        nextPage && nextPage();
      },
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    "Continue"
  ), /* @__PURE__ */ React22.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setForceFallback(false);
        setWorldFailed(false);
        setStep("GAME");
        trailEvent("Snap Chase: Replay");
      },
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
    },
    "Play Again"
  ))))), /* @__PURE__ */ React22.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip Game",
      text: "Are you sure you want to skip playing the game?",
      onSkip: () => {
        setSkipDialogOpen(false);
        trailEvent("Snap Chase: Skipped");
        nextPage && nextPage();
      }
    }
  ), /* @__PURE__ */ React22.createElement(
    PermissionsDialog,
    {
      open: permissionsDialogOpen,
      setOpen: setPermissionsDialogOpen,
      controller: perms,
      title: "Allow camera to continue",
      description: "We use your camera (and motion on iOS) to play the AR game.",
      onComplete: async () => {
        setPermissionsDialogOpen(false);
        const updated = await refreshAndGet();
        const granted = requiredPermissions.every(
          (id) => updated[id] === "granted"
        );
        if (granted) {
          setStep("GAME");
        }
      }
    }
  ));
}

// src/components/Pages/DecoderRing/DecoderRing.tsx
import React26, { useState as useState11, useMemo as useMemo4, useRef as useRef9 } from "react";

// src/components/Pages/DecoderRing/emojiSets.ts
var emojiSets = {
  easter: [
    "\u{1F955}",
    "\u{1F95A}",
    "\u{1F430}",
    "\u{1F986}",
    "\u{1F423}",
    "\u{1F424}",
    "\u{1F36B}",
    "\u{1F425}",
    "\u{1F9C1}",
    "\u{1F411}",
    "\u{1F413}",
    "\u{1F36C}",
    "\u{1F36D}",
    "\u{1F308}",
    "\u{1F407}",
    "\u{1F338}",
    "\u{1F33C}",
    "\u{1F31E}",
    "\u{1F3A9}",
    "\u{1FABA}",
    "\u{1F984}",
    "\u2B50\uFE0F",
    "\u{1F9DA}",
    "\u{1F680}",
    "\u{1F496}",
    "\u{1F451}"
  ],
  christmas: [
    // Note: the base '🎄' glyph is intentionally omitted — it is a
    // byte-for-byte prefix of '🧑‍🎄' (Mx Claus) below, and the decode
    // step (`encodedMessage.split(emoji).join(letter)`) would match the short
    // glyph *inside* the long one and corrupt it (same class of bug fixed for
    // the halloween set below).
    "\u{1F385}",
    // Santa Claus
    "\u{1F936}",
    // Mrs. Claus
    "\u{1F98C}",
    // Reindeer
    "\u{1F9D1}\u200D\u{1F384}",
    // Mx Claus
    "\u26C4",
    // Snowman
    "\u2603\uFE0F",
    // Snowman with Snow
    "\u2744\uFE0F",
    // Snowflake
    "\u{1F381}",
    // Gift
    "\u{1F514}",
    // Bell
    "\u{1F6F7}",
    // Sled
    "\u{1F56F}\uFE0F",
    // Candle
    "\u{1F36A}",
    // Cookie (for Santa!)
    "\u{1F95B}",
    // Glass of Milk (Santa's drink)
    "\u{1F31F}",
    // Glowing Star (Tree Topper)
    "\u2728",
    // Sparkles (Festive Magic)
    "\u{1F3B6}",
    // Musical Notes (Christmas Carols)
    "\u{1F3A4}",
    // Microphone (Christmas Singing)
    "\u{1F942}",
    // Clinking Glasses (New Year Celebration)
    "\u{1F37E}",
    // Champagne Bottle (Festive Drinks)
    "\u{1F38A}",
    // Confetti Ball
    "\u{1F389}",
    // Party Popper
    "\u{1F999}",
    // Llama (as a fun nod to Christmas llamas)
    "\u{1F6CD}\uFE0F",
    // Shopping Bags (Christmas Shopping)
    "\u{1F9E3}",
    // Scarf (Winter Clothes)
    "\u{1F9E4}",
    // Gloves (Winter Accessories)
    "\u{1F9E6}",
    // Socks (Christmas Stockings)
    "\u{1F3AE}",
    // Video Game (Popular Christmas Gift)
    "\u{1F54E}",
    // Menorah (Hanukkah)
    "\u{1F54A}\uFE0F",
    // Dove of Peace
    "\u{1F3C2}",
    // Snowboarder (Winter Sports)
    "\u26F8\uFE0F",
    // Ice Skate
    "\u{1F3A0}",
    // Carousel Horse (Christmas Markets)
    "\u{1F377}",
    // Wine Glass (Mulled Wine)
    "\u{1F976}",
    // Cold Face (Winter Chill)
    "\u{1F36C}",
    // Candy (Christmas Treats)
    "\u{1F36B}",
    // Chocolate Bar (Christmas Sweets)
    "\u{1F36D}",
    // Lollipop (Festive Treats)
    "\u{1F386}"
    // Fireworks (New Year's Eve)
  ],
  halloween: [
    "\u{1F383}",
    // Jack-O-Lantern
    "\u{1F47B}",
    // Ghost
    "\u{1F577}\uFE0F",
    // Spider
    "\u{1F578}\uFE0F",
    // Spider Web
    "\u{1F987}",
    // Bat
    "\u2620\uFE0F",
    // Skull and Crossbones
    "\u{1F480}",
    // Skull
    // Note: the base '🧛'/'🧟'/'🧙' glyphs are intentionally omitted — they are
    // byte-for-byte prefixes of the gendered ZWJ sequences below, and the
    // decode step (`encodedMessage.split(emoji).join(letter)`) would match the
    // short glyph *inside* the long one and corrupt it. Keeping only the
    // (mutually non-colliding) gendered variants keeps decode prefix-safe.
    "\u{1F9DB}\u200D\u2642\uFE0F",
    // Vampire (Male)
    "\u{1F9DB}\u200D\u2640\uFE0F",
    // Vampire (Female)
    "\u{1F9DF}\u200D\u2642\uFE0F",
    // Zombie (Male)
    "\u{1F9DF}\u200D\u2640\uFE0F",
    // Zombie (Female)
    "\u{1F9D9}\u200D\u2640\uFE0F",
    // Witch
    "\u{1F9D9}\u200D\u2642\uFE0F",
    // Wizard
    "\u{1F989}",
    // Owl (Spooky Vibes)
    "\u{1F9DA}",
    // Fairy (Magical Vibes)
    "\u{1F440}",
    // Eyes (Watching You!)
    "\u{1FA78}",
    // Blood Drop
    "\u26B0\uFE0F",
    // Coffin
    "\u26B1\uFE0F",
    // Urn
    "\u{1F56F}\uFE0F",
    // Candle (Spooky Lighting)
    "\u{1F315}",
    // Full Moon
    "\u{1F319}",
    // Crescent Moon
    "\u{1F311}",
    // New Moon (Dark Night)
    "\u{1F32B}\uFE0F",
    // Fog (Spooky Atmosphere)
    "\u{1F5A4}",
    // Black Heart (Dark & Gothic)
    "\u{1F3AD}",
    // Performing Arts (Masquerade Theme)
    "\u{1F3B5}",
    // Musical Note (Haunting Music)
    "\u{1F9B9}\u200D\u2642\uFE0F",
    // Supervillain (Male)
    "\u{1F9B9}\u200D\u2640\uFE0F",
    // Supervillain (Female)
    "\u{1F36C}",
    // Candy (Trick or Treat)
    "\u{1F36D}",
    // Lollipop
    "\u{1F36B}",
    // Chocolate Bar
    "\u{1F441}\uFE0F\u200D\u{1F5E8}\uFE0F",
    // Eye in Speech Bubble (Spooky Watching)
    "\u{1F9F5}",
    // Thread (Costume Making)
    "\u{1F9F6}",
    // Yarn (Crafty Costumes)
    "\u{1F575}\uFE0F\u200D\u2642\uFE0F",
    // Detective (Male)
    "\u{1F575}\uFE0F\u200D\u2640\uFE0F",
    // Detective (Female)
    "\u{1F52E}",
    // Crystal Ball (Fortune Telling)
    "\u{1F3A9}",
    // Top Hat (Magician or Classic Monster)
    "\u{1F940}",
    // Wilted Rose (Gothic & Dark Vibes)
    "\u{1F921}",
    // Clown Face (Creepy Clown)
    "\u{1F479}",
    // Ogre (Monster)
    "\u{1F47A}",
    // Goblin (Spooky Creature)
    "\u{1F47D}",
    // Alien (Sci-Fi Horror)
    "\u{1F47F}",
    // Angry Face with Horns
    "\u{1F608}"
    // Smiling Face with Horns
  ],
  default: [
    "\u{1F600}",
    // Grinning Face
    "\u{1F603}",
    // Smiling Face
    "\u{1F60E}",
    // Cool Face
    "\u{1F929}",
    // Starry-Eyed
    "\u{1F973}",
    // Party Face
    "\u{1F984}",
    // Unicorn
    "\u{1F431}",
    // Cat Face
    "\u{1F436}",
    // Dog Face
    "\u{1F43C}",
    // Panda Face
    "\u{1F98A}",
    // Fox Face
    "\u{1F43B}",
    // Bear Face
    "\u{1F438}",
    // Frog Face
    "\u{1F42F}",
    // Tiger Face
    "\u{1F435}",
    // Monkey Face
    "\u{1F425}",
    // Baby Chick
    "\u{1F42E}",
    // Cow Face
    "\u{1F981}",
    // Lion Face
    "\u{1F418}",
    // Elephant
    "\u{1F422}",
    // Turtle
    "\u{1F42C}",
    // Dolphin
    "\u{1F409}",
    // Dragon
    "\u{1F41D}",
    // Bee
    "\u{1F33B}",
    // Sunflower
    "\u{1F31F}",
    // Star
    "\u{1F34E}",
    // Red Apple
    "\u{1F349}",
    // Watermelon
    "\u{1F355}",
    // Pizza
    "\u{1F369}",
    // Donut
    "\u{1F36A}",
    // Cookie
    "\u{1F36D}",
    // Lollipop
    "\u{1F382}",
    // Birthday Cake
    "\u{1F36B}",
    // Chocolate Bar
    "\u{1F680}",
    // Rocket
    "\u{1F3C6}",
    // Trophy
    "\u26BD",
    // Soccer Ball
    "\u{1F3C0}",
    // Basketball
    "\u{1F3B8}",
    // Guitar
    "\u{1F3AE}",
    // Video Game Controller
    "\u{1F3A8}",
    // Artist Palette
    "\u{1F3AF}",
    // Bullseye (For Fun Challenges)
    "\u{1F3B5}",
    // Musical Note
    "\u{1F388}",
    // Balloon
    "\u{1F381}",
    // Gift Box
    "\u{1F9E9}",
    // Puzzle Piece
    "\u{1F6F4}",
    // Scooter
    "\u{1F6B2}",
    // Bicycle
    "\u{1F68C}",
    // School Bus
    "\u2708\uFE0F",
    // Airplane
    "\u{1F3A0}"
    // Carousel Horse
  ]
};
var emojiSets_default = emojiSets;

// src/components/Pages/DecoderRing/RotatableCircle.tsx
import React24, { useState as useState10, useRef as useRef8 } from "react";

// src/components/Pages/DecoderRing/Segment.tsx
import React23 from "react";
var rainbowColours = [
  ["#e73642", "#f484a1"],
  ["#ea673a", "#f6b88e"],
  ["#f2c33f", "#f2c33f"],
  ["#ddf544", "#f0faa5"],
  ["#7bf240", "#c2f99e"],
  ["#3ef047", "#99f8a8"],
  ["#3ef0a1", "#9af8d3"],
  ["#3df0e3", "#9af8f2"],
  ["#3699e9", "#87d0f5"],
  ["#3038e2", "#758af2"],
  ["#6331e3", "#b475f2"],
  ["#bd33e6", "#e07df3"],
  ["#e836c6", "#f484e5"]
];
var Segment = React23.memo(
  ({ index, stepAngle, height, letter, emoji, screenHeight }) => /* @__PURE__ */ React23.createElement(
    "div",
    {
      className: `absolute inset-1/2 h-0 w-0`,
      style: { transform: `rotate(${index * stepAngle}deg)` }
    },
    /* @__PURE__ */ React23.createElement(
      "div",
      {
        className: "absolute bottom-0 left-0 flex flex-col items-center",
        style: {
          height: `${height}rem`,
          width: `${height * 0.24284}rem`,
          left: `${0 - height * 0.24284 / 2}rem`
        }
      },
      /* @__PURE__ */ React23.createElement(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          version: "1.1",
          viewBox: "0 0 100 411.8",
          className: "absolute top-0 left-0 h-full w-full"
        },
        /* @__PURE__ */ React23.createElement("defs", null, /* @__PURE__ */ React23.createElement(
          "linearGradient",
          {
            id: `Gradient${index}`,
            x1: "0%",
            y1: "0%",
            x2: "0%",
            y2: "100%"
          },
          /* @__PURE__ */ React23.createElement(
            "stop",
            {
              stopColor: rainbowColours[index % rainbowColours.length][0],
              offset: "0%"
            }
          ),
          /* @__PURE__ */ React23.createElement(
            "stop",
            {
              stopColor: rainbowColours[index % rainbowColours.length][1],
              offset: "100%"
            }
          )
        )),
        /* @__PURE__ */ React23.createElement(
          "polygon",
          {
            fill: `url(#Gradient${index})`,
            points: "50 411.8 0 0 100 0 50 411.8"
          }
        )
      ),
      /* @__PURE__ */ React23.createElement(
        "div",
        {
          className: `relative select-none ${HEIGHT_BREAKPOINT > screenHeight ? "mt-2" : "mt-4"} text-4xl`
        },
        /* @__PURE__ */ React23.createElement("span", null, emoji)
      ),
      /* @__PURE__ */ React23.createElement(
        "div",
        {
          className: `relative select-none ${HEIGHT_BREAKPOINT > screenHeight ? "mt-1 size-8 min-w-[1.5rem] text-xl leading-8" : "mt-2 size-9 min-w-[1.75rem] text-2xl leading-9"} bg-mt-surface flex flex-col items-center justify-center rounded-full text-center text-2xl leading-9 font-semibold`
        },
        /* @__PURE__ */ React23.createElement("span", null, letter)
      )
    )
  )
);
var Segment_default = Segment;

// src/components/Pages/DecoderRing/RotatableCircle.tsx
var RotatableCircle = ({ onDecode, setSelected, mapping, screenHeight }) => {
  const [rotation, setRotation] = useState10(0);
  const circleRef = useRef8(null);
  const dragging = useRef8(false);
  const startAngleRef = useRef8(0);
  const startRotationRef = useRef8(0);
  const currentRotationRef = useRef8(0);
  const stepAngle = 360 / 26;
  const radius = screenHeight > HEIGHT_BREAKPOINT ? 16 : 14;
  const buttonDiameter = 8;
  const centerRef = useRef8(null);
  const getAngle = (clientX, clientY) => {
    const { cx, cy } = centerRef.current || { cx: 0, cy: 0 };
    const x = clientX - cx;
    const y = clientY - cy;
    return Math.atan2(y, x) * (180 / Math.PI);
  };
  const computeSelectedIndex = (rot) => {
    const normalized = (rot % 360 + 360) % 360;
    const index = Math.round((360 - normalized) / stepAngle) % mapping.length;
    return index;
  };
  const onPointerDown = (e) => {
    e.preventDefault();
    dragging.current = true;
    if (circleRef.current) {
      const rect = circleRef.current.getBoundingClientRect();
      centerRef.current = {
        cx: rect.left + rect.width / 2,
        cy: rect.top + rect.height / 2
      };
    }
    startAngleRef.current = getAngle(e.clientX, e.clientY);
    startRotationRef.current = rotation;
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);
    window.addEventListener("pointercancel", onPointerUp);
  };
  const onPointerMove = (e) => {
    if (!dragging.current) return;
    const currentAngle = getAngle(e.clientX, e.clientY);
    const angleDiff = currentAngle - startAngleRef.current;
    const newRotation = startRotationRef.current + angleDiff;
    setRotation(newRotation);
    currentRotationRef.current = newRotation;
    const selectedIndex = computeSelectedIndex(newRotation);
    setSelected(mapping[selectedIndex]);
  };
  const onPointerUp = () => {
    if (!dragging.current) return;
    dragging.current = false;
    const finalRotation = currentRotationRef.current;
    const snappedRotation = Math.round(finalRotation / stepAngle) * stepAngle;
    setRotation(snappedRotation);
    currentRotationRef.current = snappedRotation;
    const selectedIndex = computeSelectedIndex(snappedRotation);
    setSelected(mapping[selectedIndex]);
    window.removeEventListener("pointermove", onPointerMove);
    window.removeEventListener("pointerup", onPointerUp);
    window.removeEventListener("pointercancel", onPointerUp);
  };
  return /* @__PURE__ */ React24.createElement(
    "div",
    {
      className: "relative",
      style: {
        width: `${buttonDiameter}rem`,
        height: `${buttonDiameter}rem`,
        marginTop: `${radius - buttonDiameter / 2}rem`
      }
    },
    /* @__PURE__ */ React24.createElement(
      "div",
      {
        className: "absolute h-0 w-0",
        style: {
          top: `${buttonDiameter / 2}rem`,
          left: `${buttonDiameter / 2}rem`
        }
      },
      /* @__PURE__ */ React24.createElement(
        "div",
        {
          ref: circleRef,
          onPointerDown,
          className: "bg-mt-surface-2 absolute flex items-center justify-center overflow-hidden rounded-full border-8 border-white select-none",
          style: {
            transform: `rotate(${rotation}deg)`,
            touchAction: "none",
            height: `${radius * 2}rem`,
            width: `${radius * 2}rem`,
            top: `-${radius}rem`,
            left: `-${radius}rem`,
            background: "radial-gradient(#9abaff, #2563eb)",
            boxShadow: "0 0 8rem 4rem rgba(0, 16, 50, 0.5)"
          }
        },
        mapping.map((pair, index) => /* @__PURE__ */ React24.createElement(
          Segment_default,
          {
            key: index,
            index,
            height: radius,
            stepAngle,
            letter: pair.letter,
            emoji: pair.emoji,
            screenHeight
          }
        ))
      )
    ),
    /* @__PURE__ */ React24.createElement(
      "button",
      {
        onClick: () => {
          onDecode();
        },
        type: "button",
        className: "absolute top-0 left-0 flex items-center justify-center rounded-full border-4 border-white bg-red-600 p-0 text-2xl font-bold text-white shadow-lg select-none active:bg-red-700",
        style: {
          width: `${buttonDiameter}rem`,
          height: `${buttonDiameter}rem`,
          fontWeight: "bold",
          boxShadow: "0 -0.5rem 1rem 0 rgba(16, 0, 0, 0.25) inset"
        }
      },
      "DECODE"
    ),
    /* @__PURE__ */ React24.createElement(
      "div",
      {
        className: "pointer-events-none absolute h-32 w-14 rounded-sm border-8 border-blue-700 shadow-sm",
        style: {
          bottom: `${radius - 3.5}rem`,
          left: "50%",
          transform: "translateX(-50%)"
        }
      }
    )
  );
};
var RotatableCircle_default = RotatableCircle;

// src/components/Pages/DecoderRing/EncodedMessage.tsx
import React25 from "react";
var EncodedMessage = ({
  message,
  selectedEmoji
}) => {
  const words = message.split(" ");
  return /* @__PURE__ */ React25.createElement("div", { className: "text-center text-4xl whitespace-normal" }, words.map((word, wordIndex) => {
    const parts = word.split(selectedEmoji);
    return /* @__PURE__ */ React25.createElement(
      "span",
      {
        key: wordIndex,
        className: "bg-mt-surface text-mt-ink-soft relative z-10 inline-block rounded-lg px-4 py-3 font-bold tracking-wider whitespace-nowrap shadow"
      },
      parts.map((part, index) => /* @__PURE__ */ React25.createElement(React25.Fragment, { key: index }, part, index < parts.length - 1 && /* @__PURE__ */ React25.createElement(
        "span",
        {
          className: "inline-block underline transition",
          style: { transform: "scale(1.2)" }
        },
        selectedEmoji
      ))),
      wordIndex < words.length - 1 && " "
    );
  }));
};
var EncodedMessage_default = EncodedMessage;

// src/components/Pages/DecoderRing/DecoderRing.tsx
import { CheckIcon as CheckIcon9, ChevronDownIcon } from "@heroicons/react/20/solid";
var HEIGHT_BREAKPOINT = 600;
function DecoderRing({
  page,
  pageHeight,
  trailEvent,
  nextPage
}) {
  const {
    message,
    backgroundImage,
    instructions,
    completeImage,
    completeTitle,
    completeText
  } = page;
  const mapping = useMemo4(() => {
    const letters = Array.from(
      { length: 26 },
      (_, i) => String.fromCharCode(65 + i)
    );
    const emojiPool = [...emojiSets_default[page.emojiSet] ?? emojiSets_default.default];
    for (let i = emojiPool.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [emojiPool[i], emojiPool[j]] = [emojiPool[j], emojiPool[i]];
    }
    const selectedEmojis = emojiPool.slice(0, 26);
    return letters.map((letter, i) => ({ letter, emoji: selectedEmojis[i] }));
  }, []);
  const [selectedCharacters, setSelectedCharacters] = useState11(
    mapping[0]
  );
  const [showInstructions, setShowInstructions] = useState11(true);
  const [showEndScreen, setShowEndScreen] = useState11(false);
  const [showMatchMessage, setShowMatchMessage] = useState11(
    message.toLowerCase().includes("a")
  );
  const completedRef = useRef9(false);
  const [encodedMessage, setEncodedMessage] = useState11(() => {
    return message.split("").map((ch) => {
      const mappingItem = mapping.find((m) => m.letter === ch.toUpperCase());
      return mappingItem ? mappingItem.emoji : ch;
    }).join("");
  });
  const decodeTarget = useMemo4(() => {
    return message.split("").map((ch) => {
      const mappingItem = mapping.find((m) => m.letter === ch.toUpperCase());
      return mappingItem ? ch.toUpperCase() : ch;
    }).join("");
  }, [message, mapping]);
  const decodeSelectedCharacter = () => {
    const { emoji, letter } = selectedCharacters;
    const newMessage = encodedMessage.split(emoji).join(letter);
    setEncodedMessage(newMessage);
    if (showInstructions) {
      setShowInstructions(false);
    }
    setShowMatchMessage(false);
    setTimeout(() => {
      if (newMessage === decodeTarget && !completedRef.current) {
        completedRef.current = true;
        trailEvent?.("Decoder Ring: Completed");
        setShowEndScreen(true);
      }
    }, 0);
  };
  return /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(
    "div",
    {
      className: `flex h-full w-full flex-col items-center justify-between overflow-hidden bg-cover bg-center bg-no-repeat ${pageHeight > HEIGHT_BREAKPOINT ? "py-8" : "py-2"}`,
      style: backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}
    },
    /* @__PURE__ */ React26.createElement("div", { className: "flex grow flex-col items-center justify-center" }, /* @__PURE__ */ React26.createElement("div", { className: "h-0" }, /* @__PURE__ */ React26.createElement(
      EncodedMessage_default,
      {
        selectedEmoji: selectedCharacters.emoji,
        message: encodedMessage
      }
    ))),
    /* @__PURE__ */ React26.createElement("div", { className: "mt-8 flex grow flex-col items-center" }, showMatchMessage && /* @__PURE__ */ React26.createElement("div", { className: "h-0" }, /* @__PURE__ */ React26.createElement(
      "p",
      {
        className: `relative z-10 rounded-lg border-2 border-white bg-linear-to-t from-indigo-500 to-indigo-800 text-center ${pageHeight > HEIGHT_BREAKPOINT ? "p-4" : "p-2"} text-sm font-bold text-white shadow`
      },
      /* @__PURE__ */ React26.createElement("span", { className: "text-xl text-yellow-300 uppercase" }, "Symbols match!"),
      /* @__PURE__ */ React26.createElement("br", null),
      "Press the Decode button!",
      /* @__PURE__ */ React26.createElement("br", null),
      /* @__PURE__ */ React26.createElement(ChevronDownIcon, { className: "mx-auto -my-1 size-8" })
    ))),
    /* @__PURE__ */ React26.createElement(
      RotatableCircle_default,
      {
        screenHeight: pageHeight,
        onDecode: decodeSelectedCharacter,
        mapping,
        setSelected: (mappingItem) => {
          setSelectedCharacters(mappingItem);
          if (showInstructions) {
            setShowInstructions(false);
          }
          setShowMatchMessage(encodedMessage.includes(mappingItem.emoji));
        }
      }
    )
  ), /* @__PURE__ */ React26.createElement(
    Instructions,
    {
      show: showInstructions && !!instructions,
      title: "Instructions",
      text: instructions,
      close: () => setShowInstructions(false),
      continueButtonText: "Continue"
    }
  ), /* @__PURE__ */ React26.createElement(GameCompleteModal, { open: showEndScreen, image: completeImage }, /* @__PURE__ */ React26.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React26.createElement(CheckIcon9, { className: "text-mt-success h-6 w-6", "aria-hidden": "true" })), /* @__PURE__ */ React26.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React26.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle), /* @__PURE__ */ React26.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React26.createElement("p", { className: "text-mt-ink-muted text-sm" }, completeText))), nextPage && /* @__PURE__ */ React26.createElement("div", { className: "mt-5 sm:mt-6" }, /* @__PURE__ */ React26.createElement(
    "button",
    {
      type: "button",
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
      onClick: () => nextPage?.()
    },
    "Continue"
  ))));
}

// src/hooks/useDebouncedSize.ts
import { useEffect as useEffect9, useRef as useRef10, useState as useState12 } from "react";
function useDebouncedSize(debounceMs = 120) {
  const ref = useRef10(null);
  const [size, setSize] = useState12({
    pageWidth: 0,
    pageHeight: 0,
    cssBreakpoint: "not set"
  });
  useEffect9(() => {
    if (!ref.current) return;
    let timer = null;
    const measure = () => {
      const el = ref.current;
      if (!el) return;
      let cssBreakpoint = window.getComputedStyle(document.body, ":before").content || "not set";
      if (cssBreakpoint.substring(0, 1) === '"' && cssBreakpoint.substring(cssBreakpoint.length - 1) === '"') {
        cssBreakpoint = cssBreakpoint.substring(1, cssBreakpoint.length - 1);
      }
      const next = {
        pageWidth: el.offsetWidth,
        pageHeight: el.offsetHeight,
        cssBreakpoint
      };
      setSize(
        (prev) => prev.pageWidth === next.pageWidth && prev.pageHeight === next.pageHeight ? prev : next
      );
    };
    measure();
    const observer = new ResizeObserver(() => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(measure, debounceMs);
    });
    observer.observe(ref.current);
    return () => {
      if (timer) clearTimeout(timer);
      observer.disconnect();
    };
  }, [debounceMs]);
  return [ref, size];
}

// src/components/Pages/LocationCheck.tsx
import React27, { useCallback as useCallback7, useEffect as useEffect10, useRef as useRef11, useState as useState13 } from "react";

// src/utils/haversineDistance.ts
function haversineDistance(lat1, lng1, lat2, lng2) {
  const toRadians = (degrees) => degrees * Math.PI / 180;
  const R = 6371e3;
  const \u03C61 = toRadians(lat1);
  const \u03C62 = toRadians(lat2);
  const \u0394\u03C6 = toRadians(lat2 - lat1);
  const \u0394\u03BB = toRadians(lng2 - lng1);
  const a = Math.sin(\u0394\u03C6 / 2) ** 2 + Math.cos(\u03C61) * Math.cos(\u03C62) * Math.sin(\u0394\u03BB / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// src/components/Pages/LocationCheck.tsx
function LocationCheck({
  page,
  trailEvent,
  nextPage,
  latlng,
  editorMode
}) {
  const { geofenceRadius, title, image, content, backgroundImage } = page;
  const [showLocationPermissionRequest, setShowLocationPermissionRequest] = useState13(false);
  const [resultText, setResultText] = useState13("");
  const [skipDialogOpen, setSkipDialogOpen] = useState13(false);
  const perms = usePermissionStatuses(["geolocation"]);
  const { statuses, refresh, hasLoaded } = perms;
  const watchIdRef = useRef11(null);
  const completedRef = useRef11(false);
  const targetLat = latlng[0];
  const targetLng = latlng[1];
  const clearWatch = () => {
    if (watchIdRef.current !== null && typeof navigator !== "undefined") {
      navigator.geolocation.clearWatch(watchIdRef.current);
      watchIdRef.current = null;
    }
  };
  const handlePositionUpdate = useCallback7(
    (pos) => {
      if (completedRef.current) return;
      const { latitude, longitude } = pos.coords;
      const distance = haversineDistance(
        latitude,
        longitude,
        targetLat,
        targetLng
      );
      if (distance <= geofenceRadius) {
        completedRef.current = true;
        setResultText("");
        clearWatch();
        trailEvent("locationCheck:success");
        nextPage?.();
      } else {
        const rounded = Math.round(distance);
        setResultText(
          `You are ${rounded} metres from the location (you need to be within ${geofenceRadius} metres to continue).`
        );
      }
    },
    [geofenceRadius, targetLat, targetLng, nextPage, trailEvent]
  );
  const handlePositionError = useCallback7((err) => {
    if (err.code === err.PERMISSION_DENIED) {
      setResultText("Location blocked on this device");
      clearWatch();
    } else {
      setResultText("Still finding your location\u2026 make sure GPS is on.");
    }
  }, []);
  const startWatchingPosition = useCallback7(() => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      setResultText("Location unavailable on this device");
      return;
    }
    clearWatch();
    const id = navigator.geolocation.watchPosition(
      handlePositionUpdate,
      handlePositionError,
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 15e3
      }
    );
    watchIdRef.current = id;
  }, [handlePositionError, handlePositionUpdate]);
  useEffect10(() => {
    completedRef.current = false;
    refresh();
    return () => {
      clearWatch();
    };
  }, [refresh, targetLat, targetLng, geofenceRadius]);
  const geolocationStatus = statuses.geolocation;
  const ready = hasLoaded && Boolean(geolocationStatus);
  useEffect10(() => {
    if (!hasLoaded || !geolocationStatus) return;
    if (geolocationStatus === "granted" || geolocationStatus === "granted_no_fix") {
      setShowLocationPermissionRequest(false);
      setResultText(
        geolocationStatus === "granted_no_fix" ? "Location permission is allowed, but we can\u2019t get a GPS fix yet. Try moving outside or checking Location Services." : "Checking your location\u2026"
      );
      startWatchingPosition();
      return;
    }
    clearWatch();
    if (geolocationStatus === "prompt" && editorMode === false) {
      setShowLocationPermissionRequest(false);
      setResultText("");
    } else if (geolocationStatus === "denied") {
      setResultText("Location blocked on this device");
    } else if (geolocationStatus === "blocked_by_system") {
      setResultText("Location blocked by device settings");
    } else if (geolocationStatus === "unavailable") {
      setResultText("Location unavailable on this device");
    }
  }, [geolocationStatus, hasLoaded, startWatchingPosition, editorMode]);
  return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React27.createElement(QuestionCard, { image }, /* @__PURE__ */ React27.createElement("div", { className: "space-y-2" }, title && /* @__PURE__ */ React27.createElement("h2", { className: "text-mt-ink text-2xl leading-7 font-bold sm:truncate sm:text-3xl sm:tracking-tight" }, title), content && /* @__PURE__ */ React27.createElement(HTMLBlock_default, { html: content }), !ready && /* @__PURE__ */ React27.createElement("p", null, "Checking location permission\u2026"), ready && geolocationStatus === "prompt" && /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement("p", null, "Enable location so we can verify you are at the right spot."), /* @__PURE__ */ React27.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setShowLocationPermissionRequest(true);
      },
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs sm:ml-3 sm:w-auto"
    },
    "Request location permission"
  ), /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
    },
    "Skip Location Check"
  ))), ready && geolocationStatus === "user_denied" && /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement("p", null, "You chose not to allow location access. If you are definitely in the right place, press ", /* @__PURE__ */ React27.createElement("strong", null, "Continue"), ". If you want Magical Trails to verify it properly, press", " ", /* @__PURE__ */ React27.createElement("strong", null, "Request location permission"), "."), /* @__PURE__ */ React27.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs sm:ml-3 sm:w-auto"
    },
    "Continue"
  ), /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setShowLocationPermissionRequest(true),
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
    },
    "Request location permission"
  ))), ready && geolocationStatus === "denied" && /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement("p", null, "Location is blocked for Magical Trails in your browser settings. If you are definitely in the right place, press", " ", /* @__PURE__ */ React27.createElement("strong", null, "Continue"), ". If you want to enable location, open your browser site settings for Magical Trails, set Location to Allow, then reload this page."), /* @__PURE__ */ React27.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs sm:ml-3 sm:w-auto"
    },
    "Continue"
  ), /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setShowLocationPermissionRequest(true),
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
    },
    "Request location permission"
  ))), ready && geolocationStatus === "blocked_by_system" && /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement("p", null, "Location is blocked by your device settings. On iOS go to Settings \u2192 Privacy & Security \u2192 Location Services \u2192 Safari Websites \u2192 While Using the App, then reload this page."), /* @__PURE__ */ React27.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs sm:ml-3 sm:w-auto"
    },
    "Continue"
  ), /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setShowLocationPermissionRequest(true),
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
    },
    "Request location permission"
  ))), ready && geolocationStatus === "unavailable" && /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement("p", null, "Your device does not support location. Press", " ", /* @__PURE__ */ React27.createElement("strong", null, "Continue"), " if you promise you really are in the right area."), /* @__PURE__ */ React27.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs sm:ml-3 sm:w-auto"
    },
    "Continue"
  ))), ready && (geolocationStatus === "granted" || geolocationStatus === "granted_no_fix") && /* @__PURE__ */ React27.createElement(React27.Fragment, null, resultText && /* @__PURE__ */ React27.createElement("p", null, resultText), /* @__PURE__ */ React27.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React27.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
    },
    "Skip Location Check"
  )))))), /* @__PURE__ */ React27.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip Location Check",
      text: "Are you sure you want to skip the location check?",
      onSkip: () => {
        setSkipDialogOpen(false);
        trailEvent("Location Check: Skipped");
        nextPage && nextPage();
      }
    }
  ), /* @__PURE__ */ React27.createElement(
    PermissionsDialog,
    {
      open: showLocationPermissionRequest,
      setOpen: setShowLocationPermissionRequest,
      controller: perms,
      title: "Allow location to continue",
      description: "We use your location to confirm you\u2019re at the trail point.",
      onComplete: () => {
        setShowLocationPermissionRequest(false);
        setResultText("Checking your location\u2026");
        startWatchingPosition();
      }
    }
  ));
}

// src/components/Pages/AudioPage.tsx
import React28, { useEffect as useEffect11, useRef as useRef12, useState as useState14 } from "react";
import {
  PauseIcon,
  PlayIcon,
  ArrowUturnLeftIcon
} from "@heroicons/react/24/solid";
function formatTime(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}
var AudioPage = ({
  page,
  trailEvent,
  nextPage,
  closeModal
}) => {
  const audioRef = useRef12(null);
  const [isPlaying, setIsPlaying] = useState14(false);
  const [currentTime, setCurrentTime] = useState14(0);
  const [duration, setDuration] = useState14(0);
  const [hasError, setHasError] = useState14(false);
  const playedRef = useRef12(false);
  const completedRef = useRef12(false);
  useEffect11(() => {
    if (page.autoplay) {
      audioRef.current?.play().catch(() => void 0);
    }
  }, [page.autoplay]);
  useEffect11(() => {
    const audio = audioRef.current;
    return () => {
      audio?.pause();
    };
  }, []);
  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.play().catch(() => setHasError(true));
    } else {
      audio.pause();
    }
  };
  const skipBack = () => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.currentTime = Math.max(0, audio.currentTime - 10);
  };
  const handleSeek = (event) => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.currentTime = Number(event.target.value);
    setCurrentTime(audio.currentTime);
  };
  return /* @__PURE__ */ React28.createElement("div", { className: "bg-mt-surface text-mt-ink flex h-full w-full flex-col" }, /* @__PURE__ */ React28.createElement("div", { className: "min-h-0 w-full flex-1 overflow-y-auto" }, page.image && /* @__PURE__ */ React28.createElement(
    "img",
    {
      src: page.image,
      alt: page.altText || page.title || "Audio guide header image",
      className: "block h-auto max-h-[40vh] w-full object-cover"
    }
  ), /* @__PURE__ */ React28.createElement("div", { className: "mx-auto flex w-full max-w-[65ch] flex-col gap-6 px-5 pt-8 pb-8 sm:px-6" }, page.title && /* @__PURE__ */ React28.createElement("h1", { className: "text-mt-ink text-2xl leading-tight font-semibold tracking-tight sm:text-3xl" }, page.title), /* @__PURE__ */ React28.createElement("div", { className: "prose prose-neutral max-w-none" }, /* @__PURE__ */ React28.createElement(HTMLBlock_default, { html: page.content })), page.transcript && /* @__PURE__ */ React28.createElement("details", { className: "border-mt-border-soft bg-mt-surface-2 rounded-md border px-4 py-3" }, /* @__PURE__ */ React28.createElement("summary", { className: "text-mt-ink-soft cursor-pointer text-sm font-medium" }, "Read transcript"), /* @__PURE__ */ React28.createElement("div", { className: "prose prose-neutral mt-3 max-w-none" }, /* @__PURE__ */ React28.createElement(HTMLBlock_default, { html: page.transcript }))), (nextPage || page.showCloseButton && closeModal) && /* @__PURE__ */ React28.createElement("div", { className: "flex flex-wrap items-center gap-3 pt-2" }, nextPage && /* @__PURE__ */ React28.createElement(
    "button",
    {
      type: "button",
      className: "border-mt-border bg-mt-surface text-mt-ink-soft hover:border-mt-border hover:bg-mt-surface-2 rounded-md border px-4 py-2 text-sm font-medium transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-700",
      onClick: () => nextPage()
    },
    "Continue"
  ), page.showCloseButton && closeModal && /* @__PURE__ */ React28.createElement(
    "button",
    {
      type: "button",
      className: "border-mt-border bg-mt-surface text-mt-ink-soft hover:border-mt-border hover:bg-mt-surface-2 rounded-md border px-4 py-2 text-sm font-medium transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-700",
      onClick: () => closeModal()
    },
    page.closeButtonText || "Close"
  )))), /* @__PURE__ */ React28.createElement("div", { className: "border-mt-border-soft bg-mt-surface-2 w-full border-t px-4 py-3" }, /* @__PURE__ */ React28.createElement(
    "audio",
    {
      ref: audioRef,
      src: page.audioUrl,
      preload: "metadata",
      onPlay: () => {
        setIsPlaying(true);
        if (!playedRef.current) {
          playedRef.current = true;
          trailEvent?.("audio_played");
        }
      },
      onPause: () => setIsPlaying(false),
      onEnded: () => {
        setIsPlaying(false);
        if (!completedRef.current) {
          completedRef.current = true;
          trailEvent?.("audio_completed");
        }
        if (page.autoAdvance && nextPage) {
          nextPage();
        }
      },
      onTimeUpdate: (e) => setCurrentTime(e.currentTarget.currentTime),
      onDurationChange: (e) => setDuration(e.currentTarget.duration),
      onError: () => setHasError(true)
    }
  ), hasError ? /* @__PURE__ */ React28.createElement("p", { className: "text-mt-ink-muted text-center text-sm", role: "alert" }, "Sorry, the audio could not be loaded.") : /* @__PURE__ */ React28.createElement("div", { className: "mx-auto flex w-full max-w-[65ch] items-center gap-3" }, /* @__PURE__ */ React28.createElement(
    "button",
    {
      type: "button",
      onClick: skipBack,
      "aria-label": "Back 10 seconds",
      className: "text-mt-ink-muted hover:bg-mt-surface-2 flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-700"
    },
    /* @__PURE__ */ React28.createElement(ArrowUturnLeftIcon, { className: "h-5 w-5" })
  ), /* @__PURE__ */ React28.createElement(
    "button",
    {
      type: "button",
      onClick: togglePlay,
      "aria-label": isPlaying ? "Pause audio" : "Play audio",
      className: "flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-neutral-900 text-white transition hover:bg-neutral-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-700"
    },
    isPlaying ? /* @__PURE__ */ React28.createElement(PauseIcon, { className: "h-6 w-6" }) : /* @__PURE__ */ React28.createElement(PlayIcon, { className: "ml-0.5 h-6 w-6" })
  ), /* @__PURE__ */ React28.createElement("span", { className: "text-mt-ink-muted w-10 shrink-0 text-right text-xs tabular-nums" }, formatTime(currentTime)), /* @__PURE__ */ React28.createElement(
    "input",
    {
      type: "range",
      min: 0,
      max: duration || 0,
      step: 0.1,
      value: Math.min(currentTime, duration || 0),
      onChange: handleSeek,
      "aria-label": "Seek audio",
      className: "h-1.5 w-full min-w-0 flex-1 cursor-pointer accent-neutral-900"
    }
  ), /* @__PURE__ */ React28.createElement("span", { className: "text-mt-ink-muted w-10 shrink-0 text-xs tabular-nums" }, formatTime(duration)))));
};

// src/components/Pages/VideoPage.tsx
import React29, { useEffect as useEffect12, useRef as useRef13, useState as useState15 } from "react";
import {
  PlayIcon as PlayIcon2,
  SpeakerWaveIcon,
  SpeakerXMarkIcon
} from "@heroicons/react/24/solid";
var VideoPage = ({ page, trailEvent, nextPage }) => {
  const videoRef = useRef13(null);
  const [isPlaying, setIsPlaying] = useState15(false);
  const [isMuted, setIsMuted] = useState15(page.startMuted ?? true);
  const [progress, setProgress] = useState15(0);
  const [hasError, setHasError] = useState15(false);
  const playedRef = useRef13(false);
  const completedRef = useRef13(false);
  useEffect12(() => {
    videoRef.current?.play().catch(() => void 0);
  }, [page.videoUrl]);
  useEffect12(() => {
    const video = videoRef.current;
    return () => {
      video?.pause();
    };
  }, []);
  const shouldLoop = !page.autoAdvance && (page.loop ?? true);
  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => setHasError(true));
    } else {
      video.pause();
    }
  };
  const handleEnded = () => {
    setIsPlaying(false);
    if (!completedRef.current) {
      completedRef.current = true;
      trailEvent?.("video_completed");
    }
    if (page.autoAdvance && nextPage) {
      nextPage();
    }
  };
  const handleTimeUpdate = (event) => {
    const video = event.currentTarget;
    if (video.duration > 0) {
      setProgress(video.currentTime / video.duration);
      if (!completedRef.current && video.currentTime >= video.duration - 0.25) {
        completedRef.current = true;
        trailEvent?.("video_completed");
      }
    }
  };
  return /* @__PURE__ */ React29.createElement("div", { className: "relative h-full w-full overflow-hidden bg-black" }, hasError ? /* @__PURE__ */ React29.createElement("div", { className: "flex h-full w-full flex-col items-center justify-center gap-4 px-6 text-center" }, /* @__PURE__ */ React29.createElement("p", { className: "text-sm text-neutral-300", role: "alert" }, "Sorry, the video could not be loaded."), nextPage && /* @__PURE__ */ React29.createElement(
    "button",
    {
      type: "button",
      className: "hover:border-mt-border rounded-md border border-neutral-600 px-4 py-2 text-sm font-medium text-neutral-200 transition",
      onClick: () => nextPage()
    },
    "Continue"
  )) : /* @__PURE__ */ React29.createElement(React29.Fragment, null, /* @__PURE__ */ React29.createElement(
    "video",
    {
      ref: videoRef,
      src: page.videoUrl,
      poster: page.posterImage,
      className: "h-full w-full object-contain",
      playsInline: true,
      muted: isMuted,
      loop: shouldLoop,
      preload: "auto",
      onPlay: () => {
        setIsPlaying(true);
        if (!playedRef.current) {
          playedRef.current = true;
          trailEvent?.("video_played");
        }
      },
      onPause: () => setIsPlaying(false),
      onEnded: handleEnded,
      onTimeUpdate: handleTimeUpdate,
      onError: () => setHasError(true)
    }
  ), /* @__PURE__ */ React29.createElement(
    "button",
    {
      type: "button",
      onClick: togglePlay,
      "aria-label": isPlaying ? "Pause video" : "Play video",
      className: `absolute inset-0 flex items-center justify-center ${isPlaying ? "" : "bg-black/30"}`
    },
    !isPlaying && /* @__PURE__ */ React29.createElement("span", { className: "flex h-16 w-16 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm" }, /* @__PURE__ */ React29.createElement(PlayIcon2, { className: "ml-1 h-9 w-9 text-white" }))
  ), /* @__PURE__ */ React29.createElement(
    "button",
    {
      type: "button",
      onClick: () => setIsMuted((muted) => !muted),
      "aria-label": isMuted ? "Unmute video" : "Mute video",
      className: "absolute top-4 right-4 flex h-10 w-10 items-center justify-center rounded-full bg-black/40 text-white backdrop-blur-sm transition hover:bg-black/60"
    },
    isMuted ? /* @__PURE__ */ React29.createElement(SpeakerXMarkIcon, { className: "h-5 w-5" }) : /* @__PURE__ */ React29.createElement(SpeakerWaveIcon, { className: "h-5 w-5" })
  ), (page.title || page.caption) && /* @__PURE__ */ React29.createElement("div", { className: "pointer-events-none absolute inset-x-0 bottom-1 bg-gradient-to-t from-black/70 to-transparent px-4 pt-12 pb-4" }, page.title && /* @__PURE__ */ React29.createElement("h1", { className: "text-lg font-semibold text-white drop-shadow" }, page.title), page.caption && /* @__PURE__ */ React29.createElement("p", { className: "mt-1 text-sm text-neutral-200 drop-shadow" }, page.caption)), /* @__PURE__ */ React29.createElement(
    "div",
    {
      className: "absolute inset-x-0 bottom-0 h-1 bg-white/20",
      role: "progressbar",
      "aria-label": "Video progress",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": Math.round(progress * 100)
    },
    /* @__PURE__ */ React29.createElement(
      "div",
      {
        className: "bg-mt-surface h-full",
        style: { width: `${progress * 100}%` }
      }
    )
  )));
};

// src/components/Pages/Selfie/Selfie.tsx
import React30, { useEffect as useEffect13, useMemo as useMemo5, useState as useState16 } from "react";
var SelfieAR = React30.lazy(() => import("./SelfieAR-JIRID5QI.mjs"));
var PRIMARY_BTN = "inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary shadow-sm hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
var SECONDARY_BTN = "inline-flex w-full items-center justify-center rounded-md bg-mt-surface px-3 py-2 text-sm font-semibold text-mt-ink shadow-sm ring-1 ring-inset ring-mt-border hover:bg-mt-surface-2";
function Selfie({ page, trailEvent, nextPage }) {
  const { title, instructions } = page;
  const [step, setStep] = useState16("INSTRUCTIONS");
  const [permissionsDialogOpen, setPermissionsDialogOpen] = useState16(false);
  const [gameKey, setGameKey] = useState16(0);
  const requiredPermissions = useMemo5(() => ["camera"], []);
  const perms = usePermissionStatuses(requiredPermissions);
  const {
    statuses,
    loading: permissionsLoading,
    hasLoaded,
    refresh,
    refreshAndGet,
    allGranted,
    anyDenied,
    anyUnavailable,
    anyPrompt,
    anyUserDenied
  } = perms;
  useEffect13(() => {
    if (step === "INSTRUCTIONS") refresh();
  }, [refresh, step]);
  const overallState = useMemo5(() => {
    if (anyUnavailable) return "unavailable";
    if (anyDenied) return "denied";
    if (anyUserDenied) return "user_denied";
    if (anyPrompt) return "prompt";
    return allGranted ? "granted" : "prompt";
  }, [allGranted, anyDenied, anyPrompt, anyUnavailable, anyUserDenied]);
  const cameraUnavailable = statuses.camera === "denied" || statuses.camera === "blocked_by_system" || statuses.camera === "unavailable" || statuses.camera === "user_denied";
  if (step === "SELFIE") {
    return (
      // Keyed so a retry after a WebGL context loss (or engine crash) remounts
      // with a fresh canvas/context — the only 3D page that was still on a bare
      // Suspense instead of the shared guard.
      /* @__PURE__ */ React30.createElement("div", { className: "relative h-full w-full" }, /* @__PURE__ */ React30.createElement(
        GameCanvasGuard,
        {
          key: gameKey,
          logTag: "Selfie",
          emoji: "\u2728",
          loadingLabel: "Loading the magic mirror\u2026",
          onRetry: () => setGameKey((k) => k + 1)
        },
        /* @__PURE__ */ React30.createElement(SelfieAR, { page, trailEvent, onContinue: nextPage })
      ), nextPage && /* @__PURE__ */ React30.createElement(
        "button",
        {
          type: "button",
          onClick: () => nextPage(),
          className: "absolute top-3 right-3 z-40 rounded-full bg-black/55 px-3.5 py-1.5 text-sm font-semibold text-white shadow-lg hover:bg-black/70 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-white"
        },
        "Skip"
      ))
    );
  }
  return /* @__PURE__ */ React30.createElement("div", { className: "flex h-full w-full flex-col items-center justify-center overflow-auto p-4" }, /* @__PURE__ */ React30.createElement("div", { className: "bg-mt-surface relative w-full max-w-lg rounded-lg p-5 text-left shadow-xl" }, /* @__PURE__ */ React30.createElement("h2", { className: "text-mt-ink text-xl font-semibold" }, title || "Magic Selfie \u2728"), instructions && /* @__PURE__ */ React30.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React30.createElement(HTMLBlock_default, { html: instructions })), (permissionsLoading || !hasLoaded) && /* @__PURE__ */ React30.createElement("p", { className: "text-mt-ink-muted mt-3 text-sm" }, "Checking permissions\u2026"), !permissionsLoading && hasLoaded && /* @__PURE__ */ React30.createElement("div", { className: "text-mt-ink-soft mt-3 space-y-2 text-sm" }, overallState === "prompt" && /* @__PURE__ */ React30.createElement("p", null, "We need access to your camera to add magical lenses to your selfie."), overallState === "user_denied" && /* @__PURE__ */ React30.createElement("p", null, "You chose not to enable the camera yet. You can continue without it, or enable it to take a magic selfie."), overallState === "denied" && /* @__PURE__ */ React30.createElement("p", null, "Camera access is blocked. Enable it to take a selfie, or continue."), overallState === "unavailable" && /* @__PURE__ */ React30.createElement("p", null, "The camera is not available on this device. You can still continue.")), /* @__PURE__ */ React30.createElement("div", { className: "mt-5 flex flex-col gap-3" }, overallState === "granted" && /* @__PURE__ */ React30.createElement(
    "button",
    {
      type: "button",
      className: PRIMARY_BTN,
      onClick: () => setStep("SELFIE")
    },
    "Start Magic Selfie"
  ), overallState !== "granted" && hasLoaded && !cameraUnavailable && /* @__PURE__ */ React30.createElement(
    "button",
    {
      type: "button",
      className: PRIMARY_BTN,
      onClick: () => setPermissionsDialogOpen(true)
    },
    "Enable camera"
  ), nextPage && /* @__PURE__ */ React30.createElement(
    "button",
    {
      type: "button",
      className: overallState === "granted" || !cameraUnavailable && hasLoaded ? SECONDARY_BTN : PRIMARY_BTN,
      onClick: nextPage
    },
    "Continue"
  ))), /* @__PURE__ */ React30.createElement(
    PermissionsDialog,
    {
      open: permissionsDialogOpen,
      setOpen: setPermissionsDialogOpen,
      controller: perms,
      title: "Allow camera to continue",
      description: "We use your camera to add magical lenses to your selfie.",
      onComplete: async () => {
        setPermissionsDialogOpen(false);
        const updated = await refreshAndGet();
        if (updated.camera === "granted" || updated.camera === "granted_no_fix") {
          setStep("SELFIE");
        }
      }
    }
  ));
}

// src/components/Pages/ARShooter/ARShooter.tsx
import React31, {
  useCallback as useCallback8,
  useEffect as useEffect14,
  useMemo as useMemo6,
  useRef as useRef14,
  useState as useState17
} from "react";
import { CheckIcon as CheckIcon10, SparklesIcon } from "@heroicons/react/20/solid";
var loadARShooterAR = () => import("./ARShooterAR-7SNQ3OVQ.mjs");
var ARShooterAR = React31.lazy(loadARShooterAR);
var warmUpARShooterAR = () => {
  void loadARShooterAR().catch(() => void 0);
  warmUpImmersiveARSupport();
};
var DEFAULT_TARGET_SCORE = {
  pumpkins: 8,
  balloons: 5
};
function ARShooter({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const {
    variant,
    targetScore,
    targets,
    fallbackMode,
    backgroundImage,
    theme,
    title,
    instructions,
    instructionsImage,
    completeImage,
    completeTitle,
    completeText,
    rewardChest,
    rewardText,
    encounter,
    mode,
    lives
  } = page;
  const [step, setStep] = useState17("INSTRUCTIONS");
  useEffect14(() => {
    warmUpARShooterAR();
  }, []);
  const [gameKey, setGameKey] = useState17(0);
  const [forceFallback, setForceFallback] = useState17(false);
  const [skipDialogOpen, setSkipDialogOpen] = useState17(false);
  const [permissionsDialogOpen, setPermissionsDialogOpen] = useState17(false);
  const [requiredPermissions, setRequiredPermissions] = useState17(["camera"]);
  const [permissionsResolved, setPermissionsResolved] = useState17(false);
  const wasHidden = useRef14(false);
  const resolvedTargetScore = targetScore ?? DEFAULT_TARGET_SCORE[variant];
  const reward = rewardText?.trim();
  useEffect14(() => {
    let cancelled = false;
    void (async () => {
      if (!isIOS) {
        if (!cancelled) {
          setRequiredPermissions(["camera"]);
          setPermissionsResolved(true);
        }
        return;
      }
      const motionStatus = await getPermissionStatus("motion");
      if (cancelled) return;
      setRequiredPermissions(
        motionStatus !== "unavailable" ? ["camera", "motion"] : ["camera"]
      );
      setPermissionsResolved(true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  const perms = usePermissionStatuses(requiredPermissions);
  const {
    statuses,
    loading: permissionsLoading,
    hasLoaded,
    refresh,
    refreshAndGet,
    allGranted,
    anyDenied,
    anyUnavailable,
    anyPrompt,
    anyUserDenied
  } = perms;
  useEffect14(() => {
    if (step === "INSTRUCTIONS") refresh();
  }, [refresh, step, requiredPermissions]);
  const overallState = useMemo6(() => {
    if (anyUnavailable) return "unavailable";
    if (anyDenied) return "denied";
    if (anyUserDenied) return "user_denied";
    if (anyPrompt) return "prompt";
    return allGranted ? "granted" : "prompt";
  }, [allGranted, anyDenied, anyPrompt, anyUnavailable, anyUserDenied]);
  const motionBlocked = requiredPermissions.includes("motion") && statuses.motion === "blocked_by_system";
  const resolvedFallback = Boolean(fallbackMode) || editorMode || requiredPermissions.some((id) => {
    const status = statuses[id];
    return status === "denied" || status === "blocked_by_system" || status === "unavailable" || status === "user_denied";
  });
  const effectiveFallback = resolvedFallback || forceFallback;
  const handleSetStep = useCallback8(
    (next) => {
      setStep(next);
      if (next === "INSTRUCTIONS") setForceFallback(false);
      if (next === "COMPLETE") trailEvent("AR Shooter: Completed");
    },
    [trailEvent]
  );
  useEffect14(() => {
    if (step !== "GAME" || editorMode) return;
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        wasHidden.current = true;
        return;
      }
      if (wasHidden.current && document.visibilityState === "visible") {
        wasHidden.current = false;
        handleSetStep("INSTRUCTIONS");
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [editorMode, handleSetStep, step]);
  const primaryButtonClass6 = "shadow-xs inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
  return /* @__PURE__ */ React31.createElement(React31.Fragment, null, step === "INSTRUCTIONS" && /* @__PURE__ */ React31.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React31.createElement(QuestionCard, { image: instructionsImage }, title && /* @__PURE__ */ React31.createElement("h2", { className: "text-mt-ink mb-2 text-center text-xl font-bold" }, title), instructions && /* @__PURE__ */ React31.createElement(HTMLBlock_default, { html: instructions }), !resolvedFallback && (!permissionsResolved || permissionsLoading || !hasLoaded) && /* @__PURE__ */ React31.createElement("p", { className: "text-mt-ink-muted text-sm" }, "Checking permissions\u2026"), permissionsResolved && !permissionsLoading && hasLoaded && !resolvedFallback && /* @__PURE__ */ React31.createElement("div", { className: "text-mt-ink-soft space-y-2 text-sm" }, overallState === "prompt" && /* @__PURE__ */ React31.createElement("p", null, "We need access to your camera", requiredPermissions.includes("motion") ? " and motion" : "", " ", "to play this game."), overallState === "user_denied" && /* @__PURE__ */ React31.createElement("p", null, "You chose not to enable the camera", requiredPermissions.includes("motion") ? " and motion" : "", " ", "yet. You can continue in fallback mode, or enable them to play the full AR version."), overallState === "denied" && /* @__PURE__ */ React31.createElement("p", null, motionBlocked ? "Motion access is blocked by your device settings. Enable Motion & Orientation Access to play, or continue in fallback mode." : "Camera access is blocked. Enable it to play, or continue in fallback mode."), overallState === "unavailable" && /* @__PURE__ */ React31.createElement("p", null, "Camera or motion is not available on this device. We will switch to fallback mode.")), /* @__PURE__ */ React31.createElement("div", { className: "mt-5 flex flex-col gap-3" }, permissionsResolved && overallState === "granted" && /* @__PURE__ */ React31.createElement(
    "button",
    {
      className: primaryButtonClass6,
      onClick: () => setStep("GAME")
    },
    /* @__PURE__ */ React31.createElement(SparklesIcon, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
    "Start Game"
  ), permissionsResolved && overallState !== "granted" && hasLoaded && !resolvedFallback && /* @__PURE__ */ React31.createElement(
    "button",
    {
      className: primaryButtonClass6,
      onClick: () => setPermissionsDialogOpen(true)
    },
    "Enable camera",
    requiredPermissions.includes("motion") ? " & motion" : ""
  ), (resolvedFallback || permissionsResolved && overallState !== "granted" && hasLoaded) && /* @__PURE__ */ React31.createElement(
    "button",
    {
      className: primaryButtonClass6,
      onClick: () => {
        setForceFallback(true);
        setStep("GAME");
      }
    },
    resolvedFallback ? "Start Game" : "Continue without camera"
  ), /* @__PURE__ */ React31.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset"
    },
    "Skip Game"
  )))), step === "GAME" && /* @__PURE__ */ React31.createElement("div", { className: "relative h-full w-full" }, /* @__PURE__ */ React31.createElement(
    GameCanvasGuard,
    {
      key: gameKey,
      logTag: "ARShooter",
      emoji: "\u{1F3AF}",
      loadingLabel: "Loading AR...",
      onRetry: () => setGameKey((k) => k + 1)
    },
    /* @__PURE__ */ React31.createElement(
      ARShooterAR,
      {
        variant,
        targetScore: resolvedTargetScore,
        targets,
        fallbackMode: effectiveFallback,
        backgroundImage,
        theme,
        rewardChest,
        rewardText,
        encounter,
        mode,
        lives,
        onChestOpened: () => trailEvent("AR Shooter: Chest Opened"),
        onComplete: () => handleSetStep("COMPLETE")
      }
    )
  ), /* @__PURE__ */ React31.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "absolute top-3 right-3 z-40 rounded-full bg-black/55 px-3.5 py-1.5 text-sm font-semibold text-white shadow-lg hover:bg-black/70 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-white"
    },
    "Skip"
  )), step === "COMPLETE" && /* @__PURE__ */ React31.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React31.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React31.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React31.createElement(
    CheckIcon10,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React31.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React31.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle), completeText && /* @__PURE__ */ React31.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React31.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), rewardChest && /* @__PURE__ */ React31.createElement(RewardRevealPanel_default, { reward }), /* @__PURE__ */ React31.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React31.createElement(
    "button",
    {
      onClick: () => nextPage && nextPage(),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    "Continue"
  ), /* @__PURE__ */ React31.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setForceFallback(false);
        setStep("GAME");
        trailEvent("AR Shooter: Replay");
      },
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset"
    },
    "Play Again"
  ))))), /* @__PURE__ */ React31.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip Game",
      text: "Are you sure you want to skip playing the game?",
      onSkip: () => {
        setSkipDialogOpen(false);
        trailEvent("AR Shooter: Skipped");
        nextPage && nextPage();
      }
    }
  ), /* @__PURE__ */ React31.createElement(
    PermissionsDialog,
    {
      open: permissionsDialogOpen,
      setOpen: setPermissionsDialogOpen,
      controller: perms,
      title: "Allow camera to continue",
      description: "We use your camera (and motion on iOS) to play the AR game.",
      onComplete: async () => {
        setPermissionsDialogOpen(false);
        const updated = await refreshAndGet();
        const granted = requiredPermissions.every(
          (id) => updated[id] === "granted"
        );
        if (granted) setStep("GAME");
      }
    }
  ));
}

// src/components/Pages/SliceGame/SliceGame.tsx
import React33 from "react";

// src/components/Pages/arcade/ArcadeGameShell.tsx
import React32, {
  useCallback as useCallback9,
  useEffect as useEffect15,
  useRef as useRef15,
  useState as useState18
} from "react";
import { CheckIcon as CheckIcon11, SparklesIcon as SparklesIcon2 } from "@heroicons/react/20/solid";
var primaryButtonClass = "shadow-xs inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
var secondaryButtonClass = "inline-flex w-full justify-center rounded-md bg-mt-surface px-3 py-2 text-sm font-semibold text-mt-ink shadow-xs ring-1 ring-mt-border ring-inset hover:bg-mt-surface-2";
function ArcadeGameShell({
  content,
  eventName,
  trailEvent,
  nextPage,
  startLabel = "Start Game",
  renderGame
}) {
  const {
    title,
    backgroundImage,
    instructions,
    instructionsImage,
    completeImage,
    completeTitle,
    completeText,
    wrongAnswerImage,
    wrongAnswerTitle,
    wrongAnswerText
  } = content;
  const [step, setStep] = useState18("INSTRUCTIONS");
  const [replayKey, setReplayKey] = useState18(0);
  const instructionsFocusRef = useRef15(null);
  const completeFocusRef = useRef15(null);
  const wrongFocusRef = useRef15(null);
  useEffect15(() => {
    const target = step === "INSTRUCTIONS" ? instructionsFocusRef.current : step === "COMPLETE" ? completeFocusRef.current : step === "WRONG" ? wrongFocusRef.current : null;
    target?.focus();
  }, [step]);
  const start = useCallback9(() => {
    setReplayKey((k) => k + 1);
    setStep("GAME");
  }, []);
  const onWin = useCallback9(() => {
    trailEvent(`${eventName}: Completed`);
    setStep("COMPLETE");
  }, [eventName, trailEvent]);
  const onLose = useCallback9(() => {
    trailEvent(`${eventName}: Failed`);
    setStep("WRONG");
  }, [eventName, trailEvent]);
  const giveUp = useCallback9(() => {
    trailEvent(`${eventName}: Gave Up`);
    setStep("WRONG");
  }, [eventName, trailEvent]);
  return /* @__PURE__ */ React32.createElement(React32.Fragment, null, step === "INSTRUCTIONS" && /* @__PURE__ */ React32.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React32.createElement(QuestionCard, { image: instructionsImage }, title && /* @__PURE__ */ React32.createElement("h2", { className: "text-mt-ink mb-2 text-center text-xl font-bold" }, title), instructions && /* @__PURE__ */ React32.createElement(HTMLBlock_default, { html: instructions }), /* @__PURE__ */ React32.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React32.createElement(
    "button",
    {
      ref: instructionsFocusRef,
      className: primaryButtonClass,
      onClick: start
    },
    /* @__PURE__ */ React32.createElement(SparklesIcon2, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
    startLabel
  ), nextPage && /* @__PURE__ */ React32.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        trailEvent(`${eventName}: Skipped`);
        nextPage();
      },
      className: secondaryButtonClass
    },
    "Skip Game"
  )))), step === "GAME" && // `relative` + `h-full w-full` so the give-up button can be positioned
  // over the (also h-full w-full) canvas without a viewport-fixed element
  // that would escape the editor's contained preview frame.
  /* @__PURE__ */ React32.createElement("div", { className: "relative h-full w-full" }, /* @__PURE__ */ React32.createElement(
    GameCanvasGuard,
    {
      key: replayKey,
      logTag: eventName,
      onRetry: () => setReplayKey((k) => k + 1)
    },
    renderGame({ onWin, onLose, replayKey })
  ), /* @__PURE__ */ React32.createElement(
    "button",
    {
      type: "button",
      onClick: giveUp,
      "aria-label": "Give up and leave this game",
      className: "absolute top-3 right-3 z-20 rounded-md bg-black/60 px-3 py-1.5 text-sm font-semibold text-white shadow-sm backdrop-blur-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
    },
    "Give Up"
  )), step === "COMPLETE" && /* @__PURE__ */ React32.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React32.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React32.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React32.createElement(
    CheckIcon11,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React32.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React32.createElement(
    "h3",
    {
      ref: completeFocusRef,
      tabIndex: -1,
      className: "text-mt-ink focus-visible:outline-mt-primary text-base leading-6 font-semibold focus-visible:outline focus-visible:outline-offset-2"
    },
    completeTitle
  ), completeText && /* @__PURE__ */ React32.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React32.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), /* @__PURE__ */ React32.createElement("div", { className: "mt-5 flex flex-col gap-3" }, nextPage && /* @__PURE__ */ React32.createElement(
    "button",
    {
      onClick: () => nextPage(),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    "Continue"
  ), /* @__PURE__ */ React32.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        trailEvent(`${eventName}: Replay`);
        start();
      },
      className: secondaryButtonClass
    },
    "Play Again"
  ))))), step === "WRONG" && /* @__PURE__ */ React32.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React32.createElement(QuestionCard, { image: wrongAnswerImage }, /* @__PURE__ */ React32.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React32.createElement(
    "h3",
    {
      ref: wrongFocusRef,
      tabIndex: -1,
      className: "text-mt-ink focus-visible:outline-mt-primary text-base leading-6 font-semibold focus-visible:outline focus-visible:outline-offset-2"
    },
    wrongAnswerTitle || "Oh no!"
  ), wrongAnswerText && /* @__PURE__ */ React32.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React32.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: wrongAnswerText
    }
  )), /* @__PURE__ */ React32.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React32.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        trailEvent(`${eventName}: Replay`);
        start();
      },
      className: primaryButtonClass
    },
    "Try Again"
  ), nextPage && /* @__PURE__ */ React32.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        trailEvent(`${eventName}: Skipped`);
        nextPage();
      },
      className: secondaryButtonClass
    },
    "Skip Game"
  ))))));
}

// src/components/Pages/SliceGame/SliceGame.tsx
var SliceGame3D = React33.lazy(() => import("./SliceGame3D-A7XQMXRG.mjs"));
function SliceGame({ page, trailEvent, nextPage }) {
  return /* @__PURE__ */ React33.createElement(
    ArcadeGameShell,
    {
      content: page,
      eventName: "Slice Game",
      trailEvent,
      nextPage,
      startLabel: "Start Slicing",
      renderGame: ({ onWin, onLose, replayKey }) => /* @__PURE__ */ React33.createElement(
        SliceGame3D,
        {
          key: replayKey,
          images: page.images,
          bombImages: page.bombImages,
          targetScore: clampCount(page.targetScore, 1),
          spawnIntervalMs: clampOptionalDuration(page.spawnIntervalMs, 50),
          objectSpeed: page.objectSpeed,
          gravity: page.gravity,
          maxOnScreen: clampOptionalCount(page.maxOnScreen, 1),
          bombRatio: page.bombRatio,
          onWin,
          onLose
        }
      )
    }
  );
}

// src/components/Pages/WhackGame/WhackGame.tsx
import React34 from "react";
var WhackGame3D = React34.lazy(() => import("./WhackGame3D-X7ZT5PBI.mjs"));
function WhackGame({ page, trailEvent, nextPage }) {
  return /* @__PURE__ */ React34.createElement(
    ArcadeGameShell,
    {
      content: page,
      eventName: "Whack Game",
      trailEvent,
      nextPage,
      startLabel: "Start Whacking",
      renderGame: ({ onWin, onLose, replayKey }) => /* @__PURE__ */ React34.createElement(
        WhackGame3D,
        {
          key: replayKey,
          images: page.images,
          decoyImages: page.decoyImages,
          targetScore: clampCount(page.targetScore, 1),
          holeCount: clampOptionalCount(page.holeCount, 1),
          popDurationMs: clampOptionalDuration(page.popDurationMs, 100),
          spawnIntervalMs: clampOptionalDuration(page.spawnIntervalMs, 50),
          onWin,
          onLose
        }
      )
    }
  );
}

// src/components/Pages/TargetTossGame/TargetTossGame.tsx
import React35 from "react";
var TargetTossGame3D = React35.lazy(() => import("./TargetTossGame3D-V7T7BPWQ.mjs"));
function TargetTossGame({ page, trailEvent, nextPage }) {
  return /* @__PURE__ */ React35.createElement(
    ArcadeGameShell,
    {
      content: page,
      eventName: "Target Toss Game",
      trailEvent,
      nextPage,
      startLabel: "Start Tossing",
      renderGame: ({ onWin, onLose, replayKey }) => /* @__PURE__ */ React35.createElement(
        TargetTossGame3D,
        {
          key: replayKey,
          targetImages: page.targetImages,
          projectileImage: page.projectileImage,
          targetScore: clampCount(page.targetScore, 1),
          movingTarget: page.movingTarget,
          throws: clampOptionalCount(page.throws, 1),
          onWin,
          onLose
        }
      )
    }
  );
}

// src/components/Pages/StackGame/StackGame.tsx
import React36 from "react";
var StackGame3D = React36.lazy(() => import("./StackGame3D-FVBWYWBA.mjs"));
function StackGame({ page, trailEvent, nextPage }) {
  return /* @__PURE__ */ React36.createElement(
    ArcadeGameShell,
    {
      content: page,
      eventName: "Stack Game",
      trailEvent,
      nextPage,
      startLabel: "Start Stacking",
      renderGame: ({ onWin, onLose, replayKey }) => /* @__PURE__ */ React36.createElement(
        StackGame3D,
        {
          key: replayKey,
          blockImage: page.blockImage,
          blockColor: page.blockColor,
          targetScore: clampCount(page.targetScore, 1),
          speed: page.speed,
          onWin,
          onLose
        }
      )
    }
  );
}

// src/components/Pages/SpinWheelGame/SpinWheelGame.tsx
import React37 from "react";
var SpinWheelGame3D = React37.lazy(() => import("./SpinWheelGame3D-HEZUWKUL.mjs"));
function SpinWheelGame({ page, trailEvent, nextPage }) {
  return /* @__PURE__ */ React37.createElement(
    ArcadeGameShell,
    {
      content: page,
      eventName: "Spin Wheel Game",
      trailEvent,
      nextPage,
      startLabel: "Start Spinning",
      renderGame: ({ onWin, replayKey }) => /* @__PURE__ */ React37.createElement(
        SpinWheelGame3D,
        {
          key: replayKey,
          segments: page.segments,
          targetScore: clampCount(page.targetScore, 1),
          onWin
        }
      )
    }
  );
}

// src/components/Pages/BasketCatchGame/BasketCatchGame.tsx
import React38 from "react";
var BasketCatchGame3D = React38.lazy(() => import("./BasketCatchGame3D-GBQLMPTE.mjs"));
function BasketCatchGame({ page, trailEvent, nextPage }) {
  return /* @__PURE__ */ React38.createElement(
    ArcadeGameShell,
    {
      content: page,
      eventName: "Basket Catch Game",
      trailEvent,
      nextPage,
      startLabel: "Start Catching",
      renderGame: ({ onWin, onLose, replayKey }) => /* @__PURE__ */ React38.createElement(
        BasketCatchGame3D,
        {
          key: replayKey,
          itemImages: page.itemImages,
          basketImage: page.basketImage,
          catcherType: page.catcherType,
          targetScore: clampCount(page.targetScore, 1),
          lives: clampOptionalCount(page.lives, 1),
          useTilt: page.useTilt,
          fallSpeed: page.fallSpeed,
          spawnIntervalMs: clampOptionalDuration(page.spawnIntervalMs, 50),
          onWin,
          onLose
        }
      )
    }
  );
}

// src/components/Pages/MemoryPairsGame/MemoryPairsGame.tsx
import React39 from "react";
var MemoryPairsGame3D = React39.lazy(() => import("./MemoryPairsGame3D-2CYT75N3.mjs"));
function MemoryPairsGame({ page, trailEvent, nextPage }) {
  return /* @__PURE__ */ React39.createElement(
    ArcadeGameShell,
    {
      content: page,
      eventName: "Memory Pairs Game",
      trailEvent,
      nextPage,
      startLabel: "Start Matching",
      renderGame: ({ onWin, onLose, replayKey }) => /* @__PURE__ */ React39.createElement(
        MemoryPairsGame3D,
        {
          key: replayKey,
          images: page.images,
          gridColumns: clampOptionalCount(page.gridColumns, 1),
          pairCount: clampOptionalCount(page.pairCount, 1),
          moveLimit: clampOptionalCount(page.moveLimit, 1),
          onWin,
          onLose
        }
      )
    }
  );
}

// src/components/Pages/TiltMazeGame/TiltMazeGame.tsx
import React40 from "react";
var TiltMazeGame3D = React40.lazy(() => import("./TiltMazeGame3D-LINR647V.mjs"));
function TiltMazeGame({ page, trailEvent, nextPage }) {
  return /* @__PURE__ */ React40.createElement(
    ArcadeGameShell,
    {
      content: page,
      eventName: "Tilt Maze Game",
      trailEvent,
      nextPage,
      startLabel: "Start Rolling",
      renderGame: ({ onWin, onLose, replayKey }) => /* @__PURE__ */ React40.createElement(
        TiltMazeGame3D,
        {
          key: replayKey,
          ballImage: page.ballImage,
          mazeSize: page.mazeSize,
          wallColor: page.wallColor,
          timeLimitSec: clampOptionalDuration(page.timeLimitSec, 1),
          onWin,
          onLose
        }
      )
    }
  );
}

// src/components/Pages/Lumina/Lumina.tsx
import React41, {
  useCallback as useCallback10,
  useEffect as useEffect16,
  useMemo as useMemo7,
  useRef as useRef16,
  useState as useState19
} from "react";
import { CheckIcon as CheckIcon12, SparklesIcon as SparklesIcon3 } from "@heroicons/react/20/solid";

// src/components/Pages/Lumina/audio.ts
var CHIME_SCALE = [
  523.25,
  587.33,
  659.25,
  783.99,
  880,
  987.77,
  1046.5,
  1174.66
];
var LuminaAudio = class _LuminaAudio {
  ctx = null;
  master = null;
  muted = false;
  disposed = false;
  /** Master chime volume; also the level mute ramps back up to. */
  static MASTER_LEVEL = 0.6;
  ensureContext() {
    if (this.disposed) return null;
    try {
      if (!this.ctx) {
        this.ctx = new AudioContext();
        this.master = this.ctx.createGain();
        this.master.gain.value = this.muted ? 0 : _LuminaAudio.MASTER_LEVEL;
        this.master.connect(this.ctx.destination);
      }
      if (this.ctx.state === "suspended") void this.ctx.resume();
      return this.ctx;
    } catch {
      return null;
    }
  }
  /**
   * Prime (and resume) the AudioContext. Must be called from within a user
   * gesture (the "Enter the grove"/"Wander again" button) so the context is
   * allowed to start and later chimes aren't blocked by autoplay policy.
   */
  start() {
    this.ensureContext();
  }
  /**
   * Play a bell chime for a lantern bloom. `index` picks the pitch so the
   * grove plays an ascending phrase as it lights up.
   */
  playChime(index = 0) {
    if (this.muted) return;
    const ctx = this.ensureContext();
    if (!ctx || !this.master) return;
    const base = CHIME_SCALE[index % CHIME_SCALE.length];
    const now = ctx.currentTime;
    const partials = [
      { mult: 1, gain: 0.5, decay: 1.6 },
      { mult: 2.01, gain: 0.22, decay: 1.1 },
      { mult: 3.02, gain: 0.12, decay: 0.7 }
    ];
    for (const partial of partials) {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = base * partial.mult;
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(1e-4, now);
      gain.gain.exponentialRampToValueAtTime(partial.gain, now + 0.012);
      gain.gain.exponentialRampToValueAtTime(1e-4, now + partial.decay);
      osc.connect(gain);
      gain.connect(this.master);
      osc.start(now);
      osc.stop(now + partial.decay + 0.05);
    }
  }
  /** A soft, final shimmer when the last lantern lights and the grove wins. */
  playComplete() {
    if (this.muted) return;
    const ctx = this.ensureContext();
    if (!ctx || !this.master) return;
    const now = ctx.currentTime;
    [523.25, 659.25, 783.99, 1046.5].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      const gain = ctx.createGain();
      const start = now + i * 0.14;
      gain.gain.setValueAtTime(1e-4, start);
      gain.gain.exponentialRampToValueAtTime(0.3, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(1e-4, start + 1.8);
      osc.connect(gain);
      gain.connect(this.master);
      osc.start(start);
      osc.stop(start + 1.9);
    });
  }
  setMuted(muted) {
    this.muted = muted;
    if (!this.ctx || !this.master) return;
    const now = this.ctx.currentTime;
    this.master.gain.cancelScheduledValues(now);
    this.master.gain.setValueAtTime(this.master.gain.value, now);
    this.master.gain.linearRampToValueAtTime(
      muted ? 0 : _LuminaAudio.MASTER_LEVEL,
      now + 0.25
    );
  }
  isMuted() {
    return this.muted;
  }
  /**
   * Tear down the audio graph and close the context. Chime voices stop
   * themselves (each schedules its own `osc.stop`), so closing the context is
   * enough to release everything. Safe to call more than once.
   */
  dispose() {
    if (this.disposed) return;
    this.disposed = true;
    try {
      this.master?.disconnect();
    } catch {
    }
    this.master = null;
    const ctx = this.ctx;
    this.ctx = null;
    if (ctx) void ctx.close().catch(() => void 0);
  }
};

// src/components/Pages/Lumina/Lumina.tsx
var LuminaCanvas = React41.lazy(() => import("./LuminaCanvas-ZQRBOWZI.mjs"));
var DEFAULT_TARGET = "orb";
var DEFAULT_MOTE_COUNT = 200;
var MIN_MOTES = 120;
var MAX_MOTES = 320;
var TARGET_NAMES = {
  orb: "magic orb",
  egg: "Easter egg",
  bauble: "bauble",
  // Legacy variants render as the orb; keep names so old pages read sensibly.
  snowman: "magic orb",
  present: "magic orb",
  chest: "magic orb"
};
var COMPLETE_LINES = {
  orb: "It bursts with light \u2728",
  egg: "The egg cracks open! \u{1F95A}",
  bauble: "The bauble bursts open! \u2728",
  snowman: "It bursts with light \u2728",
  present: "It bursts with light \u2728",
  chest: "It bursts with light \u2728"
};
var clamp = (value, min, max) => Math.min(max, Math.max(min, Math.round(value)));
function Lumina({ page, trailEvent, nextPage }) {
  const {
    theme,
    target,
    moteCount,
    sceneBackgroundImage,
    revealImage,
    backgroundImage,
    title,
    instructions,
    instructionsImage,
    completeImage,
    completeTitle,
    completeText
  } = page;
  const resolvedTarget = target ?? DEFAULT_TARGET;
  const targetName = TARGET_NAMES[resolvedTarget];
  const resolvedMoteCount = useMemo7(
    () => clamp(moteCount ?? DEFAULT_MOTE_COUNT, MIN_MOTES, MAX_MOTES),
    [moteCount]
  );
  const [step, setStep] = useState19("INSTRUCTIONS");
  const [muted, setMuted] = useState19(false);
  const [percent, setPercent] = useState19(0);
  const [skipDialogOpen, setSkipDialogOpen] = useState19(false);
  const [sceneKey, setSceneKey] = useState19(0);
  const audioRef = useRef16(null);
  useEffect16(() => {
    const audio = new LuminaAudio();
    audioRef.current = audio;
    return () => {
      audio.dispose();
      audioRef.current = null;
    };
  }, []);
  const completeTimer = useRef16(null);
  const completeLatched = useRef16(false);
  const revealedLatched = useRef16(false);
  const clearCompleteTimer = useCallback10(() => {
    if (completeTimer.current !== null) {
      clearTimeout(completeTimer.current);
      completeTimer.current = null;
    }
  }, []);
  useEffect16(() => clearCompleteTimer, [clearCompleteTimer]);
  const handleComplete = useCallback10(() => {
    if (completeLatched.current) return;
    completeLatched.current = true;
    trailEvent("Lumina: Completed");
    if (!revealImage) {
      completeTimer.current = setTimeout(() => {
        completeTimer.current = null;
        setStep("COMPLETE");
      }, 1800);
    }
  }, [trailEvent, revealImage]);
  const handleRevealed = useCallback10(() => {
    if (revealedLatched.current) return;
    revealedLatched.current = true;
    trailEvent("Lumina: Revealed");
    if (nextPage) {
      nextPage();
    } else {
      setStep("COMPLETE");
    }
  }, [trailEvent, nextPage]);
  const handleProgress = useCallback10((nextPercent) => {
    setPercent(nextPercent);
  }, []);
  const startGame = useCallback10(() => {
    clearCompleteTimer();
    completeLatched.current = false;
    revealedLatched.current = false;
    audioRef.current?.start();
    setPercent(0);
    setStep("PLAY");
    trailEvent("Lumina: Started");
  }, [clearCompleteTimer, trailEvent]);
  const primaryButtonClass6 = "shadow-xs inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
  return /* @__PURE__ */ React41.createElement(React41.Fragment, null, step === "INSTRUCTIONS" && /* @__PURE__ */ React41.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React41.createElement(QuestionCard, { image: instructionsImage }, title && /* @__PURE__ */ React41.createElement("h2", { className: "text-mt-ink mb-2 text-center text-xl font-bold" }, title), instructions ? /* @__PURE__ */ React41.createElement(HTMLBlock_default, { html: instructions }) : /* @__PURE__ */ React41.createElement("p", { className: "text-mt-ink-soft text-center text-sm" }, "Draw circles around the ", targetName, " with your finger to weave the magic around it. Three loops and it bursts open! Tap the drifting sparks to catch them too."), /* @__PURE__ */ React41.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React41.createElement("button", { className: primaryButtonClass6, onClick: startGame }, /* @__PURE__ */ React41.createElement(SparklesIcon3, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }), "Gather the magic"), /* @__PURE__ */ React41.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset"
    },
    "Skip"
  )))), step === "PLAY" && /* @__PURE__ */ React41.createElement("div", { className: "bg-mt-surface relative h-full w-full touch-none overflow-hidden select-none" }, /* @__PURE__ */ React41.createElement(
    GameCanvasGuard,
    {
      key: sceneKey,
      logTag: "Lumina",
      emoji: "\u2728",
      loadingLabel: "Gathering the magic\u2026",
      onRetry: () => {
        setPercent(0);
        setSceneKey((k) => k + 1);
      }
    },
    /* @__PURE__ */ React41.createElement(
      LuminaCanvas,
      {
        theme,
        moteCount: resolvedMoteCount,
        target: resolvedTarget,
        sceneBackgroundImage,
        revealImage,
        muted,
        audio: audioRef.current,
        onProgress: handleProgress,
        onComplete: handleComplete,
        onRevealed: handleRevealed
      }
    )
  ), /* @__PURE__ */ React41.createElement("div", { className: "pointer-events-none absolute inset-0 z-20 select-none" }, /* @__PURE__ */ React41.createElement("div", { className: "absolute top-4 left-4 rounded-full bg-black/45 px-3 py-1 text-sm font-semibold text-white shadow-lg" }, "\u2728 ", percent, "% charged"), /* @__PURE__ */ React41.createElement("div", { className: "pointer-events-auto absolute top-4 right-4 flex items-center gap-2" }, /* @__PURE__ */ React41.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "flex h-10 items-center justify-center rounded-full bg-black/45 px-4 text-sm font-semibold text-white shadow-lg hover:bg-black/60"
    },
    "Skip"
  ), /* @__PURE__ */ React41.createElement(
    "button",
    {
      type: "button",
      onClick: () => setMuted((m) => !m),
      className: "flex h-10 w-10 items-center justify-center rounded-full bg-black/45 text-lg text-white shadow-lg hover:bg-black/60",
      "aria-label": muted ? "Unmute sound" : "Mute sound",
      "aria-pressed": muted
    },
    muted ? "\u{1F507}" : "\u{1F50A}"
  )), /* @__PURE__ */ React41.createElement("div", { className: "absolute bottom-6 left-1/2 max-w-[90%] -translate-x-1/2 rounded-full bg-black/45 px-4 py-2 text-center text-sm font-medium text-white shadow-lg" }, percent === 0 ? `Draw circles around the ${targetName} to weave the magic` : percent < 100 ? "Keep weaving \u2014 the magic is building!" : COMPLETE_LINES[resolvedTarget]))), step === "COMPLETE" && /* @__PURE__ */ React41.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React41.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React41.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React41.createElement(
    CheckIcon12,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React41.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React41.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle || "The magic is complete"), completeText && /* @__PURE__ */ React41.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React41.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), /* @__PURE__ */ React41.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React41.createElement(
    "button",
    {
      onClick: () => nextPage && nextPage(),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    "Continue"
  ), /* @__PURE__ */ React41.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        clearCompleteTimer();
        completeLatched.current = false;
        audioRef.current?.start();
        revealedLatched.current = false;
        setStep("PLAY");
        setPercent(0);
        trailEvent("Lumina: Replay");
      },
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset"
    },
    "Wander again"
  ))))), /* @__PURE__ */ React41.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip Lumina",
      text: "Are you sure you want to skip this magic game?",
      onSkip: () => {
        clearCompleteTimer();
        setSkipDialogOpen(false);
        trailEvent("Lumina: Skipped");
        nextPage && nextPage();
      }
    }
  ));
}

// src/components/Pages/QRCheck/QRCheck.tsx
import React44, { useCallback as useCallback11, useEffect as useEffect18, useRef as useRef18, useState as useState20 } from "react";
import {
  CheckIcon as CheckIcon13,
  InformationCircleIcon as InformationCircleIcon5,
  QrCodeIcon as QrCodeIcon2,
  XMarkIcon as XMarkIcon10
} from "@heroicons/react/20/solid";

// src/components/Pages/QRCheck/QRScanner.tsx
import React42, { useEffect as useEffect17, useRef as useRef17 } from "react";

// src/components/Pages/QRCheck/scanDedupe.ts
function initialDedupeState() {
  return { lastValue: null, noDecodeMs: 0 };
}
function stepScanDedupe(state, decoded, intervalMs, resetMs) {
  if (decoded) {
    const emit = decoded !== state.lastValue ? decoded : null;
    return { state: { lastValue: decoded, noDecodeMs: 0 }, emit };
  }
  const noDecodeMs = state.noDecodeMs + intervalMs;
  const lastValue = noDecodeMs >= resetMs ? null : state.lastValue;
  return { state: { lastValue, noDecodeMs }, emit: null };
}

// src/components/Pages/QRCheck/QRScanner.tsx
var SCAN_INTERVAL_MS2 = 200;
var FRAME_MAX_WIDTH2 = 640;
var LAST_VALUE_RESET_MS = 1e3;
var jsQRModule = null;
async function loadJsQR() {
  if (!jsQRModule) {
    jsQRModule = (await import("jsqr")).default;
  }
  return jsQRModule;
}
function QRScanner({ onDecode, onUnavailable }) {
  const { videoRef, videoReady, cameraError } = useCameraVideo();
  const canvasRef = useRef17(null);
  const onDecodeRef = useRef17(onDecode);
  useEffect17(() => {
    onDecodeRef.current = onDecode;
  }, [onDecode]);
  const onUnavailableRef = useRef17(onUnavailable);
  useEffect17(() => {
    onUnavailableRef.current = onUnavailable;
  }, [onUnavailable]);
  useEffect17(() => {
    if (cameraError) onUnavailable();
  }, [cameraError, onUnavailable]);
  useEffect17(() => {
    if (!videoReady) return;
    let cancelled = false;
    let timer;
    let dedupe = initialDedupeState();
    let jsQR = null;
    const scan = () => {
      if (cancelled || !jsQR) return;
      const video = videoRef.current;
      const canvas = canvasRef.current;
      let decoded = null;
      if (video && canvas && video.videoWidth > 0) {
        const scale = Math.min(1, FRAME_MAX_WIDTH2 / video.videoWidth);
        const w = Math.round(video.videoWidth * scale);
        const h = Math.round(video.videoHeight * scale);
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (ctx) {
          ctx.drawImage(video, 0, 0, w, h);
          try {
            const { data } = ctx.getImageData(0, 0, w, h);
            const result = jsQR(data, w, h, {
              inversionAttempts: "dontInvert"
            });
            decoded = result?.data ?? null;
          } catch (error) {
            console.error("[QRCheck] decode error", error);
          }
        }
      }
      const { state, emit } = stepScanDedupe(
        dedupe,
        decoded,
        SCAN_INTERVAL_MS2,
        LAST_VALUE_RESET_MS
      );
      dedupe = state;
      if (emit !== null && !cancelled) onDecodeRef.current(emit);
      if (!cancelled) timer = setTimeout(scan, SCAN_INTERVAL_MS2);
    };
    loadJsQR().then((mod) => {
      if (cancelled) return;
      jsQR = mod;
      timer = setTimeout(scan, SCAN_INTERVAL_MS2);
    }).catch((error) => {
      console.error("[QRCheck] failed to load decoder", error);
      if (!cancelled) onUnavailableRef.current();
    });
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [videoReady, videoRef]);
  return /* @__PURE__ */ React42.createElement("div", { className: "relative aspect-[3/4] w-full max-w-lg overflow-hidden rounded-lg bg-black sm:aspect-video" }, /* @__PURE__ */ React42.createElement(
    "video",
    {
      ref: videoRef,
      playsInline: true,
      muted: true,
      autoPlay: true,
      className: "h-full w-full object-cover"
    }
  ), /* @__PURE__ */ React42.createElement("canvas", { ref: canvasRef, className: "hidden" }), /* @__PURE__ */ React42.createElement("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center" }, /* @__PURE__ */ React42.createElement("div", { className: "h-2/3 w-2/3 rounded-2xl border-2 border-white/70 shadow-[0_0_0_100vmax_rgba(0,0,0,0.25)]" })), !videoReady && !cameraError && /* @__PURE__ */ React42.createElement("div", { className: "absolute inset-0 flex items-center justify-center bg-black/60" }, /* @__PURE__ */ React42.createElement("div", { className: "flex flex-col items-center gap-3 text-white" }, /* @__PURE__ */ React42.createElement("div", { className: "h-8 w-8 animate-spin rounded-full border-2 border-white/30 border-t-white" }), /* @__PURE__ */ React42.createElement("span", { className: "text-sm font-medium" }, "Starting camera\u2026"))), /* @__PURE__ */ React42.createElement("div", { className: "absolute inset-x-0 bottom-0 flex flex-col gap-2 bg-gradient-to-t from-black/70 to-transparent p-4" }, /* @__PURE__ */ React42.createElement("p", { className: "text-center text-sm font-medium text-white drop-shadow" }, "Line the QR code up inside the frame")));
}

// src/components/Pages/QRCheck/QRCheckInstructions.tsx
import React43 from "react";
import { QrCodeIcon } from "@heroicons/react/20/solid";
function QRCheckInstructions() {
  return /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement("div", { className: "border-mt-border-soft bg-mt-surface border-b px-4 pb-5 sm:px-6" }, /* @__PURE__ */ React43.createElement("h3", { className: "text-mt-ink flex items-center gap-2 text-base font-semibold" }, /* @__PURE__ */ React43.createElement(QrCodeIcon, { "aria-hidden": "true", className: "text-mt-primary h-5 w-5" }), "How to scan")), /* @__PURE__ */ React43.createElement("div", { className: "px-4 pt-4 sm:px-6" }, /* @__PURE__ */ React43.createElement("ul", { className: "text-mt-ink-muted list-disc space-y-2 pl-5 text-sm" }, /* @__PURE__ */ React43.createElement("li", null, "Find the QR code at this stop and hold your phone up to it."), /* @__PURE__ */ React43.createElement("li", null, "Line the code up inside the on-screen frame."), /* @__PURE__ */ React43.createElement("li", null, "Hold steady \u2014 it scans automatically, no button to press."), /* @__PURE__ */ React43.createElement("li", null, "Good, even lighting and a straight-on angle read fastest. Move a little closer or further away if it doesn't catch at first."))));
}

// src/components/Pages/QRCheck/match.ts
function matchesExpected(decoded, page) {
  const mode = page.matchMode ?? "exact";
  const caseSensitive = page.caseSensitive ?? false;
  let actual = decoded.trim();
  let expected = page.expectedValue.trim();
  if (!expected) return false;
  if (!caseSensitive) {
    actual = actual.toLowerCase();
    expected = expected.toLowerCase();
  }
  return mode === "contains" ? actual.includes(expected) : actual === expected;
}

// src/components/Pages/QRCheck/QRCheck.tsx
var DEFAULT_WRONG_SCAN_TITLE = "That's not the right code \u2014 keep looking!";
var WRONG_NOTICE_MS = 2800;
function QRCheck({ page, trailEvent, nextPage }) {
  const {
    backgroundImage,
    instructions,
    instructionsImage,
    completeImage,
    completeTitle,
    completeText,
    wrongScanTitle,
    wrongScanText
  } = page;
  const [step, setStep] = useState20("INSTRUCTIONS");
  const [skipDialogOpen, setSkipDialogOpen] = useState20(false);
  const [instructionsOpen, setInstructionsOpen] = useState20(false);
  const [wrongNotice, setWrongNotice] = useState20(false);
  const matchedRef = useRef18(false);
  const reportedWrongRef = useRef18(/* @__PURE__ */ new Set());
  const noticeTimerRef = useRef18(null);
  useEffect18(
    () => () => {
      if (noticeTimerRef.current) clearTimeout(noticeTimerRef.current);
    },
    []
  );
  const handleDecode = useCallback11(
    (value) => {
      if (matchedRef.current) return;
      if (matchesExpected(value, page)) {
        matchedRef.current = true;
        trailEvent("qrCheckPassed");
        setStep("COMPLETE");
        return;
      }
      if (!reportedWrongRef.current.has(value)) {
        reportedWrongRef.current.add(value);
        trailEvent("qrCheckWrongScan");
      }
      setWrongNotice(true);
      if (noticeTimerRef.current) clearTimeout(noticeTimerRef.current);
      noticeTimerRef.current = setTimeout(
        () => setWrongNotice(false),
        WRONG_NOTICE_MS
      );
    },
    [page, trailEvent]
  );
  const handleUnavailable = useCallback11(() => {
    trailEvent("qrCheckError");
    setStep("UNAVAILABLE");
  }, [trailEvent]);
  return /* @__PURE__ */ React44.createElement(React44.Fragment, null, /* @__PURE__ */ React44.createElement(
    "div",
    {
      className: "flex h-full w-full flex-col items-center justify-center overflow-auto bg-cover bg-center bg-no-repeat p-4",
      style: backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}
    },
    step === "INSTRUCTIONS" && /* @__PURE__ */ React44.createElement(QuestionCard, { image: instructionsImage }, instructions && /* @__PURE__ */ React44.createElement(HTMLBlock_default, { html: instructions }), /* @__PURE__ */ React44.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        onClick: () => setStep("SCANNING"),
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2.5 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2"
      },
      /* @__PURE__ */ React44.createElement(QrCodeIcon2, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
      "Start Scanning"
    ), /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2",
        onClick: () => setInstructionsOpen(true)
      },
      /* @__PURE__ */ React44.createElement(
        InformationCircleIcon5,
        {
          "aria-hidden": "true",
          className: "mr-2 h-6 w-6"
        }
      ),
      "Instructions"
    ), /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        onClick: () => setSkipDialogOpen(true),
        className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
      },
      "Skip Scanning"
    ))),
    step === "SCANNING" && /* @__PURE__ */ React44.createElement("div", { className: "flex w-full max-w-lg flex-col items-center gap-3" }, /* @__PURE__ */ React44.createElement("div", { className: "relative w-full" }, /* @__PURE__ */ React44.createElement(
      QRScanner,
      {
        onDecode: handleDecode,
        onUnavailable: handleUnavailable
      }
    ), wrongNotice && /* @__PURE__ */ React44.createElement(
      "div",
      {
        role: "status",
        "aria-live": "polite",
        className: "pointer-events-none absolute inset-x-3 top-3 rounded-lg bg-red-600/90 px-3 py-2 text-center text-white shadow-lg backdrop-blur-sm"
      },
      /* @__PURE__ */ React44.createElement("p", { className: "text-sm font-semibold" }, wrongScanTitle || DEFAULT_WRONG_SCAN_TITLE),
      wrongScanText && /* @__PURE__ */ React44.createElement("p", { className: "mt-0.5 text-xs text-white/90" }, wrongScanText)
    )), /* @__PURE__ */ React44.createElement("div", { className: "flex w-full flex-col gap-3" }, /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3.5 py-2 text-lg font-semibold shadow-xs focus-visible:outline focus-visible:outline-offset-2",
        onClick: () => setInstructionsOpen(true)
      },
      /* @__PURE__ */ React44.createElement(
        InformationCircleIcon5,
        {
          "aria-hidden": "true",
          className: "mr-2 h-6 w-6"
        }
      ),
      "Instructions"
    ), /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        onClick: () => setSkipDialogOpen(true),
        className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset"
      },
      "Skip Scanning"
    ))),
    step === "UNAVAILABLE" && /* @__PURE__ */ React44.createElement(QuestionCard, null, /* @__PURE__ */ React44.createElement("div", { className: "bg-mt-danger-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React44.createElement(
      XMarkIcon10,
      {
        className: "text-mt-danger h-6 w-6",
        "aria-hidden": "true"
      }
    )), /* @__PURE__ */ React44.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React44.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, "Camera unavailable"), /* @__PURE__ */ React44.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React44.createElement("p", { className: "text-mt-ink-muted text-sm" }, "We couldn't access your camera. Check your browser's camera permission and try again, or skip this step."))), /* @__PURE__ */ React44.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        onClick: () => setStep("SCANNING"),
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
      },
      "Try Again"
    ), /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        onClick: () => setSkipDialogOpen(true),
        className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset sm:col-start-1 sm:mt-0"
      },
      "Skip Scanning"
    ))),
    step === "COMPLETE" && /* @__PURE__ */ React44.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React44.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React44.createElement(
      CheckIcon13,
      {
        className: "text-mt-success h-6 w-6",
        "aria-hidden": "true"
      }
    )), /* @__PURE__ */ React44.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React44.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle || "You're in the right place!"), completeText && /* @__PURE__ */ React44.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React44.createElement(
      HTMLBlock_default,
      {
        className: "text-mt-ink-muted text-sm",
        html: completeText
      }
    )), /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        onClick: () => nextPage && nextPage(),
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
      },
      "Continue"
    )))
  ), /* @__PURE__ */ React44.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip Scanning",
      text: "Are you sure you want to skip scanning the QR code?",
      onSkip: () => {
        setSkipDialogOpen(false);
        trailEvent("qrCheckSkipped");
        nextPage && nextPage();
      }
    }
  ), /* @__PURE__ */ React44.createElement(
    PageModal,
    {
      open: instructionsOpen,
      onBackdropClick: () => setInstructionsOpen(false),
      ariaLabel: "How to scan",
      align: "end"
    },
    /* @__PURE__ */ React44.createElement("div", { className: "bg-mt-surface relative transform overflow-hidden rounded-lg px-4 pt-5 pb-4 text-left shadow-xl sm:my-8 sm:w-full sm:max-w-lg sm:p-6" }, /* @__PURE__ */ React44.createElement("div", { className: "absolute top-0 right-0 pt-5 pr-5" }, /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        onClick: () => setInstructionsOpen(false),
        className: "bg-mt-surface text-mt-ink-faint hover:text-mt-ink-muted focus:ring-mt-primary rounded-md focus:ring-2 focus:ring-offset-2 focus:outline-none"
      },
      /* @__PURE__ */ React44.createElement("span", { className: "sr-only" }, "Close"),
      /* @__PURE__ */ React44.createElement(XMarkIcon10, { "aria-hidden": "true", className: "size-6" })
    )), /* @__PURE__ */ React44.createElement(QRCheckInstructions, null), /* @__PURE__ */ React44.createElement("div", { className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" }, /* @__PURE__ */ React44.createElement(
      "button",
      {
        type: "button",
        onClick: () => setInstructionsOpen(false),
        className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs sm:ml-3 sm:w-auto"
      },
      "Continue"
    )))
  ));
}

// src/components/Pages/ARMarker/ARMarker.tsx
import React45, {
  useCallback as useCallback12,
  useEffect as useEffect19,
  useMemo as useMemo8,
  useRef as useRef19,
  useState as useState21
} from "react";
import { CheckIcon as CheckIcon14, SparklesIcon as SparklesIcon4 } from "@heroicons/react/20/solid";
var ARMarkerScene = React45.lazy(() => import("./ARMarkerScene-RGDD5FJS.mjs"));
var DEFAULT_DWELL_SECONDS = 4;
function ARMarker({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const {
    object,
    markerSizeMm,
    mount,
    dwellSeconds,
    display,
    windowScene,
    panoImageUrl,
    worldHeightM,
    persistentAnchor,
    backgroundImage,
    title,
    instructions,
    instructionsImage,
    completeImage,
    completeTitle,
    completeText
  } = page;
  const [step, setStep] = useState21("INSTRUCTIONS");
  const [sceneKey, setSceneKey] = useState21(0);
  const [skipDialogOpen, setSkipDialogOpen] = useState21(false);
  const [permissionsDialogOpen, setPermissionsDialogOpen] = useState21(false);
  const [requiredPermissions, setRequiredPermissions] = useState21(["camera"]);
  const [permissionsResolved, setPermissionsResolved] = useState21(false);
  const wasHidden = useRef19(false);
  const lockFiredRef = useRef19(false);
  const resolvedDwell = dwellSeconds ?? DEFAULT_DWELL_SECONDS;
  useEffect19(() => {
    let cancelled = false;
    void (async () => {
      if (!isIOS) {
        if (!cancelled) {
          setRequiredPermissions(["camera"]);
          setPermissionsResolved(true);
        }
        return;
      }
      const motionStatus = await getPermissionStatus("motion");
      if (cancelled) return;
      setRequiredPermissions(
        motionStatus !== "unavailable" ? ["camera", "motion"] : ["camera"]
      );
      setPermissionsResolved(true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  const perms = usePermissionStatuses(requiredPermissions);
  const {
    statuses,
    loading: permissionsLoading,
    hasLoaded,
    refresh,
    refreshAndGet,
    allGranted,
    anyDenied,
    anyUnavailable,
    anyPrompt,
    anyUserDenied
  } = perms;
  useEffect19(() => {
    if (step === "INSTRUCTIONS") refresh();
  }, [refresh, step, requiredPermissions]);
  const overallState = useMemo8(() => {
    if (anyUnavailable) return "unavailable";
    if (anyDenied) return "denied";
    if (anyUserDenied) return "user_denied";
    if (anyPrompt) return "prompt";
    return allGranted ? "granted" : "prompt";
  }, [allGranted, anyDenied, anyPrompt, anyUnavailable, anyUserDenied]);
  const motionBlocked = requiredPermissions.includes("motion") && statuses.motion === "blocked_by_system";
  const startView = useCallback12(() => {
    lockFiredRef.current = false;
    setStep("VIEW");
    trailEvent("AR Marker: Started");
  }, [trailEvent]);
  const handleFirstLock = useCallback12(() => {
    if (lockFiredRef.current) return;
    lockFiredRef.current = true;
    trailEvent("AR Marker: Locked");
  }, [trailEvent]);
  const handleComplete = useCallback12(() => {
    setStep("COMPLETE");
    trailEvent("AR Marker: Completed");
  }, [trailEvent]);
  useEffect19(() => {
    if (step !== "VIEW" || editorMode) return;
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        wasHidden.current = true;
        return;
      }
      if (wasHidden.current && document.visibilityState === "visible") {
        wasHidden.current = false;
        setStep("INSTRUCTIONS");
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [editorMode, step]);
  const primaryButtonClass6 = "shadow-xs inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
  const canStartDirectly = editorMode || permissionsResolved && overallState === "granted";
  return /* @__PURE__ */ React45.createElement(React45.Fragment, null, step === "INSTRUCTIONS" && /* @__PURE__ */ React45.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React45.createElement(QuestionCard, { image: instructionsImage }, title && /* @__PURE__ */ React45.createElement("h2", { className: "text-mt-ink mb-2 text-center text-xl font-bold" }, title), instructions && /* @__PURE__ */ React45.createElement(HTMLBlock_default, { html: instructions }), !editorMode && (!permissionsResolved || permissionsLoading || !hasLoaded) && /* @__PURE__ */ React45.createElement("p", { className: "text-mt-ink-muted text-sm" }, "Checking permissions\u2026"), !editorMode && permissionsResolved && !permissionsLoading && hasLoaded && /* @__PURE__ */ React45.createElement("div", { className: "text-mt-ink-soft space-y-2 text-sm" }, overallState === "prompt" && /* @__PURE__ */ React45.createElement("p", null, "We need access to your camera", requiredPermissions.includes("motion") ? " and motion" : "", " ", "to find the sign."), overallState === "user_denied" && /* @__PURE__ */ React45.createElement("p", null, "You chose not to enable the camera", requiredPermissions.includes("motion") ? " and motion" : "", " ", "yet. Enable it to point your camera at the sign."), overallState === "denied" && /* @__PURE__ */ React45.createElement("p", null, motionBlocked ? "Motion access is blocked by your device settings. Enable Motion & Orientation Access to place the object correctly." : "Camera access is blocked. Enable it to point your camera at the sign."), overallState === "unavailable" && /* @__PURE__ */ React45.createElement("p", null, "Camera is not available on this device.")), /* @__PURE__ */ React45.createElement("div", { className: "mt-5 flex flex-col gap-3" }, canStartDirectly && /* @__PURE__ */ React45.createElement("button", { className: primaryButtonClass6, onClick: startView }, /* @__PURE__ */ React45.createElement(SparklesIcon4, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }), "Start"), !editorMode && permissionsResolved && overallState !== "granted" && hasLoaded && /* @__PURE__ */ React45.createElement(
    "button",
    {
      className: primaryButtonClass6,
      onClick: () => setPermissionsDialogOpen(true)
    },
    "Enable camera",
    requiredPermissions.includes("motion") ? " & motion" : ""
  ), /* @__PURE__ */ React45.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset"
    },
    "Skip"
  )))), step === "VIEW" && // The scene is all procedural geometry over a camera feed — the guard
  // covers the real failure modes: WebGL context loss, a failed lazy-chunk
  // load, or a scene throw. Keyed so 'Look again' gets a fresh canvas.
  /* @__PURE__ */ React45.createElement("div", { className: "relative h-full w-full" }, /* @__PURE__ */ React45.createElement(
    GameCanvasGuard,
    {
      key: sceneKey,
      logTag: "ARMarker",
      emoji: "\u{1FAA7}",
      loadingLabel: "Loading AR...",
      onRetry: () => setSceneKey((k) => k + 1)
    },
    /* @__PURE__ */ React45.createElement(
      ARMarkerScene,
      {
        object,
        markerSizeMm,
        mount: mount ?? "auto",
        dwellSeconds: resolvedDwell,
        display,
        windowScene,
        panoImageUrl,
        worldHeightM,
        persistentAnchor,
        editorMode,
        onFirstLock: handleFirstLock,
        onComplete: handleComplete,
        onSkip: () => setSkipDialogOpen(true)
      }
    )
  ), /* @__PURE__ */ React45.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: "absolute top-3 right-3 z-40 rounded-full bg-black/55 px-3.5 py-1.5 text-sm font-semibold text-white shadow-lg hover:bg-black/70 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-white"
    },
    "Skip"
  )), step === "COMPLETE" && /* @__PURE__ */ React45.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React45.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React45.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React45.createElement(
    CheckIcon14,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React45.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React45.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle || "You found it!"), completeText && /* @__PURE__ */ React45.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React45.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), /* @__PURE__ */ React45.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React45.createElement(
    "button",
    {
      onClick: () => nextPage && nextPage(),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    "Continue"
  ), /* @__PURE__ */ React45.createElement(
    "button",
    {
      type: "button",
      onClick: () => {
        setSceneKey((k) => k + 1);
        setStep("VIEW");
      },
      className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset"
    },
    "Look again"
  ))))), /* @__PURE__ */ React45.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip",
      text: "Are you sure you want to skip finding the sign?",
      onSkip: () => {
        setSkipDialogOpen(false);
        trailEvent("AR Marker: Skipped");
        nextPage && nextPage();
      }
    }
  ), /* @__PURE__ */ React45.createElement(
    PermissionsDialog,
    {
      open: permissionsDialogOpen,
      setOpen: setPermissionsDialogOpen,
      controller: perms,
      title: "Allow camera to continue",
      description: "We use your camera (and motion on iOS) to find the sign and place the object.",
      onComplete: async () => {
        setPermissionsDialogOpen(false);
        const updated = await refreshAndGet();
        const granted = requiredPermissions.every(
          (id) => updated[id] === "granted"
        );
        if (granted) startView();
      }
    }
  ));
}

// src/components/Pages/MelodyGame/MelodyGame.tsx
import React53, {
  useCallback as useCallback14,
  useEffect as useEffect26,
  useMemo as useMemo9,
  useRef as useRef23,
  useState as useState23
} from "react";
import {
  ArrowPathIcon,
  CheckIcon as CheckIcon15,
  MusicalNoteIcon,
  SparklesIcon as SparklesIcon5
} from "@heroicons/react/20/solid";

// src/components/Pages/MelodyGame/instruments.ts
var INSTRUMENTS = ["strings", "piano", "drums", "chimes"];
var NOTE_COUNTS = {
  strings: 4,
  piano: 6,
  drums: 4,
  chimes: 5
};
var INSTRUMENT_LABELS = {
  strings: "Strings",
  piano: "Piano",
  drums: "Drums",
  chimes: "Chimes"
};
var INSTRUMENT_EMOJI = {
  strings: "\u{1F3B8}",
  piano: "\u{1F3B9}",
  drums: "\u{1F941}",
  chimes: "\u{1F514}"
};
var NOTE_COLORS = [
  "#ef476f",
  // rose
  "#ff9f45",
  // amber
  "#ffd166",
  // gold
  "#06d6a0",
  // mint
  "#22b8cf",
  // aqua
  "#4dabf7",
  // sky
  "#9775fa",
  // violet
  "#f06595"
  // pink
];
function noteColor(index) {
  return NOTE_COLORS[(index % NOTE_COLORS.length + NOTE_COLORS.length) % NOTE_COLORS.length];
}
var FREQUENCIES = {
  // G3 A3 C4 D4 — a low major-pentatonic cluster that plucks warmly.
  strings: [196, 220, 261.63, 293.66],
  // C4 D4 E4 G4 A4 C5 — a full major-pentatonic octave.
  piano: [261.63, 293.66, 329.63, 392, 440, 523.25],
  // Base body pitch per pad (kick, tom, snare, hat) — see DRUM_FLAVORS.
  drums: [90, 150, 220, 400],
  // C5 D5 E5 G5 A5 — a bright pentatonic bell run.
  chimes: [523.25, 587.33, 659.25, 783.99, 880]
};
var DRUM_FLAVORS = ["kick", "tom", "snare", "hat"];
function getInstrumentDef(id) {
  const noteCount = NOTE_COUNTS[id];
  return {
    id,
    label: INSTRUMENT_LABELS[id],
    emoji: INSTRUMENT_EMOJI[id],
    noteCount,
    frequencies: FREQUENCIES[id],
    colors: Array.from({ length: noteCount }, (_, i) => noteColor(i))
  };
}
function noteFrequency(id, index) {
  const freqs = FREQUENCIES[id];
  const i = Math.max(0, Math.min(freqs.length - 1, index));
  return freqs[i];
}

// src/components/Pages/MelodyGame/sequence.ts
var HINTS_AFTER_ATTEMPTS = 2;
function createSequenceState(sequence) {
  return {
    sequence: [...sequence],
    progress: 0,
    attempts: 0,
    status: sequence.length === 0 ? "complete" : "playing"
  };
}
function pressNote(state, note) {
  if (state.status === "complete") {
    return { state, outcome: "complete" };
  }
  const expected = state.sequence[state.progress];
  if (note === expected) {
    const progress = state.progress + 1;
    const complete = progress >= state.sequence.length;
    return {
      state: {
        ...state,
        progress,
        status: complete ? "complete" : "playing"
      },
      outcome: complete ? "complete" : "advance"
    };
  }
  return {
    state: { ...state, progress: 0, attempts: state.attempts + 1 },
    outcome: "wrong"
  };
}
function hintsActive(state) {
  return state.status === "playing" && state.attempts >= HINTS_AFTER_ATTEMPTS;
}
function nextExpectedNote(state) {
  if (state.status === "complete") return null;
  return state.sequence[state.progress] ?? null;
}

// src/components/Pages/MelodyGame/synth.ts
var MelodySynth = class _MelodySynth {
  ctx = null;
  master = null;
  noiseBuffer = null;
  // Cache of rendered plucked-string buffers, keyed by rounded frequency, so a
  // repeated pluck doesn't re-run the Karplus-Strong loop every tap.
  pluckCache = /* @__PURE__ */ new Map();
  muted = false;
  disposed = false;
  /** Master volume; also the level mute ramps back up to. */
  static MASTER_LEVEL = 0.55;
  ensureContext() {
    if (this.disposed) return null;
    try {
      if (!this.ctx) {
        const Ctor = window.AudioContext || window.webkitAudioContext;
        if (!Ctor) return null;
        this.ctx = new Ctor();
        this.master = this.ctx.createGain();
        this.master.gain.value = this.muted ? 0 : _MelodySynth.MASTER_LEVEL;
        this.master.connect(this.ctx.destination);
      }
      if (this.ctx.state === "suspended") void this.ctx.resume();
      return this.ctx;
    } catch {
      return null;
    }
  }
  /**
   * Prime (and resume) the AudioContext. Must be called from within a user
   * gesture (the Start / "Just play" button) so the context is allowed to start
   * and later notes aren't blocked by autoplay policy.
   */
  start() {
    this.ensureContext();
  }
  /** Play one note of an instrument. Safe to call straight from pointerdown. */
  playNote(instrument, index) {
    if (this.muted) return;
    const ctx = this.ensureContext();
    if (!ctx || !this.master) return;
    const now = ctx.currentTime;
    switch (instrument) {
      case "strings":
        this.playPluck(ctx, this.master, noteFrequency("strings", index), now);
        break;
      case "piano":
        this.playPiano(ctx, this.master, noteFrequency("piano", index), now);
        break;
      case "drums": {
        const drumIndex = Number.isFinite(index) ? Math.max(0, Math.min(DRUM_FLAVORS.length - 1, Math.trunc(index))) : 0;
        this.playDrum(
          ctx,
          this.master,
          DRUM_FLAVORS[drumIndex],
          noteFrequency("drums", drumIndex),
          now
        );
        break;
      }
      case "chimes":
        this.playBell(ctx, this.master, noteFrequency("chimes", index), now, 0.4);
        break;
    }
  }
  /** A soft "not quite" cue — two gently descending sine tones, never harsh. */
  playWrong() {
    if (this.muted) return;
    const ctx = this.ensureContext();
    if (!ctx || !this.master) return;
    const now = ctx.currentTime;
    [330, 277].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      const gain = ctx.createGain();
      const start = now + i * 0.13;
      gain.gain.setValueAtTime(1e-4, start);
      gain.gain.exponentialRampToValueAtTime(0.16, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(1e-4, start + 0.35);
      osc.connect(gain);
      gain.connect(this.master);
      osc.start(start);
      osc.stop(start + 0.4);
    });
  }
  /** A rising bell shimmer when the melody is completed. */
  playComplete() {
    if (this.muted) return;
    const ctx = this.ensureContext();
    if (!ctx || !this.master) return;
    const now = ctx.currentTime;
    [523.25, 659.25, 783.99, 1046.5].forEach((freq, i) => {
      this.playBell(ctx, this.master, freq, now + i * 0.13, 0.3);
    });
  }
  // --- Timbres -------------------------------------------------------------
  /** Karplus-Strong plucked string. */
  playPluck(ctx, dest, freq, now) {
    const buffer = this.renderPluck(ctx, freq);
    if (!buffer) {
      this.playPiano(ctx, dest, freq, now);
      return;
    }
    const src = ctx.createBufferSource();
    src.buffer = buffer;
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(1e-4, now);
    gain.gain.exponentialRampToValueAtTime(0.9, now + 5e-3);
    gain.gain.exponentialRampToValueAtTime(1e-4, now + 1.5);
    src.connect(gain);
    gain.connect(dest);
    src.start(now);
    src.stop(now + 1.55);
  }
  /** Build (and cache) a plucked-string buffer for a frequency. */
  renderPluck(ctx, freq) {
    if (typeof ctx.createBuffer !== "function") return null;
    const key = Math.round(freq);
    const cached = this.pluckCache.get(key);
    if (cached) return cached;
    const sampleRate = ctx.sampleRate || 44100;
    const duration = 1.5;
    const length2 = Math.max(1, Math.floor(sampleRate * duration));
    let buffer;
    try {
      buffer = ctx.createBuffer(1, length2, sampleRate);
    } catch {
      return null;
    }
    const data = buffer.getChannelData(0);
    const period = Math.max(2, Math.round(sampleRate / freq));
    for (let i = 0; i < period && i < length2; i++) {
      data[i] = Math.random() * 2 - 1;
    }
    const decay = 0.996;
    for (let i = period; i < length2; i++) {
      const prev = i - period - 1 >= 0 ? data[i - period - 1] : 0;
      data[i] = decay * 0.5 * (data[i - period] + prev);
    }
    this.pluckCache.set(key, buffer);
    return buffer;
  }
  /** Detuned triangle/sine partial stack with a percussive piano envelope. */
  playPiano(ctx, dest, freq, now) {
    const partials = [
      { mult: 1, type: "triangle", gain: 0.5, decay: 1.2, detune: 0 },
      { mult: 2, type: "sine", gain: 0.16, decay: 0.9, detune: 4 },
      { mult: 3, type: "sine", gain: 0.07, decay: 0.6, detune: -3 }
    ];
    for (const partial of partials) {
      const osc = ctx.createOscillator();
      osc.type = partial.type;
      osc.frequency.value = freq * partial.mult;
      if (osc.detune) osc.detune.value = partial.detune;
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(1e-4, now);
      gain.gain.exponentialRampToValueAtTime(partial.gain, now + 4e-3);
      gain.gain.exponentialRampToValueAtTime(1e-4, now + partial.decay);
      osc.connect(gain);
      gain.connect(dest);
      osc.start(now);
      osc.stop(now + partial.decay + 0.05);
    }
  }
  /** Noise burst + pitched sine drop, flavoured per pad. */
  playDrum(ctx, dest, flavor, baseFreq, now) {
    const cfg = {
      kick: {
        drop: 45,
        bodyGain: 0.9,
        bodyDecay: 0.28,
        noise: 0.05,
        nDecay: 0.05,
        subBass: 0.85
      },
      tom: {
        drop: 90,
        bodyGain: 0.7,
        bodyDecay: 0.3,
        noise: 0.08,
        nDecay: 0.08,
        subBass: 0.4
      },
      snare: {
        drop: 180,
        bodyGain: 0.28,
        bodyDecay: 0.16,
        noise: 0.5,
        nDecay: 0.2,
        subBass: 0
      },
      hat: {
        drop: 400,
        bodyGain: 0.05,
        bodyDecay: 0.05,
        noise: 0.4,
        nDecay: 0.06,
        subBass: 0
      }
    }[flavor];
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(baseFreq, now);
    osc.frequency.exponentialRampToValueAtTime(cfg.drop, now + cfg.bodyDecay);
    const bodyGain = ctx.createGain();
    bodyGain.gain.setValueAtTime(cfg.bodyGain, now);
    bodyGain.gain.exponentialRampToValueAtTime(1e-4, now + cfg.bodyDecay);
    osc.connect(bodyGain);
    bodyGain.connect(dest);
    osc.start(now);
    osc.stop(now + cfg.bodyDecay + 0.05);
    if (cfg.noise > 0) {
      const noise = this.getNoiseSource(ctx);
      if (noise) {
        const noiseGain = ctx.createGain();
        noiseGain.gain.setValueAtTime(cfg.noise, now);
        noiseGain.gain.exponentialRampToValueAtTime(1e-4, now + cfg.nDecay);
        noise.connect(noiseGain);
        noiseGain.connect(dest);
        noise.start(now);
        noise.stop(now + cfg.nDecay + 0.02);
      }
    }
    if (cfg.subBass > 0) {
      const subDecay = 0.5;
      const sub = ctx.createOscillator();
      sub.type = "sine";
      sub.frequency.setValueAtTime(78, now);
      sub.frequency.exponentialRampToValueAtTime(52, now + 0.12);
      const subGain = ctx.createGain();
      subGain.gain.setValueAtTime(1e-4, now);
      subGain.gain.exponentialRampToValueAtTime(cfg.subBass, now + 8e-3);
      subGain.gain.exponentialRampToValueAtTime(1e-4, now + subDecay);
      sub.connect(subGain);
      subGain.connect(dest);
      sub.start(now);
      sub.stop(now + subDecay + 0.05);
    }
  }
  /** Inharmonic bell (Lumina recipe), reused for chimes and the win shimmer. */
  playBell(ctx, dest, base, start, peak) {
    const partials = [
      { mult: 1, gain: peak, decay: 1.8 },
      { mult: 2.01, gain: peak * 0.45, decay: 1.2 },
      { mult: 3.02, gain: peak * 0.25, decay: 0.8 }
    ];
    for (const partial of partials) {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = base * partial.mult;
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(1e-4, start);
      gain.gain.exponentialRampToValueAtTime(partial.gain, start + 0.01);
      gain.gain.exponentialRampToValueAtTime(1e-4, start + partial.decay);
      osc.connect(gain);
      gain.connect(dest);
      osc.start(start);
      osc.stop(start + partial.decay + 0.05);
    }
  }
  /** A short looping white-noise BufferSource (rebuilt per hit — one-shot). */
  getNoiseSource(ctx) {
    if (typeof ctx.createBufferSource !== "function") return null;
    try {
      if (!this.noiseBuffer && typeof ctx.createBuffer === "function") {
        const sr = ctx.sampleRate || 44100;
        const len = Math.max(1, Math.floor(sr * 0.3));
        this.noiseBuffer = ctx.createBuffer(1, len, sr);
        const data = this.noiseBuffer.getChannelData(0);
        for (let i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
      }
      const src = ctx.createBufferSource();
      if (this.noiseBuffer) src.buffer = this.noiseBuffer;
      return src;
    } catch {
      return null;
    }
  }
  // --- Mute / lifecycle ----------------------------------------------------
  setMuted(muted) {
    this.muted = muted;
    if (!this.ctx || !this.master) return;
    const now = this.ctx.currentTime;
    this.master.gain.cancelScheduledValues(now);
    this.master.gain.setValueAtTime(this.master.gain.value, now);
    this.master.gain.linearRampToValueAtTime(
      muted ? 0 : _MelodySynth.MASTER_LEVEL,
      now + 0.2
    );
  }
  isMuted() {
    return this.muted;
  }
  /**
   * Tear down the graph and close the context. Voices self-stop (each schedules
   * its own osc/src stop), so closing is enough to release everything. Safe to
   * call more than once; a disposed instance refuses to build anything new.
   */
  dispose() {
    if (this.disposed) return;
    this.disposed = true;
    try {
      this.master?.disconnect();
    } catch {
    }
    this.master = null;
    this.pluckCache.clear();
    this.noiseBuffer = null;
    const ctx = this.ctx;
    this.ctx = null;
    if (ctx) void ctx.close().catch(() => void 0);
  }
};

// src/components/Pages/MelodyGame/InstrumentView.tsx
import React50 from "react";

// src/components/Pages/MelodyGame/Chimes.tsx
import React46, { useEffect as useEffect21 } from "react";

// src/components/Pages/MelodyGame/usePressPulse.ts
import { useCallback as useCallback13, useEffect as useEffect20, useRef as useRef20, useState as useState22 } from "react";
function usePressPulse(count, durationMs = 240) {
  const [pulsed, setPulsed] = useState22(
    () => Array.from({ length: count }, () => false)
  );
  const timers = useRef20({});
  useEffect20(() => {
    Object.values(timers.current).forEach(clearTimeout);
    timers.current = {};
    setPulsed(Array.from({ length: count }, () => false));
  }, [count]);
  useEffect20(
    () => () => {
      Object.values(timers.current).forEach(clearTimeout);
      timers.current = {};
    },
    []
  );
  const pulse = useCallback13(
    (index) => {
      setPulsed((prev) => {
        const next = [...prev];
        next[index] = true;
        return next;
      });
      if (timers.current[index]) clearTimeout(timers.current[index]);
      timers.current[index] = setTimeout(() => {
        setPulsed((prev) => {
          const next = [...prev];
          next[index] = false;
          return next;
        });
      }, durationMs);
    },
    [durationMs]
  );
  return [pulsed, pulse];
}

// src/components/Pages/MelodyGame/Chimes.tsx
function Chimes({
  def,
  litNote,
  hintNote,
  wrongNote,
  disabled,
  onNote
}) {
  const [pulsed, pulse] = usePressPulse(def.noteCount, 600);
  useEffect21(() => {
    if (litNote !== null) pulse(litNote);
  }, [litNote, pulse]);
  return /* @__PURE__ */ React46.createElement("div", { className: "w-full max-w-md select-none" }, /* @__PURE__ */ React46.createElement("div", { className: "mx-auto mb-0 h-2 w-[92%] rounded-full bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 shadow" }), /* @__PURE__ */ React46.createElement("div", { className: "flex items-start justify-center gap-3" }, def.colors.map((color, i) => {
    const isPressed = pulsed[i] || litNote === i;
    const isHint = hintNote === i;
    const isWrong = wrongNote === i;
    const mid = (def.noteCount - 1) / 2;
    const height = 130 - Math.abs(i - mid) * 12;
    return /* @__PURE__ */ React46.createElement(
      "button",
      {
        key: i,
        type: "button",
        "aria-label": `Chime ${i + 1}`,
        "data-note-index": i,
        disabled,
        onPointerDown: (e) => {
          if (disabled) return;
          e.preventDefault();
          onNote(i);
          pulse(i);
        },
        onKeyDown: (e) => {
          if (disabled) return;
          if (e.key !== "Enter" && e.key !== " ") return;
          if (e.repeat) return;
          e.preventDefault();
          onNote(i);
          pulse(i);
        },
        className: "relative flex min-w-11 flex-col items-center disabled:cursor-default",
        style: { transformOrigin: "top center" }
      },
      /* @__PURE__ */ React46.createElement("span", { className: "h-3 w-px bg-amber-700/60" }),
      /* @__PURE__ */ React46.createElement(
        "span",
        {
          className: "block w-6 rounded-full border border-white/50",
          style: {
            height,
            background: `linear-gradient(to bottom, ${color}, ${color}cc 60%, ${color}88)`,
            transformOrigin: "top center",
            boxShadow: isPressed ? `0 0 26px 3px ${color}, inset 0 0 12px rgba(255,255,255,0.55)` : `0 4px 12px ${color}44`,
            animation: isWrong ? "melodyWrongShake 0.4s ease" : isPressed ? "melodyChimeSwing 0.6s ease" : void 0
          }
        }
      ),
      isHint && /* @__PURE__ */ React46.createElement(
        "span",
        {
          className: "pointer-events-none absolute top-3 w-6 rounded-full",
          style: {
            height,
            boxShadow: `0 0 0 3px ${color}`,
            animation: "melodyHintPulse 1s ease-in-out infinite"
          }
        }
      )
    );
  })));
}

// src/components/Pages/MelodyGame/Drums.tsx
import React47, { useEffect as useEffect22 } from "react";
function Drums({
  def,
  litNote,
  hintNote,
  wrongNote,
  disabled,
  onNote
}) {
  const [pulsed, pulse] = usePressPulse(def.noteCount);
  useEffect22(() => {
    if (litNote !== null) pulse(litNote);
  }, [litNote, pulse]);
  return /* @__PURE__ */ React47.createElement("div", { className: "mx-auto grid w-full max-w-xs grid-cols-2 gap-4 select-none" }, def.colors.map((color, i) => {
    const isPressed = pulsed[i] || litNote === i;
    const isHint = hintNote === i;
    const isWrong = wrongNote === i;
    return /* @__PURE__ */ React47.createElement(
      "button",
      {
        key: i,
        type: "button",
        "aria-label": `Pad ${i + 1}`,
        "data-note-index": i,
        disabled,
        onPointerDown: (e) => {
          if (disabled) return;
          e.preventDefault();
          onNote(i);
          pulse(i);
        },
        onKeyDown: (e) => {
          if (disabled) return;
          if (e.key !== "Enter" && e.key !== " ") return;
          if (e.repeat) return;
          e.preventDefault();
          onNote(i);
          pulse(i);
        },
        className: "relative aspect-square rounded-2xl border-4 border-white/70 shadow-lg transition-transform duration-100 ease-out disabled:cursor-default",
        style: {
          background: `radial-gradient(circle at 38% 32%, ${color}, ${color}bb 55%, ${color}77)`,
          transform: isPressed ? "scale(0.92)" : "scale(1)",
          boxShadow: isPressed ? `0 0 30px 4px ${color}, inset 0 0 20px rgba(255,255,255,0.5)` : `0 6px 16px ${color}55`,
          animation: isWrong ? "melodyWrongShake 0.4s ease" : void 0
        }
      },
      isPressed && /* @__PURE__ */ React47.createElement(
        "span",
        {
          className: "pointer-events-none absolute inset-0 rounded-2xl",
          style: { boxShadow: `0 0 0 4px ${color}66` }
        }
      ),
      isHint && /* @__PURE__ */ React47.createElement(
        "span",
        {
          className: "pointer-events-none absolute inset-[-6px] rounded-2xl",
          style: {
            boxShadow: `0 0 0 4px ${color}`,
            animation: "melodyHintPulse 1s ease-in-out infinite"
          }
        }
      )
    );
  }));
}

// src/components/Pages/MelodyGame/Piano.tsx
import React48, { useEffect as useEffect23 } from "react";
function Piano({
  def,
  litNote,
  hintNote,
  wrongNote,
  disabled,
  onNote
}) {
  const [pulsed, pulse] = usePressPulse(def.noteCount);
  useEffect23(() => {
    if (litNote !== null) pulse(litNote);
  }, [litNote, pulse]);
  return /* @__PURE__ */ React48.createElement("div", { className: "flex w-full max-w-md items-end justify-center gap-1.5 select-none" }, def.colors.map((color, i) => {
    const isPressed = pulsed[i] || litNote === i;
    const isHint = hintNote === i;
    const isWrong = wrongNote === i;
    return /* @__PURE__ */ React48.createElement(
      "button",
      {
        key: i,
        type: "button",
        "aria-label": `Note ${i + 1}`,
        "data-note-index": i,
        disabled,
        onPointerDown: (e) => {
          if (disabled) return;
          e.preventDefault();
          onNote(i);
          pulse(i);
        },
        onKeyDown: (e) => {
          if (disabled) return;
          if (e.key !== "Enter" && e.key !== " ") return;
          if (e.repeat) return;
          e.preventDefault();
          onNote(i);
          pulse(i);
        },
        className: "border-mt-border relative h-32 flex-1 rounded-b-lg border bg-gradient-to-b from-white to-gray-100 shadow-md transition-transform duration-150 ease-out disabled:cursor-default",
        style: {
          transformOrigin: "top center",
          transform: isPressed ? "translateY(4px) scaleY(0.97)" : "none",
          boxShadow: isPressed ? `0 0 22px 2px ${color}, inset 0 -6px 12px ${color}55` : void 0,
          animation: isWrong ? "melodyWrongShake 0.4s ease" : void 0
        }
      },
      /* @__PURE__ */ React48.createElement(
        "span",
        {
          className: "absolute inset-x-1 bottom-2 h-3 rounded-full",
          style: {
            backgroundColor: color,
            opacity: isPressed ? 1 : 0.75
          }
        }
      ),
      isHint && /* @__PURE__ */ React48.createElement(
        "span",
        {
          className: "pointer-events-none absolute inset-0 rounded-b-lg",
          style: {
            boxShadow: `inset 0 0 0 3px ${color}`,
            animation: "melodyHintPulse 1s ease-in-out infinite"
          }
        }
      )
    );
  }));
}

// src/components/Pages/MelodyGame/Strings.tsx
import React49, { useEffect as useEffect24, useRef as useRef21 } from "react";
var VB_W = 210;
var VB_H = 320;
var Y0 = 12;
var Y1 = VB_H - 12;
var MARGIN_X = 28;
function Strings({
  def,
  litNote,
  hintNote,
  wrongNote,
  disabled,
  onNote
}) {
  const count = def.noteCount;
  const containerRef = useRef21(null);
  const pathRefs = useRef21([]);
  const glowRefs = useRef21([]);
  const vibRefs = useRef21(
    Array.from({ length: count }, () => ({ amp: 0, t0: 0 }))
  );
  const rafRef = useRef21(null);
  const pointerDownRef = useRef21(false);
  const lastBandRef = useRef21(null);
  const xBase = (i) => MARGIN_X + i * (VB_W - 2 * MARGIN_X) / Math.max(1, count - 1);
  const straightPath = (i) => `M ${xBase(i)} ${Y0} L ${xBase(i)} ${Y1}`;
  const pluck = (index) => {
    if (index < 0 || index >= count) return;
    vibRefs.current[index] = {
      amp: 11,
      t0: (typeof performance !== "undefined" ? performance.now() : Date.now()) / 1e3
    };
  };
  useEffect24(() => {
    if (litNote !== null) pluck(litNote);
  }, [litNote]);
  useEffect24(() => {
    const now = () => (typeof performance !== "undefined" ? performance.now() : Date.now()) / 1e3;
    const buildPath = (i, vib, t) => {
      const elapsed = t - vib.t0;
      const amp = vib.amp * Math.exp(-5.5 * elapsed);
      const base = xBase(i);
      if (amp < 0.4) return straightPath(i);
      const osc = Math.cos(elapsed * 2 * Math.PI * 9);
      const segments = 20;
      let d = `M ${base} ${Y0}`;
      for (let s = 1; s <= segments; s++) {
        const u = s / segments;
        const y = Y0 + (Y1 - Y0) * u;
        const x = base + amp * Math.sin(Math.PI * u) * osc;
        d += ` L ${x.toFixed(1)} ${y.toFixed(1)}`;
      }
      return d;
    };
    const frame = () => {
      const t = now();
      for (let i = 0; i < count; i++) {
        const d = buildPath(i, vibRefs.current[i], t);
        pathRefs.current[i]?.setAttribute("d", d);
        glowRefs.current[i]?.setAttribute("d", d);
      }
      rafRef.current = requestAnimationFrame(frame);
    };
    rafRef.current = requestAnimationFrame(frame);
    return () => {
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
    };
  }, [count]);
  const bandFromEvent = (clientX) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect || rect.width === 0) return 0;
    const ratio = (clientX - rect.left) / rect.width;
    return Math.max(0, Math.min(count - 1, Math.floor(ratio * count)));
  };
  const strike = (index) => {
    pluck(index);
    onNote(index);
  };
  return /* @__PURE__ */ React49.createElement(
    "div",
    {
      ref: containerRef,
      className: "relative w-full max-w-md touch-none select-none",
      onPointerDown: (e) => {
        if (disabled) return;
        e.preventDefault();
        pointerDownRef.current = true;
        try {
          e.currentTarget.setPointerCapture?.(e.pointerId);
        } catch {
        }
        const band = bandFromEvent(e.clientX);
        lastBandRef.current = band;
        strike(band);
      },
      onPointerMove: (e) => {
        if (disabled || !pointerDownRef.current) return;
        const band = bandFromEvent(e.clientX);
        if (band !== lastBandRef.current) {
          lastBandRef.current = band;
          strike(band);
        }
      },
      onPointerUp: () => {
        pointerDownRef.current = false;
        lastBandRef.current = null;
      },
      onPointerCancel: () => {
        pointerDownRef.current = false;
        lastBandRef.current = null;
      }
    },
    /* @__PURE__ */ React49.createElement(
      "svg",
      {
        viewBox: `0 0 ${VB_W} ${VB_H}`,
        preserveAspectRatio: "none",
        className: "h-96 w-full",
        role: "img",
        "aria-label": `${def.label}: ${count} strings`
      },
      def.colors.map((color, i) => {
        const isHint = hintNote === i;
        const isWrong = wrongNote === i;
        const isLit = litNote === i;
        return /* @__PURE__ */ React49.createElement(
          "g",
          {
            key: i,
            style: {
              animation: isWrong ? "melodyWrongShake 0.4s ease" : void 0
            }
          },
          /* @__PURE__ */ React49.createElement(
            "path",
            {
              ref: (el) => {
                glowRefs.current[i] = el;
              },
              d: straightPath(i),
              fill: "none",
              stroke: color,
              strokeWidth: isLit ? 9 : 6,
              strokeLinecap: "round",
              style: {
                opacity: isHint ? void 0 : isLit ? 0.55 : 0.2,
                filter: "blur(3px)",
                animation: isHint ? "melodyHintPulse 1s ease-in-out infinite" : void 0
              }
            }
          ),
          /* @__PURE__ */ React49.createElement(
            "path",
            {
              ref: (el) => {
                pathRefs.current[i] = el;
              },
              d: straightPath(i),
              fill: "none",
              stroke: color,
              strokeWidth: 2.4,
              strokeLinecap: "round"
            }
          ),
          /* @__PURE__ */ React49.createElement("circle", { cx: xBase(i), cy: Y0, r: 4, fill: color }),
          /* @__PURE__ */ React49.createElement("circle", { cx: xBase(i), cy: Y1, r: 4, fill: color })
        );
      })
    ),
    Array.from({ length: count }, (_, i) => /* @__PURE__ */ React49.createElement(
      "button",
      {
        key: i,
        type: "button",
        "aria-label": `${def.label} string ${i + 1}`,
        "data-note-index": i,
        disabled,
        onKeyDown: (e) => {
          if (disabled) return;
          if (e.key !== "Enter" && e.key !== " ") return;
          if (e.repeat) return;
          e.preventDefault();
          strike(i);
        },
        className: "absolute inset-y-0 bg-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-inset disabled:cursor-default",
        style: { left: `${i / count * 100}%`, width: `${100 / count}%` }
      }
    ))
  );
}

// src/components/Pages/MelodyGame/InstrumentView.tsx
function InstrumentView(props) {
  switch (props.def.id) {
    case "strings":
      return /* @__PURE__ */ React50.createElement(Strings, { ...props });
    case "piano":
      return /* @__PURE__ */ React50.createElement(Piano, { ...props });
    case "drums":
      return /* @__PURE__ */ React50.createElement(Drums, { ...props });
    case "chimes":
      return /* @__PURE__ */ React50.createElement(Chimes, { ...props });
    default:
      return null;
  }
}

// src/components/Pages/MelodyGame/ParticleStage.tsx
import React51, {
  forwardRef,
  useEffect as useEffect25,
  useImperativeHandle,
  useRef as useRef22
} from "react";
var ParticleStage = forwardRef(
  function ParticleStage2({ className }, ref) {
    const canvasRef = useRef22(null);
    const sparklesRef = useRef22([]);
    const motesRef = useRef22([]);
    const rafRef = useRef22(null);
    const sizeRef = useRef22({ w: 0, h: 0, dpr: 1 });
    useImperativeHandle(ref, () => ({
      burst: (color, origin) => {
        const { w, h } = sizeRef.current;
        if (!w || !h) return;
        const originX = origin?.x ?? w * 0.5;
        const originY = origin?.y ?? h * 0.78;
        const count = 16;
        for (let i = 0; i < count; i++) {
          const angle = -Math.PI / 2 + (Math.random() - 0.5) * 1.5;
          const speed = 1.4 + Math.random() * 2.6;
          sparklesRef.current.push({
            x: originX + (Math.random() - 0.5) * 26,
            y: originY,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            life: 0,
            maxLife: 42 + Math.random() * 26,
            size: 2 + Math.random() * 3,
            color
          });
        }
        if (sparklesRef.current.length > 400) {
          sparklesRef.current.splice(0, sparklesRef.current.length - 400);
        }
      }
    }));
    useEffect25(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      const parent = canvas.parentElement;
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      const resize = () => {
        const rect = parent?.getBoundingClientRect();
        const w = Math.max(1, Math.floor(rect?.width ?? canvas.clientWidth));
        const h = Math.max(1, Math.floor(rect?.height ?? canvas.clientHeight));
        sizeRef.current = { w, h, dpr };
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        canvas.style.width = `${w}px`;
        canvas.style.height = `${h}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        seedMotes(w, h);
      };
      const seedMotes = (w, h) => {
        if (motesRef.current.length) return;
        const count = 26;
        motesRef.current = Array.from({ length: count }, () => ({
          x: Math.random() * w,
          y: Math.random() * h,
          vy: 0.12 + Math.random() * 0.35,
          drift: 0.3 + Math.random() * 0.6,
          phase: Math.random() * Math.PI * 2,
          size: 1.5 + Math.random() * 2.5,
          color: NOTE_COLORS[Math.floor(Math.random() * NOTE_COLORS.length)]
        }));
      };
      let observer = null;
      if (typeof ResizeObserver !== "undefined" && parent) {
        observer = new ResizeObserver(resize);
        observer.observe(parent);
      }
      resize();
      const frame = () => {
        const { w, h } = sizeRef.current;
        ctx.clearRect(0, 0, w, h);
        ctx.globalCompositeOperation = "lighter";
        for (const m of motesRef.current) {
          m.phase += 0.02;
          m.y -= m.vy;
          const x = m.x + Math.sin(m.phase) * m.drift * 6;
          if (m.y < -6) {
            m.y = h + 6;
            m.x = Math.random() * w;
          }
          ctx.globalAlpha = 0.25 + Math.sin(m.phase) * 0.12;
          ctx.fillStyle = m.color;
          ctx.beginPath();
          ctx.arc(x, m.y, m.size, 0, Math.PI * 2);
          ctx.fill();
        }
        const alive = [];
        for (const s of sparklesRef.current) {
          s.life += 1;
          if (s.life >= s.maxLife) continue;
          s.x += s.vx;
          s.y += s.vy;
          s.vy += 0.06;
          s.vx *= 0.98;
          const t = 1 - s.life / s.maxLife;
          ctx.globalAlpha = t;
          ctx.fillStyle = s.color;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.size * t, 0, Math.PI * 2);
          ctx.fill();
          alive.push(s);
        }
        sparklesRef.current = alive;
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
        rafRef.current = requestAnimationFrame(frame);
      };
      rafRef.current = requestAnimationFrame(frame);
      return () => {
        if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
        observer?.disconnect();
      };
    }, []);
    return /* @__PURE__ */ React51.createElement(
      "canvas",
      {
        ref: canvasRef,
        "aria-hidden": "true",
        className: `pointer-events-none absolute inset-0 h-full w-full ${className ?? ""}`
      }
    );
  }
);
var ParticleStage_default = ParticleStage;

// src/components/Pages/MelodyGame/MelodyCharacter.tsx
import React52 from "react";
function MelodyCharacter({
  characterImage,
  performing,
  bobKey,
  message
}) {
  return /* @__PURE__ */ React52.createElement("div", { className: "pointer-events-none flex items-end justify-center gap-3" }, /* @__PURE__ */ React52.createElement(
    "div",
    {
      key: bobKey,
      className: "melody-character-bob",
      style: { animationName: performing ? "melodyPerform" : "melodyBob" }
    },
    characterImage ? /* @__PURE__ */ React52.createElement("div", { className: "h-20 w-20 overflow-hidden rounded-2xl border-2 border-white/80 bg-white/90 shadow-lg" }, /* @__PURE__ */ React52.createElement(
      "img",
      {
        src: characterImage,
        alt: "",
        className: "h-full w-full object-cover"
      }
    )) : /* @__PURE__ */ React52.createElement(BuiltInSprite, null)
  ), message && /* @__PURE__ */ React52.createElement("div", { className: "text-mt-ink-soft relative mb-2 max-w-[60%] rounded-2xl bg-white/95 px-3 py-2 text-sm font-medium shadow-lg" }, message, /* @__PURE__ */ React52.createElement("span", { className: "absolute bottom-3 -left-1.5 h-3 w-3 rotate-45 bg-white/95" })));
}
function BuiltInSprite() {
  return /* @__PURE__ */ React52.createElement(
    "svg",
    {
      viewBox: "0 0 96 96",
      className: "h-20 w-20 drop-shadow-lg",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ React52.createElement("defs", null, /* @__PURE__ */ React52.createElement("radialGradient", { id: "melodyBody", cx: "38%", cy: "32%", r: "75%" }, /* @__PURE__ */ React52.createElement("stop", { offset: "0%", stopColor: "#a78bfa" }), /* @__PURE__ */ React52.createElement("stop", { offset: "60%", stopColor: "#7c5cf0" }), /* @__PURE__ */ React52.createElement("stop", { offset: "100%", stopColor: "#5b3fd0" }))),
    /* @__PURE__ */ React52.createElement("circle", { cx: "48", cy: "50", r: "34", fill: "url(#melodyBody)" }),
    /* @__PURE__ */ React52.createElement("circle", { cx: "32", cy: "60", r: "6", fill: "#ff8fab", opacity: "0.55" }),
    /* @__PURE__ */ React52.createElement("circle", { cx: "64", cy: "60", r: "6", fill: "#ff8fab", opacity: "0.55" }),
    /* @__PURE__ */ React52.createElement("g", { className: "melody-eye" }, /* @__PURE__ */ React52.createElement("circle", { cx: "38", cy: "46", r: "5.5", fill: "#fff" }), /* @__PURE__ */ React52.createElement("circle", { cx: "39", cy: "47", r: "2.6", fill: "#2b2140" })),
    /* @__PURE__ */ React52.createElement("g", { className: "melody-eye" }, /* @__PURE__ */ React52.createElement("circle", { cx: "58", cy: "46", r: "5.5", fill: "#fff" }), /* @__PURE__ */ React52.createElement("circle", { cx: "59", cy: "47", r: "2.6", fill: "#2b2140" })),
    /* @__PURE__ */ React52.createElement(
      "path",
      {
        d: "M40 62 Q48 70 56 62",
        fill: "none",
        stroke: "#2b2140",
        strokeWidth: "3",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ React52.createElement("g", { className: "melody-note-float" }, /* @__PURE__ */ React52.createElement("circle", { cx: "76", cy: "26", r: "4", fill: "#ffd166" }), /* @__PURE__ */ React52.createElement("rect", { x: "79", y: "12", width: "2.6", height: "15", rx: "1.2", fill: "#ffd166" }))
  );
}

// src/components/Pages/MelodyGame/styles.ts
var MELODY_KEYFRAMES = `
@keyframes melodyBob {
  0% { transform: translateY(0); }
  40% { transform: translateY(-6px); }
  100% { transform: translateY(0); }
}
@keyframes melodyPerform {
  0% { transform: translateY(0) scale(1); }
  35% { transform: translateY(-10px) scale(1.06); }
  100% { transform: translateY(0) scale(1); }
}
@keyframes melodyBlink {
  0%, 92%, 100% { transform: scaleY(1); }
  96% { transform: scaleY(0.1); }
}
@keyframes melodyFloat {
  0%, 100% { transform: translateY(0) rotate(-8deg); }
  50% { transform: translateY(-5px) rotate(8deg); }
}
@keyframes melodyHintPulse {
  0%, 100% { opacity: 0.35; transform: scale(1); }
  50% { opacity: 0.95; transform: scale(1.06); }
}
@keyframes melodyWrongShake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-5px); }
  40% { transform: translateX(5px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
}
@keyframes melodyChimeSwing {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(9deg); }
  55% { transform: rotate(-6deg); }
  80% { transform: rotate(3deg); }
  100% { transform: rotate(0deg); }
}
.melody-character-bob {
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
  animation-iteration-count: 1;
}
.melody-eye {
  transform-origin: center;
  animation: melodyBlink 4.5s ease-in-out infinite;
}
.melody-note-float {
  transform-origin: center;
  animation: melodyFloat 2.4s ease-in-out infinite;
}
`;

// src/components/Pages/MelodyGame/MelodyGame.tsx
var NOTE_PACING_MS = 620;
var NOTE_LIT_MS = 460;
var INTRO_MS = 500;
var WRONG_MS = 450;
var COMPLETE_DELAY_MS = 950;
var primaryButtonClass2 = "shadow-xs inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
var secondaryButtonClass2 = "inline-flex w-full items-center justify-center rounded-md bg-mt-surface px-3 py-2 text-sm font-semibold text-mt-ink shadow-xs ring-1 ring-mt-border ring-inset hover:bg-mt-surface-2";
function MelodyGame({ page, trailEvent, nextPage }) {
  const {
    instrument,
    characterImage,
    backgroundImage,
    title,
    instructions,
    instructionsImage,
    completeImage,
    completeTitle,
    completeText
  } = page;
  const def = useMemo9(() => getInstrumentDef(instrument), [instrument]);
  const allowFreePlay = page.allowFreePlay ?? true;
  const sequence = useMemo9(() => {
    const cleaned = page.sequence.filter(
      (n) => Number.isInteger(n) && n >= 0 && n < def.noteCount
    );
    return cleaned.length ? cleaned : [0];
  }, [page.sequence, def.noteCount]);
  const [step, setStep] = useState23("INSTRUCTIONS");
  const [muted, setMuted] = useState23(false);
  const [seqState, setSeqState] = useState23(
    () => createSequenceState(sequence)
  );
  const [litNote, setLitNote] = useState23(null);
  const [demoActive, setDemoActive] = useState23(false);
  const [wrongNote, setWrongNote] = useState23(null);
  const [bobKey, setBobKey] = useState23(0);
  const [glowColor, setGlowColor] = useState23(null);
  const [skipDialogOpen, setSkipDialogOpen] = useState23(false);
  const synthRef = useRef23(null);
  const particleRef = useRef23(null);
  const stageRef = useRef23(null);
  const instrumentContainerRef = useRef23(null);
  const seqStateRef = useRef23(seqState);
  const demoTimersRef = useRef23([]);
  const wrongTimerRef = useRef23(null);
  const wrongCueTimerRef = useRef23(null);
  const completeTimerRef = useRef23(null);
  const hintsReportedRef = useRef23(false);
  const freeOriginRef = useRef23("INSTRUCTIONS");
  useEffect26(() => {
    const synth = new MelodySynth();
    synthRef.current = synth;
    return () => {
      synth.dispose();
      synthRef.current = null;
    };
  }, []);
  useEffect26(() => {
    synthRef.current?.setMuted(muted);
  }, [muted]);
  useEffect26(() => {
    seqStateRef.current = seqState;
  }, [seqState]);
  const clearDemoTimers = useCallback14(() => {
    demoTimersRef.current.forEach(clearTimeout);
    demoTimersRef.current = [];
  }, []);
  const clearAllTimers = useCallback14(() => {
    clearDemoTimers();
    if (wrongTimerRef.current) clearTimeout(wrongTimerRef.current);
    if (wrongCueTimerRef.current) clearTimeout(wrongCueTimerRef.current);
    if (completeTimerRef.current) clearTimeout(completeTimerRef.current);
    wrongTimerRef.current = null;
    wrongCueTimerRef.current = null;
    completeTimerRef.current = null;
  }, [clearDemoTimers]);
  useEffect26(() => clearAllTimers, [clearAllTimers]);
  const flourish = useCallback14((index) => {
    const color = noteColor(index);
    const stageEl = stageRef.current;
    const targetEl = instrumentContainerRef.current?.querySelector(
      `[data-note-index="${index}"]`
    );
    if (stageEl && targetEl) {
      const stageRect = stageEl.getBoundingClientRect();
      const elRect = targetEl.getBoundingClientRect();
      particleRef.current?.burst(color, {
        x: elRect.left + elRect.width / 2 - stageRect.left,
        y: elRect.top + elRect.height / 2 - stageRect.top
      });
    } else {
      particleRef.current?.burst(color);
    }
    setGlowColor(color);
    setBobKey((k) => k + 1);
  }, []);
  const runDemo = useCallback14(() => {
    clearDemoTimers();
    setDemoActive(true);
    setLitNote(null);
    sequence.forEach((note, i) => {
      const at = INTRO_MS + i * NOTE_PACING_MS;
      demoTimersRef.current.push(
        setTimeout(() => {
          setLitNote(note);
          synthRef.current?.playNote(instrument, note);
          flourish(note);
        }, at)
      );
      demoTimersRef.current.push(
        setTimeout(() => setLitNote(null), at + NOTE_LIT_MS)
      );
    });
    demoTimersRef.current.push(
      setTimeout(
        () => {
          setDemoActive(false);
          setLitNote(null);
        },
        INTRO_MS + sequence.length * NOTE_PACING_MS
      )
    );
  }, [clearDemoTimers, sequence, instrument, flourish]);
  const startGame = useCallback14(() => {
    clearAllTimers();
    synthRef.current?.start();
    hintsReportedRef.current = false;
    const fresh = createSequenceState(sequence);
    seqStateRef.current = fresh;
    setSeqState(fresh);
    setWrongNote(null);
    setStep("PLAY");
    trailEvent("Melody Game: Started");
    runDemo();
  }, [clearAllTimers, sequence, runDemo, trailEvent]);
  const enterFree = useCallback14(
    (origin) => {
      clearAllTimers();
      freeOriginRef.current = origin;
      synthRef.current?.start();
      setDemoActive(false);
      setLitNote(null);
      setWrongNote(null);
      setStep("FREE");
      trailEvent("Melody Game: Free Play");
    },
    [clearAllTimers, trailEvent]
  );
  const handleComplete = useCallback14(() => {
    trailEvent("Melody Game: Completed");
    synthRef.current?.playComplete();
    if (completeTimerRef.current) clearTimeout(completeTimerRef.current);
    completeTimerRef.current = setTimeout(() => {
      completeTimerRef.current = null;
      clearDemoTimers();
      setStep("COMPLETE");
    }, COMPLETE_DELAY_MS);
  }, [trailEvent, clearDemoTimers]);
  const handleNote = useCallback14(
    (index) => {
      if (step === "PLAY" && seqStateRef.current.status === "complete") return;
      synthRef.current?.playNote(instrument, index);
      flourish(index);
      if (step === "FREE") return;
      if (demoActive) return;
      const { state, outcome } = pressNote(seqStateRef.current, index);
      seqStateRef.current = state;
      setSeqState(state);
      if (outcome === "complete") {
        handleComplete();
        return;
      }
      if (outcome === "wrong") {
        setWrongNote(index);
        if (wrongTimerRef.current) clearTimeout(wrongTimerRef.current);
        wrongTimerRef.current = setTimeout(() => setWrongNote(null), WRONG_MS);
        if (wrongCueTimerRef.current) clearTimeout(wrongCueTimerRef.current);
        wrongCueTimerRef.current = setTimeout(() => {
          wrongCueTimerRef.current = null;
          synthRef.current?.playWrong();
        }, 90);
        if (hintsActive(state) && !hintsReportedRef.current) {
          hintsReportedRef.current = true;
          trailEvent("Melody Game: Hints Shown");
        }
      }
    },
    [instrument, flourish, step, demoActive, handleComplete, trailEvent]
  );
  const doSkip = useCallback14(() => {
    clearAllTimers();
    setSkipDialogOpen(false);
    trailEvent("Melody Game: Skipped");
    nextPage?.();
  }, [clearAllTimers, trailEvent, nextPage]);
  const hintNote = step === "PLAY" && !demoActive && hintsActive(seqState) ? nextExpectedNote(seqState) : null;
  const characterMessage = demoActive ? "Listen closely\u2026" : hintNote !== null ? "Follow the glowing note" : "Now you try!";
  const stageDisabled = demoActive || step === "PLAY" && seqState.status === "complete";
  const renderStage = (mode) => /* @__PURE__ */ React53.createElement(
    "div",
    {
      ref: stageRef,
      className: "relative flex h-full w-full flex-col overflow-hidden bg-gradient-to-b from-[#2a1a52] via-[#3b2170] to-[#241147] select-none"
    },
    /* @__PURE__ */ React53.createElement("style", null, MELODY_KEYFRAMES),
    /* @__PURE__ */ React53.createElement(ParticleStage_default, { ref: particleRef }),
    /* @__PURE__ */ React53.createElement("div", { className: "relative z-20 flex items-center justify-between p-4" }, mode === "PLAY" ? /* @__PURE__ */ React53.createElement("div", { className: "flex items-center gap-2 rounded-full bg-black/30 px-3 py-1.5 backdrop-blur-sm" }, sequence.map((_, i) => /* @__PURE__ */ React53.createElement(
      "span",
      {
        key: i,
        className: "h-2.5 w-2.5 rounded-full transition-all duration-200",
        style: {
          backgroundColor: i < seqState.progress ? noteColor(sequence[i]) : "#ffffff55",
          transform: i < seqState.progress ? "scale(1.25)" : "scale(1)"
        }
      }
    ))) : /* @__PURE__ */ React53.createElement("span", { className: "rounded-full bg-black/30 px-3 py-1.5 text-sm font-semibold text-white backdrop-blur-sm" }, "Free play"), /* @__PURE__ */ React53.createElement(
      "button",
      {
        type: "button",
        onClick: () => setMuted((m) => !m),
        className: "flex h-10 w-10 items-center justify-center rounded-full bg-black/30 text-lg text-white shadow-lg backdrop-blur-sm hover:bg-black/50",
        "aria-label": muted ? "Unmute sound" : "Mute sound",
        "aria-pressed": muted
      },
      muted ? "\u{1F507}" : "\u{1F50A}"
    )),
    /* @__PURE__ */ React53.createElement("div", { className: "relative z-20 px-4" }, /* @__PURE__ */ React53.createElement(
      MelodyCharacter,
      {
        characterImage,
        performing: mode === "PLAY" && demoActive,
        bobKey,
        message: mode === "PLAY" ? characterMessage : "Play whatever you like!"
      }
    )),
    /* @__PURE__ */ React53.createElement("div", { className: "relative z-10 flex flex-1 items-center justify-center px-4" }, /* @__PURE__ */ React53.createElement(
      "div",
      {
        className: "pointer-events-none absolute inset-0 transition-colors duration-300",
        style: {
          background: glowColor ? `radial-gradient(circle at 50% 65%, ${glowColor}55, transparent 60%)` : "radial-gradient(circle at 50% 65%, #ffffff14, transparent 60%)"
        }
      }
    ), /* @__PURE__ */ React53.createElement(
      "div",
      {
        ref: instrumentContainerRef,
        className: "relative z-10 w-full max-w-md"
      },
      /* @__PURE__ */ React53.createElement(
        InstrumentView,
        {
          def,
          litNote,
          hintNote,
          wrongNote,
          disabled: stageDisabled,
          onNote: handleNote
        }
      )
    )),
    /* @__PURE__ */ React53.createElement("div", { className: "relative z-20 flex flex-col items-center gap-2 p-4" }, mode === "PLAY" ? /* @__PURE__ */ React53.createElement(
      "button",
      {
        type: "button",
        onClick: runDemo,
        disabled: stageDisabled,
        className: "text-mt-ink hover:bg-mt-surface inline-flex items-center gap-2 rounded-full bg-white/90 px-4 py-2 text-sm font-semibold shadow-lg disabled:opacity-60"
      },
      /* @__PURE__ */ React53.createElement(ArrowPathIcon, { "aria-hidden": "true", className: "h-4 w-4" }),
      "Hear it again"
    ) : /* @__PURE__ */ React53.createElement(
      "button",
      {
        type: "button",
        onClick: () => {
          if (freeOriginRef.current === "COMPLETE") {
            nextPage?.();
          } else {
            clearAllTimers();
            setStep("INSTRUCTIONS");
          }
        },
        className: "text-mt-ink hover:bg-mt-surface inline-flex items-center gap-2 rounded-full bg-white/90 px-4 py-2 text-sm font-semibold shadow-lg"
      },
      "Done playing"
    ), /* @__PURE__ */ React53.createElement(
      "button",
      {
        type: "button",
        onClick: () => setSkipDialogOpen(true),
        className: "text-xs font-medium text-white/70 underline-offset-2 hover:underline"
      },
      "Skip"
    ))
  );
  return /* @__PURE__ */ React53.createElement(React53.Fragment, null, step === "INSTRUCTIONS" && /* @__PURE__ */ React53.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React53.createElement("style", null, MELODY_KEYFRAMES), /* @__PURE__ */ React53.createElement(QuestionCard, { image: instructionsImage }, title && /* @__PURE__ */ React53.createElement("h2", { className: "text-mt-ink mb-2 text-center text-xl font-bold" }, title), /* @__PURE__ */ React53.createElement("div", { className: "mb-3 flex justify-center" }, /* @__PURE__ */ React53.createElement(
    MelodyCharacter,
    {
      characterImage,
      performing: false,
      bobKey: 0,
      message: ""
    }
  )), instructions ? /* @__PURE__ */ React53.createElement(HTMLBlock_default, { html: instructions }) : /* @__PURE__ */ React53.createElement("p", { className: "text-mt-ink-soft text-center text-sm" }, `Listen to the ${def.label.toLowerCase()} melody, then play it back to open the way. Miss a couple of times and the next note will light up to guide you.`), /* @__PURE__ */ React53.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React53.createElement("button", { className: primaryButtonClass2, onClick: startGame }, /* @__PURE__ */ React53.createElement(MusicalNoteIcon, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }), "Start the melody"), allowFreePlay && /* @__PURE__ */ React53.createElement(
    "button",
    {
      type: "button",
      className: secondaryButtonClass2,
      onClick: () => enterFree("INSTRUCTIONS")
    },
    "Just play"
  ), /* @__PURE__ */ React53.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: secondaryButtonClass2
    },
    "Skip"
  )))), step === "PLAY" && renderStage("PLAY"), step === "FREE" && renderStage("FREE"), step === "COMPLETE" && /* @__PURE__ */ React53.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React53.createElement("style", null, MELODY_KEYFRAMES), /* @__PURE__ */ React53.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React53.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React53.createElement(
    CheckIcon15,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React53.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React53.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, completeTitle || "Perfectly played!"), completeText && /* @__PURE__ */ React53.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React53.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), /* @__PURE__ */ React53.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React53.createElement(
    "button",
    {
      onClick: () => nextPage?.(),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-1 inline-flex w-full items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    /* @__PURE__ */ React53.createElement(SparklesIcon5, { "aria-hidden": "true", className: "mr-2 h-5 w-5" }),
    "Continue"
  ), allowFreePlay && /* @__PURE__ */ React53.createElement(
    "button",
    {
      type: "button",
      onClick: () => enterFree("COMPLETE"),
      className: secondaryButtonClass2
    },
    "Play freely"
  ))))), /* @__PURE__ */ React53.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      title: "Skip the melody",
      text: "Are you sure you want to skip playing the melody?",
      onSkip: doSkip
    }
  ));
}

// src/components/Pages/NumberLock/NumberLock.tsx
import React54, {
  useCallback as useCallback15,
  useEffect as useEffect27,
  useMemo as useMemo10,
  useRef as useRef24,
  useState as useState24
} from "react";
import {
  CheckIcon as CheckIcon16,
  LightBulbIcon,
  LockClosedIcon,
  SparklesIcon as SparklesIcon6,
  XMarkIcon as XMarkIcon11
} from "@heroicons/react/20/solid";
import {
  NUMBER_LOCK_SKIPPED_ANSWER
} from "magical-trails";

// src/components/Pages/NumberLock/types.ts
var LOCK_ENTRY_MODE = {
  keypad: "sequential",
  briefcase: "wheels",
  padlock: "wheels",
  safe: "sequential",
  chest: "wheels"
};
var WRONG_STATUS_MS2 = 700;

// src/components/Pages/NumberLock/lockLogic.ts
var DEFAULT_HINT_AFTER_ATTEMPTS = 3;
function isValidCode(code) {
  return /^\d{1,6}$/.test(code);
}
function entryModeFor(style) {
  return LOCK_ENTRY_MODE[style];
}
function initialEntry(mode, digitCount) {
  return mode === "wheels" ? "0".repeat(digitCount) : "";
}
function sanitizeEntry(next, mode, digitCount) {
  const digits = next.replace(/\D/g, "").slice(0, digitCount);
  if (mode === "wheels") return digits.padEnd(digitCount, "0");
  return digits;
}
function isEntryComplete(entry, digitCount) {
  return entry.length === digitCount;
}
function isCorrect(entry, code) {
  return entry === code;
}
function shouldShowHint(wrongAttempts, hint, hintAfterAttempts) {
  if (!hint) return false;
  const threshold = hintAfterAttempts && hintAfterAttempts > 0 ? Math.floor(hintAfterAttempts) : DEFAULT_HINT_AFTER_ATTEMPTS;
  return wrongAttempts >= threshold;
}
function entryAfterWrong(entry, mode, digitCount) {
  return mode === "wheels" ? entry : initialEntry(mode, digitCount);
}

// src/components/Pages/NumberLock/NumberLock.tsx
var SCENES = {
  keypad: React54.lazy(() => import("./KeypadScene-HYYQ4NHR.mjs")),
  briefcase: React54.lazy(() => import("./BriefcaseScene-GL4LJJLY.mjs")),
  padlock: React54.lazy(() => import("./PadlockScene-IDZEWVLW.mjs")),
  safe: React54.lazy(() => import("./SafeScene-LG2N7NZN.mjs")),
  chest: React54.lazy(() => import("./ChestScene-JUTCJVA2.mjs"))
};
var STYLE_COPY = {
  keypad: {
    label: "keypad",
    startLabel: "Go to the keypad",
    submitLabel: "Enter",
    backdrop: "radial-gradient(120% 80% at 50% 0%, #1b2a3a 0%, #0b1119 55%, #05080c 100%)",
    wrongText: "Access denied. Check the number and try again."
  },
  briefcase: {
    label: "briefcase",
    startLabel: "Open the briefcase",
    submitLabel: "Release the latch",
    backdrop: "radial-gradient(120% 80% at 50% 0%, #3a2a1c 0%, #1a120b 55%, #0a0704 100%)",
    wrongText: "The latch holds fast. Check the number and try again."
  },
  padlock: {
    label: "padlock",
    startLabel: "Go to the padlock",
    submitLabel: "Pull the shackle",
    backdrop: "radial-gradient(120% 80% at 50% 0%, #2a2f2a 0%, #121512 55%, #060806 100%)",
    wrongText: "The shackle won\u2019t budge. Check the number and try again."
  },
  safe: {
    label: "safe",
    startLabel: "Approach the safe",
    submitLabel: "Turn the handle",
    backdrop: "radial-gradient(120% 80% at 50% 0%, #1f2d26 0%, #0d1512 55%, #050807 100%)",
    wrongText: "The handle jams. Check the number and try again."
  },
  chest: {
    label: "chest",
    startLabel: "Open the chest",
    submitLabel: "Pull the padlock",
    backdrop: "radial-gradient(120% 80% at 50% 0%, #3a1f3d 0%, #1a1017 55%, #080509 100%)",
    wrongText: "The padlock holds tight. Check the number and try again."
  }
};
var REVEAL_MS = 900;
var primaryButtonClass3 = "shadow-xs inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
var secondaryButtonClass3 = "inline-flex w-full items-center justify-center rounded-md bg-mt-surface px-3 py-2 text-sm font-semibold text-mt-ink shadow-xs ring-1 ring-mt-border ring-inset hover:bg-mt-surface-2";
function NumberLock({
  page,
  trailEvent,
  nextPage,
  answerQuestion,
  editorMode,
  startAtLock = false
}) {
  const {
    title,
    instructions,
    instructionsImage,
    backgroundImage,
    lockPrompt,
    plateText,
    hint,
    hintAfterAttempts,
    completeTitle,
    completeText,
    completeImage,
    revealImage
  } = page;
  const lockStyle = page.lockStyle ?? "keypad";
  const allowSkip = page.allowSkip ?? true;
  const copy = STYLE_COPY[lockStyle];
  const mode = entryModeFor(lockStyle);
  const codeValid = isValidCode(page.code);
  const digitCount = codeValid ? page.code.length : 4;
  const reduceMotion = usePrefersReducedMotion();
  const alreadyUnlocked = codeValid && page.userAnswer !== void 0 && page.userAnswer === page.code;
  const alreadySkipped = codeValid && allowSkip && page.userAnswer === NUMBER_LOCK_SKIPPED_ANSWER;
  const [step, setStep] = useState24(
    alreadyUnlocked || alreadySkipped ? "COMPLETE" : startAtLock ? "LOCK" : "INTRO"
  );
  const [skipped, setSkipped] = useState24(alreadySkipped);
  const [entry, setEntry] = useState24(() => initialEntry(mode, digitCount));
  const [status, setStatus] = useState24("idle");
  const [wrongAttempts, setWrongAttempts] = useState24(0);
  const [lastWrong, setLastWrong] = useState24(false);
  const [showTyped, setShowTyped] = useState24(false);
  const [typed, setTyped] = useState24("");
  const [skipDialogOpen, setSkipDialogOpen] = useState24(false);
  const [revealOpen, setRevealOpen] = useState24(false);
  const [sceneKey, setSceneKey] = useState24(0);
  const wrongTimer = useRef24(null);
  const advancedRef = useRef24(false);
  const hintShownRef = useRef24(false);
  useEffect27(
    () => () => {
      if (wrongTimer.current) clearTimeout(wrongTimer.current);
    },
    []
  );
  const startedRef = useRef24(false);
  useEffect27(() => {
    if (startedRef.current || step !== "LOCK" || !codeValid) return;
    startedRef.current = true;
    trailEvent("Number Lock: Started");
  }, [step, codeValid, trailEvent]);
  const hintVisible = shouldShowHint(wrongAttempts, hint, hintAfterAttempts);
  useEffect27(() => {
    if (hintVisible && !hintShownRef.current) {
      hintShownRef.current = true;
      trailEvent("Number Lock: Hint Shown");
    }
  }, [hintVisible, trailEvent]);
  const handleEntryChange = useCallback15(
    (next) => {
      if (status !== "idle") return;
      setLastWrong(false);
      setEntry(sanitizeEntry(next, mode, digitCount));
    },
    [status, mode, digitCount]
  );
  const submit = useCallback15(
    (candidate) => {
      if (status !== "idle") return;
      if (!isEntryComplete(candidate, digitCount)) return;
      if (isCorrect(candidate, page.code)) {
        setStatus("unlocked");
        setLastWrong(false);
        trailEvent("Number Lock: Unlocked");
        answerQuestion?.(candidate);
        return;
      }
      setStatus("wrong");
      setLastWrong(true);
      setWrongAttempts((n) => n + 1);
      trailEvent("Number Lock: Wrong");
      if (wrongTimer.current) clearTimeout(wrongTimer.current);
      wrongTimer.current = setTimeout(() => {
        setEntry((e) => entryAfterWrong(e, mode, digitCount));
        setStatus("idle");
      }, WRONG_STATUS_MS2);
    },
    [status, digitCount, page.code, trailEvent, answerQuestion, mode]
  );
  const handleSubmit = useCallback15(() => submit(entry), [submit, entry]);
  const advance = useCallback15(() => {
    if (advancedRef.current) return;
    advancedRef.current = true;
    if (nextPage) nextPage();
    else setStep("COMPLETE");
  }, [nextPage]);
  const OPENED_FALLBACK_MS2 = 2500;
  const openedRef = useRef24(false);
  useEffect27(() => {
    if (status !== "unlocked") return;
    const t = setTimeout(() => {
      if (!openedRef.current) handleOpenedRef.current();
    }, OPENED_FALLBACK_MS2);
    return () => clearTimeout(t);
  }, [status]);
  const handleOpenedRef = useRef24(() => {
  });
  const handleOpened = useCallback15(() => {
    if (openedRef.current) return;
    openedRef.current = true;
    if (revealImage) {
      setRevealOpen(true);
      return;
    }
    setStep("COMPLETE");
  }, [revealImage]);
  handleOpenedRef.current = handleOpened;
  useEffect27(() => {
    if (!revealOpen) return;
    const t = setTimeout(advance, REVEAL_MS + 500);
    return () => clearTimeout(t);
  }, [revealOpen, advance]);
  const startLock = useCallback15(() => {
    setStep("LOCK");
  }, []);
  const doSkip = useCallback15(() => {
    setSkipDialogOpen(false);
    if (status !== "idle") return;
    trailEvent("Number Lock: Skipped");
    answerQuestion?.(NUMBER_LOCK_SKIPPED_ANSWER);
    if (nextPage) {
      nextPage();
      return;
    }
    setSkipped(true);
    setStep("COMPLETE");
  }, [status, trailEvent, nextPage, answerQuestion]);
  const Scene = SCENES[lockStyle];
  const sceneProps = useMemo10(
    () => ({
      digitCount,
      entry,
      onEntryChange: handleEntryChange,
      onSubmit: handleSubmit,
      status,
      onOpened: handleOpened,
      reduceMotion,
      prompt: lockPrompt,
      plateText
    }),
    [
      digitCount,
      entry,
      handleEntryChange,
      handleSubmit,
      status,
      handleOpened,
      reduceMotion,
      lockPrompt,
      plateText
    ]
  );
  if (!codeValid) {
    return /* @__PURE__ */ React54.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React54.createElement(QuestionCard, { image: instructionsImage }, /* @__PURE__ */ React54.createElement("div", { className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100" }, /* @__PURE__ */ React54.createElement(XMarkIcon11, { className: "h-6 w-6 text-yellow-600", "aria-hidden": "true" })), /* @__PURE__ */ React54.createElement("div", { className: "mt-3 text-center" }, /* @__PURE__ */ React54.createElement("h3", { className: "text-mt-ink text-base font-semibold" }, "This lock is misconfigured"), /* @__PURE__ */ React54.createElement("p", { className: "text-mt-ink-muted mt-2 text-sm" }, "The code must be 1 to 6 digits. Please contact the trail creator.")), nextPage && /* @__PURE__ */ React54.createElement(
      "button",
      {
        type: "button",
        className: `${secondaryButtonClass3} mt-5`,
        onClick: () => nextPage()
      },
      "Skip"
    )));
  }
  const entryDisplay = mode === "wheels" ? entry : entry.padEnd(digitCount, "_");
  return /* @__PURE__ */ React54.createElement(React54.Fragment, null, step === "INTRO" && /* @__PURE__ */ React54.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React54.createElement(QuestionCard, { image: instructionsImage }, /* @__PURE__ */ React54.createElement("div", { className: "bg-mt-primary-soft mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React54.createElement(
    LockClosedIcon,
    {
      className: "text-mt-primary h-6 w-6",
      "aria-hidden": "true"
    }
  )), title && /* @__PURE__ */ React54.createElement("h2", { className: "text-mt-ink mb-2 text-center text-xl font-bold" }, title), instructions ? /* @__PURE__ */ React54.createElement(HTMLBlock_default, { html: instructions }) : /* @__PURE__ */ React54.createElement("p", { className: "text-mt-ink-soft text-center text-sm" }, `Find the ${digitCount}-digit number nearby, then enter it on the ${copy.label} to open the way.`), /* @__PURE__ */ React54.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React54.createElement(
    "button",
    {
      type: "button",
      className: primaryButtonClass3,
      onClick: startLock
    },
    /* @__PURE__ */ React54.createElement(LockClosedIcon, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
    copy.startLabel
  ), allowSkip && /* @__PURE__ */ React54.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: secondaryButtonClass3
    },
    "Skip"
  )))), step === "LOCK" && /* @__PURE__ */ React54.createElement(
    "div",
    {
      className: "relative flex h-full w-full flex-col overflow-hidden select-none",
      style: { background: copy.backdrop },
      "data-testid": "number-lock-stage"
    },
    /* @__PURE__ */ React54.createElement("div", { className: "relative min-h-0 flex-1" }, /* @__PURE__ */ React54.createElement(
      GameCanvasGuard,
      {
        key: sceneKey,
        onRetry: () => setSceneKey((k) => k + 1),
        loadingLabel: "Loading the lock\u2026",
        logTag: "NumberLock",
        emoji: "\u{1F510}"
      },
      /* @__PURE__ */ React54.createElement(Scene, { ...sceneProps })
    ), revealImage && /* @__PURE__ */ React54.createElement(
      "img",
      {
        src: revealImage,
        alt: "",
        "aria-hidden": "true",
        onTransitionEnd: (e) => {
          const done = reduceMotion ? "opacity" : "transform";
          if (e.propertyName === done && revealOpen) advance();
        },
        style: {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transformOrigin: "50% 50%",
          transform: revealOpen ? "scale(1)" : "scale(0.02)",
          opacity: revealOpen ? 1 : 0,
          borderRadius: revealOpen ? 0 : "50%",
          transition: reduceMotion ? "opacity 250ms ease-out" : `transform ${REVEAL_MS}ms cubic-bezier(.2,.7,.2,1), opacity 600ms ease-out, border-radius ${REVEAL_MS}ms ease-out`,
          pointerEvents: "none",
          willChange: "transform, opacity",
          zIndex: 30
        }
      }
    )),
    /* @__PURE__ */ React54.createElement(
      "div",
      {
        className: `relative z-20 flex flex-col gap-2 px-4 pt-2 pb-4 transition-opacity duration-300 ${revealOpen ? "pointer-events-none opacity-0" : "opacity-100"}`,
        "aria-hidden": revealOpen
      },
      /* @__PURE__ */ React54.createElement("div", { className: "flex items-center justify-between gap-3" }, /* @__PURE__ */ React54.createElement("p", { className: "text-sm font-medium text-white/80" }, lockPrompt || `Enter the ${digitCount}-digit number`), /* @__PURE__ */ React54.createElement(
        "output",
        {
          "aria-live": "polite",
          "aria-label": "Current entry",
          className: `rounded-md px-2.5 py-1 font-mono text-lg tracking-[0.3em] tabular-nums shadow-inner ${status === "unlocked" ? "bg-emerald-500/20 text-emerald-200" : status === "wrong" ? "bg-red-500/25 text-red-200" : "bg-black/40 text-white"}`
        },
        entryDisplay
      )),
      /* @__PURE__ */ React54.createElement(
        "div",
        {
          role: "status",
          "aria-live": "polite",
          className: "min-h-5 text-center text-xs text-white/70"
        },
        status === "unlocked" ? "It opens!" : lastWrong ? copy.wrongText : ""
      ),
      hintVisible && /* @__PURE__ */ React54.createElement("div", { className: "flex items-start gap-2 rounded-md bg-amber-400/15 px-3 py-2 text-sm text-amber-100 ring-1 ring-amber-300/30" }, /* @__PURE__ */ React54.createElement(
        LightBulbIcon,
        {
          "aria-hidden": "true",
          className: "mt-0.5 h-4 w-4 shrink-0 text-amber-300"
        }
      ), /* @__PURE__ */ React54.createElement(HTMLBlock_default, { html: hint ?? "" })),
      /* @__PURE__ */ React54.createElement("div", { className: "flex gap-2" }, mode === "sequential" && /* @__PURE__ */ React54.createElement(
        "button",
        {
          type: "button",
          onClick: () => handleEntryChange(""),
          disabled: status !== "idle" || entry === "",
          className: "inline-flex items-center justify-center rounded-md bg-white/10 px-3 py-2 text-sm font-semibold text-white ring-1 ring-white/20 hover:bg-white/20 disabled:opacity-40"
        },
        "Clear"
      ), /* @__PURE__ */ React54.createElement(
        "button",
        {
          type: "button",
          onClick: handleSubmit,
          disabled: status !== "idle" || !isEntryComplete(entry, digitCount),
          className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex flex-1 items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs disabled:opacity-40"
        },
        copy.submitLabel
      )),
      showTyped ? /* @__PURE__ */ React54.createElement(
        "form",
        {
          className: "flex gap-2",
          onSubmit: (e) => {
            e.preventDefault();
            const candidate = sanitizeEntry(typed, mode, digitCount);
            setEntry(candidate);
            submit(candidate);
          }
        },
        /* @__PURE__ */ React54.createElement(
          "input",
          {
            id: "number-lock-typed",
            "aria-label": "Type the number",
            inputMode: "numeric",
            pattern: "[0-9]*",
            autoComplete: "off",
            maxLength: digitCount,
            value: typed,
            onChange: (e) => setTyped(e.target.value.replace(/\D/g, "")),
            placeholder: "0".repeat(digitCount),
            className: "bg-mt-surface text-mt-ink ring-mt-border focus:ring-mt-primary min-w-0 flex-1 rounded-md border-0 px-3 py-2 font-mono text-lg tracking-[0.3em] shadow-xs ring-1 ring-inset focus:ring-2"
          }
        ),
        /* @__PURE__ */ React54.createElement(
          "button",
          {
            type: "submit",
            disabled: status !== "idle" || typed.length !== digitCount,
            className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset disabled:opacity-40"
          },
          "Try it"
        )
      ) : /* @__PURE__ */ React54.createElement("div", { className: "flex items-center justify-between" }, /* @__PURE__ */ React54.createElement(
        "button",
        {
          type: "button",
          onClick: () => setShowTyped(true),
          className: "text-xs font-medium text-white/70 underline-offset-2 hover:underline"
        },
        "Type the number instead"
      ), allowSkip && !editorMode && /* @__PURE__ */ React54.createElement(
        "button",
        {
          type: "button",
          onClick: () => setSkipDialogOpen(true),
          className: "text-xs font-medium text-white/70 underline-offset-2 hover:underline"
        },
        "Skip"
      ))
    )
  ), step === "COMPLETE" && /* @__PURE__ */ React54.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React54.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React54.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React54.createElement(
    CheckIcon16,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React54.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React54.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, skipped ? "Lock skipped" : completeTitle || "Unlocked!"), !skipped && completeText && /* @__PURE__ */ React54.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React54.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), /* @__PURE__ */ React54.createElement("div", { className: "mt-5" }, /* @__PURE__ */ React54.createElement(
    "button",
    {
      type: "button",
      onClick: () => nextPage?.(),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-1 inline-flex w-full items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    /* @__PURE__ */ React54.createElement(SparklesIcon6, { "aria-hidden": "true", className: "mr-2 h-5 w-5" }),
    "Continue"
  ))))), /* @__PURE__ */ React54.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      onSkip: doSkip,
      title: "Skip this lock?",
      text: "You can move on without opening it. You won\u2019t be able to come back and try again."
    }
  ));
}

// src/components/Pages/CipherLock/CipherLock.tsx
import React55, {
  useCallback as useCallback16,
  useEffect as useEffect28,
  useMemo as useMemo11,
  useRef as useRef25,
  useState as useState25
} from "react";
import {
  CheckIcon as CheckIcon17,
  KeyIcon,
  LightBulbIcon as LightBulbIcon2,
  SparklesIcon as SparklesIcon7,
  XMarkIcon as XMarkIcon12
} from "@heroicons/react/20/solid";
import {
  CIPHER_ALPHABET_SIZE,
  NUMBER_LOCK_SKIPPED_ANSWER as NUMBER_LOCK_SKIPPED_ANSWER2,
  caesarDecode,
  cipherLockCiphertext,
  cipherLockPage as cipherLockSchema,
  normalizeCipherAnswer,
  normalizeShift
} from "magical-trails";
var CipherWheelScene = React55.lazy(() => import("./CipherWheelScene-RK4RH4NT.mjs"));
var REVEAL_MS2 = 900;
var OPENED_FALLBACK_MS = 2500;
var BACKDROP = "radial-gradient(120% 80% at 50% 0%, #2b1d12 0%, #150e08 55%, #070403 100%)";
var primaryButtonClass4 = "shadow-xs inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
var secondaryButtonClass4 = "inline-flex w-full items-center justify-center rounded-md bg-mt-surface px-3 py-2 text-sm font-semibold text-mt-ink shadow-xs ring-1 ring-mt-border ring-inset hover:bg-mt-surface-2";
function CipherLock({
  page,
  trailEvent,
  nextPage,
  answerQuestion,
  editorMode
}) {
  const {
    title,
    instructions,
    instructionsImage,
    backgroundImage,
    lockPrompt,
    hint,
    hintAfterAttempts,
    completeTitle,
    completeText,
    completeImage,
    revealImage
  } = page;
  const allowSkip = page.allowSkip ?? true;
  const reduceMotion = usePrefersReducedMotion();
  const configValid = useMemo11(
    () => cipherLockSchema.safeParse({
      ...page,
      userAnswer: void 0
    }).success,
    [page]
  );
  const target = useMemo11(
    () => normalizeCipherAnswer(page.answer ?? ""),
    [page.answer]
  );
  const ciphertext = useMemo11(
    () => cipherLockCiphertext(page.answer ?? "", page.shift ?? 0),
    [page.answer, page.shift]
  );
  const alreadyUnlocked = configValid && page.userAnswer !== void 0 && page.userAnswer === target;
  const alreadySkipped = configValid && allowSkip && page.userAnswer === NUMBER_LOCK_SKIPPED_ANSWER2;
  const [step, setStep] = useState25(
    alreadyUnlocked || alreadySkipped ? "COMPLETE" : "INTRO"
  );
  const [skipped, setSkipped] = useState25(alreadySkipped);
  const [shift, setShift] = useState25(0);
  const [status, setStatus] = useState25("idle");
  const [wrongAttempts, setWrongAttempts] = useState25(0);
  const [lastWrong, setLastWrong] = useState25(false);
  const [showTyped, setShowTyped] = useState25(false);
  const [typed, setTyped] = useState25("");
  const [skipDialogOpen, setSkipDialogOpen] = useState25(false);
  const [revealOpen, setRevealOpen] = useState25(false);
  const [sceneKey, setSceneKey] = useState25(0);
  const wrongTimer = useRef25(null);
  const advancedRef = useRef25(false);
  const openedRef = useRef25(false);
  const hintShownRef = useRef25(false);
  useEffect28(
    () => () => {
      if (wrongTimer.current) clearTimeout(wrongTimer.current);
    },
    []
  );
  const decoded = useMemo11(
    () => caesarDecode(ciphertext, shift),
    [ciphertext, shift]
  );
  const hintVisible = shouldShowHint(wrongAttempts, hint, hintAfterAttempts);
  useEffect28(() => {
    if (hintVisible && !hintShownRef.current) {
      hintShownRef.current = true;
      trailEvent("Cipher Lock: Hint Shown");
    }
  }, [hintVisible, trailEvent]);
  const handleShiftChange = useCallback16(
    (next) => {
      if (status !== "idle") return;
      setLastWrong(false);
      setShift(normalizeShift(next));
    },
    [status]
  );
  const submit = useCallback16(
    (candidate) => {
      if (status !== "idle") return;
      const normalized = normalizeCipherAnswer(candidate);
      if (!normalized) return;
      if (normalized === target) {
        setStatus("unlocked");
        setLastWrong(false);
        trailEvent("Cipher Lock: Unlocked");
        answerQuestion?.(target);
        return;
      }
      setStatus("wrong");
      setLastWrong(true);
      setWrongAttempts((n) => n + 1);
      trailEvent("Cipher Lock: Wrong");
      if (wrongTimer.current) clearTimeout(wrongTimer.current);
      wrongTimer.current = setTimeout(() => setStatus("idle"), WRONG_STATUS_MS);
    },
    [status, target, trailEvent, answerQuestion]
  );
  const handleSubmit = useCallback16(() => submit(decoded), [submit, decoded]);
  const advance = useCallback16(() => {
    if (advancedRef.current) return;
    advancedRef.current = true;
    if (nextPage) nextPage();
    else setStep("COMPLETE");
  }, [nextPage]);
  const handleOpened = useCallback16(() => {
    if (openedRef.current) return;
    openedRef.current = true;
    if (revealImage) {
      setRevealOpen(true);
      return;
    }
    setStep("COMPLETE");
  }, [revealImage]);
  const handleOpenedRef = useRef25(handleOpened);
  handleOpenedRef.current = handleOpened;
  useEffect28(() => {
    if (status !== "unlocked") return;
    const t = setTimeout(() => {
      if (!openedRef.current) handleOpenedRef.current();
    }, OPENED_FALLBACK_MS);
    return () => clearTimeout(t);
  }, [status]);
  useEffect28(() => {
    if (!revealOpen) return;
    const t = setTimeout(advance, REVEAL_MS2 + 500);
    return () => clearTimeout(t);
  }, [revealOpen, advance]);
  const startLock = useCallback16(() => {
    setStep("LOCK");
    trailEvent("Cipher Lock: Started");
  }, [trailEvent]);
  const doSkip = useCallback16(() => {
    setSkipDialogOpen(false);
    if (status !== "idle") return;
    trailEvent("Cipher Lock: Skipped");
    answerQuestion?.(NUMBER_LOCK_SKIPPED_ANSWER2);
    if (nextPage) {
      nextPage();
      return;
    }
    setSkipped(true);
    setStep("COMPLETE");
  }, [status, trailEvent, nextPage, answerQuestion]);
  const sceneProps = useMemo11(
    () => ({
      shift,
      alphabetSize: CIPHER_ALPHABET_SIZE,
      onShiftChange: handleShiftChange,
      onSubmit: handleSubmit,
      status,
      onOpened: handleOpened,
      reduceMotion,
      prompt: lockPrompt
    }),
    [
      shift,
      handleShiftChange,
      handleSubmit,
      status,
      handleOpened,
      reduceMotion,
      lockPrompt
    ]
  );
  if (!configValid) {
    return /* @__PURE__ */ React55.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React55.createElement(QuestionCard, { image: instructionsImage }, /* @__PURE__ */ React55.createElement("div", { className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100" }, /* @__PURE__ */ React55.createElement(XMarkIcon12, { className: "h-6 w-6 text-yellow-600", "aria-hidden": "true" })), /* @__PURE__ */ React55.createElement("div", { className: "mt-3 text-center" }, /* @__PURE__ */ React55.createElement("h3", { className: "text-mt-ink text-base font-semibold" }, "This lock is misconfigured"), /* @__PURE__ */ React55.createElement("p", { className: "text-mt-ink-muted mt-2 text-sm" }, "The answer must be letters only and the key a number from 1 to 25. Please contact the trail creator.")), nextPage && /* @__PURE__ */ React55.createElement(
      "button",
      {
        type: "button",
        className: `${secondaryButtonClass4} mt-5`,
        onClick: () => nextPage()
      },
      "Skip"
    )));
  }
  return /* @__PURE__ */ React55.createElement(React55.Fragment, null, step === "INTRO" && /* @__PURE__ */ React55.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React55.createElement(QuestionCard, { image: instructionsImage }, /* @__PURE__ */ React55.createElement("div", { className: "bg-mt-primary-soft mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React55.createElement(KeyIcon, { className: "text-mt-primary h-6 w-6", "aria-hidden": "true" })), title && /* @__PURE__ */ React55.createElement("h2", { className: "text-mt-ink mb-2 text-center text-xl font-bold" }, title), instructions ? /* @__PURE__ */ React55.createElement(HTMLBlock_default, { html: instructions }) : /* @__PURE__ */ React55.createElement("p", { className: "text-mt-ink-soft text-center text-sm" }, "Find the key nearby, then turn the cipher wheel to it and read the hidden message."), /* @__PURE__ */ React55.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React55.createElement(
    "button",
    {
      type: "button",
      className: primaryButtonClass4,
      onClick: startLock
    },
    /* @__PURE__ */ React55.createElement(KeyIcon, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
    "Go to the cipher wheel"
  ), allowSkip && /* @__PURE__ */ React55.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: secondaryButtonClass4
    },
    "Skip"
  )))), step === "LOCK" && /* @__PURE__ */ React55.createElement(
    "div",
    {
      className: "relative flex h-full w-full flex-col overflow-hidden select-none",
      style: { background: BACKDROP },
      "data-testid": "cipher-lock-stage"
    },
    /* @__PURE__ */ React55.createElement("div", { className: "relative min-h-0 flex-1" }, /* @__PURE__ */ React55.createElement(
      GameCanvasGuard,
      {
        key: sceneKey,
        onRetry: () => setSceneKey((k) => k + 1),
        loadingLabel: "Loading the cipher wheel\u2026",
        logTag: "CipherLock",
        emoji: "\u{1F5DD}\uFE0F"
      },
      /* @__PURE__ */ React55.createElement(CipherWheelScene, { ...sceneProps })
    ), revealImage && /* @__PURE__ */ React55.createElement(
      "img",
      {
        src: revealImage,
        alt: "",
        "aria-hidden": "true",
        onTransitionEnd: (e) => {
          const done = reduceMotion ? "opacity" : "transform";
          if (e.propertyName === done && revealOpen) advance();
        },
        style: {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transformOrigin: "50% 50%",
          transform: revealOpen ? "scale(1)" : "scale(0.02)",
          opacity: revealOpen ? 1 : 0,
          borderRadius: revealOpen ? 0 : "50%",
          transition: reduceMotion ? "opacity 250ms ease-out" : `transform ${REVEAL_MS2}ms cubic-bezier(.2,.7,.2,1), opacity 600ms ease-out, border-radius ${REVEAL_MS2}ms ease-out`,
          pointerEvents: "none",
          willChange: "transform, opacity",
          zIndex: 30
        }
      }
    )),
    /* @__PURE__ */ React55.createElement(
      "div",
      {
        className: `relative z-20 flex flex-col gap-2 px-4 pt-2 pb-4 transition-opacity duration-300 ${revealOpen ? "pointer-events-none opacity-0" : "opacity-100"}`,
        "aria-hidden": revealOpen
      },
      /* @__PURE__ */ React55.createElement("div", { className: "flex items-center justify-between gap-3" }, /* @__PURE__ */ React55.createElement("p", { className: "text-sm font-medium text-white/80" }, lockPrompt || "Turn the wheel to the key"), /* @__PURE__ */ React55.createElement(
        "output",
        {
          "aria-label": "Current key",
          className: "rounded-md bg-black/40 px-2.5 py-1 font-mono text-lg text-white tabular-nums shadow-inner"
        },
        shift
      )),
      /* @__PURE__ */ React55.createElement("div", { className: "rounded-md bg-black/40 px-3 py-2 font-mono tracking-[0.25em] shadow-inner" }, /* @__PURE__ */ React55.createElement("div", { className: "text-xs text-white/50" }, ciphertext), /* @__PURE__ */ React55.createElement(
        "output",
        {
          "aria-live": "polite",
          "aria-label": "Decoded message",
          className: `block text-lg ${status === "unlocked" ? "text-emerald-200" : status === "wrong" ? "text-red-200" : "text-amber-100"}`
        },
        decoded
      )),
      /* @__PURE__ */ React55.createElement(
        "div",
        {
          role: "status",
          "aria-live": "polite",
          className: "min-h-5 text-center text-xs text-white/70"
        },
        status === "unlocked" ? "The wheel turns true \u2014 it opens!" : lastWrong ? "That\u2019s not it. Check the key and try again." : ""
      ),
      hintVisible && /* @__PURE__ */ React55.createElement("div", { className: "flex items-start gap-2 rounded-md bg-amber-400/15 px-3 py-2 text-sm text-amber-100 ring-1 ring-amber-300/30" }, /* @__PURE__ */ React55.createElement(
        LightBulbIcon2,
        {
          "aria-hidden": "true",
          className: "mt-0.5 h-4 w-4 shrink-0 text-amber-300"
        }
      ), /* @__PURE__ */ React55.createElement(HTMLBlock_default, { html: hint ?? "" })),
      /* @__PURE__ */ React55.createElement(
        "button",
        {
          type: "button",
          onClick: handleSubmit,
          disabled: status !== "idle",
          className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs disabled:opacity-40"
        },
        "Unlock"
      ),
      showTyped ? /* @__PURE__ */ React55.createElement(
        "form",
        {
          className: "flex gap-2",
          onSubmit: (e) => {
            e.preventDefault();
            submit(typed);
          }
        },
        /* @__PURE__ */ React55.createElement(
          "input",
          {
            id: "cipher-lock-typed",
            "aria-label": "Type the answer",
            autoComplete: "off",
            autoCapitalize: "characters",
            value: typed,
            onChange: (e) => setTyped(e.target.value),
            placeholder: "Decoded message",
            className: "bg-mt-surface text-mt-ink ring-mt-border focus:ring-mt-primary min-w-0 flex-1 rounded-md border-0 px-3 py-2 font-mono text-lg tracking-[0.2em] shadow-xs ring-1 ring-inset focus:ring-2"
          }
        ),
        /* @__PURE__ */ React55.createElement(
          "button",
          {
            type: "submit",
            disabled: status !== "idle" || normalizeCipherAnswer(typed) === "",
            className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset disabled:opacity-40"
          },
          "Try it"
        )
      ) : /* @__PURE__ */ React55.createElement("div", { className: "flex items-center justify-between" }, /* @__PURE__ */ React55.createElement(
        "button",
        {
          type: "button",
          onClick: () => setShowTyped(true),
          className: "text-xs font-medium text-white/70 underline-offset-2 hover:underline"
        },
        "Type the answer instead"
      ), allowSkip && !editorMode && /* @__PURE__ */ React55.createElement(
        "button",
        {
          type: "button",
          onClick: () => setSkipDialogOpen(true),
          className: "text-xs font-medium text-white/70 underline-offset-2 hover:underline"
        },
        "Skip"
      ))
    )
  ), step === "COMPLETE" && /* @__PURE__ */ React55.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React55.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React55.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React55.createElement(
    CheckIcon17,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React55.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React55.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, skipped ? "Lock skipped" : completeTitle || "Decoded!"), !skipped && completeText && /* @__PURE__ */ React55.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React55.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), /* @__PURE__ */ React55.createElement("div", { className: "mt-5" }, /* @__PURE__ */ React55.createElement(
    "button",
    {
      type: "button",
      onClick: () => nextPage?.(),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-1 inline-flex w-full items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    /* @__PURE__ */ React55.createElement(SparklesIcon7, { "aria-hidden": "true", className: "mr-2 h-5 w-5" }),
    "Continue"
  ))))), /* @__PURE__ */ React55.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      onSkip: doSkip,
      title: "Skip this lock?",
      text: "You can move on without decoding it. You won\u2019t be able to come back and try again."
    }
  ));
}

// src/components/Pages/NfcTap/NfcTap.tsx
import React57, {
  useCallback as useCallback17,
  useEffect as useEffect30,
  useMemo as useMemo12,
  useRef as useRef26,
  useState as useState27
} from "react";
import {
  CheckIcon as CheckIcon18,
  DevicePhoneMobileIcon,
  SparklesIcon as SparklesIcon8,
  XMarkIcon as XMarkIcon13
} from "@heroicons/react/20/solid";
import {
  NUMBER_LOCK_SKIPPED_ANSWER as NUMBER_LOCK_SKIPPED_ANSWER3,
  nfcTapPage as nfcTapSchema,
  normalizeNfcFallbackCode,
  normalizeNfcToken as normalizeNfcToken2
} from "magical-trails";

// src/utils/nfcScans.ts
import { useEffect as useEffect29, useState as useState26 } from "react";
import {
  NFC_TAP_QUERY_PARAM,
  isValidNfcToken,
  normalizeNfcToken
} from "magical-trails";
var NFC_SCANS_STORAGE_KEY = "MAGICAL_TRAILS_NFC_SCANS";
var NFC_SCAN_TTL_MS = 24 * 60 * 60 * 1e3;
var NFC_SCAN_EVENT = "mt:nfc-scan";
var MAX_SCANS = 50;
function storage() {
  try {
    if (typeof window === "undefined") return null;
    return window.localStorage ?? null;
  } catch {
    return null;
  }
}
function readStore() {
  const store = storage();
  if (!store) return {};
  try {
    const raw = store.getItem(NFC_SCANS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    const out = {};
    for (const [token, at] of Object.entries(parsed))
      if (typeof at === "number" && Number.isFinite(at)) out[token] = at;
    return out;
  } catch {
    return {};
  }
}
function writeStore(next) {
  const store = storage();
  if (!store) return;
  try {
    store.setItem(NFC_SCANS_STORAGE_KEY, JSON.stringify(next));
  } catch {
  }
}
function prune(store, now) {
  const live = Object.entries(store).filter(
    ([, at]) => now - at < NFC_SCAN_TTL_MS
  );
  live.sort((a, b) => b[1] - a[1]);
  return Object.fromEntries(live.slice(0, MAX_SCANS));
}
function recordNfcScan(token, now = Date.now()) {
  const normalized = normalizeNfcToken(token ?? "");
  if (!isValidNfcToken(normalized)) return;
  const next = prune({ ...readStore(), [normalized]: now }, now);
  next[normalized] = now;
  writeStore(next);
  try {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent(NFC_SCAN_EVENT));
  } catch {
  }
}
function hasNfcScan(token, now = Date.now()) {
  const normalized = normalizeNfcToken(token ?? "");
  if (!isValidNfcToken(normalized)) return false;
  const at = readStore()[normalized];
  return typeof at === "number" && now - at < NFC_SCAN_TTL_MS;
}
function recordNfcScanFromLocation(loc, hist) {
  let location = loc;
  let history = hist;
  try {
    if (!location && typeof window !== "undefined") location = window.location;
    if (!history && typeof window !== "undefined") history = window.history;
  } catch {
    return void 0;
  }
  if (!location) return void 0;
  let url;
  try {
    url = new URL(location.href);
  } catch {
    return void 0;
  }
  const raw = url.searchParams.get(NFC_TAP_QUERY_PARAM);
  if (raw === null) return void 0;
  const token = normalizeNfcToken(raw);
  const valid = isValidNfcToken(token);
  if (valid) recordNfcScan(token);
  try {
    url.searchParams.delete(NFC_TAP_QUERY_PARAM);
    const search = url.searchParams.toString();
    history?.replaceState(
      history.state,
      "",
      `${url.pathname}${search ? `?${search}` : ""}${url.hash}`
    );
  } catch {
  }
  return valid ? token : void 0;
}
function subscribeNfcScans(cb) {
  if (typeof window === "undefined") return () => {
  };
  const onStorage = (event) => {
    if (event.key === null || event.key === NFC_SCANS_STORAGE_KEY) cb();
  };
  const onAny = () => cb();
  window.addEventListener(NFC_SCAN_EVENT, onAny);
  window.addEventListener("storage", onStorage);
  window.addEventListener("visibilitychange", onAny);
  window.addEventListener("pageshow", onAny);
  window.addEventListener("focus", onAny);
  return () => {
    window.removeEventListener(NFC_SCAN_EVENT, onAny);
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("visibilitychange", onAny);
    window.removeEventListener("pageshow", onAny);
    window.removeEventListener("focus", onAny);
  };
}
function useNfcScan(token) {
  const [scanned, setScanned] = useState26(
    () => token ? hasNfcScan(token) : false
  );
  useEffect29(() => {
    if (!token) return;
    let latched = hasNfcScan(token);
    setScanned(latched);
    if (latched) return;
    return subscribeNfcScans(() => {
      if (latched || !hasNfcScan(token)) return;
      latched = true;
      setScanned(true);
    });
  }, [token]);
  return scanned;
}

// src/components/Pages/NfcTap/NfcScanStage.tsx
import React56 from "react";
var LABELS = {
  idle: "A glowing mark on a poster, waiting for a phone",
  scanning: "A phone held against a glowing mark, listening for a tag",
  waiting: "A phone held against a glowing mark, waiting for a tag",
  success: "The mark lights up and a tick appears"
};
var CX = 100;
var CY = 132;
var SPARKLE_ANGLES = [0, 60, 120, 180, 240, 300];
var STAR_PATH = "M100 116 L104.5 127.5 L116 132 L104.5 136.5 L100 148 L95.5 136.5 L84 132 L95.5 127.5 Z";
var SPARKLE_SCALE = 0.22;
function NfcScanStage({
  mode,
  prompt,
  message,
  reducedMotion
}) {
  return /* @__PURE__ */ React56.createElement(
    "div",
    {
      className: "NfcTap_stage",
      "data-mode": mode,
      "data-reduced": reducedMotion ? "true" : void 0,
      "data-testid": "nfc-tap-stage"
    },
    /* @__PURE__ */ React56.createElement(
      "svg",
      {
        className: "NfcTap_svg",
        viewBox: "0 0 200 205",
        role: "img",
        "aria-label": LABELS[mode]
      },
      /* @__PURE__ */ React56.createElement("g", { className: "NfcTap_orbit" }, SPARKLE_ANGLES.map((angle) => {
        const radians = angle * Math.PI / 180;
        const x = CX + 62 * Math.cos(radians);
        const y = CY + 62 * Math.sin(radians);
        return /* @__PURE__ */ React56.createElement(
          "path",
          {
            key: angle,
            className: "NfcTap_spark",
            d: STAR_PATH,
            transform: `translate(${x} ${y}) scale(${SPARKLE_SCALE}) translate(${-CX} ${-CY})`
          }
        );
      })),
      /* @__PURE__ */ React56.createElement("circle", { className: "NfcTap_halo", cx: CX, cy: CY, r: 46 }),
      /* @__PURE__ */ React56.createElement("circle", { className: "NfcTap_ring NfcTap_ring--1", cx: CX, cy: CY, r: 38 }),
      /* @__PURE__ */ React56.createElement("circle", { className: "NfcTap_ring NfcTap_ring--2", cx: CX, cy: CY, r: 38 }),
      /* @__PURE__ */ React56.createElement("circle", { className: "NfcTap_ring NfcTap_ring--3", cx: CX, cy: CY, r: 38 }),
      /* @__PURE__ */ React56.createElement("circle", { className: "NfcTap_mark", cx: CX, cy: CY, r: 30 }),
      /* @__PURE__ */ React56.createElement("path", { className: "NfcTap_glyph", d: STAR_PATH }),
      /* @__PURE__ */ React56.createElement("path", { className: "NfcTap_check", d: "M87 132 l9.5 10.5 L115 121" }),
      /* @__PURE__ */ React56.createElement("g", { className: "NfcTap_phone" }, /* @__PURE__ */ React56.createElement(
        "rect",
        {
          className: "NfcTap_phoneBody",
          x: 77,
          y: 18,
          width: 46,
          height: 76,
          rx: 9
        }
      ), /* @__PURE__ */ React56.createElement(
        "rect",
        {
          className: "NfcTap_phoneScreen",
          x: 83,
          y: 26,
          width: 34,
          height: 56,
          rx: 4
        }
      ), /* @__PURE__ */ React56.createElement(
        "rect",
        {
          className: "NfcTap_phoneSpeaker",
          x: 92,
          y: 22,
          width: 16,
          height: 3,
          rx: 1.5
        }
      ))
    ),
    /* @__PURE__ */ React56.createElement("p", { className: "NfcTap_prompt text-mt-ink text-center text-base font-semibold" }, prompt),
    /* @__PURE__ */ React56.createElement(
      "p",
      {
        "aria-live": "polite",
        className: "NfcTap_message text-mt-ink-soft min-h-15 text-center text-sm"
      },
      message
    )
  );
}

// src/components/Pages/NfcTap/nfcRecords.ts
import { nfcTokenFromText, nfcTokenFromUrl } from "magical-trails";
function nfcRecordToken(record) {
  if (!record?.data) return void 0;
  const text = decodeRecord(record);
  if (!text) return void 0;
  switch (record.recordType) {
    case "url":
    case "absolute-url":
      return nfcTokenFromUrl(text);
    case "text":
      return nfcTokenFromText(text);
    default:
      return void 0;
  }
}
function decodeRecord(record) {
  const label = record.encoding || "utf-8";
  try {
    return new TextDecoder(label).decode(record.data);
  } catch {
    try {
      return new TextDecoder().decode(record.data);
    } catch {
      return "";
    }
  }
}

// src/components/Pages/NfcTap/webNfc.ts
function webNfcReader() {
  try {
    if (typeof window === "undefined") return void 0;
    return window.NDEFReader;
  } catch {
    return void 0;
  }
}

// src/components/Pages/NfcTap/NfcTap.tsx
var SUCCESS_MS = 900;
var MESSAGE_MS = 2500;
var WRONG_EVENT_THROTTLE_MS = 3e3;
var WAITING_MESSAGE = "Hold the top of your phone against the mark. When a banner appears, tap it and the trail will carry on.";
var BLOCKED_MESSAGE = "Scanning was blocked. Tap the mark and follow the link that appears.";
var WRONG_TAG_MESSAGE = "That\u2019s not the right mark. Try another.";
var READ_ERROR_MESSAGE = "Couldn\u2019t read that one. Hold still and try again.";
var WRONG_CODE_MESSAGE = "Not quite. Check the code and try again.";
var DEFAULT_COMPLETE_TITLE = "The mark answers";
var primaryButtonClass5 = "shadow-xs inline-flex w-full items-center justify-center rounded-md mt-btn bg-mt-primary px-3.5 py-2.5 text-lg font-semibold text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-mt-primary";
var secondaryButtonClass5 = "inline-flex w-full items-center justify-center rounded-md bg-mt-surface px-3 py-2 text-sm font-semibold text-mt-ink shadow-xs ring-1 ring-mt-border ring-inset hover:bg-mt-surface-2";
var quietButtonClass = "text-mt-ink-muted text-xs font-medium underline-offset-2 hover:underline";
var METHOD_EVENT = {
  webnfc: "NFC Tap: Tapped via Web NFC",
  link: "NFC Tap: Tapped via Link",
  code: "NFC Tap: Code Entered"
};
function NfcTap(props) {
  return /* @__PURE__ */ React57.createElement(
    NfcTapForToken,
    {
      key: normalizeNfcToken2(props.page.token ?? ""),
      ...props
    }
  );
}
function NfcTapForToken({
  page,
  trailEvent,
  nextPage,
  answerQuestion,
  editorMode
}) {
  const {
    title,
    instructions,
    instructionsImage,
    backgroundImage,
    scanPrompt,
    fallbackCode,
    hint,
    completeTitle,
    completeText,
    completeImage,
    revealImage
  } = page;
  const allowSkip = page.allowSkip ?? false;
  const reduceMotion = usePrefersReducedMotion();
  const configValid = useMemo12(
    () => nfcTapSchema.safeParse({ ...page, userAnswer: void 0 }).success,
    [page]
  );
  const target = useMemo12(
    () => normalizeNfcToken2(page.token ?? ""),
    [page.token]
  );
  const expectedCode = useMemo12(
    () => normalizeNfcFallbackCode(fallbackCode ?? ""),
    [fallbackCode]
  );
  const scanned = useNfcScan(configValid ? target : void 0);
  const alreadyTapped = configValid && page.userAnswer !== void 0 && page.userAnswer === target;
  const alreadySkipped = configValid && allowSkip && page.userAnswer === NUMBER_LOCK_SKIPPED_ANSWER3;
  const [step, setStep] = useState27(
    alreadyTapped || alreadySkipped ? "COMPLETE" : "INTRO"
  );
  const [mode, setMode] = useState27("idle");
  const [message, setMessage] = useState27("");
  const [skipped, setSkipped] = useState27(alreadySkipped);
  const [skipDialogOpen, setSkipDialogOpen] = useState27(false);
  const [helpOpen, setHelpOpen] = useState27(false);
  const [codeOpen, setCodeOpen] = useState27(false);
  const [typedCode, setTypedCode] = useState27("");
  const confirmedRef = useRef26(alreadyTapped || alreadySkipped);
  const abortRef = useRef26(null);
  const messageTimer = useRef26(null);
  const wrongEventAt = useRef26(0);
  const helpShownRef = useRef26(false);
  const unsupportedRef = useRef26(false);
  const startedRef = useRef26(false);
  const standingMessage = useRef26("");
  const ReaderCtor = useMemo12(() => webNfcReader(), []);
  const abortScan = useCallback17(() => {
    try {
      abortRef.current?.abort();
    } catch {
    }
    abortRef.current = null;
  }, []);
  useEffect30(
    () => () => {
      abortScan();
      if (messageTimer.current) clearTimeout(messageTimer.current);
    },
    [abortScan]
  );
  const setStandingMessage = useCallback17((text) => {
    standingMessage.current = text;
    setMessage(text);
  }, []);
  const flashMessage = useCallback17((text) => {
    setMessage(text);
    if (messageTimer.current) clearTimeout(messageTimer.current);
    messageTimer.current = setTimeout(
      () => setMessage(standingMessage.current),
      MESSAGE_MS
    );
  }, []);
  const confirm = useCallback17(
    (method) => {
      if (confirmedRef.current) return;
      confirmedRef.current = true;
      abortScan();
      if (messageTimer.current) clearTimeout(messageTimer.current);
      setStandingMessage("");
      setStep((current) => current === "INTRO" ? "SCAN" : current);
      setMode("success");
      if (method !== "editor") {
        answerQuestion?.(target);
        trailEvent("NFC Tap: Tapped");
        trailEvent(METHOD_EVENT[method]);
      }
    },
    [abortScan, answerQuestion, target, trailEvent, setStandingMessage]
  );
  useEffect30(() => {
    if (mode !== "success") return;
    const timer = setTimeout(() => setStep("COMPLETE"), SUCCESS_MS);
    return () => clearTimeout(timer);
  }, [mode]);
  useEffect30(() => {
    if (scanned) confirm("link");
  }, [scanned, confirm]);
  const handleReading = useCallback17(
    (event) => {
      const records = event?.message?.records ?? [];
      for (const record of records) {
        if (nfcRecordToken(record) === target) {
          confirm("webnfc");
          return;
        }
      }
      flashMessage(WRONG_TAG_MESSAGE);
      const now = Date.now();
      if (now - wrongEventAt.current > WRONG_EVENT_THROTTLE_MS) {
        wrongEventAt.current = now;
        trailEvent("NFC Tap: Wrong Tag");
      }
    },
    [target, confirm, flashMessage, trailEvent]
  );
  const handleReadingRef = useRef26(handleReading);
  handleReadingRef.current = handleReading;
  const startScanning = useCallback17(async () => {
    if (!ReaderCtor || confirmedRef.current) return;
    abortScan();
    const controller = new AbortController();
    abortRef.current = controller;
    setMode("scanning");
    setStandingMessage("");
    try {
      const reader = new ReaderCtor();
      reader.addEventListener(
        "reading",
        (event) => handleReadingRef.current(event)
      );
      reader.addEventListener(
        "readingerror",
        () => flashMessage(READ_ERROR_MESSAGE)
      );
      await reader.scan({ signal: controller.signal });
    } catch (error) {
      if (controller.signal.aborted) return;
      if (abortRef.current === controller) abortRef.current = null;
      const name = error instanceof Error ? error.name : "";
      setMode("waiting");
      if (name === "NotAllowedError") {
        setStandingMessage(BLOCKED_MESSAGE);
        trailEvent("NFC Tap: Permission Denied");
        return;
      }
      setStandingMessage(WAITING_MESSAGE);
      reportCaughtError({
        source: "NfcTap",
        kind: "nfc-unavailable",
        error,
        message: name || "Web NFC scan failed"
      });
    }
  }, [ReaderCtor, abortScan, flashMessage, setStandingMessage, trailEvent]);
  const trailEventRef = useRef26(trailEvent);
  trailEventRef.current = trailEvent;
  useEffect30(() => {
    if (step !== "SCAN" || confirmedRef.current) return;
    if (editorMode) {
      setMode("waiting");
      return;
    }
    if (ReaderCtor) {
      setMode("idle");
      return;
    }
    setMode("waiting");
    setStandingMessage(WAITING_MESSAGE);
    if (!unsupportedRef.current) {
      unsupportedRef.current = true;
      trailEventRef.current("NFC Tap: Unsupported");
    }
  }, [step, editorMode, ReaderCtor, setStandingMessage]);
  useEffect30(() => {
    if (step !== "SCAN" || startedRef.current) return;
    startedRef.current = true;
    trailEvent("NFC Tap: Started");
  }, [step, trailEvent]);
  const startStage = useCallback17(() => setStep("SCAN"), []);
  const submitCode = useCallback17(() => {
    if (!expectedCode) return;
    if (normalizeNfcFallbackCode(typedCode) === expectedCode) {
      confirm("code");
      return;
    }
    flashMessage(WRONG_CODE_MESSAGE);
    trailEvent("NFC Tap: Wrong Code");
  }, [expectedCode, typedCode, confirm, flashMessage, trailEvent]);
  const toggleHelp = useCallback17(() => {
    setHelpOpen((open) => {
      if (!open && !helpShownRef.current) {
        helpShownRef.current = true;
        trailEvent("NFC Tap: Help Shown");
      }
      return !open;
    });
  }, [trailEvent]);
  const doSkip = useCallback17(() => {
    setSkipDialogOpen(false);
    if (confirmedRef.current) return;
    confirmedRef.current = true;
    abortScan();
    trailEvent("NFC Tap: Skipped");
    answerQuestion?.(NUMBER_LOCK_SKIPPED_ANSWER3);
    if (nextPage) {
      nextPage();
      return;
    }
    setSkipped(true);
    setStep("COMPLETE");
  }, [abortScan, trailEvent, answerQuestion, nextPage]);
  if (!configValid) {
    return /* @__PURE__ */ React57.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React57.createElement(QuestionCard, { image: instructionsImage }, /* @__PURE__ */ React57.createElement("div", { className: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100" }, /* @__PURE__ */ React57.createElement(XMarkIcon13, { className: "h-6 w-6 text-yellow-600", "aria-hidden": "true" })), /* @__PURE__ */ React57.createElement("div", { className: "mt-3 text-center" }, /* @__PURE__ */ React57.createElement("h3", { className: "text-mt-ink text-base font-semibold" }, "This tag is misconfigured"), /* @__PURE__ */ React57.createElement("p", { className: "text-mt-ink-muted mt-2 text-sm" }, "The page needs a tag token of 6 to 32 letters or digits. Please contact the trail creator.")), nextPage && /* @__PURE__ */ React57.createElement(
      "button",
      {
        type: "button",
        className: `${secondaryButtonClass5} mt-5`,
        onClick: () => {
          answerQuestion?.(NUMBER_LOCK_SKIPPED_ANSWER3);
          nextPage();
        }
      },
      "Skip"
    )));
  }
  return /* @__PURE__ */ React57.createElement(React57.Fragment, null, step === "INTRO" && /* @__PURE__ */ React57.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React57.createElement(QuestionCard, { image: instructionsImage }, /* @__PURE__ */ React57.createElement("div", { className: "bg-mt-primary-soft mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React57.createElement(
    DevicePhoneMobileIcon,
    {
      className: "text-mt-primary h-6 w-6",
      "aria-hidden": "true"
    }
  )), title && /* @__PURE__ */ React57.createElement("h2", { className: "text-mt-ink mb-2 text-center text-xl font-bold" }, title), instructions ? /* @__PURE__ */ React57.createElement(HTMLBlock_default, { html: instructions }) : /* @__PURE__ */ React57.createElement("p", { className: "text-mt-ink-soft text-center text-sm" }, "Find the mark nearby and press your phone against it."), /* @__PURE__ */ React57.createElement("div", { className: "mt-5 flex flex-col gap-3" }, /* @__PURE__ */ React57.createElement(
    "button",
    {
      type: "button",
      className: primaryButtonClass5,
      onClick: startStage
    },
    /* @__PURE__ */ React57.createElement(
      DevicePhoneMobileIcon,
      {
        "aria-hidden": "true",
        className: "mr-2 h-6 w-6"
      }
    ),
    "Begin"
  ), allowSkip && !editorMode && /* @__PURE__ */ React57.createElement(
    "button",
    {
      type: "button",
      onClick: () => setSkipDialogOpen(true),
      className: secondaryButtonClass5
    },
    "Skip"
  )))), step === "SCAN" && /* @__PURE__ */ React57.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React57.createElement(QuestionCard, null, /* @__PURE__ */ React57.createElement(
    NfcScanStage,
    {
      mode,
      prompt: (
        // The tag has answered: leaving "Hold your phone against the
        // mark" up over a finished tick reads as a picture that has
        // not noticed what just happened.
        mode === "success" ? completeTitle || DEFAULT_COMPLETE_TITLE : scanPrompt || "Hold your phone against the mark"
      ),
      message,
      reducedMotion: reduceMotion
    }
  ), /* @__PURE__ */ React57.createElement(
    "div",
    {
      className: `mt-2 flex flex-col gap-3 ${mode === "success" ? "invisible" : ""}`
    },
    ReaderCtor && !editorMode && mode === "idle" && /* @__PURE__ */ React57.createElement(
      "button",
      {
        type: "button",
        className: primaryButtonClass5,
        onClick: () => {
          void startScanning();
        }
      },
      /* @__PURE__ */ React57.createElement(SparklesIcon8, { "aria-hidden": "true", className: "mr-2 h-6 w-6" }),
      "Start scanning"
    ),
    editorMode && /* @__PURE__ */ React57.createElement(
      "button",
      {
        type: "button",
        className: secondaryButtonClass5,
        onClick: () => confirm("editor")
      },
      "Simulate a tap"
    ),
    expectedCode && (codeOpen ? /* @__PURE__ */ React57.createElement(
      "form",
      {
        className: "flex gap-2",
        onSubmit: (event) => {
          event.preventDefault();
          submitCode();
        }
      },
      /* @__PURE__ */ React57.createElement(
        "input",
        {
          id: "nfc-tap-code",
          "aria-label": "Enter the code",
          autoComplete: "off",
          autoFocus: true,
          value: typedCode,
          onChange: (event) => setTypedCode(event.target.value),
          placeholder: "Code from the poster",
          className: "bg-mt-surface text-mt-ink ring-mt-border focus:ring-mt-primary min-w-0 flex-1 rounded-md border-0 px-3 py-2 text-base shadow-xs ring-1 ring-inset focus:ring-2"
        }
      ),
      /* @__PURE__ */ React57.createElement(
        "button",
        {
          type: "submit",
          disabled: typedCode.trim() === "",
          className: "bg-mt-surface text-mt-ink ring-mt-border hover:bg-mt-surface-2 inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs ring-1 ring-inset disabled:opacity-40"
        },
        "Unlock"
      )
    ) : /* @__PURE__ */ React57.createElement(
      "button",
      {
        type: "button",
        onClick: () => setCodeOpen(true),
        "aria-expanded": codeOpen,
        "aria-controls": "nfc-tap-code",
        className: quietButtonClass
      },
      "Can\u2019t scan? Enter the code instead"
    )),
    /* @__PURE__ */ React57.createElement("div", { className: "flex items-center justify-between gap-3" }, /* @__PURE__ */ React57.createElement(
      "button",
      {
        type: "button",
        onClick: toggleHelp,
        "aria-expanded": helpOpen,
        className: quietButtonClass
      },
      "Having trouble?"
    ), allowSkip && !editorMode && /* @__PURE__ */ React57.createElement(
      "button",
      {
        type: "button",
        onClick: () => setSkipDialogOpen(true),
        className: quietButtonClass
      },
      "Skip"
    )),
    helpOpen && /* @__PURE__ */ React57.createElement("div", { className: "bg-mt-surface-2 text-mt-ink-soft ring-mt-border rounded-md px-3 py-2 text-sm ring-1" }, /* @__PURE__ */ React57.createElement(
      "ul",
      {
        className: "list-disc space-y-1 pl-4",
        style: { listStyleType: "disc" }
      },
      /* @__PURE__ */ React57.createElement("li", null, "Check NFC is turned on in your phone settings."),
      /* @__PURE__ */ React57.createElement("li", null, "Take the phone out of a thick case."),
      /* @__PURE__ */ React57.createElement("li", null, "On an iPhone, the reader is in the top edge of the phone."),
      /* @__PURE__ */ React57.createElement("li", null, "On an Android, it is in the middle of the back."),
      /* @__PURE__ */ React57.createElement("li", null, "Hold still against the mark for a second.")
    ), hint && /* @__PURE__ */ React57.createElement(HTMLBlock_default, { className: "mt-2", html: hint }))
  ))), step === "COMPLETE" && /* @__PURE__ */ React57.createElement(BackgroundWrapper, { backgroundImage }, /* @__PURE__ */ React57.createElement(QuestionCard, { image: completeImage }, /* @__PURE__ */ React57.createElement("div", { className: "bg-mt-success-soft mx-auto flex h-12 w-12 items-center justify-center rounded-full" }, /* @__PURE__ */ React57.createElement(
    CheckIcon18,
    {
      className: "text-mt-success h-6 w-6",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React57.createElement("div", { className: "mt-3 text-center sm:mt-5" }, /* @__PURE__ */ React57.createElement("h3", { className: "text-mt-ink text-base leading-6 font-semibold" }, skipped ? "Tag skipped" : completeTitle || DEFAULT_COMPLETE_TITLE), !skipped && completeText && /* @__PURE__ */ React57.createElement("div", { className: "mt-2" }, /* @__PURE__ */ React57.createElement(
    HTMLBlock_default,
    {
      className: "text-mt-ink-muted text-sm",
      html: completeText
    }
  )), !skipped && revealImage && /* @__PURE__ */ React57.createElement(
    "img",
    {
      src: revealImage,
      alt: "",
      className: "mt-3 w-full rounded-md object-cover"
    }
  ), /* @__PURE__ */ React57.createElement("div", { className: "mt-5" }, /* @__PURE__ */ React57.createElement(
    "button",
    {
      type: "button",
      onClick: () => nextPage?.(),
      className: "mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary mt-1 inline-flex w-full items-center justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
    },
    /* @__PURE__ */ React57.createElement(SparklesIcon8, { "aria-hidden": "true", className: "mr-2 h-5 w-5" }),
    "Continue"
  ))))), /* @__PURE__ */ React57.createElement(
    SkipDialog,
    {
      skipDialogOpen,
      setSkipDialogOpen,
      onSkip: doSkip,
      title: "Skip this tag?",
      text: "You can move on without finding the tag. You won\u2019t be able to come back and try again."
    }
  ));
}

// src/components/Pages/TreasureChest/TreasureChest.tsx
import React58, { useCallback as useCallback18, useMemo as useMemo13, useRef as useRef27, useState as useState28 } from "react";
import { CubeIcon } from "@heroicons/react/20/solid";
import {
  NUMBER_LOCK_SKIPPED_ANSWER as NUMBER_LOCK_SKIPPED_ANSWER4
} from "magical-trails";
var loadTreasureChestView = () => import("./TreasureChestView-7PP7CUZQ.mjs");
var TreasureChestView = React58.lazy(loadTreasureChestView);
var warmUpTreasureChestView = () => {
  void loadTreasureChestView().catch(() => void 0);
};
var DEFAULT_CHEST_NAME = "the treasure chest";
function TreasureChest({
  page,
  trailEvent,
  nextPage,
  answerQuestion,
  editorMode = false
}) {
  const chestName = page.chestName?.trim() || DEFAULT_CHEST_NAME;
  const allowSkip = page.allowSkip ?? true;
  const alreadyAnswered = page.userAnswer !== void 0 && (page.userAnswer === page.code || page.userAnswer === NUMBER_LOCK_SKIPPED_ANSWER4);
  const [phase, setPhase] = useState28(
    alreadyAnswered ? "lock" : "hunt"
  );
  const placedRef = useRef27(false);
  const handlePlaced = useCallback18(() => {
    if (placedRef.current) return;
    placedRef.current = true;
    trailEvent("Treasure Chest: Placed");
  }, [trailEvent]);
  const goToLock = useCallback18(() => setPhase("lock"), []);
  const lockPage = useMemo13(
    () => ({ ...page, type: "numberLock", lockStyle: "chest" }),
    [page]
  );
  if (phase === "lock") {
    return /* @__PURE__ */ React58.createElement(
      NumberLock,
      {
        page: lockPage,
        startAtLock: true,
        trailEvent,
        nextPage,
        answerQuestion,
        editorMode
      }
    );
  }
  return /* @__PURE__ */ React58.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Treasure Chest",
      trailEvent,
      nextPage: goToLock,
      autoAdvanceOnComplete: true,
      editorMode,
      warmUp: warmUpTreasureChestView,
      copy: {
        startLabel: "Start hunting",
        startIcon: CubeIcon,
        permissionPurpose: `to find ${chestName}`,
        permissionDescription: "We use your camera (and motion on iOS) to look around and work out where the chest is buried.",
        skipText: allowSkip ? "Go straight to the lock without finding the chest?" : "Go straight to the lock without finding the chest? You will still need the code.",
        loadingLabel: "Digging up the chest...",
        emoji: "\u{1F9F0}",
        logTag: "TreasureChest",
        completeTitleFallback: `You found ${chestName}!`,
        noCameraLabel: "Hunt without the camera"
      },
      renderView: ({ onComplete, noCamera }) => /* @__PURE__ */ React58.createElement(
        TreasureChestView,
        {
          chestName,
          plateText: page.plateText,
          hideDistanceM: resolveHideDistanceM(page.hideDistanceM),
          openRadiusM: resolveOpenRadiusM(page.openRadiusM),
          editorMode,
          noCamera,
          onPlaced: handlePlaced,
          onOpen: onComplete
        }
      )
    }
  );
}

// src/components/Pages/FairyEncounter/FairyEncounter.tsx
import React59 from "react";
var loadFairyEncounterView = () => import("./FairyEncounterView-BWRHLMWH.mjs");
var FairyEncounterView = React59.lazy(loadFairyEncounterView);
var warmUpFairyEncounterView = () => {
  void loadFairyEncounterView().catch(() => void 0);
};
var DEFAULT_DWELL_SECONDS2 = 4;
function FairyEncounter({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const { creatureName, dwellSeconds } = page;
  const resolvedDwell = dwellSeconds ?? DEFAULT_DWELL_SECONDS2;
  return /* @__PURE__ */ React59.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Fairy Encounter",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpFairyEncounterView,
      copy: {
        startLabel: "Start looking",
        permissionPurpose: "to find the fairy",
        motionPurpose: "so the fairy can find a place to land",
        permissionDescription: "We use your camera (and motion on iOS) to look around and find where the fairy is hiding.",
        skipText: page.anchor === "target" ? "Are you sure you want to skip finding the fairy at the sign?" : "Are you sure you want to skip finding the fairy?",
        loadingLabel: "Waking the fairy...",
        emoji: "\u{1F9DA}",
        logTag: "FairyEncounter",
        completeTitleFallback: creatureName ? `You found ${creatureName}!` : "You found the fairy!",
        lookAgainLabel: "Look again",
        // Only the area mode can play without a camera; the sign mode has
        // nothing to track without one.
        noCameraLabel: page.anchor === "target" ? void 0 : "Look without the camera"
      },
      renderView: ({ onFound, onComplete, onSkip, noCamera }) => /* @__PURE__ */ React59.createElement(
        FairyEncounterView,
        {
          page,
          dwellSeconds: resolvedDwell,
          editorMode,
          noCamera,
          onFound,
          onComplete,
          onSkip
        }
      )
    }
  );
}

// src/components/Pages/SignalDetector/SignalDetector.tsx
import React60, { useCallback as useCallback19, useRef as useRef28 } from "react";
var loadSignalDetectorView = () => import("./SignalDetectorView-ESHBWA5K.mjs");
var SignalDetectorView = React60.lazy(loadSignalDetectorView);
var warmUpSignalDetectorView = () => {
  void loadSignalDetectorView().catch(() => void 0);
};
var DEFAULT_SIGNAL_NAME = "the signal";
function SignalDetector({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const signalName = page.signalName?.trim() || DEFAULT_SIGNAL_NAME;
  const placedRef = useRef28(false);
  const handlePlaced = useCallback19(() => {
    if (placedRef.current) return;
    placedRef.current = true;
    trailEvent("Signal Detector: Placed");
  }, [trailEvent]);
  return /* @__PURE__ */ React60.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Signal Detector",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpSignalDetectorView,
      copy: {
        startLabel: "Switch on the detector",
        permissionPurpose: "to follow the signal",
        permissionDescription: "We use your camera (and motion on iOS) to work out which way the signal is coming from.",
        skipText: "Are you sure you want to skip following the signal?",
        loadingLabel: "Warming up the detector\u2026",
        emoji: "\u{1F4E1}",
        logTag: "SignalDetector",
        completeTitleFallback: `You found ${signalName}!`,
        lookAgainLabel: "Search again",
        noCameraLabel: "Hunt without the camera"
      },
      renderView: ({ onFound, onComplete, sceneKey, noCamera }) => /* @__PURE__ */ React60.createElement(
        SignalDetectorView,
        {
          key: sceneKey,
          page,
          editorMode,
          noCamera,
          onPlaced: handlePlaced,
          onFound,
          onComplete
        }
      )
    }
  );
}

// src/components/Pages/SpellCast/SpellCast.tsx
import React61, { useCallback as useCallback20 } from "react";
var loadSpellCastView = () => import("./SpellCastView-L7K7RLAP.mjs");
var SpellCastView = React61.lazy(loadSpellCastView);
var warmUpSpellCastView = () => {
  void loadSpellCastView().catch(() => void 0);
};
var DEFAULT_SPELL_NAME = "the spell";
function SpellCast({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const spellName = page.spellName?.trim() || DEFAULT_SPELL_NAME;
  const handleFizzled = useCallback20(() => {
    trailEvent("Spell Cast: Fizzled");
  }, [trailEvent]);
  return /* @__PURE__ */ React61.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Spell Cast",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpSpellCastView,
      copy: {
        startLabel: "Pick up the wand",
        permissionPurpose: "to draw the spell in the air",
        permissionDescription: "We use your camera (and motion on iOS) so the spell you draw hangs in the air in front of you.",
        skipText: "Are you sure you want to skip casting the spell?",
        loadingLabel: "Preparing the wand\u2026",
        emoji: "\u{1FA84}",
        logTag: "SpellCast",
        completeTitleFallback: `You cast ${spellName}!`,
        lookAgainLabel: "Cast it again",
        noCameraLabel: "Draw without the camera"
      },
      renderView: ({ onFound, onComplete, sceneKey, noCamera }) => /* @__PURE__ */ React61.createElement(
        SpellCastView,
        {
          key: sceneKey,
          page,
          editorMode,
          noCamera,
          onFizzled: handleFizzled,
          onFound,
          onComplete
        }
      )
    }
  );
}

// src/components/Pages/SnapChaseAR/SnapChaseAR.tsx
import React62 from "react";
import { CameraIcon as CameraIcon4 } from "@heroicons/react/20/solid";
var loadSnapChaseARView = () => import("./SnapChaseARView-PLKOQF5R.mjs");
var SnapChaseARView = React62.lazy(loadSnapChaseARView);
var warmUpSnapChaseARView = () => {
  void loadSnapChaseARView().catch(() => void 0);
};
function SnapChaseAR2({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  return /* @__PURE__ */ React62.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Snap Chase AR",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpSnapChaseARView,
      copy: {
        startLabel: "Start the chase",
        startIcon: CameraIcon4,
        permissionPurpose: "to find the character and take the photo",
        motionPurpose: "so the character can find a spot to land",
        permissionDescription: "We use your camera (and motion on iOS) to place the character in the world around you and to take the photo.",
        skipText: "Are you sure you want to skip the photo?",
        loadingLabel: "Finding a spot\u2026",
        emoji: "\u{1F4F8}",
        logTag: "SnapChaseAR",
        completeTitleFallback: "Great shot!",
        lookAgainLabel: "Take another",
        noCameraLabel: "Play without the camera"
      },
      renderView: ({ onFound, onComplete, sceneKey, noCamera }) => /* @__PURE__ */ React62.createElement(
        SnapChaseARView,
        {
          key: sceneKey,
          page,
          editorMode,
          noCamera,
          onFound,
          onComplete
        }
      )
    }
  );
}

// src/components/Pages/CauldronBrew/CauldronBrew.tsx
import React63 from "react";
var loadCauldronBrewView = () => import("./CauldronBrewView-6H3BSL3T.mjs");
var CauldronBrewView = React63.lazy(loadCauldronBrewView);
var warmUpCauldronBrewView = () => {
  void loadCauldronBrewView().catch(() => void 0);
};
function CauldronBrew({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const reward = page.rewardChest ? page.rewardText?.trim() : void 0;
  return /* @__PURE__ */ React63.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Cauldron Brew",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpCauldronBrewView,
      copy: {
        startLabel: "Find the cauldron",
        permissionPurpose: "to find the cauldron and the ingredients nearby",
        motionPurpose: "so the ingredients can hang in the right places",
        permissionDescription: "We use your camera (and motion on iOS) to stand the cauldron on the ground and float the ingredients around you.",
        skipText: "Are you sure you want to skip brewing the potion?",
        loadingLabel: "Stirring the cauldron\u2026",
        emoji: "\u{1F9EA}",
        logTag: "CauldronBrew",
        completeTitleFallback: "The brew is done!",
        lookAgainLabel: "Brew again",
        noCameraLabel: "Brew without the camera"
      },
      completeExtra: /* @__PURE__ */ React63.createElement(RewardRevealPanel_default, { reward }),
      renderView: ({ onFound, onComplete, sceneKey, noCamera }) => /* @__PURE__ */ React63.createElement(
        CauldronBrewView,
        {
          key: sceneKey,
          page,
          editorMode,
          noCamera,
          onFirstPickUp: onFound,
          onRight: () => trailEvent("Cauldron Brew: Right ingredient"),
          onWrong: () => trailEvent("Cauldron Brew: Wrong ingredient"),
          onChestOpened: () => trailEvent("Cauldron Brew: Chest Opened"),
          onComplete
        }
      )
    }
  );
}

// src/components/Pages/TowerTopple/TowerTopple.tsx
import React64, { useEffect as useEffect31 } from "react";
var loadTowerToppleView = () => import("./TowerToppleView-HYH3IME4.mjs");
var TowerToppleView = React64.lazy(loadTowerToppleView);
var warmUpTowerToppleView = () => {
  void loadTowerToppleView().catch(() => void 0);
  warmUpRapier();
};
function TowerTopple({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const reward = page.rewardChest ? page.rewardText?.trim() : void 0;
  useEffect31(() => {
    warmUpRapier();
  }, []);
  return /* @__PURE__ */ React64.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Haunted Tower",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpTowerToppleView,
      copy: {
        startLabel: "Load the catapult",
        permissionPurpose: "to stand the tower on the ground ahead",
        motionPurpose: "so the tower stays put where it lands",
        permissionDescription: "We use your camera (and motion on iOS) to stand the haunted tower in the world around you.",
        skipText: "Are you sure you want to skip the haunted tower?",
        loadingLabel: "Building the tower\u2026",
        emoji: "\u{1F383}",
        logTag: "TowerTopple",
        completeTitleFallback: "Timber!",
        lookAgainLabel: "Play again",
        noCameraLabel: "Play without the camera"
      },
      completeExtra: /* @__PURE__ */ React64.createElement(RewardRevealPanel_default, { reward }),
      renderView: ({ onFound, onComplete, sceneKey, noCamera }) => /* @__PURE__ */ React64.createElement(
        TowerToppleView,
        {
          key: sceneKey,
          page,
          editorMode,
          noCamera,
          onFirstHit: onFound,
          onShot: () => trailEvent("Haunted Tower: Shot"),
          onRebuild: () => trailEvent("Haunted Tower: Rebuilt"),
          onChestOpened: () => trailEvent("Haunted Tower: Chest Opened"),
          onComplete
        }
      )
    }
  );
}

// src/components/Pages/MagicMirror/MagicMirror.tsx
import React65, { useCallback as useCallback21, useRef as useRef29 } from "react";
import { normalizeMagicMirrorWord } from "magical-trails";
var loadMagicMirrorView = () => import("./MagicMirrorView-HP2BYSQE.mjs");
var MagicMirrorView = React65.lazy(loadMagicMirrorView);
var warmUpMagicMirrorView = () => {
  void loadMagicMirrorView().catch(() => void 0);
};
function MagicMirror({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const theme = resolveMirrorTheme(page.theme);
  const noun = theme.noun;
  const collectedWord = normalizeMagicMirrorWord(page.word);
  const revealText = page.revealText?.trim() ? page.revealText : null;
  const handlePopped = useCallback21(() => {
    trailEvent("Magic Mirror: Popped");
  }, [trailEvent]);
  const tapModeReportedRef = useRef29(false);
  const handleTapMode = useCallback21(
    (reason) => {
      if (tapModeReportedRef.current) return;
      tapModeReportedRef.current = true;
      trailEvent(`Magic Mirror: Tap Mode (${reason})`);
    },
    [trailEvent]
  );
  return /* @__PURE__ */ React65.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Magic Mirror",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpMagicMirrorView,
      cameraOnly: true,
      copy: {
        startLabel: "Look in the mirror",
        permissionPurpose: `to show you the mirror and see your hands reach for the ${noun}`,
        permissionDescription: `We use your camera to show the mirror and to spot where your hands are. Nothing is recorded or uploaded.`,
        skipText: "Are you sure you want to skip the magic mirror?",
        loadingLabel: "Polishing the mirror\u2026",
        emoji: "\u{1FA9E}",
        logTag: "MagicMirror",
        completeTitleFallback: "The mirror is clear!",
        lookAgainLabel: "Look again",
        noCameraLabel: "Play without the camera"
      },
      completeExtra: collectedWord || revealText ? /* @__PURE__ */ React65.createElement(React65.Fragment, null, collectedWord && /* @__PURE__ */ React65.createElement("div", { className: "border-mt-border bg-mt-surface-2 mt-4 rounded-lg border p-4" }, /* @__PURE__ */ React65.createElement("p", { className: "text-mt-ink-muted text-xs font-semibold tracking-widest uppercase" }, "You collected"), /* @__PURE__ */ React65.createElement("p", { className: "text-mt-ink mt-1 text-2xl font-bold tracking-[0.2em] break-words" }, collectedWord)), revealText && /* @__PURE__ */ React65.createElement("div", { className: "border-mt-border bg-mt-surface-2 mt-4 rounded-lg border p-4" }, /* @__PURE__ */ React65.createElement("p", { className: "text-mt-ink text-xl font-bold tracking-wide break-words" }, revealText))) : void 0,
      renderView: ({ onFound, onComplete, sceneKey, noCamera }) => /* @__PURE__ */ React65.createElement(
        MagicMirrorView,
        {
          key: sceneKey,
          page,
          editorMode,
          noCamera,
          onFirstPop: onFound,
          onPopped: handlePopped,
          onTapMode: handleTapMode,
          onComplete
        }
      )
    }
  );
}

// src/components/Pages/ARChomp/ARChomp.tsx
import React66 from "react";
var loadARChompView = () => import("./ARChompView-HKZUX6ZR.mjs");
var ARChompView = React66.lazy(loadARChompView);
var warmUpARChompView = () => {
  void loadARChompView().catch(() => void 0);
};
function ARChomp({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const reward = page.rewardText?.trim();
  return /* @__PURE__ */ React66.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Chomp",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpARChompView,
      cameraOnly: true,
      copy: {
        startLabel: "Start feeding",
        permissionPurpose: "to find faces to feed",
        permissionDescription: "We use your camera to find faces and give each one a hungry mouth. No photos or video are recorded or sent anywhere.",
        skipText: "Are you sure you want to skip the feeding?",
        loadingLabel: "Waking the hungry mouths\u2026",
        emoji: "\u{1F60B}",
        logTag: "ARChomp",
        completeTitleFallback: "Everybody is full!",
        lookAgainLabel: "Play again"
      },
      completeExtra: /* @__PURE__ */ React66.createElement(RewardRevealPanel_default, { reward }),
      renderView: ({ onFound, onComplete, sceneKey }) => /* @__PURE__ */ React66.createElement(
        ARChompView,
        {
          key: sceneKey,
          page,
          trailEvent,
          onFirstFeed: onFound,
          onComplete
        }
      )
    }
  );
}

// src/components/Pages/SignReveal/SignReveal.tsx
import React67 from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
var loadSignRevealView = () => import("./SignRevealView-EHKKHKDN.mjs");
var SignRevealView = React67.lazy(loadSignRevealView);
var warmUpSignRevealView = () => {
  void loadSignRevealView().catch(() => void 0);
};
var DEFAULT_DWELL_SECONDS3 = 4;
function SignReveal({
  page,
  trailEvent,
  nextPage,
  editorMode = false
}) {
  const resolvedDwell = page.dwellSeconds ?? DEFAULT_DWELL_SECONDS3;
  return /* @__PURE__ */ React67.createElement(
    ARPageShell,
    {
      page,
      eventPrefix: "Sign Reveal",
      trailEvent,
      nextPage,
      editorMode,
      warmUp: warmUpSignRevealView,
      copy: {
        startLabel: "Start scanning",
        startIcon: MagnifyingGlassIcon,
        permissionPurpose: "to scan the sign",
        permissionDescription: "We use your camera (and motion on iOS) to spot the sign and reveal what is hidden on it.",
        skipText: "Are you sure you want to skip scanning the sign?",
        loadingLabel: "Warming up the scanner\u2026",
        emoji: "\u{1F50E}",
        logTag: "SignReveal",
        completeTitleFallback: "Revealed!",
        lookAgainLabel: "Scan again"
      },
      renderView: ({ onFound, onComplete, onSkip }) => /* @__PURE__ */ React67.createElement(
        SignRevealView,
        {
          page,
          dwellSeconds: resolvedDwell,
          editorMode,
          onFound,
          onComplete,
          onSkip
        }
      )
    }
  );
}

// src/components/Pages/Showcase3D/Showcase3D.tsx
import React68, { useCallback as useCallback22, useEffect as useEffect32, useRef as useRef30, useState as useState29 } from "react";
import {
  ArrowRightIcon as ArrowRightIcon2,
  ChevronLeftIcon as ChevronLeftIcon3,
  XMarkIcon as XMarkIcon14
} from "@heroicons/react/20/solid";
var Showcase3DScene = React68.lazy(() => import("./Showcase3DScene-QGEDVJO7.mjs"));
var BACKDROP_FALLBACK = "linear-gradient(180deg, #0a0f2c 0%, #1b1f5c 55%, #33296f 100%)";
var HINT_TIMEOUT_MS = 6e3;
var HINT_FADE_MS = 400;
function Showcase3D({
  page,
  trailEvent,
  nextPage,
  prevPage,
  closeModal
}) {
  const reduceMotion = usePrefersReducedMotion();
  const [sceneKey, setSceneKey] = useState29(0);
  const [hintPhase, setHintPhase] = useState29("shown");
  const viewedRef = useRef30(false);
  const spunRef = useRef30(false);
  const fallbackRef = useRef30(false);
  const trailEventRef = useRef30(trailEvent);
  trailEventRef.current = trailEvent;
  useEffect32(() => {
    if (viewedRef.current) return;
    viewedRef.current = true;
    trailEventRef.current("Showcase3D: Viewed");
  }, []);
  const dismissHint = useCallback22(() => {
    setHintPhase((phase) => phase === "shown" ? "hiding" : phase);
  }, []);
  useEffect32(() => {
    if (hintPhase === "shown") {
      const timer = setTimeout(dismissHint, HINT_TIMEOUT_MS);
      return () => clearTimeout(timer);
    }
    if (hintPhase === "hiding") {
      const timer = setTimeout(() => setHintPhase("hidden"), HINT_FADE_MS);
      return () => clearTimeout(timer);
    }
    return void 0;
  }, [hintPhase, dismissHint]);
  const handleFirstSpin = useCallback22(() => {
    dismissHint();
    if (spunRef.current) return;
    spunRef.current = true;
    trailEventRef.current("Showcase3D: Spun");
  }, [dismissHint]);
  const handleModelFallback = useCallback22(() => {
    if (fallbackRef.current) return;
    fallbackRef.current = true;
    trailEventRef.current("Showcase3D: Model fallback");
  }, []);
  const hasCardText = Boolean(page.title || page.content);
  const hasButtons = Boolean(nextPage || prevPage || closeModal);
  return /* @__PURE__ */ React68.createElement(
    "div",
    {
      className: "relative flex h-full w-full shrink grow flex-col overflow-hidden bg-cover bg-center bg-no-repeat",
      style: {
        backgroundImage: page.backgroundImage ? `url(${page.backgroundImage})` : BACKDROP_FALLBACK
      }
    },
    /* @__PURE__ */ React68.createElement("div", { className: "absolute inset-0" }, /* @__PURE__ */ React68.createElement(
      GameCanvasGuard,
      {
        key: sceneKey,
        onRetry: () => setSceneKey((key) => key + 1),
        logTag: "Showcase3D",
        emoji: "\u{1F381}",
        loadingLabel: "Loading the scene\u2026",
        transparent: true
      },
      /* @__PURE__ */ React68.createElement(
        "div",
        {
          className: "absolute inset-0",
          role: "img",
          "aria-label": page.altText || page.title || "3D object"
        },
        /* @__PURE__ */ React68.createElement(
          React68.Suspense,
          {
            fallback: /* @__PURE__ */ React68.createElement(
              "div",
              {
                "aria-hidden": "true",
                className: "absolute inset-0 flex items-center justify-center"
              },
              /* @__PURE__ */ React68.createElement("div", { className: "h-40 w-40 animate-pulse rounded-full bg-white/25 blur-2xl motion-reduce:animate-none" })
            )
          },
          /* @__PURE__ */ React68.createElement(
            Showcase3DScene,
            {
              page,
              reduceMotion,
              onFirstSpin: handleFirstSpin,
              onModelFallback: handleModelFallback
            }
          )
        )
      )
    )),
    (hasCardText || hasButtons) && /* @__PURE__ */ React68.createElement(
      "div",
      {
        className: "pointer-events-none absolute inset-x-0 bottom-0 z-10 flex max-h-full flex-col items-center justify-end px-3 pb-3",
        style: { paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }
      },
      hintPhase !== "hidden" && /* @__PURE__ */ React68.createElement(
        "div",
        {
          "aria-hidden": "true",
          className: `mb-2 rounded-full bg-black/45 px-3 py-1 text-xs font-medium text-white shadow-lg backdrop-blur-sm transition-opacity duration-300 ${hintPhase === "hiding" ? "opacity-0" : "opacity-100"}`
        },
        "Drag to spin"
      ),
      /* @__PURE__ */ React68.createElement(
        "div",
        {
          className: `pointer-events-auto min-h-0 w-full max-w-lg overflow-y-auto rounded-2xl bg-white/95 text-center shadow-lg backdrop-blur ${hasCardText ? "p-4" : "px-4 pb-3"}`
        },
        page.title && /* @__PURE__ */ React68.createElement("h1", { className: "mb-2 text-lg font-bold" }, page.title),
        page.content && /* @__PURE__ */ React68.createElement(HTMLBlock_default, { html: page.content }),
        nextPage && /* @__PURE__ */ React68.createElement(
          "button",
          {
            type: "button",
            className: "mt-btn bg-mt-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary text-mt-on-primary mx-auto mt-6 flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
            onClick: () => nextPage()
          },
          "Continue",
          /* @__PURE__ */ React68.createElement(
            ArrowRightIcon2,
            {
              className: "-mr-0.5 h-5 w-5",
              "aria-hidden": "true"
            }
          )
        ),
        (prevPage || closeModal) && /* @__PURE__ */ React68.createElement("div", { className: "flex w-full gap-4" }, prevPage && /* @__PURE__ */ React68.createElement(
          "button",
          {
            type: "button",
            className: "mt-btn bg-mt-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary text-mt-on-primary mx-auto flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
            onClick: () => prevPage()
          },
          /* @__PURE__ */ React68.createElement(
            ChevronLeftIcon3,
            {
              className: "-mr-0.5 h-5 w-5",
              "aria-hidden": "true"
            }
          ),
          "Previous"
        ), closeModal && /* @__PURE__ */ React68.createElement(
          "button",
          {
            type: "button",
            className: "mt-btn bg-mt-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary text-mt-on-primary mx-auto flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2",
            onClick: () => closeModal()
          },
          "Close",
          /* @__PURE__ */ React68.createElement(XMarkIcon14, { className: "-mr-0.5 h-5 w-5", "aria-hidden": "true" })
        ))
      )
    )
  );
}

// src/components/Pages/CrackerReveal/CrackerReveal.tsx
import React69, { useCallback as useCallback23, useEffect as useEffect33, useRef as useRef31, useState as useState30 } from "react";
import { ChevronLeftIcon as ChevronLeftIcon4, XMarkIcon as XMarkIcon15 } from "@heroicons/react/20/solid";
var CrackerScene = React69.lazy(() => import("./CrackerScene-C5FSE7GJ.mjs"));
var DEFAULT_PROMPT = "Pull the cracker!";
var ADVANCE_AFTER_BANG_MS = 900;
var ADVANCE_AFTER_REVEAL_MS = 1500;
var VIBRATE_MS = 80;
function CrackerReveal({
  page,
  trailEvent,
  nextPage,
  prevPage,
  closeModal
}) {
  const {
    title,
    instructions,
    backgroundImage,
    primaryColor,
    secondaryColor,
    revealImage,
    altText
  } = page;
  const reduceMotion = usePrefersReducedMotion();
  const [phase, setPhase] = useState30("ready");
  const [tension, setTension] = useState30(0);
  const [sceneKey, setSceneKey] = useState30(0);
  const bangLatched = useRef31(false);
  const advanceLatched = useRef31(false);
  const advanceTimer = useRef31(null);
  useEffect33(
    () => () => {
      if (advanceTimer.current !== null) clearTimeout(advanceTimer.current);
    },
    []
  );
  const advance = useCallback23(() => {
    if (advanceLatched.current) return;
    advanceLatched.current = true;
    if (nextPage) {
      nextPage();
      return;
    }
    setPhase("done");
  }, [nextPage]);
  const handleTension = useCallback23((next) => {
    if (bangLatched.current) return;
    setTension(next);
    setPhase(next > 0 ? "pulling" : "ready");
  }, []);
  const handleBang = useCallback23(() => {
    if (bangLatched.current) return;
    bangLatched.current = true;
    setTension(1);
    if (typeof navigator !== "undefined" && "vibrate" in navigator) {
      navigator.vibrate?.(VIBRATE_MS);
    }
    trailEvent("Cracker: Pulled");
    setPhase(revealImage ? "revealing" : "bang");
    advanceTimer.current = setTimeout(
      advance,
      revealImage ? ADVANCE_AFTER_REVEAL_MS : ADVANCE_AFTER_BANG_MS
    );
  }, [advance, revealImage, trailEvent]);
  const handleRetry = useCallback23(() => {
    setTension(0);
    setPhase("ready");
    setSceneKey((k) => k + 1);
  }, []);
  const banged = phase === "bang" || phase === "revealing" || phase === "done";
  const sceneProps = {
    primaryColor,
    secondaryColor,
    reduceMotion,
    onTension: handleTension,
    onBang: handleBang
  };
  return /* @__PURE__ */ React69.createElement(
    "div",
    {
      className: "CrackerReveal relative h-full w-full touch-none overflow-hidden bg-cover bg-center bg-no-repeat select-none",
      style: backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : (
        // A deep evergreen-to-midnight ground so the foil has something to
        // shine against when the author has not set a background.
        {
          backgroundImage: "linear-gradient(160deg, #0d3b2e 0%, #0a2540 55%, #060d1c 100%)"
        }
      )
    },
    /* @__PURE__ */ React69.createElement("div", { className: "CrackerReveal_stage" }, /* @__PURE__ */ React69.createElement(
      GameCanvasGuard,
      {
        key: sceneKey,
        logTag: "CrackerReveal",
        emoji: "\u{1F389}",
        loadingLabel: "Wrapping the cracker\u2026",
        onRetry: handleRetry,
        transparent: true
      },
      /* @__PURE__ */ React69.createElement(CrackerScene, { ...sceneProps })
    )),
    title && !banged && /* @__PURE__ */ React69.createElement("div", { className: "pointer-events-none absolute top-4 left-1/2 z-20 w-[min(90%,28rem)] -translate-x-1/2" }, /* @__PURE__ */ React69.createElement("h2", { className: "rounded-full bg-black/55 px-5 py-2 text-center text-base font-semibold text-white shadow-lg backdrop-blur-sm" }, title)),
    !banged && /* @__PURE__ */ React69.createElement("div", { className: "pointer-events-none absolute bottom-[14%] left-1/2 z-20 w-[min(88%,24rem)] -translate-x-1/2" }, /* @__PURE__ */ React69.createElement(
      "div",
      {
        className: `relative overflow-hidden rounded-full bg-black/55 px-5 py-2.5 shadow-lg backdrop-blur-sm ${tension === 0 && !reduceMotion ? "CrackerReveal_promptIdle" : ""}`
      },
      /* @__PURE__ */ React69.createElement(
        "div",
        {
          "data-testid": "cracker-meter",
          "aria-hidden": "true",
          className: "absolute inset-y-0 left-0 bg-white/25",
          style: { width: `${Math.round(tension * 100)}%` }
        }
      ),
      /* @__PURE__ */ React69.createElement("p", { className: "relative text-center text-sm font-semibold text-white" }, instructions ?? DEFAULT_PROMPT),
      /* @__PURE__ */ React69.createElement("p", { className: "relative text-center text-xs font-medium text-white/70" }, "or tap it")
    )),
    !banged && /* @__PURE__ */ React69.createElement(
      "button",
      {
        type: "button",
        onClick: handleBang,
        className: "focus:bg-mt-primary-hover sr-only z-40 focus:not-sr-only focus:absolute focus:bottom-4 focus:left-1/2 focus:-translate-x-1/2 focus:rounded-md focus:px-3.5 focus:py-2.5 focus:text-sm focus:font-semibold focus:text-white focus:outline-2 focus:outline-offset-2 focus:outline-white"
      },
      "Pull the cracker"
    ),
    banged && /* @__PURE__ */ React69.createElement(
      "div",
      {
        "data-testid": "cracker-flash",
        "aria-hidden": "true",
        className: `bg-mt-surface pointer-events-none absolute inset-0 z-30 ${reduceMotion ? "CrackerReveal_flashReduced" : "CrackerReveal_flash"}`
      }
    ),
    revealImage && (phase === "revealing" || phase === "done") && /* @__PURE__ */ React69.createElement(
      "img",
      {
        src: revealImage,
        alt: altText ?? "",
        className: `pointer-events-none absolute inset-0 z-20 h-full w-full object-cover ${reduceMotion ? "CrackerReveal_revealReduced" : "CrackerReveal_reveal"}`
      }
    ),
    phase === "done" && closeModal && /* @__PURE__ */ React69.createElement(
      "button",
      {
        type: "button",
        onClick: () => closeModal(),
        className: "mt-btn bg-mt-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary text-mt-on-primary absolute right-4 bottom-6 z-40 flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
      },
      /* @__PURE__ */ React69.createElement(XMarkIcon15, { className: "-ml-0.5 h-5 w-5", "aria-hidden": "true" }),
      "Close"
    ),
    phase === "done" && !closeModal && prevPage && /* @__PURE__ */ React69.createElement(
      "button",
      {
        type: "button",
        onClick: () => prevPage(),
        className: "mt-btn bg-mt-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary text-mt-on-primary absolute bottom-6 left-4 z-40 flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
      },
      /* @__PURE__ */ React69.createElement(ChevronLeftIcon4, { className: "-ml-0.5 h-5 w-5", "aria-hidden": "true" }),
      "Previous"
    )
  );
}

// src/components/Pages/PageRenderer.tsx
function PageRenderer({
  pages,
  code,
  currentPage,
  handlenextPage,
  handleprevPage,
  handleSetPage,
  answerQuestion,
  handleClose,
  trailEvent,
  compareImages,
  latlng,
  editorMode = false
}) {
  const paginationData = getPaginationData(
    pages?.map((page) => !!page?.allowNavigation) || [],
    currentPage || 0
  );
  const [pageRef, { pageWidth, pageHeight }] = useDebouncedSize(150);
  const [modalContainer, setModalContainer] = useState31(
    null
  );
  const setPageRoot = useCallback24(
    (el) => {
      pageRef.current = el;
      setModalContainer(el);
    },
    [pageRef]
  );
  const renderPage = (page, currentPage2, answerQuestion2, nextPage, prevPage, handleClose2, latlng2) => {
    if (page?.type === "pageLayout01") {
      return /* @__PURE__ */ React70.createElement(
        Layout01_default,
        {
          key: currentPage2,
          page,
          nextPage,
          prevPage,
          closeModal: handleClose2
        }
      );
    }
    if (page?.type === "pageLayout02") {
      return /* @__PURE__ */ React70.createElement(
        Layout02,
        {
          key: currentPage2,
          page,
          nextPage,
          prevPage,
          closeModal: handleClose2
        }
      );
    }
    if (page?.type === "audioPage") {
      return /* @__PURE__ */ React70.createElement(
        AudioPage,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          closeModal: handleClose2
        }
      );
    }
    if (page?.type === "videoPage") {
      return /* @__PURE__ */ React70.createElement(
        VideoPage,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          closeModal: handleClose2
        }
      );
    }
    if (page?.type === "pageReveal01") {
      return /* @__PURE__ */ React70.createElement(
        Reveal01_default,
        {
          key: currentPage2,
          page,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "starburst") {
      return /* @__PURE__ */ React70.createElement(
        Starburst,
        {
          key: currentPage2,
          page,
          nextPage,
          prevPage,
          closeModal: handleClose2
        }
      );
    }
    if (page?.type === "showcase3d") {
      return /* @__PURE__ */ React70.createElement(
        Showcase3D,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          closeModal: handleClose2,
          editorMode
        }
      );
    }
    if (page?.type === "crackerReveal") {
      return /* @__PURE__ */ React70.createElement(
        CrackerReveal,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          closeModal: handleClose2,
          editorMode
        }
      );
    }
    if (page?.type === "question") {
      return /* @__PURE__ */ React70.createElement(
        Question_default,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          answerQuestion: answerQuestion2
        }
      );
    }
    if (page?.type === "iframe") {
      return /* @__PURE__ */ React70.createElement(
        IFrame_default,
        {
          key: currentPage2,
          page,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "locationCheck") {
      return /* @__PURE__ */ React70.createElement(
        LocationCheck,
        {
          key: currentPage2,
          page,
          latlng: latlng2 || [0, 0],
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "imageSliceMatcherGame") {
      return /* @__PURE__ */ React70.createElement(
        ImageSliceMatcher_default,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "slidingTilePuzzleGame") {
      return /* @__PURE__ */ React70.createElement(
        SlidingTilePuzzle_default,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "tapTheThingGame") {
      return /* @__PURE__ */ React70.createElement(
        TapTheThing_default,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "visionMatch") {
      return /* @__PURE__ */ React70.createElement(
        VisionMatch,
        {
          key: currentPage2,
          page,
          trailEvent,
          compareImages,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "objectScan") {
      return /* @__PURE__ */ React70.createElement(
        ObjectScan,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "snapChase") {
      return /* @__PURE__ */ React70.createElement(
        SnapChase,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "selfie") {
      return /* @__PURE__ */ React70.createElement(
        Selfie,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "arShooterGame") {
      return /* @__PURE__ */ React70.createElement(
        ARShooter,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "sliceGame") {
      return /* @__PURE__ */ React70.createElement(
        SliceGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "whackGame") {
      return /* @__PURE__ */ React70.createElement(
        WhackGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "targetTossGame") {
      return /* @__PURE__ */ React70.createElement(
        TargetTossGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "stackGame") {
      return /* @__PURE__ */ React70.createElement(
        StackGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "spinWheelGame") {
      return /* @__PURE__ */ React70.createElement(
        SpinWheelGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "basketCatchGame") {
      return /* @__PURE__ */ React70.createElement(
        BasketCatchGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "memoryPairsGame") {
      return /* @__PURE__ */ React70.createElement(
        MemoryPairsGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "tiltMazeGame") {
      return /* @__PURE__ */ React70.createElement(
        TiltMazeGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "luminaGame") {
      return /* @__PURE__ */ React70.createElement(
        Lumina,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "qrCheck") {
      return /* @__PURE__ */ React70.createElement(
        QRCheck,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (page?.type === "arMarker") {
      return /* @__PURE__ */ React70.createElement(
        ARMarker,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "fairyEncounter") {
      return /* @__PURE__ */ React70.createElement(
        FairyEncounter,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "signReveal") {
      return /* @__PURE__ */ React70.createElement(
        SignReveal,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "signalDetector") {
      return /* @__PURE__ */ React70.createElement(
        SignalDetector,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "spellCast") {
      return /* @__PURE__ */ React70.createElement(
        SpellCast,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "snapChaseAR") {
      return /* @__PURE__ */ React70.createElement(
        SnapChaseAR2,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "creaturePhoto") {
      return /* @__PURE__ */ React70.createElement(
        CreaturePhoto,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "feedingGame") {
      return /* @__PURE__ */ React70.createElement(
        FeedingGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "cauldronBrew") {
      return /* @__PURE__ */ React70.createElement(
        CauldronBrew,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "towerToppleGame") {
      return /* @__PURE__ */ React70.createElement(
        TowerTopple,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "magicMirror") {
      return /* @__PURE__ */ React70.createElement(
        MagicMirror,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "arChomp") {
      return /* @__PURE__ */ React70.createElement(
        ARChomp,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "melodyGame") {
      return /* @__PURE__ */ React70.createElement(
        MelodyGame,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          editorMode
        }
      );
    }
    if (page?.type === "numberLock") {
      return /* @__PURE__ */ React70.createElement(
        NumberLock,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          answerQuestion: answerQuestion2,
          editorMode
        }
      );
    }
    if (page?.type === "cipherLock") {
      return /* @__PURE__ */ React70.createElement(
        CipherLock,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          answerQuestion: answerQuestion2,
          editorMode
        }
      );
    }
    if (page?.type === "nfcTap") {
      return /* @__PURE__ */ React70.createElement(
        NfcTap,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          answerQuestion: answerQuestion2,
          editorMode
        }
      );
    }
    if (page?.type === "treasureChest") {
      return /* @__PURE__ */ React70.createElement(
        TreasureChest,
        {
          key: currentPage2,
          page,
          trailEvent,
          nextPage,
          prevPage,
          answerQuestion: answerQuestion2,
          editorMode
        }
      );
    }
    if (page?.type === "decoderRingGame") {
      return /* @__PURE__ */ React70.createElement(
        DecoderRing,
        {
          key: currentPage2,
          page,
          pageHeight,
          trailEvent,
          nextPage,
          prevPage
        }
      );
    }
    if (!page) return null;
    return /* @__PURE__ */ React70.createElement("div", { className: "flex h-full w-full items-center justify-center bg-black p-6" }, /* @__PURE__ */ React70.createElement("p", { className: "max-w-xs text-center text-sm font-medium text-white" }, "This page type isn't supported by this player version."));
  };
  return /* @__PURE__ */ React70.createElement(
    "div",
    {
      className: "Page text-mt-ink @container relative flex h-full w-full flex-col justify-between overflow-hidden",
      ref: setPageRoot
    },
    /* @__PURE__ */ React70.createElement(PageModalContainerProvider, { value: modalContainer }, /* @__PURE__ */ React70.createElement("div", { className: "relative w-full shrink grow overflow-hidden" }, renderPage(
      pages?.[currentPage],
      currentPage,
      (userAnswer) => answerQuestion({
        code: code || "",
        page: currentPage || 0,
        userAnswer
      }),
      (currentPage || 0) < (pages?.length || 1) - 1 ? handlenextPage : void 0,
      handleprevPage,
      handleClose,
      latlng
    )), paginationData.paginationRequired && /* @__PURE__ */ React70.createElement(
      Pagination,
      {
        totalPages: paginationData.totalPages,
        currentPage: paginationData.currentPage,
        setPage: (page) => {
          const pageIndex = paginationData.navigableIndexes[page - 1];
          if (pageIndex !== void 0) {
            handleSetPage(pageIndex);
          }
        }
      }
    ))
  );
}
var navigationFingerprint = (pages) => pages?.map(
  (page) => page && "allowNavigation" in page && page.allowNavigation ? "1" : "0"
).join("") ?? "";
var PageRenderer_default = React70.memo(PageRenderer, (prev, next) => {
  return prev.currentPage === next.currentPage && // Optional chaining to match the component's own null-safe access:
  // runtime callers have passed undefined pages despite the prop type.
  prev.pages?.length === next.pages?.length && prev.pages?.[prev.currentPage] === next.pages?.[next.currentPage] && navigationFingerprint(prev.pages) === navigationFingerprint(next.pages) && prev.code === next.code && prev.latlng === next.latlng && prev.editorMode === next.editorMode && prev.handlenextPage === next.handlenextPage && prev.handleprevPage === next.handleprevPage && prev.handleSetPage === next.handleSetPage && prev.answerQuestion === next.answerQuestion && prev.handleClose === next.handleClose && prev.trailEvent === next.trailEvent && prev.compareImages === next.compareImages;
});

// src/components/Pages/Selfie/LazyAccessoryPreview.tsx
import React71, { lazy, Suspense as Suspense2 } from "react";
var Preview = lazy(() => import("./SelfieAccessoryPreview-523BSEIQ.mjs"));
function SelfieAccessoryPreview({ lens }) {
  return /* @__PURE__ */ React71.createElement(Suspense2, { fallback: /* @__PURE__ */ React71.createElement("p", { role: "status" }, "Opening the fitting room\u2026") }, /* @__PURE__ */ React71.createElement(Preview, { lens }));
}

// src/vision/visionMatchCore.ts
var DEFAULT_MATCHER_OPTIONS = {
  referenceMaxWidth: 480,
  frameMaxWidth: 480,
  maxFeatures: 1e3,
  fastThreshold: 10,
  ratio: 0.8,
  clahe: false,
  claheClipLimit: 3,
  channel: "auto",
  verify: true,
  ransacReprojThreshold: 5,
  minInliers: 8
};
var LEGACY_MATCHER_OPTIONS = {
  referenceMaxWidth: 400,
  frameMaxWidth: 400,
  maxFeatures: 500,
  fastThreshold: 20,
  ratio: 0.75,
  clahe: false,
  claheClipLimit: 0,
  channel: "grey",
  verify: false,
  ransacReprojThreshold: 5,
  minInliers: 8
};
var CHANNEL_INDEX = {
  r: 0,
  g: 1,
  b: 2
};
function toWorkingChannel(cv, rgba, maxWidth, channel, options) {
  const scale = rgba.cols > maxWidth ? rgba.cols / maxWidth : 1;
  let resized = null;
  let single = null;
  let equalised = null;
  let result = null;
  try {
    let source = rgba;
    if (scale > 1) {
      resized = new cv.Mat();
      cv.resize(
        rgba,
        resized,
        new cv.Size(
          Math.round(rgba.cols / scale),
          Math.round(rgba.rows / scale)
        ),
        0,
        0,
        cv.INTER_AREA
      );
      source = resized;
    }
    if (channel === "grey") {
      single = new cv.Mat();
      cv.cvtColor(source, single, cv.COLOR_RGBA2GRAY, 0);
    } else {
      const planes = new cv.MatVector();
      try {
        cv.split(source, planes);
        const plane = planes.get(CHANNEL_INDEX[channel]);
        try {
          single = plane.clone();
        } finally {
          plane.delete();
        }
      } finally {
        planes.delete();
      }
    }
    if (options.clahe) {
      const clahe = new cv.CLAHE(options.claheClipLimit, new cv.Size(8, 8));
      equalised = new cv.Mat();
      try {
        clahe.apply(single, equalised);
      } finally {
        clahe.delete();
      }
      result = equalised;
      equalised = null;
    } else {
      result = single;
      single = null;
    }
    return { image: result, scale };
  } finally {
    resized?.delete();
    single?.delete();
    equalised?.delete();
  }
}
function makeDetector(cv, options) {
  const orb = cv.ORB ? new cv.ORB(options.maxFeatures) : null;
  if (!orb) throw new Error("OpenCV runtime has no ORB");
  orb.setFastThreshold?.(options.fastThreshold);
  return orb;
}
function extractFeatures(cv, rgba, maxWidth, channel, options) {
  const { image, scale } = toWorkingChannel(
    cv,
    rgba,
    maxWidth,
    channel,
    options
  );
  const detector = makeDetector(cv, options);
  const mask = new cv.Mat();
  const keypoints = new cv.KeyPointVector();
  const descriptors = new cv.Mat();
  try {
    detector.detectAndCompute(image, mask, keypoints, descriptors);
  } catch (error) {
    keypoints.delete();
    descriptors.delete();
    throw error;
  } finally {
    detector.delete();
    mask.delete();
    image.delete();
  }
  const features = {
    keypoints,
    descriptors,
    width: Math.round(rgba.cols / scale),
    height: Math.round(rgba.rows / scale),
    scale,
    fullWidth: rgba.cols,
    fullHeight: rgba.rows,
    channel,
    delete: () => {
      keypoints.delete();
      descriptors.delete();
    }
  };
  return features;
}
function chooseChannel(cv, rgba, options) {
  const counts = {};
  const count = (channel) => {
    const features = extractFeatures(
      cv,
      rgba,
      options.referenceMaxWidth,
      channel,
      options
    );
    const n = features.keypoints.size();
    features.delete();
    counts[channel] = n;
    return n;
  };
  const grey = count("grey");
  if (options.channel !== "auto" || grey >= options.maxFeatures * 0.8) {
    return { channel: "grey", counts };
  }
  let best = "grey";
  let bestCount = grey;
  for (const channel of ["r", "g", "b"]) {
    const n = count(channel);
    if (n > bestCount) {
      best = channel;
      bestCount = n;
    }
  }
  return {
    channel: bestCount >= grey * 1.25 ? best : "grey",
    counts
  };
}
function extractReference(cv, rgba, options) {
  const { channel } = chooseChannel(cv, rgba, options);
  return extractFeatures(cv, rgba, options.referenceMaxWidth, channel, options);
}
function extractFrame(cv, rgba, channel, options) {
  return extractFeatures(cv, rgba, options.frameMaxWidth, channel, options);
}
function matchFeatures(cv, reference, frame, options) {
  const empty = {
    good: 0,
    inliers: 0,
    verified: false,
    pairs: { reference: [], frame: [] }
  };
  if (reference.descriptors.rows < 2 || frame.descriptors.rows < 2) {
    return empty;
  }
  const matcher = new cv.BFMatcher(cv.NORM_HAMMING, false);
  const matches = new cv.DMatchVectorVector();
  const refPts = [];
  const framePts = [];
  try {
    matcher.knnMatch(reference.descriptors, frame.descriptors, matches, 2);
    const n = matches.size();
    for (let i = 0; i < n; i++) {
      const pair = matches.get(i);
      if (pair.size() >= 2) {
        const best = pair.get(0);
        const second = pair.get(1);
        if (best.distance <= options.ratio * second.distance) {
          const r = reference.keypoints.get(best.queryIdx).pt;
          const f = frame.keypoints.get(best.trainIdx).pt;
          refPts.push(r.x, r.y);
          framePts.push(f.x, f.y);
        }
      }
      pair.delete();
    }
  } finally {
    matches.delete();
    matcher.delete();
  }
  const good = refPts.length / 2;
  const toFull = (flat, scale, keep) => {
    const out = [];
    for (let i = 0; i < flat.length / 2; i++) {
      if (keep && !keep[i]) continue;
      out.push([flat[i * 2] * scale, flat[i * 2 + 1] * scale]);
    }
    return out;
  };
  if (!options.verify || good < 4) {
    return {
      good,
      inliers: 0,
      verified: false,
      pairs: {
        reference: toFull(refPts, reference.scale),
        frame: toFull(framePts, frame.scale)
      }
    };
  }
  const src = cv.matFromArray(good, 1, cv.CV_32FC2, refPts);
  const dst = cv.matFromArray(good, 1, cv.CV_32FC2, framePts);
  const mask = new cv.Mat();
  let h = null;
  try {
    h = cv.findHomography(
      src,
      dst,
      cv.RANSAC,
      options.ransacReprojThreshold,
      mask
    );
    const inlierMask = mask.rows === good ? mask.data.slice(0, good) : null;
    let inliers = 0;
    if (inlierMask) {
      for (let i = 0; i < good; i++) if (inlierMask[i]) inliers++;
    }
    const working = h && h.rows === 3 ? Array.from(h.data64F) : null;
    const usable = working !== null && inlierMask !== null && inliers >= options.minInliers && isPlausibleHomography(
      working,
      reference.width,
      reference.height,
      frame.width,
      frame.height
    );
    if (!usable || !working || !inlierMask) {
      return {
        good,
        inliers: 0,
        verified: false,
        pairs: {
          reference: toFull(refPts, reference.scale),
          frame: toFull(framePts, frame.scale)
        }
      };
    }
    return {
      good,
      inliers,
      verified: true,
      homography: homographyToFullSize(working, reference.scale, frame.scale),
      pairs: {
        reference: toFull(refPts, reference.scale, inlierMask),
        frame: toFull(framePts, frame.scale, inlierMask)
      }
    };
  } finally {
    src.delete();
    dst.delete();
    mask.delete();
    h?.delete();
  }
}
function scoreOf(outcome, options) {
  if (!options.verify) return outcome.good;
  if (outcome.verified) return outcome.inliers;
  return Math.min(outcome.good, unverifiedCap(options));
}
function unverifiedCap(options) {
  return Math.max(0, Math.floor(options.minInliers / 2));
}
function effectiveThreshold(requested, options) {
  if (!options.verify) return requested;
  return Math.max(requested, options.minInliers);
}
function apply(h, x, y) {
  const w = h[6] * x + h[7] * y + h[8];
  const d = Math.abs(w) < 1e-9 ? 1e-9 : w;
  return [(h[0] * x + h[1] * y + h[2]) / d, (h[3] * x + h[4] * y + h[5]) / d];
}
function isPlausibleHomography(h, referenceWidth, referenceHeight, frameWidth, frameHeight) {
  if (h.length !== 9 || !h.every((v) => Number.isFinite(v))) return false;
  const corners = [
    apply(h, 0, 0),
    apply(h, referenceWidth, 0),
    apply(h, referenceWidth, referenceHeight),
    apply(h, 0, referenceHeight)
  ];
  let area = 0;
  for (let i = 0; i < 4; i++) {
    const [ax, ay] = corners[i];
    const [bx, by] = corners[(i + 1) % 4];
    area += ax * by - bx * ay;
  }
  area /= 2;
  const frameArea = frameWidth * frameHeight;
  if (!(area > frameArea * 4e-3) || area > frameArea * 6) return false;
  for (let i = 0; i < 4; i++) {
    const [ax, ay] = corners[i];
    const [bx, by] = corners[(i + 1) % 4];
    const [cx, cy] = corners[(i + 2) % 4];
    const cross2 = (bx - ax) * (cy - by) - (by - ay) * (cx - bx);
    if (cross2 <= 0) return false;
  }
  const side = (i) => {
    const [ax, ay] = corners[i];
    const [bx, by] = corners[(i + 1) % 4];
    return Math.hypot(bx - ax, by - ay);
  };
  const ratio = (a, b) => Math.min(a, b) / Math.max(a, b, 1e-9);
  return ratio(side(0), side(2)) > 0.1 && ratio(side(1), side(3)) > 0.1;
}
function homographyToFullSize(h, referenceScale, frameScale) {
  const rs = referenceScale;
  const fs = frameScale;
  const out = [
    h[0] * fs / rs,
    h[1] * fs / rs,
    h[2] * fs,
    h[3] * fs / rs,
    h[4] * fs / rs,
    h[5] * fs,
    h[6] / rs,
    h[7] / rs,
    h[8]
  ];
  const k = Math.abs(out[8]) < 1e-12 ? 1 : 1 / out[8];
  return out.map((v) => v * k);
}

// src/vision/signGeometry.ts
function orderQuad(points) {
  if (points.length !== 4) throw new Error("orderQuad needs exactly 4 points");
  const cx = points.reduce((sum, [x]) => sum + x, 0) / 4;
  const cy = points.reduce((sum, [, y]) => sum + y, 0) / 4;
  const sorted = [...points].sort(
    (a, b) => Math.atan2(a[1] - cy, a[0] - cx) - Math.atan2(b[1] - cy, b[0] - cx)
  );
  let start = 0;
  let best = Infinity;
  sorted.forEach(([x, y], i) => {
    const d = x + y;
    if (d < best) {
      best = d;
      start = i;
    }
  });
  const rotated = [...sorted.slice(start), ...sorted.slice(0, start)];
  return [rotated[0], rotated[1], rotated[2], rotated[3]];
}
function defaultQuad(width, height, inset = 0.12) {
  const x0 = width * inset;
  const y0 = height * inset;
  const x1 = width * (1 - inset);
  const y1 = height * (1 - inset);
  return [
    [x0, y0],
    [x1, y0],
    [x1, y1],
    [x0, y1]
  ];
}
function fullQuad(width, height) {
  return [
    [0, 0],
    [width, 0],
    [width, height],
    [0, height]
  ];
}
var cross = (o, a, b) => (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
function isConvexQuad(quad) {
  for (let i = 0; i < 4; i++) {
    const c = cross(quad[i], quad[(i + 1) % 4], quad[(i + 2) % 4]);
    if (c <= 0) return false;
  }
  return true;
}
function quadArea(quad) {
  let area = 0;
  for (let i = 0; i < 4; i++) {
    const [ax, ay] = quad[i];
    const [bx, by] = quad[(i + 1) % 4];
    area += ax * by - bx * ay;
  }
  return area / 2;
}
var length = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]);
function quadAspect(quad) {
  const [tl, tr, br, bl] = quad;
  const width = Math.max(length(tl, tr), length(bl, br));
  const height = Math.max(length(tl, bl), length(tr, br));
  if (!(width > 0) || !(height > 0)) return 1;
  return width / height;
}
function outputSizeForQuad(quad, maxLongSide = 1600) {
  const [tl, tr, br, bl] = quad;
  const width = Math.max(length(tl, tr), length(bl, br));
  const height = Math.max(length(tl, bl), length(tr, br));
  const scale = Math.min(1, maxLongSide / Math.max(width, height, 1));
  return {
    width: Math.max(16, Math.round(width * scale)),
    height: Math.max(16, Math.round(height * scale))
  };
}
function scaleQuad(quad, k) {
  return [
    [quad[0][0] * k, quad[0][1] * k],
    [quad[1][0] * k, quad[1][1] * k],
    [quad[2][0] * k, quad[2][1] * k],
    [quad[3][0] * k, quad[3][1] * k]
  ];
}
function clampQuad(quad, width, height) {
  const clamp2 = ([x, y]) => [
    Math.min(width, Math.max(0, x)),
    Math.min(height, Math.max(0, y))
  ];
  return [clamp2(quad[0]), clamp2(quad[1]), clamp2(quad[2]), clamp2(quad[3])];
}

// src/vision/warpPerspective.ts
function createImageData(width, height) {
  if (typeof ImageData !== "undefined") return new ImageData(width, height);
  return {
    width,
    height,
    data: new Uint8ClampedArray(width * height * 4),
    colorSpace: "srgb"
  };
}
function straightenQuad(source, quad, width, height) {
  const rect = [
    [0, 0],
    [width, 0],
    [width, height],
    [0, height]
  ];
  const h = fitHomography(rect, quad);
  if (!h) throw new Error("The four corners do not describe a usable shape");
  return warp(source, h, width, height, [0, 0, 0, 0]);
}
function renderIntoQuad(source, target, width, height, fill = [96, 104, 88, 255]) {
  const rect = [
    [0, 0],
    [source.width, 0],
    [source.width, source.height],
    [0, source.height]
  ];
  const h = fitHomography(target, rect);
  if (!h) throw new Error("The target quad is degenerate");
  return warp(source, h, width, height, fill);
}
function warp(source, outputToSource, width, height, fill) {
  const out = createImageData(width, height);
  const dst = out.data;
  const src = source.data;
  const sw = source.width;
  const sh = source.height;
  const [h0, h1, h2, h3, h4, h5, h6, h7, h8] = outputToSource;
  let o = 0;
  for (let y = 0; y < height; y++) {
    const yc = y + 0.5;
    for (let x = 0; x < width; x++) {
      const xc = x + 0.5;
      const w = h6 * xc + h7 * yc + h8;
      const d = Math.abs(w) < 1e-9 ? 1e-9 : w;
      const sxRaw = (h0 * xc + h1 * yc + h2) / d - 0.5;
      const syRaw = (h3 * xc + h4 * yc + h5) / d - 0.5;
      if (sxRaw < -0.5 || syRaw < -0.5 || sxRaw > sw - 0.5 || syRaw > sh - 0.5) {
        dst[o] = fill[0];
        dst[o + 1] = fill[1];
        dst[o + 2] = fill[2];
        dst[o + 3] = fill[3];
      } else {
        const sx = Math.min(Math.max(sxRaw, 0), sw - 1);
        const sy = Math.min(Math.max(syRaw, 0), sh - 1);
        const x0 = Math.floor(sx);
        const y0 = Math.floor(sy);
        const x1 = Math.min(x0 + 1, sw - 1);
        const y1 = Math.min(y0 + 1, sh - 1);
        const fx = sx - x0;
        const fy = sy - y0;
        const i00 = (y0 * sw + x0) * 4;
        const i10 = (y0 * sw + x1) * 4;
        const i01 = (y1 * sw + x0) * 4;
        const i11 = (y1 * sw + x1) * 4;
        const w00 = (1 - fx) * (1 - fy);
        const w10 = fx * (1 - fy);
        const w01 = (1 - fx) * fy;
        const w11 = fx * fy;
        for (let c = 0; c < 4; c++) {
          dst[o + c] = src[i00 + c] * w00 + src[i10 + c] * w10 + src[i01 + c] * w01 + src[i11 + c] * w11;
        }
      }
      o += 4;
    }
  }
  return out;
}

// src/vision/scannability.ts
var REFERENCE_THRESHOLD = 15;
function verdictFor(keypoints, inliers, threshold = REFERENCE_THRESHOLD) {
  const tips = [];
  if (keypoints < 150) {
    tips.push(
      "The sign has very little detail for the camera to hold on to. Plain painted boards and engraved wood are the hardest; a sign with a picture, a map or several lines of text scans far better."
    );
  }
  if (inliers < threshold) {
    tips.push(
      "Get closer so the sign fills the photo, and make sure the writing is sharp: a soft or distant photo cannot be recovered by the player."
    );
    tips.push(
      "Avoid glare and deep shadow across the sign; flat, even daylight is best."
    );
    return { verdict: "poor", tips };
  }
  if (inliers < threshold * 2.5) {
    tips.push(
      "It should scan, but not with much to spare: in dull light or at an angle it may struggle. A sharper, closer photo would help."
    );
    return { verdict: "fair", tips };
  }
  return { verdict: "good", tips };
}
function testViewQuad(width, height, aspect) {
  let w = width * 0.66;
  let h = w / aspect;
  if (h > height * 0.8) {
    h = height * 0.8;
    w = h * aspect;
  }
  const cx = width / 2;
  const cy = height / 2;
  return [
    [cx - w * 0.52, cy - h * 0.56],
    [cx + w * 0.46, cy - h * 0.44],
    [cx + w * 0.46, cy + h * 0.44],
    [cx - w * 0.52, cy + h * 0.56]
  ];
}
function soften(image) {
  const { width, height, data } = image;
  const out = createImageData(width, height);
  const dst = out.data;
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      for (let c = 0; c < 3; c++) {
        let sum = 0;
        let n = 0;
        for (let dy = -1; dy <= 1; dy++) {
          const yy = y + dy;
          if (yy < 0 || yy >= height) continue;
          for (let dx = -1; dx <= 1; dx++) {
            const xx = x + dx;
            if (xx < 0 || xx >= width) continue;
            sum += data[(yy * width + xx) * 4 + c];
            n++;
          }
        }
        dst[(y * width + x) * 4 + c] = sum / n;
      }
      dst[(y * width + x) * 4 + 3] = 255;
    }
  }
  return out;
}
var FRAME_WIDTH = 640;
var FRAME_HEIGHT = 480;
function assessScannability(cv, reference, toMat, threshold = REFERENCE_THRESHOLD) {
  const view = soften(
    renderIntoQuad(
      reference,
      testViewQuad(
        FRAME_WIDTH,
        FRAME_HEIGHT,
        reference.width / reference.height
      ),
      FRAME_WIDTH,
      FRAME_HEIGHT
    )
  );
  const options = DEFAULT_MATCHER_OPTIONS;
  const bar = effectiveThreshold(threshold, options);
  const referenceMat = toMat(reference);
  const viewMat = toMat(view);
  try {
    const { channel } = chooseChannel(cv, referenceMat, options);
    const referenceFeatures = extractFeatures(
      cv,
      referenceMat,
      options.referenceMaxWidth,
      channel,
      options
    );
    let viewFeatures = null;
    try {
      viewFeatures = extractFeatures(
        cv,
        viewMat,
        options.frameMaxWidth,
        channel,
        options
      );
      const outcome = matchFeatures(
        cv,
        referenceFeatures,
        viewFeatures,
        options
      );
      const keypoints = referenceFeatures.keypoints.size();
      const inliers = outcome.verified ? outcome.inliers : 0;
      return {
        ...verdictFor(keypoints, inliers, bar),
        keypoints,
        inliers,
        channel,
        threshold: bar
      };
    } finally {
      referenceFeatures.delete();
      viewFeatures?.delete();
    }
  } finally {
    referenceMat.delete();
    viewMat.delete();
  }
}

// src/vision/detectSignQuad.ts
var WORKING_WIDTH = 640;
var MIN_AREA_FRACTION = 0.06;
function detectSignQuad(cv, rgba) {
  const scale = rgba.cols > WORKING_WIDTH ? rgba.cols / WORKING_WIDTH : 1;
  const small = new cv.Mat();
  const grey = new cv.Mat();
  const blurred = new cv.Mat();
  const edges = new cv.Mat();
  const dilated = new cv.Mat();
  const kernel = cv.matFromArray(3, 3, cv.CV_8UC1, [1, 1, 1, 1, 1, 1, 1, 1, 1]);
  const contours = new cv.MatVector();
  const hierarchy = new cv.Mat();
  try {
    cv.resize(
      rgba,
      small,
      new cv.Size(Math.round(rgba.cols / scale), Math.round(rgba.rows / scale)),
      0,
      0,
      cv.INTER_AREA
    );
    cv.cvtColor(small, grey, cv.COLOR_RGBA2GRAY, 0);
    cv.GaussianBlur(grey, blurred, new cv.Size(5, 5), 0, 0, cv.BORDER_DEFAULT);
    cv.Canny(blurred, edges, 40, 120);
    cv.dilate(edges, dilated, kernel);
    cv.findContours(
      dilated,
      contours,
      hierarchy,
      cv.RETR_LIST,
      cv.CHAIN_APPROX_SIMPLE
    );
    const imageArea = small.cols * small.rows;
    let best = null;
    const n = contours.size();
    for (let i = 0; i < n; i++) {
      const contour = contours.get(i);
      const approx = new cv.Mat();
      try {
        const area = cv.contourArea(contour);
        if (area < imageArea * MIN_AREA_FRACTION) continue;
        if (best && area <= best.area) continue;
        cv.approxPolyDP(
          contour,
          approx,
          0.03 * cv.arcLength(contour, true),
          true
        );
        if (approx.rows !== 4 || !cv.isContourConvex(approx)) continue;
        const values = new Int32Array(
          approx.data.buffer,
          approx.data.byteOffset,
          8
        );
        const points = [
          [values[0], values[1]],
          [values[2], values[3]],
          [values[4], values[5]],
          [values[6], values[7]]
        ];
        const quad = orderQuad(points.map(([x, y]) => [x * scale, y * scale]));
        if (!isConvexQuad(quad)) continue;
        best = { quad, area };
      } finally {
        approx.delete();
        contour.delete();
      }
    }
    return best?.quad ?? null;
  } finally {
    small.delete();
    grey.delete();
    blurred.delete();
    edges.delete();
    dilated.delete();
    kernel.delete();
    contours.delete();
    hierarchy.delete();
  }
}

// src/hooks/useScreenProperties.ts
import { useEffect as useEffect34, useState as useState32 } from "react";
function useScreenProperties(debounceMs = 120) {
  const [screen, setScreen] = useState32({
    screenWidth: typeof window === "undefined" ? 0 : window.innerWidth,
    screenHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    cssBreakpoint: typeof window === "undefined" ? "not set" : getCssBreakpoint(window)
  });
  useEffect34(() => {
    if (typeof window === "undefined") return;
    let timer = null;
    const measure = () => {
      setScreen((prev) => {
        const next = {
          screenWidth: window.innerWidth,
          screenHeight: window.innerHeight,
          cssBreakpoint: getCssBreakpoint(window)
        };
        return prev.screenWidth === next.screenWidth && prev.screenHeight === next.screenHeight && prev.cssBreakpoint === next.cssBreakpoint ? prev : next;
      });
    };
    measure();
    const onResize = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(measure, debounceMs);
    };
    window.addEventListener("resize", onResize);
    return () => {
      if (timer) clearTimeout(timer);
      window.removeEventListener("resize", onResize);
    };
  }, [debounceMs]);
  return screen;
}
function getCssBreakpoint(win) {
  let bp = win.getComputedStyle(win.document.body, ":before").content || "not set";
  if (bp.startsWith('"') && bp.endsWith('"')) {
    bp = bp.slice(1, -1);
  }
  return bp;
}

// src/components/Pages/ARChomp/LazyChompMouthPreview.tsx
import React72, { lazy as lazy2, Suspense as Suspense3 } from "react";
var Preview2 = lazy2(() => import("./ChompMouthPreview-AHWHNHWF.mjs"));
function ChompMouthPreview({ mouth }) {
  return /* @__PURE__ */ React72.createElement(Suspense3, { fallback: /* @__PURE__ */ React72.createElement("p", { role: "status" }, "Opening the snack audition\u2026") }, /* @__PURE__ */ React72.createElement(Preview2, { mouth }));
}

// src/characters/LazyCreatureStudio.tsx
import React73, { lazy as lazy3, Suspense as Suspense4 } from "react";
var Studio = lazy3(() => import("./CreatureStudio-WPOXGFDU.mjs"));
function CreatureStudio({ creature }) {
  return /* @__PURE__ */ React73.createElement(Suspense4, { fallback: /* @__PURE__ */ React73.createElement("p", { role: "status" }, "Opening the creature studio\u2026") }, /* @__PURE__ */ React73.createElement(Studio, { creature }));
}
export {
  CAUGHT_ERROR_EVENT,
  CHARACTERS,
  CHARACTER_IDS,
  ChompMouthPreview,
  CreatureStudio,
  DEFAULT_GADGET_THEME,
  DEFAULT_MATCHER_OPTIONS,
  DEFAULT_SCANNER_THEME,
  ErrorBoundary_default as ErrorBoundary,
  FEEDABLE_CHARACTERS,
  FOODS,
  GADGET_THEMES,
  HeroIcon,
  INSTRUMENTS,
  INSTRUMENT_LABELS,
  LEGACY_MATCHER_OPTIONS,
  MelodySynth,
  NFC_SCANS_STORAGE_KEY,
  NFC_SCAN_EVENT,
  NFC_SCAN_TTL_MS,
  NOTE_COUNTS,
  OBJECT_DETECTOR_ASSETS_BASE_URL,
  OBJECT_DETECTOR_DEFAULT_MAX_RESULTS,
  OBJECT_DETECTOR_DEFAULT_SCORE_THRESHOLD,
  OBJECT_DETECTOR_MODEL_FILE,
  OBJECT_DETECTOR_MODEL_PATH,
  OBJECT_DETECTOR_WASM_PATH,
  OutsideClickHandler_default as OutsideClickHandler,
  PHOTO_CHARACTERS,
  PageRenderer_default as PageRenderer,
  REFERENCE_THRESHOLD,
  SCANNER_THEMES,
  SVGIcon_default as SVGIcon,
  SelfieAccessoryPreview,
  SnapChase,
  applyHomography,
  assessScannability,
  bestDetectionFor,
  boxToView,
  characterCollection,
  characterModelUrl,
  characterMotion,
  characterSpec,
  chooseChannel,
  clampQuad,
  coverTransform,
  createImageData,
  defaultQuad,
  detectSignQuad,
  effectiveThreshold,
  extractFeatures,
  extractFrame,
  extractReference,
  fitHomography,
  fullQuad,
  gadgetThemeClass,
  getInstrumentDef,
  gradeAnswer,
  hasNfcScan,
  homographyToFullSize,
  isCharacterId,
  isCloseEnough,
  isConvexQuad,
  isPlausibleHomography,
  labelsSeen,
  loadObjectDetector,
  matchFeatures,
  noteColor,
  orderQuad,
  outputSizeForQuad,
  prefetchCharacter,
  quadArea,
  quadAspect,
  ransacHomography,
  recordNfcScan,
  recordNfcScanFromLocation,
  renderIntoQuad,
  reportCaughtError,
  resolveGadgetTheme,
  resolveScannerTheme,
  sanitizeHtml,
  scaleQuad,
  scannerThemeClass,
  scoreOf,
  soften,
  straightenQuad,
  subscribeNfcScans,
  testViewQuad,
  toDetections,
  toWorkingChannel,
  unverifiedCap,
  useDebouncedSize,
  useNfcScan,
  useScreenProperties,
  verdictFor,
  warp
};
//# sourceMappingURL=index.mjs.map